export default {
    keshiList: [
        {
            "name": "心内科",
            "imgUrl": "xinneike",
            "clickedImgUrl": "xinneike2",
            "keShiCode": "xinneike",
            "disease": [
                {
                    "name": "高血压",
                    "diseaseCode": "gaoxueya",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "hegu",
                            "xueweiName": "合谷"
                        },
                        {
                            "xueweiCode": "neiguan",
                            "xueweiName": "内关"
                        },
                        {
                            "xueweiCode": "quchi",
                            "xueweiName": "曲池"
                        },
                        {
                            "xueweiCode": "taiyang",
                            "xueweiName": "太阳"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "高血压1-合谷",
                            "description": "用拇指指腹点按合谷30次，力度稍重。"
                        },
                        {
                            "imgUrlName": "高血压2-内关",
                            "description": "用拇指点揉内关3-5分钟，力度适中。"
                        },
                        {
                            "imgUrlName": "高血压3-曲池",
                            "description": "用食指中节按压曲池3分钟，力度稍重。"
                        },
                        {
                            "imgUrlName": "高血压4-太阳",
                            "description": "用双手掌根按揉两侧太阳，顺时针方向、逆时针方向各1分钟。"
                        }
                    ],
                    "classicalSymptom": "头疼、眩晕、耳鸣、心悸。"
                },
                {
                    "name": "高脂血症",
                    "diseaseCode": "gaozhixuezheng",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "shanzhong",
                            "xueweiName": "膻中"
                        },
                        {
                            "xueweiCode": "zhongwan",
                            "xueweiName": "中脘"
                        },
                        {
                            "xueweiCode": "fenglong",
                            "xueweiName": "丰隆"
                        },
                        {
                            "xueweiCode": "hegu",
                            "xueweiName": "合谷"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "高脂血症1-膻中",
                            "description": "用食指、中指、无名指指腹按揉膻中50次。"
                        },
                        {
                            "imgUrlName": "高脂血症2-中脘",
                            "description": "用拇指指端轻轻按压中脘20次。"
                        },
                        {
                            "imgUrlName": "高脂血症3-丰隆",
                            "description": "用拇指指端用力按揉丰隆2分钟。"
                        },
                        {
                            "imgUrlName": "高脂血症4-合谷",
                            "description": "用拇指指腹点按合谷30次，力度稍重。"
                        }
                    ],
                    "classicalSymptom": "神疲乏力、失眠健忘、胸闷心悸。"
                },
                {
                    "name": "冠心病",
                    "diseaseCode": "guanxinbing",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "xinyu",
                            "xueweiName": "心俞"
                        },
                        {
                            "xueweiCode": "neiguan",
                            "xueweiName": "内关"
                        },
                        {
                            "xueweiCode": "shenmen",
                            "xueweiName": "神门"
                        },
                        {
                            "xueweiCode": "jiquan",
                            "xueweiName": "极泉"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "冠心病1-心俞",
                            "description": "用食指指端轻轻叩击心俞2分钟，以产生酸胀感为宜。"
                        },
                        {
                            "imgUrlName": "冠心病2-内关",
                            "description": "用拇指点按内关30次，两手交替进行，力度适中。"
                        },
                        {
                            "imgUrlName": "冠心病3-神门",
                            "description": "用拇指和食指揉捏神门3-5分钟，两手交替进行，力度适中。"
                        },
                        {
                            "imgUrlName": "冠心病4-极泉",
                            "description": "用拇指按压极泉1分钟，其余四指扶住腋窝后方的肩膀。"
                        }
                    ],
                    "classicalSymptom": "胸痛憋闷、心悸气短、脉搏不齐。"
                },
                {
                    "name": "胸闷",
                    "diseaseCode": "xiongmen",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "neiguan",
                            "xueweiName": "内关"
                        },
                        {
                            "xueweiCode": "waiguan",
                            "xueweiName": "外关"
                        },
                        {
                            "xueweiCode": "shanzhong",
                            "xueweiName": "膻中"
                        },
                        {
                            "xueweiCode": "sanyinjiao",
                            "xueweiName": "三阴交"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "胸闷1-内关",
                            "description": "用拇指指腹按揉内关20-30次。"
                        },
                        {
                            "imgUrlName": "胸闷2-外关",
                            "description": "用拇指指腹按压外关2分钟，力度适中。"
                        },
                        {
                            "imgUrlName": "胸闷3-膻中",
                            "description": "中间三指并拢，用指腹按压膻中，力度要轻，直至胸闷缓解。"
                        },
                        {
                            "imgUrlName": "胸闷4-三阴交",
                            "description": "用拇指指腹按揉三阴交2分钟，左右交替进行，力度适中。"
                        }
                    ],
                    "classicalSymptom": "呼吸费力、气不够用、全身乏力。"
                },
                {
                    "name": "心悸",
                    "diseaseCode": "xinji",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "juque",
                            "xueweiName": "巨阙"
                        },
                        {
                            "xueweiCode": "xinyu",
                            "xueweiName": "心俞"
                        },
                        {
                            "xueweiCode": "qiemen",
                            "xueweiName": "郄门"
                        },
                        {
                            "xueweiCode": "quze",
                            "xueweiName": "曲泽"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "心悸1-巨阙",
                            "description": "用大鱼际从腹部巨阙处向下轻轻推摩30次。"
                        },
                        {
                            "imgUrlName": "心悸2-心俞",
                            "description": "右手握拳面轻轻叩击心俞1-3分钟。"
                        },
                        {
                            "imgUrlName": "心悸3-郄门",
                            "description": "用拇指指腹按压郄门3分钟，力度适中。"
                        },
                        {
                            "imgUrlName": "心悸4-曲泽",
                            "description": "用拇指按压曲泽30次，力度适中。"
                        }
                    ],
                    "classicalSymptom": "心悸心慌、时作时息、善惊易恐、坐卧不安。"
                }
            ]
        },
        {
            "name": "呼吸科",
            "imgUrl": "huxike",
            "clickedImgUrl": "huxike2",
            "keShiCode": "huxike",
            "disease": [
                {
                    "name": "感冒",
                    "diseaseCode": "ganmao",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "yingxiang",
                            "xueweiName": "迎香"
                        },
                        {
                            "xueweiCode": "fengchi",
                            "xueweiName": "风池"
                        },
                        {
                            "xueweiCode": "jianjing",
                            "xueweiName": "肩井"
                        },
                        {
                            "xueweiCode": "quchi",
                            "xueweiName": "曲池"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "感冒1-迎香",
                            "description": "双手食指置于迎香处，上下搓擦1分钟，直至用鼻呼吸通畅。"
                        },
                        {
                            "imgUrlName": "感冒2-风池",
                            "description": "双手抱拢头部，用双手拇指在颈后的风池处揉捻1分钟。"
                        },
                        {
                            "imgUrlName": "感冒3-肩井",
                            "description": "用右手中间三指按揉左侧肩井1分钟，然后左手按右侧肩井，力度宜重。"
                        },
                        {
                            "imgUrlName": "感冒4-曲池",
                            "description": "用食指中节叩压曲池1分钟，力度稍大，双侧交替进行。"
                        }
                    ],
                    "classicalSymptom": "喷嚏、鼻塞、流涕、咽痛。"
                },
                {
                    "name": "咳嗽",
                    "diseaseCode": "kesou",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "feiyu",
                            "xueweiName": "肺俞"
                        },
                        {
                            "xueweiCode": "chize",
                            "xueweiName": "尺泽"
                        },
                        {
                            "xueweiCode": "lieque",
                            "xueweiName": "列缺"
                        },
                        {
                            "xueweiCode": "taixi",
                            "xueweiName": "太溪"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "咳嗽1-肺俞",
                            "description": "用中指端按揉肺俞1分钟，力度适中。"
                        },
                        {
                            "imgUrlName": "咳嗽2-尺泽",
                            "description": "用拇指指腹按压尺泽1-3分钟，力度适中。"
                        },
                        {
                            "imgUrlName": "咳嗽3-列缺",
                            "description": "用拇指指端压捻列缺2分钟，逐渐加力。"
                        },
                        {
                            "imgUrlName": "咳嗽4-太溪",
                            "description": "用拇指指腹按压太溪10-15次，力度适中。"
                        }
                    ],
                    "classicalSymptom": "咳痰、气喘。"
                },
                {
                    "name": "哮喘",
                    "diseaseCode": "xiaochuan",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "tiantu",
                            "xueweiName": "天突"
                        },
                        {
                            "xueweiCode": "renying",
                            "xueweiName": "人迎"
                        },
                        {
                            "xueweiCode": "dingchuan",
                            "xueweiName": "定喘"
                        },
                        {
                            "xueweiCode": "taiyuan",
                            "xueweiName": "太渊"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "哮喘1-天突",
                            "description": "用食指和中指轻轻按压天突1-2分钟。"
                        },
                        {
                            "imgUrlName": "哮喘2-人迎",
                            "description": "用拇指和食指同时按压两侧人迎1-3分钟。"
                        },
                        {
                            "imgUrlName": "哮喘3-定喘",
                            "description": "哮喘急性发作时，用拇指指端重按定喘30-50次。"
                        },
                        {
                            "imgUrlName": "哮喘4-太渊",
                            "description": "用拇指指腹按压太渊1-3分钟。"
                        }
                    ],
                    "classicalSymptom": "咳嗽、喘息、胸闷、咳痰。"
                },
                {
                    "name": "肺炎",
                    "diseaseCode": "feiyan",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "dazhui",
                            "xueweiName": "大椎"
                        },
                        {
                            "xueweiCode": "shanzhong",
                            "xueweiName": "膻中"
                        },
                        {
                            "xueweiCode": "fengchi",
                            "xueweiName": "风池"
                        },
                        {
                            "xueweiCode": "chize",
                            "xueweiName": "尺泽"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "肺炎1-大椎",
                            "description": "用拇指按揉大椎1分钟，力度要轻。"
                        },
                        {
                            "imgUrlName": "肺炎2-膻中",
                            "description": "用中间三指的指腹轻轻按压膻中1分钟。"
                        },
                        {
                            "imgUrlName": "肺炎3-风池",
                            "description": "用两手拇指抵住风池，左右同时按压1-3分钟"
                        },
                        {
                            "imgUrlName": "肺炎4-尺泽",
                            "description": "用拇指指端按揉尺泽3分钟，力度适中。"
                        }
                    ],
                    "classicalSymptom": "呼吸急促、持久干咳、单边胸痛。"
                },
                {
                    "name": "慢性支气管炎",
                    "diseaseCode": "manxingzhiqiguanyan",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "feiyu",
                            "xueweiName": "肺俞"
                        },
                        {
                            "xueweiCode": "shenyu",
                            "xueweiName": "肾俞"
                        },
                        {
                            "xueweiCode": "zhongfu",
                            "xueweiName": "中府"
                        },
                        {
                            "xueweiCode": "hegu",
                            "xueweiName": "合谷"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "慢性支气管炎1-肺俞",
                            "description": "用拇指按揉肺俞3分钟，力度适中。"
                        },
                        {
                            "imgUrlName": "慢性支气管炎2-肾俞",
                            "description": "用双手拇指点按肾俞30次，力度适中。"
                        },
                        {
                            "imgUrlName": "慢性支气管炎3-中府",
                            "description": "中间三指并拢，轻轻按揉中府2-3分钟。"
                        },
                        {
                            "imgUrlName": "慢性支气管炎4-合谷",
                            "description": "用拇指和食指捏按合谷30次，适当加力。"
                        }
                    ],
                    "classicalSymptom": "终年咳嗽、咳痰不停、冬秋加剧。"
                }
            ]
        },
        {
            "name": "消化科",
            "imgUrl": "xiaohuake",
            "clickedImgUrl": "xiaohuake2",
            "keShiCode": "xiaohuake",
            "disease": [
                {
                    "name": "脂肪肝",
                    "diseaseCode": "zhifanggan",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "ganyu",
                            "xueweiName": "肝俞"
                        },
                        {
                            "xueweiCode": "piyu",
                            "xueweiName": "脾俞"
                        },
                        {
                            "xueweiCode": "zusanli",
                            "xueweiName": "足三里"
                        },
                        {
                            "xueweiCode": "sanyinjiao",
                            "xueweiName": "三阴交"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "脂肪肝1-肝俞",
                            "description": "用双手的拇指同时按压两侧肝俞20次，可边按边转圈。"
                        },
                        {
                            "imgUrlName": "脂肪肝2-脾俞",
                            "description": "用双手的拇指同时按压两侧脾俞20次，可边按边转圈。"
                        },
                        {
                            "imgUrlName": "脂肪肝3-足三里",
                            "description": "用拇指指腹重力按压足三里1-3分钟。"
                        },
                        {
                            "imgUrlName": "脂肪肝4-三阴交",
                            "description": "用拇指指腹均匀地按压三阴交2分钟。"
                        }
                    ],
                    "classicalSymptom": "消化不良、肝区隐痛、神疲乏力。"
                },
                {
                    "name": "慢性胆囊炎",
                    "diseaseCode": "manxingdannangyan",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "danyu",
                            "xueweiName": "胆俞"
                        },
                        {
                            "xueweiCode": "waiguan",
                            "xueweiName": "外关"
                        },
                        {
                            "xueweiCode": "yanglingquan",
                            "xueweiName": "阳陵泉"
                        },
                        {
                            "xueweiCode": "dannang",
                            "xueweiName": "胆囊"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "慢性胆囊炎1-胆俞",
                            "description": "用拇指指腹按揉胆俞1-3分钟。"
                        },
                        {
                            "imgUrlName": "慢性胆囊炎2-外关",
                            "description": "用拇指点按外关20次，力度适中。"
                        },
                        {
                            "imgUrlName": "慢性胆囊炎3-阳陵泉",
                            "description": "用拇指指端按揉阳陵泉100次，力度稍重。"
                        },
                        {
                            "imgUrlName": "慢性胆囊炎4-胆囊",
                            "description": "用拇指指端按揉胆囊3分钟，用力均衡。"
                        }
                    ],
                    "classicalSymptom": "消化不良、胆囊绞痛。"
                },
                {
                    "name": "打嗝",
                    "diseaseCode": "dage",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "zhongwan",
                            "xueweiName": "中脘"
                        },
                        {
                            "xueweiCode": "quepen",
                            "xueweiName": "缺盆"
                        },
                        {
                            "xueweiCode": "neiguan",
                            "xueweiName": "内关"
                        },
                        {
                            "xueweiCode": "zusanli",
                            "xueweiName": "足三里"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "打嗝1-中脘",
                            "description": "用拇指指端轻轻按压中脘20次。"
                        },
                        {
                            "imgUrlName": "打嗝2-缺盆",
                            "description": "用食指指腹按揉对侧缺盆1-3分钟。"
                        },
                        {
                            "imgUrlName": "打嗝3-内关",
                            "description": "用食指和拇指夹住手腕的内关，掐按3分钟。"
                        },
                        {
                            "imgUrlName": "打嗝4-足三里",
                            "description": "用拇指指腹按压足三里1-3分钟。"
                        }
                    ],
                    "classicalSymptom": "持续、反复打嗝。"
                },
                {
                    "name": "恶心呕吐",
                    "diseaseCode": "exinoutu",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "shanzhong",
                            "xueweiName": "膻中"
                        },
                        {
                            "xueweiCode": "tianshu",
                            "xueweiName": "天枢"
                        },
                        {
                            "xueweiCode": "neiguan",
                            "xueweiName": "内关"
                        },
                        {
                            "xueweiCode": "weiyu",
                            "xueweiName": "胃俞"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "恶心呕吐1-膻中",
                            "description": "用中间三指的指腹推下膻中100次。"
                        },
                        {
                            "imgUrlName": "恶心呕吐2-天枢",
                            "description": "用拇指指腹按揉天枢1分钟，适当用力。"
                        },
                        {
                            "imgUrlName": "恶心呕吐3-内关",
                            "description": "用拇指指端掐按内关20次，力度适中。"
                        },
                        {
                            "imgUrlName": "恶心呕吐4-胃俞",
                            "description": "用拇指指端按压胃俞20次。"
                        }
                    ],
                    "classicalSymptom": "皮肤苍白、出汗流涎、两眼发黑。"
                },
                {
                    "name": "腹泻",
                    "diseaseCode": "fuxie",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "dazhui",
                            "xueweiName": "大椎"
                        },
                        {
                            "xueweiCode": "zhongwan",
                            "xueweiName": "中脘"
                        },
                        {
                            "xueweiCode": "shenque",
                            "xueweiName": "神阙"
                        },
                        {
                            "xueweiCode": "zusanli",
                            "xueweiName": "足三里"
                        },
                        {
                            "xueweiCode": "shanglian",
                            "xueweiName": "上廉"
                        },
                        {
                            "xueweiCode": "xialian",
                            "xueweiName": "下廉"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "腹泻1-大椎",
                            "description": "用拇指指腹按揉大椎20次，其余四指置于脖间，力度要轻。"
                        },
                        {
                            "imgUrlName": "腹泻2-中脘神阙",
                            "description": "用掌心在中脘穴和神阙周围揉摩1-3分钟，直至腹部发热。"
                        },
                        {
                            "imgUrlName": "腹泻3-足三里",
                            "description": "用拇指指腹按压足三里20次，力度稍重。"
                        },
                        {
                            "imgUrlName": "腹泻4-上廉下廉",
                            "description": "用拇指指腹按揉上廉、下廉1-3分钟。"
                        }
                    ],
                    "classicalSymptom": "发热、腹痛、腹胀、呕吐。"
                },
                {
                    "name": "肠鸣腹胀",
                    "diseaseCode": "changmingfuzhang",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "zhongwan",
                            "xueweiName": "中脘"
                        },
                        {
                            "xueweiCode": "shenque",
                            "xueweiName": "神阙"
                        },
                        {
                            "xueweiCode": "tianshu",
                            "xueweiName": "天枢"
                        },
                        {
                            "xueweiCode": "zusanli",
                            "xueweiName": "足三里"
                        },
                        {
                            "xueweiCode": "gongsun",
                            "xueweiName": "公孙"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "肠鸣腹胀1-中脘",
                            "description": "用拇指或中指轻轻点按中脘1分钟。"
                        },
                        {
                            "imgUrlName": "肠鸣腹胀2-神阙天枢",
                            "description": "用掌心按摩神阙、天枢，直至腹部发热。"
                        },
                        {
                            "imgUrlName": "肠鸣腹胀3-足三里",
                            "description": "用拇指重力按压足三里20次。"
                        },
                        {
                            "imgUrlName": "肠鸣腹胀4-公孙",
                            "description": "用拇指指腹按揉两侧公孙100次，两侧可同时进行。"
                        }
                    ],
                    "classicalSymptom": "嗳气、呕吐、便秘、矢气。"
                },
                {
                    "name": "慢性胃炎",
                    "diseaseCode": "manxingweiyan",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "zusanli",
                            "xueweiName": "足三里"
                        },
                        {
                            "xueweiCode": "sanyinjiao",
                            "xueweiName": "三阴交"
                        },
                        {
                            "xueweiCode": "zhongwan",
                            "xueweiName": "中脘"
                        },
                        {
                            "xueweiCode": "weiyu",
                            "xueweiName": "胃俞"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "慢性胃炎1-足三里",
                            "description": "用拇指指端按压足三里，左右各3分钟。"
                        },
                        {
                            "imgUrlName": "慢性胃炎2-三阴交",
                            "description": "用拇指指端用力按压三阴交，左右各3分钟。"
                        },
                        {
                            "imgUrlName": "慢性胃炎3-中脘",
                            "description": "中间三指并拢，用指腹按揉中脘3分钟。"
                        },
                        {
                            "imgUrlName": "慢性胃炎4-胃俞",
                            "description": "双手拇指用力按压背部的胃俞10次。"
                        }
                    ],
                    "classicalSymptom": "上腹隐痛、食欲减退、餐后饱胀。"
                },
                {
                    "name": "胃下垂",
                    "diseaseCode": "weixiachui",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "shenque",
                            "xueweiName": "神阙"
                        },
                        {
                            "xueweiCode": "qihai",
                            "xueweiName": "气海"
                        },
                        {
                            "xueweiCode": "weiyu",
                            "xueweiName": "胃俞"
                        },
                        {
                            "xueweiCode": "zusanli",
                            "xueweiName": "足三里"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "胃下垂1-神阙",
                            "description": "两手掌相叠，自神阙向左上腹推抹100次。"
                        },
                        {
                            "imgUrlName": "胃下垂2-气海",
                            "description": "中间三指并拢，用指腹按揉腹部气海1分钟。"
                        },
                        {
                            "imgUrlName": "胃下垂3-胃俞",
                            "description": "用双手拇指用力按压胃俞20次。"
                        },
                        {
                            "imgUrlName": "胃下垂4-足三里",
                            "description": "用拇指按压两侧足三里各1分钟。"
                        }
                    ],
                    "classicalSymptom": "胃痛、恶心、腹胀、嗳气。"
                },
                {
                    "name": "十二指肠溃疡",
                    "diseaseCode": "shierzhichangkuiyang",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "zusanli",
                            "xueweiName": "足三里"
                        },
                        {
                            "xueweiCode": "weiyu",
                            "xueweiName": "胃俞"
                        },
                        {
                            "xueweiCode": "sanyinjiao",
                            "xueweiName": "三阴交"
                        },
                        {
                            "xueweiCode": "zhongwan",
                            "xueweiName": "中脘"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "十二指肠溃疡1-足三里",
                            "description": "用拇指指端重按足三里100次。"
                        },
                        {
                            "imgUrlName": "十二指肠溃疡2-胃俞",
                            "description": "双手拇指同时按压胃俞20次。"
                        },
                        {
                            "imgUrlName": "十二指肠溃疡3-三阴交",
                            "description": "拇指用力按压三阴交20次。"
                        },
                        {
                            "imgUrlName": "十二指肠溃疡4-中脘",
                            "description": "用中间三指的指腹摩中脘2-3分钟。"
                        }
                    ],
                    "classicalSymptom": "饥饿不适、饱胀嗳气、上腹疼痛。"
                }
            ]
        },
        {
            "name": "肛肠科",
            "imgUrl": "gangchangke",
            "clickedImgUrl": "gangchangke2",
            "keShiCode": "gangchangke",
            "disease": [
                {
                    "name": "便秘",
                    "diseaseCode": "bianmi",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "tianshu",
                            "xueweiName": "天枢"
                        },
                        {
                            "xueweiCode": "dachangyu",
                            "xueweiName": "大肠俞"
                        },
                        {
                            "xueweiCode": "zhigou",
                            "xueweiName": "支沟"
                        },
                        {
                            "xueweiCode": "shangjuxu",
                            "xueweiName": "上巨虚"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "便秘1-天枢",
                            "description": "用拇指指腹按揉天枢1分钟，可两侧同时按压。"
                        },
                        {
                            "imgUrlName": "便秘2-大肠俞",
                            "description": "用双手拇指点按大肠俞20次，力度适中。"
                        },
                        {
                            "imgUrlName": "便秘3-支沟",
                            "description": "用拇指指腹按揉支沟1分钟，以产生酸胀感为宜，双手交替进行。"
                        },
                        {
                            "imgUrlName": "便秘4-上巨虚",
                            "description": "用拇指略微用力按压上巨虚，以略感疼痛为佳，按住5秒后松开，反复10次。"
                        }
                    ],
                    "classicalSymptom": "粪质干燥、排出困难、次数减少。"
                },
                {
                    "name": "痔疮",
                    "diseaseCode": "zhichuang",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "zhangqiang",
                            "xueweiName": "长强"
                        },
                        {
                            "xueweiCode": "chengshan",
                            "xueweiName": "承山"
                        },
                        {
                            "xueweiCode": "baihui",
                            "xueweiName": "百会"
                        },
                        {
                            "xueweiCode": "yongquan",
                            "xueweiName": "涌泉"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "痔疮1-长强",
                            "description": "用中指指端按揉长强3分钟。"
                        },
                        {
                            "imgUrlName": "痔疮2-承山",
                            "description": "取跪姿，将拳头放在承山的位置，然后用大腿夹紧，刺激3-5分钟。"
                        },
                        {
                            "imgUrlName": "痔疮3-百会",
                            "description": "用食指和中指指端按揉百会约3分钟。"
                        },
                        {
                            "imgUrlName": "痔疮4-涌泉",
                            "description": "用手掌搓擦足底涌泉3-5分钟，直至脚心发热。"
                        }
                    ],
                    "classicalSymptom": "无痛性便血。痔块脱垂时，可有胀痛。"
                }
            ]
        },
        {
            "name": "皮肤科",
            "imgUrl": "pifuke",
            "clickedImgUrl": "pifuke2",
            "keShiCode": "pifuke",
            "disease": [
                {
                    "name": "皮肤瘙痒症",
                    "diseaseCode": "pifusaoyangzheng",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "quchi",
                            "xueweiName": "曲池"
                        },
                        {
                            "xueweiCode": "shenmen",
                            "xueweiName": "神门"
                        },
                        {
                            "xueweiCode": "xuehai",
                            "xueweiName": "血海"
                        },
                        {
                            "xueweiCode": "sanyinjiao",
                            "xueweiName": "三阴交"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "皮肤瘙痒症1-曲池",
                            "description": "用拇指指腹用力按压曲池3-5分钟。"
                        },
                        {
                            "imgUrlName": "皮肤瘙痒症2-神门",
                            "description": "用拇指指腹按揉神门2分钟。"
                        },
                        {
                            "imgUrlName": "皮肤瘙痒症3-血海",
                            "description": "用拇指指腹按揉血海100次。"
                        },
                        {
                            "imgUrlName": "皮肤瘙痒症4-三阴交",
                            "description": "用拇指掐按三阴交50次，力度稍大。"
                        }
                    ],
                    "classicalSymptom": "皮肤瘙痒、抓后留痕、色素沉着。"
                },
                {
                    "name": "湿疹",
                    "diseaseCode": "shizhen",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "piyu",
                            "xueweiName": "脾俞"
                        },
                        {
                            "xueweiCode": "yinlingquan",
                            "xueweiName": "阴陵泉"
                        },
                        {
                            "xueweiCode": "quchi",
                            "xueweiName": "曲池"
                        },
                        {
                            "xueweiCode": "sanyinjiao",
                            "xueweiName": "三阴交"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "湿疹1-脾俞",
                            "description": "用双手拇指按压脾俞1-3分钟，力度适中。"
                        },
                        {
                            "imgUrlName": "湿疹2-阴陵泉",
                            "description": "双手的拇指同时按压两侧的阴陵泉100次。"
                        },
                        {
                            "imgUrlName": "湿疹3-曲池",
                            "description": "用拇指指端点按曲池1分钟，力度稍大。"
                        },
                        {
                            "imgUrlName": "湿疹4-三阴交",
                            "description": "用拇指用力按揉三阴交1分钟，两侧可同时进行。"
                        }
                    ],
                    "classicalSymptom": "成片红斑、密集丘疹、重则水疱。"
                },
                {
                    "name": "痤疮",
                    "diseaseCode": "cuochuang",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "xiaguan",
                            "xueweiName": "下关"
                        },
                        {
                            "xueweiCode": "chize",
                            "xueweiName": "尺泽"
                        },
                        {
                            "xueweiCode": "tianshu",
                            "xueweiName": "天枢"
                        },
                        {
                            "xueweiCode": "neiting",
                            "xueweiName": "内庭"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "痤疮1-下关",
                            "description": "用双手食指指腹轻轻按揉下关1分钟。"
                        },
                        {
                            "imgUrlName": "痤疮2-尺泽",
                            "description": "用拇指指腹按揉尺泽100次。"
                        },
                        {
                            "imgUrlName": "痤疮3-天枢",
                            "description": "用双手的拇指指腹同时按揉两侧天枢1分钟。"
                        },
                        {
                            "imgUrlName": "痤疮4-内庭",
                            "description": "用拇指指腹重力按压内庭1-3分钟。"
                        }
                    ],
                    "classicalSymptom": "粉刺、丘疹、脓疱。"
                },
                {
                    "name": "荨麻疹",
                    "diseaseCode": "qianmazhen",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "quchi",
                            "xueweiName": "曲池"
                        },
                        {
                            "xueweiCode": "hegu",
                            "xueweiName": "合谷"
                        },
                        {
                            "xueweiCode": "yinlingquan",
                            "xueweiName": "阴陵泉"
                        },
                        {
                            "xueweiCode": "xuehai",
                            "xueweiName": "血海"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "荨麻疹1-曲池",
                            "description": "用拇指指端按揉曲池2-3分钟。"
                        },
                        {
                            "imgUrlName": "荨麻疹2-合谷",
                            "description": "用拇指和食指夹住合谷，用力按揉1-3分钟。"
                        },
                        {
                            "imgUrlName": "荨麻疹3-阴陵泉",
                            "description": "用拇指指腹按压阴陵泉20次，力度适中。"
                        },
                        {
                            "imgUrlName": "荨麻疹4-血海",
                            "description": "用拇指指腹按揉血海100-300次。"
                        }
                    ],
                    "classicalSymptom": "风疹发痒、此起彼伏、伴麻刺感、全身不适。"
                },
                {
                    "name": "黄褐斑",
                    "diseaseCode": "huangheban",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "shenyu",
                            "xueweiName": "肾俞"
                        },
                        {
                            "xueweiCode": "xuehai",
                            "xueweiName": "血海"
                        },
                        {
                            "xueweiCode": "fuliu",
                            "xueweiName": "复溜"
                        },
                        {
                            "xueweiCode": "taichong",
                            "xueweiName": "太冲"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "黄褐斑1-肾俞",
                            "description": "用双手的拇指指端按压肾俞20次"
                        },
                        {
                            "imgUrlName": "黄褐斑2-血海",
                            "description": "用拇指指腹按压血海1-3分钟。"
                        },
                        {
                            "imgUrlName": "黄褐斑3-复溜",
                            "description": "用拇指指腹按揉复溜1分钟。"
                        },
                        {
                            "imgUrlName": "黄褐斑4-太冲",
                            "description": "用食指指腹按压太冲1分钟，力度稍大。"
                        }
                    ],
                    "classicalSymptom": "枯暗无泽、表面光滑、无痛无痒。"
                }
            ]
        },
        {
            "name": "骨伤科",
            "imgUrl": "gushangke",
            "clickedImgUrl": "gushangke2",
            "keShiCode": "gushangke",
            "disease": [
                {
                    "name": "坐骨神经痛",
                    "diseaseCode": "zuogushenjingtong",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "huantiao",
                            "xueweiName": "环跳"
                        },
                        {
                            "xueweiCode": "yanglingquan",
                            "xueweiName": "阳陵泉"
                        },
                        {
                            "xueweiCode": "weizhong",
                            "xueweiName": "委中"
                        },
                        {
                            "xueweiCode": "chengshan",
                            "xueweiName": "承山"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "坐骨神经痛1-环跳",
                            "description": "用中间三指的指端按揉患侧环跳100次，用力稍重。"
                        },
                        {
                            "imgUrlName": "坐骨神经痛2-阳陵泉",
                            "description": "用拇指用力点按阳陵泉100次。"
                        },
                        {
                            "imgUrlName": "坐骨神经痛3-委中",
                            "description": "用拇指点按委中30次，力度以可以耐受为度。"
                        },
                        {
                            "imgUrlName": "坐骨神经痛4-承山",
                            "description": "用拇指指腹按揉承山100次，用力稍重。"
                        }
                    ],
                    "classicalSymptom": "患侧疼痛、感觉减退、夜间加剧。"
                },
                {
                    "name": "颈椎病",
                    "diseaseCode": "jingzhuibing",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "fengchi",
                            "xueweiName": "风池"
                        },
                        {
                            "xueweiCode": "dazhui",
                            "xueweiName": "大椎"
                        },
                        {
                            "xueweiCode": "jianjing",
                            "xueweiName": "肩井"
                        },
                        {
                            "xueweiCode": "shousanli",
                            "xueweiName": "手三里"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "颈椎病1-风池",
                            "description": "用两手拇指同时按揉两侧风池1-3分钟，力度以全身酸透为宜。"
                        },
                        {
                            "imgUrlName": "颈椎病2-大椎",
                            "description": "用拇指和食指沿风池穴向下拿捏至大椎，约1分钟。"
                        },
                        {
                            "imgUrlName": "颈椎病3-肩井",
                            "description": "用双手中指指腹按压同侧肩井，由轻到重按压10次。"
                        },
                        {
                            "imgUrlName": "颈椎病4-手三里",
                            "description": "用拇指指腹按揉手三里1-3分钟。"
                        }
                    ],
                    "classicalSymptom": "颈部僵硬、手臂酸麻、或伴头晕。"
                },
                {
                    "name": "腰椎间盘突出症",
                    "diseaseCode": "yaozhuijianpantuchuzheng",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "dachangyu",
                            "xueweiName": "大肠俞"
                        },
                        {
                            "xueweiCode": "weizhong",
                            "xueweiName": "委中"
                        },
                        {
                            "xueweiCode": "yanglingquan",
                            "xueweiName": "阳陵泉"
                        },
                        {
                            "xueweiCode": "yaotongdian",
                            "xueweiName": "腰痛点"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "腰椎间盘突出症1-大肠俞",
                            "description": "用双手拇指分别按压两侧的大肠俞20次。"
                        },
                        {
                            "imgUrlName": "腰椎间盘突出症2-委中",
                            "description": "用拇指点按委中30次，力度以可以耐受为度。"
                        },
                        {
                            "imgUrlName": "腰椎间盘突出症3-阳陵泉",
                            "description": "用拇指点按阳陵泉30次，力度适中。"
                        },
                        {
                            "imgUrlName": "腰椎间盘突出症4-腰痛点",
                            "description": "疼痛发作时，用拇指揉按手背的腰痛点3分钟。"
                        }
                    ],
                    "classicalSymptom": "腰腿疼痛、下肢麻木、下肢发凉。"
                },
                {
                    "name": "急性腰扭伤",
                    "diseaseCode": "jixingyaoniushang",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "weizhong",
                            "xueweiName": "委中"
                        },
                        {
                            "xueweiCode": "yaotongdian",
                            "xueweiName": "腰痛点"
                        },
                        {
                            "xueweiCode": "taixi",
                            "xueweiName": "太溪"
                        },
                        {
                            "xueweiCode": "kunlun",
                            "xueweiName": "昆仑"
                        },
                        {
                            "xueweiCode": "huantiao",
                            "xueweiName": "环跳"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "急性腰扭伤1-委中",
                            "description": "用拇指点按委中30次，力度以能够耐受为度。"
                        },
                        {
                            "imgUrlName": "急性腰扭伤2-腰痛点",
                            "description": "用拇指揉按手背的腰痛点3分钟。"
                        },
                        {
                            "imgUrlName": "急性腰扭伤3-太溪昆仑",
                            "description": "用拇指、中指和食指指腹同时拿捏太溪和昆仑30次，力度要重。"
                        },
                        {
                            "imgUrlName": "急性腰扭伤4-环跳",
                            "description": "用双手拇指指腹点按环跳3分钟。"
                        }
                    ],
                    "classicalSymptom": "腰部僵硬、疼痛剧烈、不能活动。"
                },
                {
                    "name": "肩周炎",
                    "diseaseCode": "jianzhouyan",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "jianyu",
                            "xueweiName": "肩髃"
                        },
                        {
                            "xueweiCode": "jianzhen",
                            "xueweiName": "肩贞"
                        },
                        {
                            "xueweiCode": "jianliao",
                            "xueweiName": "肩髎"
                        },
                        {
                            "xueweiCode": "jianjing",
                            "xueweiName": "肩井"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "肩周炎1-肩髃",
                            "description": "用食指和中指指腹点按肩髃30次，力度适中。"
                        },
                        {
                            "imgUrlName": "肩周炎2-肩贞",
                            "description": "用食指和中指指腹点按肩贞30次，力度适中。"
                        },
                        {
                            "imgUrlName": "肩周炎3-肩髎",
                            "description": "食指和中指并拢，用二指指腹点按肩髎30次。"
                        },
                        {
                            "imgUrlName": "肩周炎4-肩井",
                            "description": "用中指指腹揉按肩井3分钟。"
                        }
                    ],
                    "classicalSymptom": "肩部疼痛、活动受限、患侧怕冷。"
                },
                {
                    "name": "腰肌劳损",
                    "diseaseCode": "yaojilaosun",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "yaotongdian",
                            "xueweiName": "腰痛点"
                        },
                        {
                            "xueweiCode": "yanglingquan",
                            "xueweiName": "阳陵泉"
                        },
                        {
                            "xueweiCode": "yaoyan",
                            "xueweiName": "腰眼"
                        },
                        {
                            "xueweiCode": "shenyu",
                            "xueweiName": "肾俞"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "腰肌劳损1-腰痛点",
                            "description": "用拇指指端按揉手背第4、第5掌骨间的腰痛点，左右各30次。"
                        },
                        {
                            "imgUrlName": "腰肌劳损2-阳陵泉",
                            "description": "用拇指指端点按阳陵泉，双侧各按摩20次。"
                        },
                        {
                            "imgUrlName": "腰肌劳损3-腰眼",
                            "description": "用双手拇指点压腰眼1分钟。"
                        },
                        {
                            "imgUrlName": "腰肌劳损4-肾俞",
                            "description": "双手五指并拢，掌根自上而下反复斜擦两侧肾俞30-50次。"
                        }
                    ],
                    "classicalSymptom": "腰部疼痛、时轻时重、缠绵不愈。"
                },
                {
                    "name": "小腿抽筋",
                    "diseaseCode": "xiaotuichoujin",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "chengshan",
                            "xueweiName": "承山"
                        },
                        {
                            "xueweiCode": "zusanli",
                            "xueweiName": "足三里"
                        },
                        {
                            "xueweiCode": "yanglingquan",
                            "xueweiName": "阳陵泉"
                        },
                        {
                            "xueweiCode": "taixi",
                            "xueweiName": "太溪"
                        },
                        {
                            "xueweiCode": "kunlun",
                            "xueweiName": "昆仑"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "小腿抽筋1-承山",
                            "description": "用拇指点揉承山约2分钟，以有酸胀感为宜。"
                        },
                        {
                            "imgUrlName": "小腿抽筋2-足三里",
                            "description": "用拇指点按足三里30次，力度稍重，两侧可同时进行。"
                        },
                        {
                            "imgUrlName": "小腿抽筋3-阳陵泉",
                            "description": "用拇指顺时针方向按揉阳陵泉1分钟，力度适中。"
                        },
                        {
                            "imgUrlName": "小腿抽筋4-太溪昆仑",
                            "description": "以拇指与食中指相对用力拿捏腓肠肌至跟腱太溪、昆仑处，重复3-5遍。"
                        }
                    ],
                    "classicalSymptom": "肌肉强直、痉挛僵硬、疼痛骤作。"
                },
                {
                    "name": "足跟痛",
                    "diseaseCode": "zugentong",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "dazhong",
                            "xueweiName": "大钟"
                        },
                        {
                            "xueweiCode": "kunlun",
                            "xueweiName": "昆仑"
                        },
                        {
                            "xueweiCode": "taixi",
                            "xueweiName": "太溪"
                        },
                        {
                            "xueweiCode": "pucan",
                            "xueweiName": "仆参"
                        },
                        {
                            "xueweiCode": "yongquan",
                            "xueweiName": "涌泉"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "足跟痛1-大钟",
                            "description": "用拇指点按大钟50次，力度适中。"
                        },
                        {
                            "imgUrlName": "足跟痛2-昆仑太溪",
                            "description": "以拇指与食中指相对用力，同时拿捏昆仑、太溪1-2分钟。"
                        },
                        {
                            "imgUrlName": "足跟痛3-仆参",
                            "description": "用拇指指端点按仆参1-2分钟。"
                        },
                        {
                            "imgUrlName": "足跟痛4-涌泉",
                            "description": "用拇指指腹从涌泉向足趾方向推行6-8次。"
                        }
                    ],
                    "classicalSymptom": "足跟疼痛、不红不肿、行走不便。"
                }
            ]
        },
        {
            "name": "五官科",
            "imgUrl": "wuguanke",
            "clickedImgUrl": "wuguanke2",
            "keShiCode": "wuguanke",
            "disease": [
                {
                    "name": "白内障",
                    "diseaseCode": "baineizhang",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "taiyang",
                            "xueweiName": "太阳"
                        },
                        {
                            "xueweiCode": "taiyang",
                            "xueweiName": "太阳"
                        },
                        {
                            "xueweiCode": "fengchi",
                            "xueweiName": "风池"
                        },
                        {
                            "xueweiCode": "zanzhu",
                            "xueweiName": "攒竹"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "白内障1-太阳",
                            "description": "双手食指弯曲，从内向外抹刮眉弓至太阳，重复2分钟。"
                        },
                        {
                            "imgUrlName": "白内障2-太阳",
                            "description": "中指和无名指并拢，用二指的指腹按揉两侧太阳2分钟。"
                        },
                        {
                            "imgUrlName": "白内障3-风池",
                            "description": "用双手拇指按揉风池2分钟，力度以酸胀透遍全身为宜。"
                        },
                        {
                            "imgUrlName": "白内障4-攒竹",
                            "description": "用双手食指按压攒竹30次，力度宜轻。"
                        }
                    ],
                    "classicalSymptom": "视物模糊、视物重影、视物变形。"
                },
                {
                    "name": "耳鸣",
                    "diseaseCode": "erming",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "tinggong",
                            "xueweiName": "听宫"
                        },
                        {
                            "xueweiCode": "zhongzhu",
                            "xueweiName": "中渚"
                        },
                        {
                            "xueweiCode": "zusanli",
                            "xueweiName": "足三里"
                        },
                        {
                            "xueweiCode": "taixi",
                            "xueweiName": "太溪"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "耳鸣1-听宫",
                            "description": "用双手中指指腹按压听宫1分钟。"
                        },
                        {
                            "imgUrlName": "耳鸣2-中渚",
                            "description": "用拇指和食指揉捏中渚1分钟。"
                        },
                        {
                            "imgUrlName": "耳鸣3-足三里",
                            "description": "用拇指指腹按压足三里20-30次，力度稍重。"
                        },
                        {
                            "imgUrlName": "耳鸣4-太溪",
                            "description": "用拇指指腹按压太溪10-15次，力度稍重。"
                        }
                    ],
                    "classicalSymptom": "耳聋、眩晕、头痛。"
                },
                {
                    "name": "牙痛",
                    "diseaseCode": "yatong",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "xiaguan",
                            "xueweiName": "下关"
                        },
                        {
                            "xueweiCode": "jiache",
                            "xueweiName": "颊车"
                        },
                        {
                            "xueweiCode": "hegu",
                            "xueweiName": "合谷"
                        },
                        {
                            "xueweiCode": "xiangu",
                            "xueweiName": "陷谷"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "牙痛1-下关",
                            "description": "用食指指腹按揉下关2分钟。"
                        },
                        {
                            "imgUrlName": "牙痛2-颊车",
                            "description": "用食指指腹按揉颊车2分钟。"
                        },
                        {
                            "imgUrlName": "牙痛3-合谷",
                            "description": "用拇指用力按压合谷1分钟。"
                        },
                        {
                            "imgUrlName": "牙痛4-陷谷",
                            "description": "用拇指指端按揉陷谷1-2分钟，力度稍重。"
                        }
                    ],
                    "classicalSymptom": "牙龈红肿、颌面疼痛、口渴口臭。"
                },
                {
                    "name": "咽喉肿痛",
                    "diseaseCode": "yanhouzhongtong",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "tiantu",
                            "xueweiName": "天突"
                        },
                        {
                            "xueweiCode": "renying",
                            "xueweiName": "人迎"
                        },
                        {
                            "xueweiCode": "yuji",
                            "xueweiName": "鱼际"
                        },
                        {
                            "xueweiCode": "zhaohai",
                            "xueweiName": "照海"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "咽喉肿痛1-天突",
                            "description": "用食指按压天突3分钟，力度以感到酸胀为宜。"
                        },
                        {
                            "imgUrlName": "咽喉肿痛2-人迎",
                            "description": "用拇指和食指同时按压两侧的人迎1-3分钟。"
                        },
                        {
                            "imgUrlName": "咽喉肿痛3-鱼际",
                            "description": "用拇指指端按压鱼际3分钟，力度适中。"
                        },
                        {
                            "imgUrlName": "咽喉肿痛4-照海",
                            "description": "用拇指指端点揉照海3分钟，力度以产生酸胀感为宜。"
                        }
                    ],
                    "classicalSymptom": "咽肿喉痛、吞咽困难、舌红苔黄。"
                },
                {
                    "name": "慢性咽炎",
                    "diseaseCode": "manxingyanyan",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "yifeng",
                            "xueweiName": "翳风"
                        },
                        {
                            "xueweiCode": "renying",
                            "xueweiName": "人迎"
                        },
                        {
                            "xueweiCode": "neiguan",
                            "xueweiName": "内关"
                        },
                        {
                            "xueweiCode": "zhaohai",
                            "xueweiName": "照海"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "慢性咽炎1-翳风",
                            "description": "双手食指同时按压翳风1分钟，力度较轻。"
                        },
                        {
                            "imgUrlName": "慢性咽炎2-人迎",
                            "description": "用拇指和食指同时按压两侧的人迎1分钟。"
                        },
                        {
                            "imgUrlName": "慢性咽炎3-内关",
                            "description": "用拇指指端按压内关1-3分钟，适当用力。"
                        },
                        {
                            "imgUrlName": "慢性咽炎4-照海",
                            "description": "用拇指指端点按照海50-100次，力度以局部酸胀为宜。"
                        }
                    ],
                    "classicalSymptom": "咽部不适、干咳恶心、白色痰液。"
                },
                {
                    "name": "过敏性鼻炎",
                    "diseaseCode": "guominxingbiyan",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "taiyang",
                            "xueweiName": "太阳"
                        },
                        {
                            "xueweiCode": "yintang",
                            "xueweiName": "印堂"
                        },
                        {
                            "xueweiCode": "yingxiang",
                            "xueweiName": "迎香"
                        },
                        {
                            "xueweiCode": "fengchi",
                            "xueweiName": "风池"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "过敏性鼻炎1-太阳",
                            "description": "用食指指腹按揉太阳2分钟。"
                        },
                        {
                            "imgUrlName": "过敏性鼻炎2-印堂",
                            "description": "用双手中指指腹交替推印堂100次。"
                        },
                        {
                            "imgUrlName": "过敏性鼻炎3-迎香",
                            "description": "用食指和中指指端上下推擦迎香2分钟。"
                        },
                        {
                            "imgUrlName": "过敏性鼻炎4-风池",
                            "description": "双手拇指按揉风池2分钟。"
                        }
                    ],
                    "classicalSymptom": "喷嚏、鼻痒、流涕、鼻塞。"
                },
                {
                    "name": "慢性鼻炎",
                    "diseaseCode": "manxingbiyan",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "baihui",
                            "xueweiName": "百会"
                        },
                        {
                            "xueweiCode": "yingxiang",
                            "xueweiName": "迎香"
                        },
                        {
                            "xueweiCode": "yintang",
                            "xueweiName": "印堂"
                        },
                        {
                            "xueweiCode": "biyi",
                            "xueweiName": "鼻翼"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "慢性鼻炎1-百会",
                            "description": "用食指指腹顺时针揉百会1分钟。"
                        },
                        {
                            "imgUrlName": "慢性鼻炎2-迎香",
                            "description": "用双手食指同时按压迎香1分钟。"
                        },
                        {
                            "imgUrlName": "慢性鼻炎3-印堂",
                            "description": "用食指指腹按压印堂1分钟，力度要轻。"
                        },
                        {
                            "imgUrlName": "慢性鼻炎4-鼻翼",
                            "description": "用食指和中指指腹推擦两侧鼻翼100次。"
                        }
                    ],
                    "classicalSymptom": "鼻塞、多涕。"
                }
            ]
        },
        {
            "name": "内分泌科",
            "imgUrl": "neifenbi",
            "clickedImgUrl": "neifenbi2",
            "keShiCode": "neifenbi",
            "disease": [
                {
                    "name": "糖尿病",
                    "diseaseCode": "tangniaobing",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "qihai",
                            "xueweiName": "气海"
                        },
                        {
                            "xueweiCode": "weiwanxiayu",
                            "xueweiName": "胃脘下俞"
                        },
                        {
                            "xueweiCode": "xuehai",
                            "xueweiName": "血海"
                        },
                        {
                            "xueweiCode": "yifeng",
                            "xueweiName": "翳风"
                        },
                        {
                            "xueweiCode": "quepen",
                            "xueweiName": "缺盆"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "糖尿病1-气海",
                            "description": "用食指、中指、无名指轻轻按摩气海2分钟，以产生酸胀感为宜。"
                        },
                        {
                            "imgUrlName": "糖尿病2-胃脘下俞",
                            "description": "用食指指端轻轻叩击胃脘下俞2分钟。"
                        },
                        {
                            "imgUrlName": "糖尿病3-血海",
                            "description": "用拇指指腹均衡用力按压血海1分钟，配合呼吸，效果更好。"
                        },
                        {
                            "imgUrlName": "糖尿病4-桥弓",
                            "description": "用拇指指腹自上向下推桥弓（翳风与缺盆的连线）10-20次，左右交替进行。"
                        }
                    ],
                    "classicalSymptom": "多尿、多饮、多食、消瘦。"
                }
            ]
        },
        {
            "name": "风湿免疫科",
            "imgUrl": "fengshimianyike",
            "clickedImgUrl": "fengshimianyike2",
            "keShiCode": "fengshimianyike",
            "disease": [
                {
                    "name": "类风湿性关节炎",
                    "diseaseCode": "leifengshixingguanjieyan",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "fengchi",
                            "xueweiName": "风池"
                        },
                        {
                            "xueweiCode": "yangchi",
                            "xueweiName": "阳池"
                        },
                        {
                            "xueweiCode": "yinlingquan",
                            "xueweiName": "阴陵泉"
                        },
                        {
                            "xueweiCode": "kunlun",
                            "xueweiName": "昆仑"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "类风湿性关节炎1-风池",
                            "description": "用两手拇指同时按压两侧风池1-3分钟。"
                        },
                        {
                            "imgUrlName": "类风湿性关节炎2-阳池",
                            "description": "用中指指腹按揉阳池1分钟，力度适中。"
                        },
                        {
                            "imgUrlName": "类风湿性关节炎3-阴陵泉",
                            "description": "用拇指点按阴陵泉1分钟，力度适中。"
                        },
                        {
                            "imgUrlName": "类风湿性关节炎4-昆仑",
                            "description": "用拇指指尖按压昆仑3分钟。"
                        }
                    ],
                    "classicalSymptom": "关节疼痛、僵硬肿大、手足麻木。"
                }
            ]
        },
        {
            "name": "神经内科",
            "imgUrl": "shenjingneike",
            "clickedImgUrl": "shenjingneike2",
            "keShiCode": "shenjingneike",
            "disease": [
                {
                    "name": "中风后遗症",
                    "diseaseCode": "zhongfenghouyizheng",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "quchi",
                            "xueweiName": "曲池"
                        },
                        {
                            "xueweiCode": "zusanli",
                            "xueweiName": "足三里"
                        },
                        {
                            "xueweiCode": "sanyinjiao",
                            "xueweiName": "三阴交"
                        },
                        {
                            "xueweiCode": "yongquan",
                            "xueweiName": "涌泉"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "中风后遗症1-曲池",
                            "description": "用拇指指腹按揉患侧曲池100次。"
                        },
                        {
                            "imgUrlName": "中风后遗症2-足三里",
                            "description": "用拇指点揉足三里1分钟，力度稍重。"
                        },
                        {
                            "imgUrlName": "中风后遗症3-三阴交",
                            "description": "用拇指点揉三阴交1分钟，力度适中。"
                        },
                        {
                            "imgUrlName": "中风后遗症4-涌泉",
                            "description": "用手掌反复搓擦涌泉3分钟至脚心发热。"
                        }
                    ],
                    "classicalSymptom": "半边瘫痪、感觉减退、半边麻木。"
                },
                {
                    "name": "头痛",
                    "diseaseCode": "toutong",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "baihui",
                            "xueweiName": "百会"
                        },
                        {
                            "xueweiCode": "taiyang",
                            "xueweiName": "太阳"
                        },
                        {
                            "xueweiCode": "taichong",
                            "xueweiName": "太冲"
                        },
                        {
                            "xueweiCode": "hegu",
                            "xueweiName": "合谷"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "头痛1-百会",
                            "description": "用食指指腹适当用力按揉百会1分钟。"
                        },
                        {
                            "imgUrlName": "头痛2-太阳",
                            "description": "用双手的指腹按揉两侧太阳1分钟。"
                        },
                        {
                            "imgUrlName": "头痛3-太冲",
                            "description": "用拇指指腹点按太冲1分钟，力度适中。"
                        },
                        {
                            "imgUrlName": "头痛4-合谷",
                            "description": "用拇指和食指夹住合谷，用力按揉1分钟。"
                        }
                    ],
                    "classicalSymptom": "头部疼痛、有重压感、面红多汗。"
                },
                {
                    "name": "头晕",
                    "diseaseCode": "touyun",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "shenmen",
                            "xueweiName": "神门"
                        },
                        {
                            "xueweiCode": "fengchi",
                            "xueweiName": "风池"
                        },
                        {
                            "xueweiCode": "yanglingquan",
                            "xueweiName": "阳陵泉"
                        },
                        {
                            "xueweiCode": "yongquan",
                            "xueweiName": "涌泉"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "头晕1-神门",
                            "description": "用拇指按揉神门2分钟，力度适中。"
                        },
                        {
                            "imgUrlName": "头晕2-风池",
                            "description": "用双手拇指指端按揉风池1-2分钟，用力适中。"
                        },
                        {
                            "imgUrlName": "头晕3-阳陵泉",
                            "description": "用拇指指尖点按阳陵泉，双侧各按摩20次。"
                        },
                        {
                            "imgUrlName": "头晕4-涌泉",
                            "description": "用手掌反复搓涌泉3分钟，直至脚心发热。"
                        }
                    ],
                    "classicalSymptom": "头昏脑胀、头重脚轻、视物旋转。"
                },
                {
                    "name": "失眠",
                    "diseaseCode": "shimian",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "qianfajixian",
                            "xueweiName": "前发际线"
                        },
                        {
                            "xueweiCode": "taiyang",
                            "xueweiName": "太阳"
                        },
                        {
                            "xueweiCode": "sanyinjiao",
                            "xueweiName": "三阴交"
                        },
                        {
                            "xueweiCode": "yongquan",
                            "xueweiName": "涌泉"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "失眠1-前发际线",
                            "description": "双手五指张开，从前发际至后发际反复拿捏10次。"
                        },
                        {
                            "imgUrlName": "失眠2-太阳",
                            "description": "双手食指弯曲，抹刮眉弓至太阳2分钟。"
                        },
                        {
                            "imgUrlName": "失眠3-三阴交",
                            "description": "用拇指揉按三阴交2分钟，两侧可同时进行。"
                        },
                        {
                            "imgUrlName": "失眠4-涌泉",
                            "description": "用小鱼际擦热涌泉2分钟，力度稍重。"
                        }
                    ],
                    "classicalSymptom": "入睡困难、不能熟睡、多梦早醒。"
                },
                {
                    "name": "神经衰弱",
                    "diseaseCode": "shenjingshuairuo",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "baihui",
                            "xueweiName": "百会"
                        },
                        {
                            "xueweiCode": "fengchi",
                            "xueweiName": "风池"
                        },
                        {
                            "xueweiCode": "laogong",
                            "xueweiName": "劳宫"
                        },
                        {
                            "xueweiCode": "shenmen",
                            "xueweiName": "神门"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "神经衰弱1-百会",
                            "description": "用中指的指腹轻轻按压百会1分钟。"
                        },
                        {
                            "imgUrlName": "神经衰弱2-风池",
                            "description": "用拇指和食指拿捏风池30次，力度适中。"
                        },
                        {
                            "imgUrlName": "神经衰弱3-劳宫",
                            "description": "用拇指指腹按揉劳宫3分钟，力度适中。"
                        },
                        {
                            "imgUrlName": "神经衰弱4-神门",
                            "description": "用拇指和食指揉捏神门3分钟，力度适中。"
                        }
                    ],
                    "classicalSymptom": "烦躁易怒、神疲乏力、睡眠障碍。"
                },
                {
                    "name": "面神经麻痹",
                    "diseaseCode": "mianshenjingmabi",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "sizhukong",
                            "xueweiName": "丝竹空"
                        },
                        {
                            "xueweiCode": "sibai",
                            "xueweiName": "四白"
                        },
                        {
                            "xueweiCode": "dicang",
                            "xueweiName": "地仓"
                        },
                        {
                            "xueweiCode": "yifeng",
                            "xueweiName": "翳风"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "面神经麻痹1-丝竹空",
                            "description": "用双手食指轻轻按揉丝竹空1-3分钟。"
                        },
                        {
                            "imgUrlName": "面神经麻痹2-四白",
                            "description": "用双手食指轻轻按压四白1-3分钟。"
                        },
                        {
                            "imgUrlName": "面神经麻痹3-地仓",
                            "description": "用双手食指按揉地仓1-3分钟。"
                        },
                        {
                            "imgUrlName": "面神经麻痹4-翳风",
                            "description": "用食指指腹轻轻揉按翳风1-3分钟。"
                        }
                    ],
                    "classicalSymptom": "面颊不灵、口眼歪斜、眼裂扩大。"
                },
                {
                    "name": "三叉神经痛",
                    "diseaseCode": "sanchashenjingtong",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "sibai",
                            "xueweiName": "四白"
                        },
                        {
                            "xueweiCode": "quanliao",
                            "xueweiName": "颧髎"
                        },
                        {
                            "xueweiCode": "xiaguan",
                            "xueweiName": "下关"
                        },
                        {
                            "xueweiCode": "yifeng",
                            "xueweiName": "翳风"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "三叉神经痛1-四白",
                            "description": "用双手食指轻轻按揉四白1分钟。"
                        },
                        {
                            "imgUrlName": "三叉神经痛2-颧髎",
                            "description": "用食指指腹轻轻按压颧髎1-3分钟。"
                        },
                        {
                            "imgUrlName": "三叉神经痛3-下关",
                            "description": "用双手食指指腹按揉下关1分钟，力度适中。"
                        },
                        {
                            "imgUrlName": "三叉神经痛4-翳风",
                            "description": "用双手食指同时按压翳风1分钟。"
                        }
                    ],
                    "classicalSymptom": "骤然发作、没有先兆、多为一侧。"
                },
                {
                    "name": "偏头痛",
                    "diseaseCode": "piantoutong",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "taiyang",
                            "xueweiName": "太阳"
                        },
                        {
                            "xueweiCode": "lügu",
                            "xueweiName": "率谷"
                        },
                        {
                            "xueweiCode": "jianjing",
                            "xueweiName": "肩井"
                        },
                        {
                            "xueweiCode": "taichong",
                            "xueweiName": "太冲"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "偏头痛1-太阳",
                            "description": "用双手大鱼际按揉两侧太阳1分钟。"
                        },
                        {
                            "imgUrlName": "偏头痛2-率谷",
                            "description": "用大鱼际向后推率谷100次。"
                        },
                        {
                            "imgUrlName": "偏头痛3-肩井",
                            "description": "用手指按揉同侧肩井3-5分钟。"
                        },
                        {
                            "imgUrlName": "偏头痛4-太冲",
                            "description": "用食指指腹按压太冲5次，力度稍大。"
                        }
                    ],
                    "classicalSymptom": "恶心、呕吐、畏光、畏声。"
                }
            ]
        },
        {
            "name": "妇科",
            "imgUrl": "fuke",
            "clickedImgUrl": "fuke2",
            "keShiCode": "fuke",
            "disease": [
                {
                    "name": "更年期综合征",
                    "diseaseCode": "gengnianqizonghezheng",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "yintang",
                            "xueweiName": "印堂"
                        },
                        {
                            "xueweiCode": "piyu",
                            "xueweiName": "脾俞"
                        },
                        {
                            "xueweiCode": "sanyinjiao",
                            "xueweiName": "三阴交"
                        },
                        {
                            "xueweiCode": "baihui",
                            "xueweiName": "百会"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "更年期综合症1-印堂",
                            "description": "用食指指腹沿印堂向上推，反复做1分钟。"
                        },
                        {
                            "imgUrlName": "更年期综合症2-脾俞",
                            "description": "双手拇指用力按住脾俞，稍等片刻再猛然放开，反复做1分钟。"
                        },
                        {
                            "imgUrlName": "更年期综合症3-三阴交",
                            "description": "用拇指指腹按揉三阴交1分钟，适当用力。"
                        },
                        {
                            "imgUrlName": "更年期综合症4-百会",
                            "description": "用中间三指的指端叩击百会2-3分钟。"
                        }
                    ],
                    "classicalSymptom": "面色潮红、自汗、多食、焦虑。"
                },
                {
                    "name": "乳腺增生",
                    "diseaseCode": "ruxianzengsheng",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "jianjing",
                            "xueweiName": "肩井"
                        },
                        {
                            "xueweiCode": "shaofu",
                            "xueweiName": "少府"
                        },
                        {
                            "xueweiCode": "taichong",
                            "xueweiName": "太冲"
                        },
                        {
                            "xueweiCode": "dabao",
                            "xueweiName": "大包"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "乳腺增生1-肩井",
                            "description": "用拇指和其余四指拿捏肩井处肌肉30次。"
                        },
                        {
                            "imgUrlName": "乳腺增生2-少府",
                            "description": "用拇指指腹按揉少府3-5分钟。"
                        },
                        {
                            "imgUrlName": "乳腺增生3-太冲",
                            "description": "用食指指端按揉太冲30次，用力略重。"
                        },
                        {
                            "imgUrlName": "乳腺增生4-大包",
                            "description": "用中指指端勾点大包50-100次，用力稍重。"
                        }
                    ],
                    "classicalSymptom": "乳房肿胀、乳腺肿块、伴有疼痛。"
                },
                {
                    "name": "月经不调",
                    "diseaseCode": "yuejingbudiao",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "shenyu",
                            "xueweiName": "肾俞"
                        },
                        {
                            "xueweiCode": "sanyinjiao",
                            "xueweiName": "三阴交"
                        },
                        {
                            "xueweiCode": "xuehai",
                            "xueweiName": "血海"
                        },
                        {
                            "xueweiCode": "diji",
                            "xueweiName": "地机"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "月经不调1-肾俞",
                            "description": "用两手叉腰，拇指按揉两侧肾俞1分钟。"
                        },
                        {
                            "imgUrlName": "月经不调2-三阴交",
                            "description": "用拇指指腹点按三阴交1分钟。"
                        },
                        {
                            "imgUrlName": "月经不调3-血海",
                            "description": "用拇指指端点按血海1分钟，力度要均衡。"
                        },
                        {
                            "imgUrlName": "月经不调4-地机",
                            "description": "用拇指指腹按揉地机1分钟，力度适中。"
                        }
                    ],
                    "classicalSymptom": "周期异常、出血量少、痛经、抑郁。"
                },
                {
                    "name": "痛经",
                    "diseaseCode": "tongjing",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "qihai",
                            "xueweiName": "气海"
                        },
                        {
                            "xueweiCode": "shenyu",
                            "xueweiName": "肾俞"
                        },
                        {
                            "xueweiCode": "xuehai",
                            "xueweiName": "血海"
                        },
                        {
                            "xueweiCode": "ligou",
                            "xueweiName": "蠡沟"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "痛经1-气海",
                            "description": "中间三指并拢，用手掌顺时针方向在气海按摩30圈。"
                        },
                        {
                            "imgUrlName": "痛经2-肾俞",
                            "description": "双手叉腰，用拇指点压两侧肾俞1分钟。"
                        },
                        {
                            "imgUrlName": "痛经3-血海",
                            "description": "用拇指指腹按压血海2分钟，力度适度。"
                        },
                        {
                            "imgUrlName": "痛经4-蠡沟",
                            "description": "以拇指指端用力点按蠡沟20次。"
                        }
                    ],
                    "classicalSymptom": "腰腹疼痛、痛及腰骶、手足厥冷。"
                },
                {
                    "name": "闭经",
                    "diseaseCode": "bijing",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "shenyu",
                            "xueweiName": "肾俞"
                        },
                        {
                            "xueweiCode": "xuehai",
                            "xueweiName": "血海"
                        },
                        {
                            "xueweiCode": "sanyinjiao",
                            "xueweiName": "三阴交"
                        },
                        {
                            "xueweiCode": "zusanli",
                            "xueweiName": "足三里"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "闭经1-肾俞",
                            "description": "双手叉腰，用拇指点压肾俞20次。"
                        },
                        {
                            "imgUrlName": "闭经2-血海",
                            "description": "用拇指指腹用力均衡地按压血海20次。"
                        },
                        {
                            "imgUrlName": "闭经3-三阴交",
                            "description": "用拇指指腹按压三阴交20次。"
                        },
                        {
                            "imgUrlName": "闭经4-足三里",
                            "description": "用拇指指腹按揉足三里50次。"
                        }
                    ],
                    "classicalSymptom": "经少色淡、初潮较迟、面色无华。"
                }
            ]
        },
        {
            "name": "男科",
            "imgUrl": "nanke",
            "clickedImgUrl": "nanke2",
            "keShiCode": "nanke",
            "disease": [
                {
                    "name": "阳痿",
                    "diseaseCode": "yangwei",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "guanyuan",
                            "xueweiName": "关元"
                        },
                        {
                            "xueweiCode": "shenyu",
                            "xueweiName": "肾俞"
                        },
                        {
                            "xueweiCode": "huiyin",
                            "xueweiName": "会阴"
                        },
                        {
                            "xueweiCode": "taichong",
                            "xueweiName": "太冲"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "阳痿1-关元",
                            "description": "用中间三指指腹按揉关元150次，动作轻柔。"
                        },
                        {
                            "imgUrlName": "阳痿2-肾俞",
                            "description": "用双手拇指指端按压两侧肾俞100次。"
                        },
                        {
                            "imgUrlName": "阳痿3-会阴",
                            "description": "用拇指指端重力按压会阴10次。"
                        },
                        {
                            "imgUrlName": "阳痿4-太冲",
                            "description": "用拇指指端重力按压太冲30次。"
                        }
                    ],
                    "classicalSymptom": "不能勃起、焦虑急躁、身心疲劳。"
                },
                {
                    "name": "早泄",
                    "diseaseCode": "zaoxie",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "shenyu",
                            "xueweiName": "肾俞"
                        },
                        {
                            "xueweiCode": "guanyuan",
                            "xueweiName": "关元"
                        },
                        {
                            "xueweiCode": "sanyinjiao",
                            "xueweiName": "三阴交"
                        },
                        {
                            "xueweiCode": "taixi",
                            "xueweiName": "太溪"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "早泄1-肾俞",
                            "description": "用双手拇指指端按压两侧肾俞50次。"
                        },
                        {
                            "imgUrlName": "早泄2-关元",
                            "description": "用拇指点按关元30次，力度适中。"
                        },
                        {
                            "imgUrlName": "早泄3-三阴交",
                            "description": "用指指腹按揉两侧三阴交50次。"
                        },
                        {
                            "imgUrlName": "早泄4-太溪",
                            "description": "用拇指指腹刮按太溪3分钟。"
                        }
                    ],
                    "classicalSymptom": "五心烦热、腰膝酸软、阴茎易勃。"
                },
                {
                    "name": "前列腺疾病",
                    "diseaseCode": "qianliexianjibing",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "zhongji",
                            "xueweiName": "中极"
                        },
                        {
                            "xueweiCode": "bangguangyu",
                            "xueweiName": "膀胱俞"
                        },
                        {
                            "xueweiCode": "yinlingquan",
                            "xueweiName": "阴陵泉"
                        },
                        {
                            "xueweiCode": "tianjing",
                            "xueweiName": "天井"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "前列腺疾病1-中极",
                            "description": "用双手中指同时按压中极1分钟。"
                        },
                        {
                            "imgUrlName": "前列腺疾病2-膀胱俞",
                            "description": "用拇指指腹按揉膀胱俞1-2分钟。"
                        },
                        {
                            "imgUrlName": "前列腺疾病3-阴陵泉",
                            "description": "用拇指指腹按揉阴陵泉1分钟。"
                        },
                        {
                            "imgUrlName": "前列腺疾病4-天井",
                            "description": "以中指指端勾点天井30-50次。"
                        }
                    ],
                    "classicalSymptom": "排尿不适、性欲减退、头晕乏力。"
                },
                {
                    "name": "遗精",
                    "diseaseCode": "yijing",
                    "massageXueWeiList": [
                        {
                            "xueweiCode": "guanyuan",
                            "xueweiName": "关元"
                        },
                        {
                            "xueweiCode": "shenyu",
                            "xueweiName": "肾俞"
                        },
                        {
                            "xueweiCode": "taixi",
                            "xueweiName": "太溪"
                        },
                        {
                            "xueweiCode": "zusanli",
                            "xueweiName": "足三里"
                        }
                    ],
                    "massageInfo": [
                        {
                            "imgUrlName": "遗精1-关元",
                            "description": "用中间三指指腹摩揉关元3-5分钟。"
                        },
                        {
                            "imgUrlName": "遗精2-肾俞",
                            "description": "用双手拇指指端按压肾俞20次。"
                        },
                        {
                            "imgUrlName": "遗精3-太溪",
                            "description": "用拇指按揉太溪2分钟，力度适中。"
                        },
                        {
                            "imgUrlName": "遗精4-足三里",
                            "description": "用拇指按揉足三里20次，力度稍大。"
                        }
                    ],
                    "classicalSymptom": "精液外泄、精神委靡、头晕耳鸣。"
                }
            ]
        }
    ],
    jingmaiList: [
        {
            "jingMaiName": "手太阴肺经",
            "jingMaiCode": "shoutaifeiyinjin",
            "xueweiList": [
                {
                    "seq": 1,
                    "xueweiName": "中府",
                    "xueweiCode": "zhongfu",
                    "position": {
                        "x": -0.1401272,
                        "y": 1.467877,
                        "z": 0.0314838
                    },
                    "xueweiDetail": {
                        "detailTitle": "中府：胸闷咳嗽中府收",
                        "detailDescription": "中，指中焦；府，处所。肺经起于中焦，是中焦脾胃之气聚汇肺经之处。",
                        "cure": "宣肺止咳。主治肺炎、哮喘、胸痛、肺结核、支气管扩张。",
                        "position": "在胸部，横平第1肋间隙，锁骨下窝外侧，前正中线旁开6寸。",
                        "quickFind": "正立，双手叉腰，锁骨外侧端下方有一凹陷，该处再向下1横指即是。",
                        "massage": "咳嗽不止时，点按中府和肺俞各200次，有即时止咳的功效。每天坚持按摩，可强化淋巴循环，减轻胸闷、肩背痛。",
                        "xueweiName": "中府",
                        "jingluoName": "手太阴肺经",
                        "titleUrl": "中府"
                    }
                },
                {
                    "seq": 2,
                    "xueweiName": "云门",
                    "xueweiCode": "yunmen",
                    "position": {
                        "x": -0.1232522,
                        "y": 1.4974543,
                        "z": 0.004292
                    },
                    "xueweiDetail": {
                        "detailTitle": "云门：胸痛肩痛全拿下",
                        "detailDescription": "云，云雾，指肺气；门，门户。穴在胸上部，如肺气出入的门户。",
                        "cure": "理气止痛。主治咳嗽、气喘、胸痛、肩痛、肩关节内侧痛等。",
                        "position": "在胸部，锁骨下窝凹陷中，肩胛骨喙突内缘，前正中线旁开6寸。",
                        "quickFind": "正立，双手叉腰，锁骨外侧端下方的三角形凹陷处即是。",
                        "massage": "每天早晚用中指指腹点揉云门1~3分钟，坚持按摩，可远离咳嗽痰多等症状。云门还可辅助降压，高血压患者可常按揉。",
                        "xueweiName": "云门",
                        "jingluoName": "手太阴肺经",
                        "titleUrl": "云门"
                    },
                    "assistPoint": [
                        {
                            "position": {
                                "x": -0.164,
                                "y": 1.482,
                                "z": 0.014
                            }
                        },
                        {
                            "position": {
                                "x": -0.193,
                                "y": 1.469,
                                "z": 0.017
                            }
                        },
                        {
                            "position": {
                                "x": -0.217,
                                "y": 1.451,
                                "z": 0.017
                            }
                        },
                        {
                            "position": {
                                "x": -0.231,
                                "y": 1.432,
                                "z": 0.015
                            }
                        }
                    ]
                },
                {
                    "seq": 3,
                    "xueweiName": "天府",
                    "xueweiCode": "tianfu",
                    "position": {
                        "x": -0.2687213,
                        "y": 1.3445437,
                        "z": 0.0009449
                    },
                    "xueweiDetail": {
                        "detailTitle": "天府：鼻炎鼻塞都不见",
                        "detailDescription": "天，天空，指上而言；府，处所。本穴是肺气聚集之处。",
                        "cure": "止咳化痰。主治咳嗽、气喘、鼻塞、上臂内侧疼痛等。",
                        "position": "在臂前部，腋前纹头下3寸，肱二头肌桡侧缘处。",
                        "quickFind": "臂向前平举，俯头，鼻尖接触上臂内侧处即是。",
                        "massage": "常用中指指腹揉按天府，每次左右各按1~3分钟，对鼻部有保健作用，可预防鼻塞、鼻炎等。",
                        "xueweiName": "天府",
                        "jingluoName": "手太阴肺经",
                        "titleUrl": "天府"
                    }
                },
                {
                    "seq": 4,
                    "xueweiName": "侠白",
                    "xueweiCode": "xiabai",
                    "position": {
                        "x": -0.2755261,
                        "y": 1.3218911,
                        "z": 0.0113672
                    },
                    "xueweiDetail": {
                        "detailTitle": "侠白：缓解肋间神经痛",
                        "detailDescription": "侠，通“夹”；白，白色属肺。两臂下垂，本穴夹于肺之两旁。",
                        "cure": "宽胸和胃，宣肺理气。主治咳嗽、气喘、干呕、肋间神经痛。",
                        "position": "在臂前部，腋前纹头下4寸，肱二头肌桡侧缘处。",
                        "quickFind": "先找到天府，向下1横指处即是。",
                        "massage": "常用中指指腹揉按侠白，每次左右各按1~3分钟，对肺有保健作用。精神极度衰弱时揉侠白3~5分钟，可很快安心宁神。",
                        "xueweiName": "侠白",
                        "jingluoName": "手太阴肺经",
                        "titleUrl": "侠白"
                    }
                },
                {
                    "seq": 5,
                    "xueweiName": "尺泽",
                    "xueweiCode": "chize",
                    "position": {
                        "x": -0.30221,
                        "y": 1.2211178,
                        "z": 0.0377177
                    },
                    "xueweiDetail": {
                        "detailTitle": "尺泽：清肺泻热止疼痛",
                        "detailDescription": "尺，指尺部（腕至肘之前臂）；泽，沼泽。穴在尺部肘窝陷中，脉气流注入此，如水注沼泽。",
                        "cure": "清泻肺热，通络止痛。主治气管炎、咳嗽、咳血、咽喉肿痛、过敏、湿疹、肘臂痉挛疼痛、膝关节疼痛。",
                        "position": "在肘部，肘横纹上，肱二头肌腱桡侧缘凹陷中。",
                        "quickFind": "屈肘时，触及肌腱，其外侧缘即是。",
                        "massage": "弯曲拇指，以指腹按压，每次左右手各按压1~3分钟。坚持按摩可补益肺肾，调节身体虚实。",
                        "xueweiName": "尺泽",
                        "jingluoName": "手太阴肺经",
                        "titleUrl": "尺泽"
                    }
                },
                {
                    "seq": 6,
                    "xueweiName": "孔最",
                    "xueweiCode": "kongzui",
                    "position": {
                        "x": -0.3263885,
                        "y": 1.1678497,
                        "z": 0.0615178
                    },
                    "xueweiDetail": {
                        "detailTitle": "孔最：咳血特效此穴神",
                        "detailDescription": "孔，孔隙；最，副词。意指本穴孔隙最深。",
                        "cure": "清热止血，润肺理气。主治气管炎、咳嗽、咳血、咽喉肿痛、肘臂痛、痔疮。",
                        "position": "在前臂内侧面，腕掌侧远端横纹上7寸，尺泽与太渊连线上。",
                        "quickFind": "手臂向前，仰掌向上，另手握住手臂中段处，拇指指甲垂直下压即是。",
                        "massage": "用拇指指腹按压孔最1~3分钟，可防止咳血。",
                        "xueweiName": "孔最",
                        "jingluoName": "手太阴肺经",
                        "titleUrl": "孔最"
                    }
                },
                {
                    "seq": 7,
                    "xueweiName": "列缺",
                    "xueweiCode": "lieque",
                    "position": {
                        "x": -0.3506437,
                        "y": 1.0567957,
                        "z": 0.0921161
                    },
                    "xueweiDetail": {
                        "detailTitle": "列缺：偏正头痛都不怕",
                        "detailDescription": "列，指陈列、裂开；缺，指缺口、空隙。古称闪电为列缺。穴在腕上之裂隙与衣袖之边缘处，所经之气常如闪电也。",
                        "cure": "止咳平喘，通络止痛，利水通淋。主治咳嗽气喘，偏、正头痛，咽喉痛，落枕。",
                        "position": "腕掌侧远端横纹上1.5寸，拇短伸肌腱与拇长展肌腱之间。",
                        "quickFind": "两手虎口相交，一手食指压另一手桡骨茎突上，食指指尖到达处即是。",
                        "massage": "每天用食指指腹揉按列缺，每次1~3分钟，可治疗腱鞘炎、头痛等病症。",
                        "xueweiName": "列缺",
                        "jingluoName": "手太阴肺经",
                        "titleUrl": "列缺"
                    }
                },
                {
                    "seq": 8,
                    "xueweiName": "经渠",
                    "xueweiCode": "jingqu",
                    "position": {
                        "x": -0.3526148,
                        "y": 1.0429196,
                        "z": 0.1014653
                    },
                    "xueweiDetail": {
                        "detailTitle": "经渠：赶走咳嗽的困扰",
                        "detailDescription": "经，经过；渠，沟渠。经脉通过的渠道。",
                        "cure": "宣肺平喘。主治咳嗽、气喘、咽喉肿痛、牙痛、无脉症。",
                        "position": "在前臂内侧面，腕掌侧远端横纹上1寸，桡骨茎突与桡动脉之间。",
                        "quickFind": "伸手，掌心向上，用一手给另一手把脉，中指所在位置即是。",
                        "massage": "经常按揉经渠穴，可防治老年慢性支气管炎。",
                        "xueweiName": "经渠",
                        "jingluoName": "手太阴肺经",
                        "titleUrl": "经渠"
                    }
                },
                {
                    "seq": 9,
                    "xueweiName": "太渊",
                    "xueweiCode": "taiyuan",
                    "position": {
                        "x": -0.3613976,
                        "y": 1.0301399,
                        "z": 0.1116699
                    },
                    "xueweiDetail": {
                        "detailTitle": "太渊：气血通畅心肺好",
                        "detailDescription": "太，高大与尊贵之意；渊，深水、深潭。太渊，口中津液名，意思是经气深如潭水。",
                        "cure": "通调血脉，止咳化痰。主治脉管炎、肺炎、心动过速、神经性皮炎。",
                        "position": "在腕部，桡骨茎突与舟状骨之间，拇长展肌腱尺侧凹陷中。",
                        "quickFind": "掌心向上，腕横纹外侧摸到桡动脉，其外侧即是。",
                        "massage": "用拇指指腹用力点揉太渊3分钟，直至穴位处有酸胀感，能很快缓解咳喘。用拇指及指甲尖掐按太渊，每次1~3分钟，可预防心肺疾病。",
                        "xueweiName": "太渊",
                        "jingluoName": "手太阴肺经",
                        "titleUrl": "太渊"
                    }
                },
                {
                    "seq": 10,
                    "xueweiName": "鱼际",
                    "xueweiCode": "yuji",
                    "position": {
                        "x": -0.395354,
                        "y": 1.0215656,
                        "z": 0.1275229
                    },
                    "xueweiDetail": {
                        "detailTitle": "鱼际：痰热咳嗽莫担心",
                        "detailDescription": "鱼，指拇掌肌肉的形状；际，边际。手掌拇指侧肌肉肥厚，其形似鱼，穴位位于它的边际。",
                        "cure": "清热利咽。咳嗽、哮喘、咳血、发热、咽喉肿痛、失音、腹泻、拇指根部疼痛、心悸。",
                        "position": "在手外侧，第1掌骨桡侧中点赤白肉际处。",
                        "quickFind": "一手轻握另手手背，弯曲拇指，指尖垂直下按第1掌骨中点肉际处即是。",
                        "massage": "每天早晚各按揉鱼际200次。按摩时用拇指指腹在鱼际处用力向下按压，并配合左右按揉，以有酸胀感为宜，可治痰热咳嗽。",
                        "xueweiName": "鱼际",
                        "jingluoName": "手太阴肺经",
                        "titleUrl": "鱼际"
                    }
                },
                {
                    "seq": 11,
                    "xueweiName": "少商",
                    "xueweiCode": "shaoshang",
                    "position": {
                        "x": -0.4627783,
                        "y": 0.9840245,
                        "z": 0.1607777
                    },
                    "xueweiDetail": {
                        "detailTitle": "少商：感冒咽痛不再烦",
                        "detailDescription": "少，幼小、微小之意；商，古代五音之一，属金，属肺。少商，是商的高音，意为金气所止或为金气初生之处也。",
                        "cure": "泻热开窍，通利咽喉。咳嗽、咽喉肿痛、慢性咽炎、扁桃体炎、中风昏迷、小儿惊风、热病、中暑、感冒。",
                        "position": "在手指，拇指末节桡侧，指甲根角侧上方0.1寸。",
                        "quickFind": "一手拇指伸直，另手拇、食指轻握，拇指弯曲掐按伸直的拇指指甲角边缘处即是。",
                        "massage": "用指甲使劲掐一掐少商，可以减轻咽喉肿痛的症状。打嗝时，用拇指按压少商，以感觉酸痛为度，持续半分钟，即可止嗝。",
                        "xueweiName": "少商",
                        "jingluoName": "手太阴肺经",
                        "titleUrl": "少商"
                    }
                }
            ]
        },
        {
            "jingMaiName": "手阳明大肠经",
            "jingMaiCode": "shouyangmingdachangjing",
            "xueweiList": [
                {
                    "seq": 1,
                    "xueweiName": "商阳",
                    "xueweiCode": "shangyang",
                    "position": {
                        "x": 0.455626,
                        "y": 0.865499,
                        "z": 0.166833
                    },
                    "xueweiDetail": {
                        "detailTitle": "商阳：调节肠胃无烦恼",
                        "detailDescription": "商，古代五音之一，属金；阳，阴阳之阳。大肠属金，在音为商；阳，指阳经，商阳为手阳明大肠经首穴。",
                        "cure": "清热解表，苏厥开窍。主治咽喉肿痛、昏厥、呕吐、扁桃体炎、便秘。",
                        "position": "在食指末节桡侧，指甲根角侧上方0.1寸。",
                        "quickFind": "食指末节指甲根角，靠拇指侧的位置。",
                        "massage": "用双手刺激商阳，可调节肠胃功能，缓解急性胃肠炎症状。",
                        "xueweiName": "商阳",
                        "jingluoName": "手阳明大肠经",
                        "titleUrl": "商阳"
                    }
                },
                {
                    "seq": 2,
                    "xueweiName": "二间",
                    "xueweiCode": "erjian",
                    "position": {
                        "x": 0.427619,
                        "y": 0.933169,
                        "z": 0.132241
                    },
                    "xueweiDetail": {
                        "detailTitle": "二间：治鼻出血有奇效",
                        "detailDescription": "二，第二；间，间隙，指穴。此为大肠经第二穴。",
                        "cure": "清热泻火，解表利咽。主治牙痛、咽喉肿痛、鼻出血、目痛、腹胀。",
                        "position": "在手指，第2掌指关节桡侧远端赤白肉际处。",
                        "quickFind": "自然弯曲食指，第2掌指关节前缘，靠拇指侧，触之有凹陷处即是。",
                        "massage": "在手上二间处刮痧，一般痧一出，可止鼻出血。",
                        "xueweiName": "二间",
                        "jingluoName": "手阳明大肠经",
                        "titleUrl": "二间"
                    }
                },
                {
                    "seq": 3,
                    "xueweiName": "三间",
                    "xueweiCode": "sanjian",
                    "position": {
                        "x": 0.419234,
                        "y": 0.95763,
                        "z": 0.119978
                    },
                    "xueweiDetail": {
                        "detailTitle": "三间：肠炎肠鸣一按消",
                        "detailDescription": "三，第三；间，间隙，指穴。此为大肠经第三穴。",
                        "cure": "泻热止痛，利咽。主治牙痛、咽喉肿痛、身热胸闷、痔疮、哮喘。",
                        "position": "在手背，第2掌指关节桡侧近端凹陷中。",
                        "quickFind": "微握拳，食指第2掌指关节后缘，触之有凹陷处即是。",
                        "massage": "常用拇指指腹揉按此穴，每次1~3分钟，可调和胃肠，改善肠炎肠鸣症状。",
                        "xueweiName": "三间",
                        "jingluoName": "手阳明大肠经",
                        "titleUrl": "三间"
                    }
                },
                {
                    "seq": 4,
                    "xueweiName": "合谷",
                    "xueweiCode": "hegu",
                    "position": {
                        "x": 0.399342,
                        "y": 0.99627,
                        "z": 0.100865
                    },
                    "xueweiDetail": {
                        "detailTitle": "合谷：头面疼痛一扫光",
                        "detailDescription": "合，结合；谷，山谷。穴在第1、第2掌骨之间，局部呈山谷样凹陷。",
                        "cure": "镇静止痛，疏经通络，清热解表。主治外感发热、头痛目眩、鼻塞、牙痛、便秘、月经不调、荨麻疹、昏迷、中风、三叉神经痛、过敏性鼻炎、咽喉肿痛、口腔溃疡、黄褐斑、高血压、高脂血症。",
                        "position": "在手背，第1、第2掌骨之间，约平第2掌骨中点处。",
                        "quickFind": "轻握拳，拇、食指指尖轻触，另手握拳外，拇指指腹垂直下压即是。",
                        "massage": "用拇指掐捏合谷，持续2~3分钟，可缓解头痛、牙痛、咽喉肿痛。",
                        "xueweiName": "合谷",
                        "jingluoName": "手阳明大肠经",
                        "titleUrl": "合谷"
                    }
                },
                {
                    "seq": 5,
                    "xueweiName": "阳溪",
                    "xueweiCode": "yangxi",
                    "position": {
                        "x": 0.373712,
                        "y": 1.019477,
                        "z": 0.09353
                    },
                    "xueweiDetail": {
                        "detailTitle": "阳溪：头痛手痛皆可治",
                        "detailDescription": "阳，指阳经；溪，山洼流水之沟。指本穴在手背之阳的两筋凹陷明显处。",
                        "cure": "清热散风，通利关节。主治头痛、耳鸣、耳聋、牙痛、目赤肿痛。",
                        "position": "在腕部，腕背侧远端横纹桡侧，桡骨茎突远端，解剖学“鼻烟窝”凹陷中。",
                        "quickFind": "手掌侧放，拇指伸直向上翘起，腕背桡侧有一凹陷处即是。",
                        "massage": "以拇指指腹按压半分钟以上，可迅速缓解头痛。经常用拇指尖垂直掐按此穴，每次1~3分钟，可以有效防治中风和手腕肿痛等症。",
                        "xueweiName": "阳溪",
                        "jingluoName": "手阳明大肠经",
                        "titleUrl": "阳溪"
                    }
                },
                {
                    "seq": 6,
                    "xueweiName": "偏历",
                    "xueweiCode": "pianli",
                    "position": {
                        "x": 0.342442,
                        "y": 1.093115,
                        "z": 0.059693
                    },
                    "xueweiDetail": {
                        "detailTitle": "偏历：专治耳鸣与耳聋",
                        "detailDescription": "偏，偏离；历，行经。大肠经从这里分出络脉，偏行肺经。",
                        "cure": "清热利尿，通经活络。主治耳聋、耳鸣、鼻出血、目赤、牙痛、肠鸣、腹痛。",
                        "position": "在前臂，腕背侧远端横纹上3寸，阳溪与曲池连线上。",
                        "quickFind": "两手虎口垂直交叉，中指端落于前臂背面处有一凹陷即是。",
                        "massage": "经常用拇指指腹揉按偏历数次，每次1~3分钟，可预防耳鸣耳聋。",
                        "xueweiName": "偏历",
                        "jingluoName": "手阳明大肠经",
                        "titleUrl": "偏历"
                    }
                },
                {
                    "seq": 7,
                    "xueweiName": "温溜",
                    "xueweiCode": "wenliu",
                    "position": {
                        "x": 0.342123,
                        "y": 1.109546,
                        "z": 0.059627
                    },
                    "xueweiDetail": {
                        "detailTitle": "温溜：肩背酸痛按摩消",
                        "detailDescription": "温，温暖；溜，流通。本穴有温通经脉之功，善治肩背酸痛。",
                        "cure": "清热理气。主治寒热头痛、面赤面肿、口舌痛、肩背疼痛。",
                        "position": "在前臂，腕横纹上5寸，阳溪与曲池连线上。",
                        "quickFind": "先确定阳溪和曲池的位置，两穴连线的中点处即是。",
                        "massage": "肩背酸痛时，用拇指按揉温溜，可缓解酸痛。",
                        "xueweiName": "温溜",
                        "jingluoName": "手阳明大肠经",
                        "titleUrl": "温溜"
                    }
                },
                {
                    "seq": 8,
                    "xueweiName": "下廉",
                    "xueweiCode": "xialian",
                    "position": {
                        "x": 0.336693,
                        "y": 1.139334,
                        "z": 0.047542
                    },
                    "xueweiDetail": {
                        "detailTitle": "下廉：肘臂健康守护神",
                        "detailDescription": "下，下方；廉，边缘。穴在前臂背面近桡侧缘，上廉之下。",
                        "cure": "调理肠胃，通经活络。主治眩晕、腹痛、上肢不遂、手肘肩无力。",
                        "position": "在前臂，肘横纹下4寸，阳溪与曲池连线上。",
                        "quickFind": "侧腕屈肘，以手掌按另一手臂，拇指位于肘弯处，小指所在位置即是。",
                        "massage": "将食指与中指并拢，以指腹垂直按压下廉，左右臂各1~3分钟，可减轻肘臂疼痛。",
                        "xueweiName": "下廉",
                        "jingluoName": "手阳明大肠经",
                        "titleUrl": "下廉"
                    }
                },
                {
                    "seq": 9,
                    "xueweiName": "上廉",
                    "xueweiCode": "shanglian",
                    "position": {
                        "x": 0.329876,
                        "y": 1.166285,
                        "z": 0.039552
                    },
                    "xueweiDetail": {
                        "detailTitle": "上廉：可清肠毒治便秘",
                        "detailDescription": "上，上方；廉，边缘。穴在前臂背面近桡侧缘，下廉穴之上。",
                        "cure": "调理肠胃，通经活络。主治腹痛、腹胀、肠鸣、上肢肿痛、上肢不遂。",
                        "position": "在前臂，肘横纹下3寸，阳溪与曲池连线上。",
                        "quickFind": "先找到阳溪、曲池，两者连线中点向上量取4横指处即是。",
                        "massage": "常配合按摩上廉、下廉，每次1~3分钟，可清肠毒、治便秘。",
                        "xueweiName": "上廉",
                        "jingluoName": "手阳明大肠经",
                        "titleUrl": "上廉"
                    }
                },
                {
                    "seq": 10,
                    "xueweiName": "手三里",
                    "xueweiCode": "shousanli",
                    "position": {
                        "x": 0.320022,
                        "y": 1.190071,
                        "z": 0.032175
                    },
                    "xueweiDetail": {
                        "detailTitle": "手三里：腰背疼痛快速消",
                        "detailDescription": "手，上肢；三，数词；里，古代有以里为寸之说。穴在上肢，因距手臂肘端三寸，故名手三里。",
                        "cure": "调理肠胃，清热明目。主治腹痛、腹泻、肩周炎、上肢不遂、牙痛。",
                        "position": "在前臂，肘横纹下2寸，阳溪与曲池连线上。",
                        "quickFind": "先找到阳溪、曲池，两者连线上曲池下3横指即是。",
                        "massage": "常用拇指揉手三里，每次1~3分钟；也可用艾灸法，每次灸5~10分钟，可治疗腰背痛。",
                        "xueweiName": "手三里",
                        "jingluoName": "手阳明大肠经",
                        "titleUrl": "手三里"
                    }
                },
                {
                    "seq": 11,
                    "xueweiName": "曲池",
                    "xueweiCode": "quchi",
                    "position": {
                        "x": 0.308816,
                        "y": 1.212125,
                        "z": 0.025333
                    },
                    "xueweiDetail": {
                        "detailTitle": "曲池：感冒发热不用愁",
                        "detailDescription": "曲，弯曲；池，水的围合之处、汇合之所。穴在肘臂屈曲时肘横纹端凹陷处，经气至此，有如水之入池。",
                        "cure": "清热和营，祛风通络。主治感冒、外感发热、咳嗽、气喘、腹痛、脂肪肝、手臂肿痛、瘗疮、皮肤瘙痒、湿疹、白瘢风、半身不遂。",
                        "position": "在肘部，尺泽与肱骨外上髁连线的中点处。",
                        "quickFind": "屈肘成直角，先找到肘横纹终点，再找到肱骨外上髁，两者连线中点处。",
                        "massage": "发热感冒及咳嗽、哮喘时，可用刮疔板刮曲池；或按揉3〜5分钟，可迅速解表、退热。",
                        "xueweiName": "曲池",
                        "jingluoName": "手阳明大肠经",
                        "titleUrl": "曲池"
                    }
                },
                {
                    "seq": 12,
                    "xueweiName": "肘髎",
                    "xueweiCode": "zhouliao",
                    "position": {
                        "x": 0.298046,
                        "y": 1.231636,
                        "z": 0.015467
                    },
                    "xueweiDetail": {
                        "detailTitle": "肘髎：肘部疾病的克星",
                        "detailDescription": "肘，肘部；髎，骨隙。穴在肘部，靠近骨隙处。",
                        "cure": "舒筋活络。主治肩臂肘疼痛、上肢麻木、拘挛。",
                        "position": "在肘部，肱骨外上髁上缘，髁上嵴的前缘。",
                        "quickFind": "先找到曲池，向上量取1横指处即是。",
                        "massage": "每天早晚用拇指指腹按揉肘髎，每次1~3分钟，长期坚持，可预防网球肘。",
                        "xueweiName": "肘髎",
                        "jingluoName": "手阳明大肠经",
                        "titleUrl": "肘髎"
                    }
                },
                {
                    "seq": 13,
                    "xueweiName": "手五里",
                    "xueweiCode": "shouwuli",
                    "position": {
                        "x": 0.292172,
                        "y": 1.259681,
                        "z": 0.011445
                    },
                    "xueweiDetail": {
                        "detailTitle": "手五里：上肢不遂有奇效",
                        "detailDescription": "手，上肢；五，数词；里，古代有以里为寸之说。穴在上肢，当天府下5寸，手三里上5寸处。",
                        "cure": "理气散结，疏经活络。主治肩周炎、手臂肿痛、上肢不遂、疟疾。",
                        "position": "在臂部，肘横纹上3寸，曲池与肩髃连线上。",
                        "quickFind": "手臂外侧曲池上4横指处。",
                        "massage": "手五里位于骨头上，通经活络的效果非常强，尤其能治上肢麻木疼痛等疾病，按摩时可用食指按压，每次3~5分钟。",
                        "xueweiName": "手五里",
                        "jingluoName": "手阳明大肠经",
                        "titleUrl": "手五里"
                    }
                },
                {
                    "seq": 14,
                    "xueweiName": "臂臑",
                    "xueweiCode": "binao",
                    "position": {
                        "x": 0.284158,
                        "y": 1.31609,
                        "z": -0.00583
                    },
                    "xueweiDetail": {
                        "detailTitle": "臂臑：眼睛专属保健师",
                        "detailDescription": "臂，通指上肢；上臂肌肉隆起处。穴在上肢肌肉隆起处。",
                        "cure": "清热明目，通络止痛。主治眼部疾病、手臂肿痛、上肢不遂、肩周炎。",
                        "position": "在臂部，曲池上7寸，三角肌下端。",
                        "quickFind": "屈肘紧握拳，使三角肌隆起，三角肌下端偏内侧，按压有酸胀感处即是。",
                        "massage": "将艾灸条对准臂隔，距皮肤2~3厘米，每次灸5~10分钟，对白内障、视神经萎缩有辅助疗效；按揉臂臑3~5分钟，可缓解颈、肩部酸痛。",
                        "xueweiName": "臂臑",
                        "jingluoName": "手阳明大肠经",
                        "titleUrl": "臂臑"
                    }
                },
                {
                    "seq": 15,
                    "xueweiName": "肩髃",
                    "xueweiCode": "jianyu",
                    "position": {
                        "x": 0.255588,
                        "y": 1.454287,
                        "z": -0.0329
                    },
                    "xueweiDetail": {
                        "detailTitle": "肩髃：缓解肩臂疼与痛",
                        "detailDescription": "肩，肩部；髃，隅角。穴在肩角部。",
                        "cure": "疏经活络，疏散风热。主治肩臂疼痛、肩周炎、肩痛、上肢不遂。",
                        "position": "在肩峰前下方，当肩峰与肱骨大结节之间凹陷处。",
                        "quickFind": "正坐，屈肘抬臂与肩同高，另一手中指按压肩尖下，肩前呈现凹陷处即是。",
                        "massage": "中指和食指并拢，以指腹垂直按压穴位，两肩按摩方法相同，每日早晚按摩，左右各按揉1〜3分钟。可治肩臂疼痛、手臂挛急等疾病。",
                        "xueweiName": "肩髃",
                        "jingluoName": "手阳明大肠经",
                        "titleUrl": "肩髃"
                    }
                },
                {
                    "seq": 16,
                    "xueweiName": "巨骨",
                    "xueweiCode": "jugu",
                    "position": {
                        "x": 0.170709,
                        "y": 1.52634,
                        "z": -0.062137
                    },
                    "xueweiDetail": {
                        "detailTitle": "巨骨：缓解预防肩周炎",
                        "detailDescription": "巨，大；骨，骨骼。古称锁骨为巨骨。穴近锁骨肩峰端。",
                        "cure": "通络止痛，滑利关节。主治肩背及上臂疼痛、手臂挛急、半身不遂。",
                        "position": "在肩部，锁骨肩峰端与肩胛冈之间凹陷中。",
                        "quickFind": "沿着锁骨向外摸至肩峰端，再找背部肩胛冈，两者之间凹陷处即是。",
                        "massage": "肩臂拘挛时可用对侧手的中指指腹按揉患侧巨骨，直至患侧感到热或局部有酸麻感，可缓解症状；常按揉巨骨，可助肩周炎患者上肢上举活动改善。",
                        "xueweiName": "巨骨",
                        "jingluoName": "手阳明大肠经",
                        "titleUrl": "巨骨"
                    }
                },
                {
                    "seq": 17,
                    "xueweiName": "天鼎",
                    "xueweiCode": "tianding",
                    "position": {
                        "x": 0.074247,
                        "y": 1.553035,
                        "z": -0.032648
                    },
                    "xueweiDetail": {
                        "detailTitle": "天鼎：扁桃体炎按之消",
                        "detailDescription": "天，天空，指上面而言；鼎，古器物名。头形似鼎，穴在耳下颈部。",
                        "cure": "利喉清咽，理气散结。主治咳嗽、气喘、咽喉肿痛、扁桃体炎、梅核气、瘿瘤（甲状腺肿瘤）。",
                        "position": "在颈部，横平环状软骨，胸锁乳突肌后缘，扶突直下1寸处。",
                        "quickFind": "先找到扶突，再找到锁骨上窝中央，两者连线中点处即是。",
                        "massage": "用力按压天鼎50次，可缓解扁桃体红肿所造成的疼痛及喉咙阻塞等症状。",
                        "xueweiName": "天鼎",
                        "jingluoName": "手阳明大肠经",
                        "titleUrl": "天鼎"
                    }
                },
                {
                    "seq": 18,
                    "xueweiName": "扶突",
                    "xueweiCode": "futu",
                    "position": {
                        "x": 0.056123,
                        "y": 1.614582,
                        "z": -0.016038
                    },
                    "xueweiDetail": {
                        "detailTitle": "扶突：咳嗽气喘效果好",
                        "detailDescription": "扶，旁边；突，隆起，指喉结。穴在喉结旁。",
                        "cure": "利咽消肿，理气降逆。主治咳嗽、气喘、咽喉肿痛、打嗝。",
                        "position": "在胸锁乳突肌区，横平喉结，当胸锁乳突肌的前、后缘中间。",
                        "quickFind": "拇指弯曲，其余四指并拢，手心向内，小指放喉结旁，食指所在处即是。",
                        "massage": "食指和中指并拢，以指腹按压扶突，每次左右各按压3分钟，可缓解咳嗽气喘。",
                        "xueweiName": "扶突",
                        "jingluoName": "手阳明大肠经",
                        "titleUrl": "扶突"
                    }
                },
                {
                    "seq": 19,
                    "xueweiName": "口禾髎",
                    "xueweiCode": "kouheliao",
                    "position": {
                        "x": 0.010685,
                        "y": 1.646913,
                        "z": 0.097928
                    },
                    "xueweiDetail": {
                        "detailTitle": "口禾髎：抛掉鼻炎的烦恼",
                        "detailDescription": "口，口部；禾，谷物；髎，间隙。谷物从口入胃，穴在口旁骨隙中。",
                        "cure": "祛风清热，牵正通窍。主治鼻塞流涕、鼻出血、口眼歪斜。",
                        "position": "在面部，横平人中沟上1/3与下2/3交点，鼻孔外缘直下。",
                        "quickFind": "鼻孔外缘直下，平鼻唇沟上1/3水沟处即是。",
                        "massage": "用食指指腹按压口禾髎，每次5~10分钟，以有酸痛感为宜，可治过敏性鼻炎、鼻前庭炎和慢性鼻炎等。",
                        "xueweiName": "口禾髎",
                        "jingluoName": "手阳明大肠经",
                        "titleUrl": "口禾髎"
                    }
                },
                {
                    "seq": 20,
                    "xueweiName": "迎香",
                    "xueweiCode": "yingxiang",
                    "position": {
                        "x": 0.0206,
                        "y": 1.663854,
                        "z": 0.089357
                    },
                    "xueweiDetail": {
                        "detailTitle": "迎香：鼻部疾病第一穴",
                        "detailDescription": "迎，迎接；香，香气。本穴在鼻旁，能治鼻病，改善嗅觉，进而迎来香气。",
                        "cure": "祛风通窍，理气止痛。主治鼻塞、过敏性鼻炎、鼻出血、面神经麻痹、黄褐斑、酒糟鼻。",
                        "position": "在面部，鼻翼外缘中点，鼻唇沟中。",
                        "quickFind": "双手轻握拳，食指和中指并拢，中指指尖贴鼻翼两侧，食指指尖处即是。",
                        "massage": "遇到伤风引起的流鼻涕、鼻塞，或者过敏性鼻炎，按摩迎香至发热，立刻见效。",
                        "xueweiName": "迎香",
                        "jingluoName": "手阳明大肠经",
                        "titleUrl": "迎香"
                    }
                }
            ]
        },
        {
            "jingMaiName": "足阳明胃经",
            "jingMaiCode": "zuyangmingweijing",
            "xueweiList": [
                {
                    "seq": 1,
                    "xueweiName": "承泣",
                    "xueweiCode": "chengqi",
                    "position": {
                        "x": -0.031057,
                        "y": 1.686961,
                        "z": 0.082854
                    },
                    "xueweiDetail": {
                        "detailTitle": "承泣：预防消退黑眼圈",
                        "detailDescription": "承，承受；泣，泪水。穴在目下，犹如承受泪水的部位。",
                        "cure": "散风清热，明目止泪。主治目赤肿痛、视力模糊、白内障、口眼歪斜。",
                        "position": "在面部，眼球与眶下缘之间，瞳孔直下。",
                        "quickFind": "食指和中指伸直并拢，中指贴于鼻侧，食指指尖位于下眼眶边缘处即是。",
                        "massage": "用食指指腹揉承泣1~3分钟，可以促进眼部血液循环，预防黑眼圈。",
                        "xueweiName": "承泣",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "承泣"
                    }
                },
                {
                    "seq": 2,
                    "xueweiName": "四白",
                    "xueweiCode": "sibai",
                    "position": {
                        "x": -0.031328,
                        "y": 1.673464,
                        "z": 0.084945
                    },
                    "xueweiDetail": {
                        "detailTitle": "四白：眼保健操的主穴",
                        "detailDescription": "四，四方；白，光明。穴在目下，能治眼病，改善视觉，明见四方。",
                        "cure": "祛风明目，通经活络。主治近视、目赤痛痒、迎风流泪、白内障、面瘫。",
                        "position": "在面部，双眼平视时，瞳孔直下，当眶下孔凹陷处。",
                        "quickFind": "食指和中指伸直并拢，中指指腹贴两侧鼻翼，食指指尖所按凹陷处即是。",
                        "massage": "双手食指伸直，以食指指腹揉按左右四白，有酸痛感，每次1~3分钟，可以缓解眼疲劳、眼干涩等。",
                        "xueweiName": "四白",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "四白"
                    }
                },
                {
                    "seq": 3,
                    "xueweiName": "巨髎",
                    "xueweiCode": "juliao",
                    "position": {
                        "x": -0.031328,
                        "y": 1.659148,
                        "z": 0.084945
                    },
                    "xueweiDetail": {
                        "detailTitle": "巨髎：主治面神经麻痹",
                        "detailDescription": "巨，大也；髎，孔隙。指穴在上颌骨与颧骨交接之巨大孔隙中，泛指面部髎孔之巨大者。",
                        "cure": "清热熄风，明目退翳。主治口眼歪斜、鼻出血、牙痛、面痛、面神经麻痹。",
                        "position": "在面部，瞳孔直下，横平鼻翼下缘，颤弓下缘凹陷处。",
                        "quickFind": "直视前方，沿瞳孔直下垂直线向下，与鼻翼下缘水平线交点凹陷处即是。",
                        "massage": "以两手拇指指腹点按巨髎3~5分钟，可纠正口眼歪斜。",
                        "xueweiName": "巨髎",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "巨髎"
                    }
                },
                {
                    "seq": 4,
                    "xueweiName": "地仓",
                    "xueweiCode": "dicang",
                    "position": {
                        "x": -0.031695,
                        "y": 1.632492,
                        "z": 0.081027
                    },
                    "xueweiDetail": {
                        "detailTitle": "地仓：面部松弛有奇效",
                        "detailDescription": "地，指土地所产之谷物；仓，仓廩、仓库。意为口腔犹如谷物仓库的组成部分。",
                        "cure": "祛风止痛，舒筋活络。主治口角歪斜、牙痛、流涎、眼睑跳动不止。",
                        "position": "在面部，当口角旁开0.4寸（指寸）。",
                        "quickFind": "轻闭口，举两手，用食指指甲垂直下压唇角外侧两旁即是。",
                        "massage": "每天按揉地仓2次，每次1~3分钟，可刺激口轮匝肌，有改善面部松弛、提拉嘴角的功效。常按揉地仓，可防治流涎。",
                        "xueweiName": "地仓",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "地仓"
                    }
                },
                {
                    "seq": 5,
                    "xueweiName": "大迎",
                    "xueweiCode": "daying",
                    "position": {
                        "x": -0.035689,
                        "y": 1.605285,
                        "z": 0.055029
                    },
                    "xueweiDetail": {
                        "detailTitle": "大迎：三叉神经疼痛消",
                        "detailDescription": "大，大小之大；迎，迎接。穴在大迎脉（面动脉）旁。",
                        "cure": "祛风通络，消肿止痛。主治口角歪斜、失音、颊肿、牙痛。",
                        "position": "在面部，下颌角前方，咬肌附着部前缘凹陷中，面动脉搏动处。",
                        "quickFind": "正坐，闭口鼓气，下颌角前下方有一凹陷，下端按之有搏动感处即是。",
                        "massage": "用食指指腹按揉大迎，每次1~3分钟，可以促进面部血液循环，预防和调理三叉神经痛等面部疾病。",
                        "xueweiName": "大迎",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "大迎"
                    }
                },
                {
                    "seq": 6,
                    "xueweiName": "颊车",
                    "xueweiCode": "jiache",
                    "position": {
                        "x": -0.048699,
                        "y": 1.632081,
                        "z": 0.050868
                    },
                    "xueweiDetail": {
                        "detailTitle": "颊车：面颊肿痛一按消",
                        "detailDescription": "颊，面颊，此处指上颌骨；车，车轮，指下颌骨。颊车，即下颌关节可以转动之处。",
                        "cure": "祛风清热，开关通络。主治口眼歪斜、牙关紧闭、牙痛、面部痉挛。",
                        "position": "在面部，下颌角前上方1横指（中指）。",
                        "quickFind": "上下牙关咬紧时，会隆起一个咬肌高点，按之有凹陷处即是。",
                        "massage": "用中指指腹压在咬肌隆起处揉按，以有酸胀感为宜，可治面颊疼痛、牙关不利等症。",
                        "xueweiName": "颊车",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "颊车"
                    }
                },
                {
                    "seq": 7,
                    "xueweiName": "下关",
                    "xueweiCode": "xiaguan",
                    "position": {
                        "x": -0.054039,
                        "y": 1.656935,
                        "z": 0.059644
                    },
                    "xueweiDetail": {
                        "detailTitle": "下关：治疗牙痛与耳鸣",
                        "detailDescription": "下，与上相对；关，机关、关节。穴在下颌关节颧弓下方，与上关互相对峙。",
                        "cure": "消肿止痛，聪耳通络。主治牙痛、口眼歪斜、面痛、耳鸣。",
                        "position": "在面部，颧弓下缘中央与下颌切迹之间凹陷处。",
                        "quickFind": "闭口，食指和中指并拢，食指贴于耳垂旁，中指指腹处即是。",
                        "massage": "用双手食指指腹按压下关3分钟，可立即消除耳鸣症状，止牙痛；常按此穴，可防治三叉神经痛。",
                        "xueweiName": "下关",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "下关"
                    }
                },
                {
                    "seq": 8,
                    "xueweiName": "头维",
                    "xueweiCode": "touwei",
                    "position": {
                        "x": -0.057823,
                        "y": 1.76949,
                        "z": 0.044105
                    },
                    "xueweiDetail": {
                        "detailTitle": "头维：明目还可止头痛",
                        "detailDescription": "头，头部；维，隅角、维系、维护。谓穴居头之隅角，是维系头冠之处。",
                        "cure": "清头明目，止痛镇痉。主治面肌痉挛，偏、正头痛，迎风流泪，目眩，口眼歪斜。",
                        "position": "在头部，额角发际直上0.5寸，头正中线旁开4.5寸处。",
                        "quickFind": "在头部，额角发际直上半横指，头正中线旁开6横指。",
                        "massage": "用双手拇指指腹强压头维，每秒钟按压1次，如此重复10-20次，以有酸胀感为宜，可治面部痉挛、疼痛等疾病。",
                        "xueweiName": "头维",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "头维"
                    }
                },
                {
                    "seq": 9,
                    "xueweiName": "人迎",
                    "xueweiCode": "renying",
                    "position": {
                        "x": -0.037534,
                        "y": 1.577907,
                        "z": 0.012384
                    },
                    "xueweiDetail": {
                        "detailTitle": "人迎：调节血压效果好",
                        "detailDescription": "人，指人体与生命；迎，接受。谓喉结两旁之动脉，可迎受天地五脏之气以养人也。",
                        "cure": "利咽散结，理气降逆。主治胸满气逆、咽喉肿痛、食欲不振、高血压。",
                        "position": "在颈部，横平喉结，胸锁乳突肌前缘，颈总动脉搏动处。",
                        "quickFind": "正坐，头微侧，从喉结往外侧量约2横指，可感胸锁乳突肌前缘颈部动脉搏动即是。",
                        "massage": "常用拇指指腹轻轻上下按压人迎，每次1〜3分钟，可促进血液循环，调节血压，清咽利喉。",
                        "xueweiName": "人迎",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "人迎"
                    }
                },
                {
                    "seq": 10,
                    "xueweiName": "水突",
                    "xueweiCode": "shuitu",
                    "position": {
                        "x": -0.03831,
                        "y": 1.547228,
                        "z": 0.01437
                    },
                    "xueweiDetail": {
                        "detailTitle": "水突：清咽润喉肿痛消",
                        "detailDescription": "水，水谷；突，穿过。穴在颈部，邻近通过食物的食管。",
                        "cure": "清热利咽，降逆平喘。主治呼吸喘鸣、咽喉肿痛、慢性咽炎、打嗝。",
                        "position": "在颈部，胸锁乳突肌的前缘，当胸锁乳突肌的胸骨头与锁骨头和锁骨所构成的凹陷处。",
                        "quickFind": "找到人迎、气舍，两者连线中点即是。",
                        "massage": "用拇指指腹轻轻按揉水突100次，以有酸胀感为佳，可利咽润喉开音。",
                        "xueweiName": "水突",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "水突"
                    }
                },
                {
                    "seq": 11,
                    "xueweiName": "气舍",
                    "xueweiCode": "qishe",
                    "position": {
                        "x": -0.048796,
                        "y": 1.51383,
                        "z": 0.010762
                    },
                    "xueweiDetail": {
                        "detailTitle": "气舍：保养肺脏咳嗽消",
                        "detailDescription": "气，指肺胃之气；舍，宅舍。穴在气管旁，犹如气之宅舍。",
                        "cure": "宣肺定喘，理气散结。主治咽喉肿痛、打嗝、瘿瘤（甲状腺肿瘤）。",
                        "position": "在胸锁乳突肌区，锁骨上小窝，锁骨内侧端上缘，胸锁乳突肌的胸骨头与锁骨头中间的凹陷中。",
                        "quickFind": "先找到人迎，直下，锁骨上缘处即是。",
                        "massage": "用中指指腹按揉气舍，每次1~3分钟，力度适中，可保护肺脏，缓解咳嗽。",
                        "xueweiName": "气舍",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "气舍"
                    }
                },
                {
                    "seq": 12,
                    "xueweiName": "缺盆",
                    "xueweiCode": "quepen",
                    "position": {
                        "x": -0.082695,
                        "y": 1.519866,
                        "z": -0.012412
                    },
                    "xueweiDetail": {
                        "detailTitle": "缺盆：咳嗽喘息不再愁",
                        "detailDescription": "缺，空缺与空虚，与残缺之意有别；盆，阔口容器。古代解剖名，如无盖之盆，指穴位于缺盆处也。",
                        "cure": "宽胸利膈，止咳平喘。主治咳嗽、哮喘、胸痛、咽喉肿痛、慢性咽炎。",
                        "position": "在颈外侧部，前正中线旁开4寸，锁骨上缘凹陷中。",
                        "quickFind": "正坐，乳中线直上锁骨上方有一凹陷，凹陷中点按有酸胀处即是。",
                        "massage": "用拇指指腹按压对侧缺盆，每次左右各按压3分钟可缓解咳嗽、气喘症状。",
                        "xueweiName": "缺盆",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "缺盆"
                    }
                },
                {
                    "seq": 13,
                    "xueweiName": "气户",
                    "xueweiCode": "qihu",
                    "position": {
                        "x": -0.088651,
                        "y": 1.487556,
                        "z": 0.032681
                    },
                    "xueweiDetail": {
                        "detailTitle": "气户：咳嗽气喘好帮手",
                        "detailDescription": "气，指肺胃之气；户，门户。穴在胸上部，故喻为气的门户。",
                        "cure": "理气宽胸，止咳平喘。主治咳嗽胸痛、呼吸喘鸣、咽喉肿痛。",
                        "position": "在胸部，锁骨下缘，前正中线旁开4寸。",
                        "quickFind": "正坐仰靠，乳中线与锁骨下缘相交的凹陷，按压有酸胀感处即是。",
                        "massage": "按摩时用双手食指指端点按气户，以上胸部有胀痛感为宜，可治疗咳嗽气喘、胸胁胀满。",
                        "xueweiName": "气户",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "气户"
                    }
                },
                {
                    "seq": 14,
                    "xueweiName": "库房",
                    "xueweiCode": "kufang",
                    "position": {
                        "x": -0.096889,
                        "y": 1.454604,
                        "z": 0.057765
                    },
                    "xueweiDetail": {
                        "detailTitle": "库房：气喘咳嗽按按它",
                        "detailDescription": "库，府库；房，房室。呼吸之气存于肺如储存库；从上至下，犹如从门户进入房室。",
                        "cure": "理气宽胸，清热化痰。主治胸满气逆、气喘、胸胁胀痛、咳嗽。",
                        "position": "在胸部，第1肋间隙，前正中线旁开4寸。",
                        "quickFind": "正坐或仰卧，从乳头沿垂直线向上推3个肋间隙，按压有酸胀感处即是。",
                        "massage": "用食指点揉库房1~2分钟，也可用艾条灸，灸时距皮肤2~3厘米，每次10分钟左右，可治胸胁胀痛、气喘等症。",
                        "xueweiName": "库房",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "库房"
                    }
                },
                {
                    "seq": 15,
                    "xueweiName": "屋翳",
                    "xueweiCode": "wuyi",
                    "position": {
                        "x": -0.106226,
                        "y": 1.420552,
                        "z": 0.078608
                    },
                    "xueweiDetail": {
                        "detailTitle": "屋翳：乳腺增生保健穴",
                        "detailDescription": "屋，深室；翳，隐蔽。穴在胸中部，呼吸之气至此如达深室隐蔽。",
                        "cure": "消痈止痒，止咳化痰。主治乳痈、乳腺增生、胸满气逆、咳嗽喘息。",
                        "position": "在胸部，第2肋间隙，前正中线旁开4寸。",
                        "quickFind": "正坐或仰卧，从乳头沿垂直线向上推2个肋间隙，按压有酸胀感处即是。",
                        "massage": "治疗乳腺炎、乳腺增生时，可用手掌小鱼际或大鱼际，在屋翳施以轻揉手法，反复揉压数次。",
                        "xueweiName": "屋翳",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "屋翳"
                    }
                },
                {
                    "seq": 16,
                    "xueweiName": "膺窗",
                    "xueweiCode": "yingchuang",
                    "position": {
                        "x": -0.115013,
                        "y": 1.383206,
                        "z": 0.096961
                    },
                    "xueweiDetail": {
                        "detailTitle": "膺窗：胸部疼痛特效穴",
                        "detailDescription": "膺，胸膺；窗，窗户。穴在胸膺部，犹如胸室之窗。",
                        "cure": "止咳宁嗽，消肿清热。主治胸满气逆、呼吸喘鸣、咳嗽喘息、乳痈。",
                        "position": "在胸部，第3肋间隙，前正中线旁开4寸。",
                        "quickFind": "正坐或仰卧，从乳头沿垂直线向上推1个肋间隙，按压有酸胀感处即是。",
                        "massage": "胸部疼痛、肋间神经痛或产后母乳不畅等症，都可以通过按摩膺窗来治疗，每次按摩1~3分钟。",
                        "xueweiName": "膺窗",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "膺窗"
                    }
                },
                {
                    "seq": 17,
                    "xueweiName": "乳中",
                    "xueweiCode": "ruzhong",
                    "position": {
                        "x": -0.121055,
                        "y": 1.349155,
                        "z": 0.107356
                    },
                    "xueweiDetail": {
                        "detailTitle": "乳中：乳房保健就靠它",
                        "detailDescription": "乳，乳头；中，正中。穴在乳头正中。",
                        "cure": "调气醒神。主治癫痫、产后乳少、乳痈。",
                        "position": "在胸部，乳头中央。",
                        "quickFind": "将食指指腹放于胸部乳头中央，食指指腹处即是。",
                        "massage": "每天用大拇指和食指捏拉乳头，每次1~3分钟，可治乳痈，并可助乳房健美。",
                        "xueweiName": "乳中",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "乳中"
                    }
                },
                {
                    "seq": 18,
                    "xueweiName": "乳根",
                    "xueweiCode": "rugen",
                    "position": {
                        "x": -0.129842,
                        "y": 1.316752,
                        "z": 0.072591
                    },
                    "xueweiDetail": {
                        "detailTitle": "乳根：乳汁不足就按它",
                        "detailDescription": "乳，乳房；根，根部。穴在乳房根部。",
                        "cure": "宣肺止咳，宽胸增乳。主治胸痛、胸闷、咳喘、乳汁不足、乳房肿痛。",
                        "position": "在胸部，第5肋间隙，前正中线旁开4寸。",
                        "quickFind": "拇指在乳房上，其余四指在乳房下，食指贴于乳房边缘，食指指腹处。",
                        "massage": "用中指和食指指腹着力按压乳根，每天早晚各揉按3~5分钟。对乳痈、乳痛、乳腺炎、乳汁不足等具有很好的疗效。",
                        "xueweiName": "乳根",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "乳根"
                    }
                },
                {
                    "seq": 19,
                    "xueweiName": "不容",
                    "xueweiCode": "burong",
                    "position": {
                        "x": -0.078,
                        "y": 1.289035,
                        "z": 0.110022
                    },
                    "xueweiDetail": {
                        "detailTitle": "不容：腹胀呕吐按之消",
                        "detailDescription": "不，不可；容，容纳。穴在上腹部，意指胃纳水谷达到的最高处，不可再纳。",
                        "cure": "调中和胃，理气止痛。主治腹胀、胃痛、呕吐、食欲不振。",
                        "position": "在上腹部，脐中上6寸，前正中线旁开2寸。",
                        "quickFind": "仰卧，先取中脘穴，再取中院与胸剑联合的中点作水平线，再取锁骨中线与前正中线之间的中点作垂直线，其交叉点按压有酸胀感处即是。",
                        "massage": "用右食指指腹按压不容，每次3~5分钟，以有酸痛感为宜。对呕吐、胃痛和腹胀均有较好疗效。",
                        "xueweiName": "不容",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "不容"
                    }
                },
                {
                    "seq": 20,
                    "xueweiName": "承满",
                    "xueweiCode": "chengman",
                    "position": {
                        "x": -0.078,
                        "y": 1.259996,
                        "z": 0.110028
                    },
                    "xueweiDetail": {
                        "detailTitle": "承满：主治胃痛和胃炎",
                        "detailDescription": "承，承受；满，充满。穴在上腹部，意指胃纳水谷至此充满。",
                        "cure": "理气和胃，降逆止呕。主治胃痛、呕吐、腹胀、胃十二指肠溃疡。",
                        "position": "在上腹部，脐中上5寸，前正中线旁开2寸。",
                        "quickFind": "仰卧，先找到不容，垂直向下量1横指，按压有酸胀感处即是。",
                        "massage": "用食指指腹按压承满，每次3~5分钟，以有酸痛感为宜，可治疗胃痛、胃炎、肋间神经痛等疾病。",
                        "xueweiName": "承满",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "承满"
                    }
                },
                {
                    "seq": 21,
                    "xueweiName": "梁门",
                    "xueweiCode": "liangmen",
                    "position": {
                        "x": -0.078,
                        "y": 1.230956,
                        "z": 0.102393
                    },
                    "xueweiDetail": {
                        "detailTitle": "梁门：预防治疗胃下垂",
                        "detailDescription": "梁，指谷梁；门，门户。穴在上腹部，寓意饮食入胃之门户。",
                        "cure": "和胃理气，健脾调中。主治胃痛、呕吐、腹胀、食欲不振、便溏、呕血。",
                        "position": "在上腹部，脐中上4寸，前正中线旁开2寸。",
                        "quickFind": "仰卧，取肚脐与胸剑联合连线的中点，再水平旁开3横指处即是。",
                        "massage": "用食指指腹按压梁门，每次3~5分钟，以有酸痛感为宜，可治胃痛、呕吐和胃下垂。",
                        "xueweiName": "梁门",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "梁门"
                    }
                },
                {
                    "seq": 22,
                    "xueweiName": "关门",
                    "xueweiCode": "guanmen",
                    "position": {
                        "x": -0.078,
                        "y": 1.201917,
                        "z": 0.095215
                    },
                    "xueweiDetail": {
                        "detailTitle": "关门：胃肠不适就找它",
                        "detailDescription": "关，关隘；门，门户。穴近胃腕下部，约当胃肠交界之关，有开有关，如同门户。",
                        "cure": "调理肠胃，利水消肿。主治胃痛、呕吐、腹胀、食欲不振、便秘、遗尿。",
                        "position": "在上腹部，脐中上3寸，前正中线旁开2寸。",
                        "quickFind": "仰卧，从肚脐沿前正中线向上量4横指，再水平旁开3横指处即是。",
                        "massage": "用食指指腹按压关门，每次3~5分钟，以有酸痛感为宜，可辅助治疗腹胀、腹泻、胃肠虚弱等症。",
                        "xueweiName": "关门",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "关门"
                    }
                },
                {
                    "seq": 23,
                    "xueweiName": "太乙",
                    "xueweiCode": "taiyi",
                    "position": {
                        "x": -0.078,
                        "y": 1.172877,
                        "z": 0.091201
                    },
                    "xueweiDetail": {
                        "detailTitle": "太乙：胃炎恶心按太乙",
                        "detailDescription": "太，甚大；乙，十天干之一。古以中央为太乙。脾土居中，寓腹中央为太乙。穴在胃腕下部，约当腹中央。",
                        "cure": "清心安神，化痰和胃。主治癫狂、吐舌、胃痛、呕吐、腹胀、食欲不振。",
                        "position": "在上腹部，脐中上2寸，前正中线旁开2寸。",
                        "quickFind": "仰卧，取中脘与脐之中点，再水平旁开3横指处即是。",
                        "massage": "每次按揉太乙3~5分钟，以有酸痛感为宜。可治胃病，如胃肠虚弱、恶心等。",
                        "xueweiName": "太乙",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "太乙"
                    }
                },
                {
                    "seq": 24,
                    "xueweiName": "滑肉门",
                    "xueweiCode": "huaroumen",
                    "position": {
                        "x": -0.078,
                        "y": 1.143838,
                        "z": 0.091725
                    },
                    "xueweiDetail": {
                        "detailTitle": "滑肉门：主治腹痛与腹胀",
                        "detailDescription": "滑，美好；肉，肌肉；门，门户。穴平脐上1寸，食物至此已分清泌浊，犹如精细食物通过之门户。",
                        "cure": "镇惊安神，和胃止吐。主治癫狂、胃痛、呕吐、腹胀、食欲不振、月经不调。",
                        "position": "在上腹部，脐中上1寸，前正中线旁开2寸。",
                        "quickFind": "仰卧，从肚脐沿前正中线向上量1横指，再水平旁开3横指处即是。",
                        "massage": "用中间三指指腹垂直下按，再向上托，用力揉按1~3分钟，可辅助治疗慢性胃肠病、呕吐、胃下垂等疾病。",
                        "xueweiName": "滑肉门",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "滑肉门"
                    }
                },
                {
                    "seq": 25,
                    "xueweiName": "天枢",
                    "xueweiCode": "tianshu",
                    "position": {
                        "x": -0.078,
                        "y": 1.108995,
                        "z": 0.098098
                    },
                    "xueweiDetail": {
                        "detailTitle": "天枢：腹泻便秘全搞定",
                        "detailDescription": "天，天空；枢，枢纽。脐上为天属阳，脐下为地属阴。穴位平脐，犹如天地之枢纽。",
                        "cure": "理气调畅，调经止痛。主治呕吐、腹胀肠鸣、腹泻不止、痢疾、便秘、口腔溃疡、月经不调。",
                        "position": "在腹部，横平脐中，前正中线旁开2寸。",
                        "quickFind": "仰卧，肚脐旁开3横指，按压有酸胀感处即是。",
                        "massage": "仰卧，用食指和中指按揉天枢2分钟，可缓解消化不良、便秘、胃胀、腹泻、腹痛等症，效果明显。",
                        "xueweiName": "天枢",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "天枢"
                    }
                },
                {
                    "seq": 26,
                    "xueweiName": "外陵",
                    "xueweiCode": "wailing",
                    "position": {
                        "x": -0.078,
                        "y": 1.077212,
                        "z": 0.101118
                    },
                    "xueweiDetail": {
                        "detailTitle": "外陵：下腹疼痛按之消",
                        "detailDescription": "外，内外之外；陵，山陵。穴位局部隆起如山陵。",
                        "cure": "和胃化湿，理气止痛。主治胃痛、腹痛、腹胀、疝气、痛经。",
                        "position": "在下腹部，脐中下1寸，前正中线旁开2寸。",
                        "quickFind": "仰卧，从肚脐沿前正中线向下量1横指，再水平旁开3横指处即是。",
                        "massage": "仰卧，用中间三个手指按揉外陵1~3分钟，可治疗下腹痛、痛经、胃下垂。",
                        "xueweiName": "外陵",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "外陵"
                    }
                },
                {
                    "seq": 27,
                    "xueweiName": "大巨",
                    "xueweiCode": "daju",
                    "position": {
                        "x": -0.078,
                        "y": 1.043715,
                        "z": 0.099042
                    },
                    "xueweiDetail": {
                        "detailTitle": "大巨：关爱男性保健穴",
                        "detailDescription": "大，大小之大；巨，巨大。穴在腹壁最大隆起的部位。",
                        "cure": "调肠胃，固肾气。主治便秘、腹痛、遗精、早泄、阳痿、小便不利。",
                        "position": "在下腹部，脐中下2寸，前正中线旁开2寸。",
                        "quickFind": "仰卧，从肚脐沿前正中线向下量3横指，再水平旁开3横指处即是。",
                        "massage": "仰卧，用中间三个手指按揉大巨1~3分钟，可治疗遗精、早泄、小便不利等男科疾病，可调理男性性功能障碍等疾病。",
                        "xueweiName": "大巨",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "大巨"
                    }
                },
                {
                    "seq": 28,
                    "xueweiName": "水道",
                    "xueweiCode": "shuidao",
                    "position": {
                        "x": -0.078,
                        "y": 1.00858,
                        "z": 0.095435
                    },
                    "xueweiDetail": {
                        "detailTitle": "水道：女人保健第一穴",
                        "detailDescription": "水，水液；道，道路。穴位深部相当于小肠并靠近膀胱，属下焦。为水道之所出。",
                        "cure": "利水消肿，调经止痛。主治便秘、腹痛、小腹胀痛、痛经、膀胱炎。",
                        "position": "在下腹部，脐中下3寸，前正中线旁开2寸。",
                        "quickFind": "仰卧，从肚脐沿前正中线向下量4横指，再水平旁开3横指处即是。",
                        "massage": "仰卧，用中间三指按揉水道1~3分钟，可治痛经、不孕等妇科疾病。",
                        "xueweiName": "水道",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "水道"
                    }
                },
                {
                    "seq": 29,
                    "xueweiName": "归来",
                    "xueweiCode": "guilai",
                    "position": {
                        "x": -0.078,
                        "y": 0.977896,
                        "z": 0.092939
                    },
                    "xueweiDetail": {
                        "detailTitle": "归来：男女生殖问题消",
                        "detailDescription": "归，归回；来，到来。本穴能治宫脱、疝气等，有归复还纳之功。",
                        "cure": "活血化瘀，调经止痛。主治腹痛、不孕、闭经、阳痿、白带过多。",
                        "position": "在下腹部，脐中下4寸，前正中线旁开2寸。",
                        "quickFind": "仰卧，从耻骨联合上缘沿前正中线向上量1横指，再水平旁开3横指处即是。",
                        "massage": "以中间三指指腹垂直下按，由内而外揉按归来，每日早晚各揉按1~3分钟，可治月经不调、不孕、阳痿等疾病。",
                        "xueweiName": "归来",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "归来"
                    }
                },
                {
                    "seq": 30,
                    "xueweiName": "气冲",
                    "xueweiCode": "qichong",
                    "position": {
                        "x": -0.078,
                        "y": 0.954698,
                        "z": 0.092595
                    },
                    "xueweiDetail": {
                        "detailTitle": "气冲：男女问题就找它",
                        "detailDescription": "气，指经气；冲，冲要。穴在经气流注之冲要。",
                        "cure": "调经血，舒宗筋，理气止痛。主治阳痿、疝气、不孕、腹痛、月经不调。",
                        "position": "在腹股沟区，耻骨联合上缘，前正中线旁开2寸，动脉搏动处。",
                        "quickFind": "仰卧，从耻骨联合上缘中点水平旁开3横指处即是。",
                        "massage": "以食指指腹揉按，每日早晚各揉按1~3分钟，可治疗疝气、月经不调、不孕、阳痿、阴肿等症。",
                        "xueweiName": "气冲",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "气冲"
                    }
                },
                {
                    "seq": 31,
                    "xueweiName": "髀关",
                    "xueweiCode": "biguan",
                    "position": {
                        "x": -0.131353,
                        "y": 0.86754,
                        "z": 0.099927
                    },
                    "xueweiDetail": {
                        "detailTitle": "髀关：改善下肢疼与麻",
                        "detailDescription": "髀，指股部及下肢；关，机关。穴处乃下肢运动之机关也。",
                        "cure": "强腰膝，通经络。主治腰膝疼痛、下肢酸软麻木、膝寒。",
                        "position": "在股前部，股直肌近端、缝匠肌与阔筋膜张肌3条肌肉之间凹陷中。",
                        "quickFind": "仰卧屈股，大腿前骼前上棘与餘底外缘连线和会阴相平的连线交点处即是。",
                        "massage": "用力按揉髀关5分钟，可治腰膝疼痛、下肢酸软麻木、膝寒、股内筋急不得屈伸等症。",
                        "xueweiName": "髀关",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "髀关"
                    }
                },
                {
                    "seq": 32,
                    "xueweiName": "伏兔",
                    "xueweiCode": "futu",
                    "position": {
                        "x": -0.153462,
                        "y": 0.794454,
                        "z": 0.09453
                    },
                    "xueweiDetail": {
                        "detailTitle": "伏兔：解除膝冷与腰疼",
                        "detailDescription": "伏，俯伏；兔，兽名。指穴位于股前方肌肉丰厚之处，形如兔伏，故名伏兔。",
                        "cure": "散寒化湿，疏通经络。主治腰膝疼痛、下肢酸软麻木、腹胀。",
                        "position": "在股前部，髌底上6寸，髂前上棘与髌底外侧端的连线上。",
                        "quickFind": "屈膝90°，手指并拢压腿上，掌后第1横纹中点按在髌骨上缘中点，中指尖端处即是。",
                        "massage": "按揉伏兔最好采取指压带揉动的方式，每个点按压时间约3分钟，可缓解腰膝疼痛、下肢酸软麻木、腹胀、足麻不仁等症。",
                        "xueweiName": "伏兔",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "伏兔"
                    }
                },
                {
                    "seq": 33,
                    "xueweiName": "阴市",
                    "xueweiCode": "yinshi",
                    "position": {
                        "x": -0.144431,
                        "y": 0.708973,
                        "z": 0.091407
                    },
                    "xueweiDetail": {
                        "detailTitle": "阴市：降低血糖好帮手",
                        "detailDescription": "阴，阴阳之阴，指寒邪；市，集市，聚散之意。穴能疏散膝部寒气。",
                        "cure": "散寒除湿，理气止痛。主治腿膝冷痛、麻痹，下肢不遂，脚气，糖尿病。",
                        "position": "在股前区，髌底上3寸，股直肌肌腱外侧缘。",
                        "quickFind": "正坐屈膝，髌底外侧直上量4横指，按压有痛感处即是。",
                        "massage": "下半身寒冷的人可多按揉阴市，最好采取指压带揉动的方式，每次1~3分钟。也可经常用拇指指腹轻轻按揉阴市，每次1~3分钟，可降血糖。",
                        "xueweiName": "阴市",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "阴市"
                    }
                },
                {
                    "seq": 34,
                    "xueweiName": "梁丘",
                    "xueweiCode": "liangqiu",
                    "position": {
                        "x": -0.118849,
                        "y": 0.656967,
                        "z": 0.081251
                    },
                    "xueweiDetail": {
                        "detailTitle": "梁丘：对付胃痛最有效",
                        "detailDescription": "梁，山梁；丘，丘陵。形如山梁丘陵，穴当其处。",
                        "cure": "理气和胃，通经活络。主治胃痛、肠鸣腹泻、膝关节炎、乳肿痛。",
                        "position": "在股前区，髌骨外缘上2寸，股外侧肌与股直肌肌腱之间。",
                        "quickFind": "坐位，下肢用力蹬直，髌骨外上缘上方凹陷正中处即是。",
                        "massage": "梁丘治疗急性病效果好。如急性胃炎、肠胃炎引发的突然乳房痛，或者突然膝盖痛时，赶紧揉一下梁丘，就会马上缓解。",
                        "xueweiName": "梁丘",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "梁丘"
                    }
                },
                {
                    "seq": 35,
                    "xueweiName": "犊鼻",
                    "xueweiCode": "dubi",
                    "position": {
                        "x": -0.12435,
                        "y": 0.51209,
                        "z": 0.034962
                    },
                    "xueweiDetail": {
                        "detailTitle": "犊鼻：治疗膝关节炎症",
                        "detailDescription": "犊，小牛；鼻，口鼻。膝盖形如牛鼻，穴在膝眼中，故名。",
                        "cure": "消肿止痛，通经活络。主治膝痛、腰痛、足跟痛、脚气。",
                        "position": "在膝前区，髌韧带外侧凹陷中。",
                        "quickFind": "坐位，下肢用力蹬直，膝盖下面外侧凹陷处即是。",
                        "massage": "揉按犊鼻5分钟，可减轻剧烈运动造成的膝关节疼痛。长期坚持用中指指腹按摩犊鼻，每次1~3分钟，可以改善膝部疼痛、酸软等症。",
                        "xueweiName": "犊鼻",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "犊鼻"
                    }
                },
                {
                    "seq": 36,
                    "xueweiName": "足三里",
                    "xueweiCode": "zusanli",
                    "position": {
                        "x": -0.139631,
                        "y": 0.404744,
                        "z": -0.007476
                    },
                    "xueweiDetail": {
                        "detailTitle": "足三里：天然滋补此穴强",
                        "detailDescription": "足，下肢；三，数词；里，古代有以里为寸之说。穴在下肢，位于外膝眼下三寸。",
                        "cure": "健脾和胃，通经活络。主治胃痛、呕吐、腹胀、腹泻、便秘、高脂血症、头痛、眩晕、鼻塞、癫痫、半身不遂、脾胃虚弱、贫血、手足怕冷、湿疹、荨麻疹、小儿咳嗽、小儿发热。",
                        "position": "在小腿前外侧，犊鼻下3寸，犊鼻与解溪连线上。",
                        "quickFind": "站位弯腰，同侧手虎口围住髌骨上外缘，余四指向下，中指指尖处即是。",
                        "massage": "每天用拇指或中指按压足三里5~10分钟，每分钟按压15~20次，长期坚持，可使人精神焕发，精力充沛，益寿延年。",
                        "xueweiName": "足三里",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "足三里"
                    }
                },
                {
                    "seq": 37,
                    "xueweiName": "上巨虚",
                    "xueweiCode": "shangjuxu",
                    "position": {
                        "x": -0.133892,
                        "y": 0.344128,
                        "z": -0.037017
                    },
                    "xueweiDetail": {
                        "detailTitle": "上巨虚：艾灸可治肠胃病",
                        "detailDescription": "上，上方；巨，巨大；虚，中空，胫骨和腓骨之间形成的较大空隙，即中空。穴在此空隙上方。",
                        "cure": "调和肠胃，通经活络。主治肠胃炎、腹泻、便秘、腹胀、高血压。",
                        "position": "在小腿外侧，犊鼻下6寸，犊鼻与解溪连线上。",
                        "quickFind": "坐位屈膝，先找到足三里，向下量4指凹陷处即是。",
                        "massage": "按揉上巨虚主治消化系统疾病，如阑尾炎、肠胃炎、腹泻等。用艾灸法效果最好，将艾条对准穴位，距皮肤2~3厘米，灸5~10分钟。",
                        "xueweiName": "上巨虚",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "上巨虚"
                    }
                },
                {
                    "seq": 38,
                    "xueweiName": "条口",
                    "xueweiCode": "tiaokou",
                    "position": {
                        "x": -0.128298,
                        "y": 0.305338,
                        "z": -0.020718
                    },
                    "xueweiDetail": {
                        "detailTitle": "条口：让肠胃更加强健",
                        "detailDescription": "条，长条；口，空隙。穴在腓骨和胫骨之间的长条隙之中。",
                        "cure": "理气和中，舒筋活络。主治肩背痛、小腿肿痛、胃肠疾病、脚气。",
                        "position": "在小腿外侧，犊鼻下8寸，胫骨前延外1寸。",
                        "quickFind": "坐位屈膝，犊鼻与外踝尖之间的中点，胫骨外1横指处。",
                        "massage": "用力按揉条口，可治肩关节剧痛、急痛，将艾条对准条口，距皮肤2~3厘米，灸5~10分钟，可治胃肠虚弱、肩臂疼痛、下肢痿痹等疾病。",
                        "xueweiName": "条口",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "条口"
                    }
                },
                {
                    "seq": 39,
                    "xueweiName": "下巨虚",
                    "xueweiCode": "xiajuxu",
                    "position": {
                        "x": -0.123164,
                        "y": 0.276213,
                        "z": -0.024543
                    },
                    "xueweiDetail": {
                        "detailTitle": "下巨虚：主治肠胃系统病",
                        "detailDescription": "下，下方；巨，巨大；虚，中空。胫骨和腓骨之间形成的较大空隙，即中空。穴在此空隙下方。",
                        "cure": "调肠胃，通经络，安神志。主治小腹疼痛、胃痛、胰腺炎、下肢浮肿。",
                        "position": "在小腿外侧，犊鼻下9寸，犊鼻与解溪连线上。",
                        "quickFind": "坐位屈膝，先找到条口，向下量1横指凹陷处即是。",
                        "massage": "按揉下巨虚，可治腹痛、腹泻、便秘等症，将艾条对准下巨虚，距皮肤2〜3厘米，灸5~10分钟，可治消化系统疾病。",
                        "xueweiName": "下巨虚",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "下巨虚"
                    }
                },
                {
                    "seq": 40,
                    "xueweiName": "丰隆",
                    "xueweiCode": "fenglong",
                    "position": {
                        "x": -0.124998,
                        "y": 0.30794,
                        "z": -0.059367
                    },
                    "xueweiDetail": {
                        "detailTitle": "丰隆：除湿化痰常刮痧",
                        "detailDescription": "丰，丰满；隆，隆盛。胃经谷气隆盛，至此处丰满溢出于大络。",
                        "cure": "和胃气，化痰湿，清神志。主治呕吐、便秘、水肿、头痛、眩晕、痰多、癫狂、下肢痿痹等。",
                        "position": "在小腿外侧，外踝尖上8寸，胫骨前肌的外缘。",
                        "quickFind": "坐位屈膝，先找到足三里，向下量6横指凹陷处即是。",
                        "massage": "当出现哮喘、咳嗽、痰多时，宜多揉丰隆，用刮痧的方式更有效，可以促进人体的新陈代谢，从而达到除湿化痰的效果。",
                        "xueweiName": "丰隆",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "丰隆"
                    }
                },
                {
                    "seq": 41,
                    "xueweiName": "解溪",
                    "xueweiCode": "jiexi",
                    "position": {
                        "x": -0.10305,
                        "y": 0.145817,
                        "z": -0.002906
                    },
                    "xueweiDetail": {
                        "detailTitle": "解溪：腹胀眩晕一起消",
                        "detailDescription": "解，分解；溪，沟溪，指体表较小凹陷。穴在踝关节前骨节分解凹陷中。",
                        "cure": "清胃化痰，镇惊安神，舒筋活络。主治面部浮肿、腹胀、下剧中痛、头痛、眩晕、癫狂。",
                        "position": "在踝部，踝关节前面中央凹陷中，拇长伸肌腱与趾长伸肌腱之间。",
                        "quickFind": "足背与小腿交界处的横纹中央凹陷处，足背两条肌腱之间即是。",
                        "massage": "经常用拇指指腹向内用力按压解溪，每次1~3分钟，可以强壮内脏器官，健胃益脑。",
                        "xueweiName": "解溪",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "解溪"
                    }
                },
                {
                    "seq": 42,
                    "xueweiName": "冲阳",
                    "xueweiCode": "chongyang",
                    "position": {
                        "x": -0.129774,
                        "y": 0.124144,
                        "z": 0.005392
                    },
                    "xueweiDetail": {
                        "detailTitle": "冲阳：除腹胀又增食欲",
                        "detailDescription": "冲，冲要；阳，阴阳之阳。穴在冲阳脉（足背动脉）所在之处。",
                        "cure": "和胃化痰，通络宁神。主治腹胀、口眼歪斜、牙痛、精神病。",
                        "position": "在足背，第2跖骨基底部与中间楔状骨关节处，足背动脉搏动处。",
                        "quickFind": "足背最高处，两条肌腱之间，按之有动脉搏动感处即是。",
                        "massage": "以中指指腹用力按压冲阳，每天早晚各按1次，每次1~3分钟，可治消化系统疾病。",
                        "xueweiName": "冲阳",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "冲阳"
                    }
                },
                {
                    "seq": 43,
                    "xueweiName": "陷谷",
                    "xueweiCode": "xiangu",
                    "position": {
                        "x": -0.179685,
                        "y": 0.079349,
                        "z": 0.053863
                    },
                    "xueweiDetail": {
                        "detailTitle": "陷谷：专治胃炎胃下垂",
                        "detailDescription": "陷，凹陷；谷，山谷，指体表凹陷。穴在第2、第3跖骨间隙凹陷中。",
                        "cure": "清热解表，和胃止痛。主治慢性胃炎、面部浮肿、腹痛、足背肿痛。",
                        "position": "在足背，第2、第3跖骨间，第28石趾关节近端凹陷中。",
                        "quickFind": "足背第2、第3跖骨结合部前方凹陷处，按压有酸胀感处即是。",
                        "massage": "弯曲拇指，用指尖下压揉按陷谷，早晚各1次，先左后右，各揉按1~3分钟，可治胃炎、胃下垂、肠炎、结膜炎等疾病。",
                        "xueweiName": "陷谷",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "陷谷"
                    }
                },
                {
                    "seq": 44,
                    "xueweiName": "内庭",
                    "xueweiCode": "neiting",
                    "position": {
                        "x": -0.210591,
                        "y": 0.05646,
                        "z": 0.081078
                    },
                    "xueweiDetail": {
                        "detailTitle": "内庭：口腔上火最有效",
                        "detailDescription": "内，里边；庭，庭院。本穴在厉兑之里，犹如门内的庭院。",
                        "cure": "清胃泻火，理气止痛。主治腹痛、腹泻、牙痛、头面痛、咽喉肿痛。",
                        "position": "在足背，第2、第3趾，趾蹼缘后方赤白肉际处。",
                        "quickFind": "足背第2、第3趾之间，皮肤颜色深浅交界处即是。",
                        "massage": "用一手拇指指腹放在对侧内庭上，适当用力上下推动，有消肿止痛的功效。可治口腔溃疡、鼻出血等上火症状。",
                        "xueweiName": "内庭",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "内庭"
                    }
                },
                {
                    "seq": 45,
                    "xueweiName": "厉兑",
                    "xueweiCode": "lidui",
                    "position": {
                        "x": -0.235142,
                        "y": 0.0407,
                        "z": 0.120346
                    },
                    "xueweiDetail": {
                        "detailTitle": "厉兑：快速止吐有奇效",
                        "detailDescription": "厉，指胃；兑，代表门。本穴在趾端，犹如胃经之门户。",
                        "cure": "清热和胃，苏厥醒神，通经活络。主治晕厥、呕吐、胃痛、水肿、牙痛、足背肿痛。",
                        "position": "在足趾，第2趾末节外侧，趾甲根角侧后方0.1寸（指寸）。",
                        "quickFind": "足背第2趾趾甲外侧缘与趾甲下缘各作一垂线，交点处即是。",
                        "massage": "用拇指指甲尖垂直掐按厉兑，有刺痛感，每次左右各掐按1~3分钟，可以有效缓解呕吐症状。",
                        "xueweiName": "厉兑",
                        "jingluoName": "足阳明胃经",
                        "titleUrl": "厉兑"
                    }
                }
            ]
        },
        {
            "jingMaiName": "足太阴脾经",
            "jingMaiCode": "zutaiyinpijing",
            "xueweiList": [
                {
                    "seq": 1,
                    "xueweiName": "隐白",
                    "xueweiCode": "yinbai",
                    "position": {
                        "x": -0.199212,
                        "y": 0.048592,
                        "z": 0.144683
                    },
                    "xueweiDetail": {
                        "detailTitle": "隐白：艾灸止血速度快",
                        "detailDescription": "隐，隐蔽；白，白色。穴在隐蔽之处，其处色白。",
                        "cure": "调经统血，健脾宁神。主治月经过多、崩漏、腹胀、便血、中风、昏迷。",
                        "position": "在足趾，大趾末节内侧，趾甲根角侧后方0.1寸（指寸）。",
                        "quickFind": "足大趾趾甲内侧缘与下缘各作一垂线，其交点处即是。",
                        "massage": "月经过多或崩漏可用艾条灸隐白，一般15分钟可见效。该穴位还可治慢性崩漏，每天灸1次，每次3分钟，掐按10~20次。",
                        "xueweiName": "隐白",
                        "jingluoName": "足太阴脾经",
                        "titleUrl": "隐白"
                    }
                },
                {
                    "seq": 2,
                    "xueweiName": "大都",
                    "xueweiCode": "dadou",
                    "position": {
                        "x": -0.156406,
                        "y": 0.064175,
                        "z": 0.096716
                    },
                    "xueweiDetail": {
                        "detailTitle": "大都：抽筋不怕按大都",
                        "detailDescription": "大，大小之大；都，都会。穴在大趾，为经气聚散之处。",
                        "cure": "健脾利湿、和胃镇惊。主治腹胀、腹痛、呕吐、便秘、胃痛、小儿惊风。",
                        "position": "在足趾，第1跖趾关节远端赤白肉际凹陷中。",
                        "quickFind": "足大趾与足掌所构成的关节，前下方掌背交界线凹陷处即是。",
                        "massage": "常用大拇指指腹按揉大都，每次300下，可有效缓解抽筋。",
                        "xueweiName": "大都",
                        "jingluoName": "足太阴脾经",
                        "titleUrl": "大都"
                    }
                },
                {
                    "seq": 3,
                    "xueweiName": "太白",
                    "xueweiCode": "taibai",
                    "position": {
                        "x": -0.124899,
                        "y": 0.08533,
                        "z": 0.049894
                    },
                    "xueweiDetail": {
                        "detailTitle": "太白：健脾化湿就按它",
                        "detailDescription": "太，甚大；白，白色。穴在大趾白肉上；此处之白肉更为开阔。",
                        "cure": "清热化湿，健脾和胃。主治脾胃虚弱、胃痛、腹胀、腹痛、腰痛、肠鸣。",
                        "position": "在跖区，第1跖趾关节近端赤白肉际凹陷中。",
                        "quickFind": "足大趾与足掌所构成的关节，后下方掌背交界线凹陷处即是。",
                        "massage": "顺时针或逆时针方向反复揉按太白，每次2~3分钟。可治呕吐、消化不良、腹痛、肠鸣、便血、便秘等症。",
                        "xueweiName": "太白",
                        "jingluoName": "足太阴脾经",
                        "titleUrl": "太白"
                    }
                },
                {
                    "seq": 4,
                    "xueweiName": "公孙",
                    "xueweiCode": "gongsun",
                    "position": {
                        "x": -0.106182,
                        "y": 0.107535,
                        "z": 0.021858
                    },
                    "xueweiDetail": {
                        "detailTitle": "公孙：摆平腹胀与胸痛",
                        "detailDescription": "公，有通的意思；孙，孙络，在此特指络脉，脾经之络脉是从此通向胃经的。",
                        "cure": "健脾益胃、通调冲脉。主治呕吐、腹痛、胃痛、失眠、小儿腹泻、小儿厌食。",
                        "position": "在跖区，当第1跖骨底的前下缘赤白肉际处。",
                        "quickFind": "足大趾与足掌所构成的关节内侧，弓形骨后端下缘凹陷处即是。",
                        "massage": "用中指指腹向内按压公孙，以有酸痛感为宜，可辅助治疗腹胀、腹痛、心痛、胃痛、胸痛等症。",
                        "xueweiName": "公孙",
                        "jingluoName": "足太阴脾经",
                        "titleUrl": "公孙"
                    }
                },
                {
                    "seq": 5,
                    "xueweiName": "商丘",
                    "xueweiCode": "shangqiu",
                    "position": {
                        "x": -0.086207,
                        "y": 0.136285,
                        "z": -0.001128
                    },
                    "xueweiDetail": {
                        "detailTitle": "商丘：扭伤康复就揉它",
                        "detailDescription": "商，五音之一，属金；丘，丘陵。此为足太阴脾经经穴，属金，在丘陵样内踝的下方。",
                        "cure": "健脾化湿，通调肠胃。主治腹胀、肠鸣、痔疮、两足无力、足踝痛。",
                        "position": "在踝部，内踝前下方，舟骨粗隆与内踝尖连线中点的凹陷中。",
                        "quickFind": "足内踝前下方凹陷处即是。",
                        "massage": "足踝痛、踝关节扭伤时可用推拿法按摩商丘。经常用拇指指腹用力揉按商丘，每次1~3分钟，长期坚持对踝关节有很好的保养作用。",
                        "xueweiName": "商丘",
                        "jingluoName": "足太阴脾经",
                        "titleUrl": "商丘"
                    }
                },
                {
                    "seq": 6,
                    "xueweiName": "三阴交",
                    "xueweiCode": "sanyinjiao",
                    "position": {
                        "x": -0.082692,
                        "y": 0.216293,
                        "z": -0.014003
                    },
                    "xueweiDetail": {
                        "detailTitle": "三阴交：妇科病首选穴位",
                        "detailDescription": "三阴，指足之三阴经而言；交，指交会与交接。为足太阴、足少阴、足厥阴三条阴经气血物质之交会处。",
                        "cure": "健脾益胃，调肝补肾，调理经带。主治脾胃虚弱、腹泻、胃痛、痛经、月经不调、月经过多、小便不利、阳痿、失眠、糖尿病、更年期综合征、白带过多、前列腺炎、早泄。",
                        "position": "在小腿内侧，内踝尖上3寸，胫骨内侧缘后际。",
                        "quickFind": "手四指并拢，小指下缘靠内踝尖上，食指上缘所在水平线与胫骨后缘交点处即是。",
                        "massage": "用拇指指尖垂直按压三阴交，每天早晚各1次，每次左右足各1~3分钟，可改善女性各种病症；孕妇禁按，有引发流产的危险。",
                        "xueweiName": "三阴交",
                        "jingluoName": "足太阴脾经",
                        "titleUrl": "三阴交"
                    }
                },
                {
                    "seq": 7,
                    "xueweiName": "漏谷",
                    "xueweiCode": "lougu",
                    "position": {
                        "x": -0.073421,
                        "y": 0.284659,
                        "z": -0.008791
                    },
                    "xueweiDetail": {
                        "detailTitle": "漏谷：小便不畅按漏谷",
                        "detailDescription": "漏，凹陷；谷，山谷。穴居胫骨后内侧缘山谷样凹陷中。",
                        "cure": "健脾和胃，利尿除湿。主治腹胀、腹痛、水肿、小便不利、足踝肿痛。",
                        "position": "在小腿内侧，内踝尖上6寸，胫骨内侧缘后际。",
                        "quickFind": "胫骨内侧缘，内踝尖直上量两个4横指处即是。",
                        "massage": "以拇指指尖垂直按压漏谷，每天早晚各1次，每次左右足各揉按1~3分钟，可缓解男性小便不利及前列腺问题。",
                        "xueweiName": "漏谷",
                        "jingluoName": "足太阴脾经",
                        "titleUrl": "漏谷"
                    }
                },
                {
                    "seq": 8,
                    "xueweiName": "地机",
                    "xueweiCode": "diji",
                    "position": {
                        "x": -0.062704,
                        "y": 0.369229,
                        "z": 0.000661
                    },
                    "xueweiDetail": {
                        "detailTitle": "地机：改善胰岛素分泌",
                        "detailDescription": "地，土地，指下肢；机，机要。穴在下肢，肌肉最为丰富，是小腿运动的机要部位。",
                        "cure": "健脾渗湿，调经止带。主治腹胀腹痛、月经不调、遗精、糖尿病。",
                        "position": "在小腿内侧，阴陵泉下3寸，胫骨内侧缘后际。",
                        "quickFind": "先找到阴陵泉，直下量4横指即是。",
                        "massage": "每天用中指指腹垂直用力按压1~3分钟，能调节胰岛素分泌，降低血糖。",
                        "xueweiName": "地机",
                        "jingluoName": "足太阴脾经",
                        "titleUrl": "地机"
                    }
                },
                {
                    "seq": 9,
                    "xueweiName": "阴陵泉",
                    "xueweiCode": "yinlingquan",
                    "position": {
                        "x": -0.055659,
                        "y": 0.443961,
                        "z": -0.008236
                    },
                    "xueweiDetail": {
                        "detailTitle": "阴陵泉：下焦湿热的克星",
                        "detailDescription": "阴，阴阳之阴；陵，山陵；泉，泉水。内为阴，穴在胫骨内上髁下缘凹陷中，如山陵下之水泉。",
                        "cure": "清利湿热，健脾理气，益肾调经，通经活络。主治腹痛、膝痛、水肿、遗尿、中风、失眠。",
                        "position": "在小腿内侧，胫骨内侧髁下缘与胫骨内侧缘之间的凹陷中。",
                        "quickFind": "拇指沿小腿内侧骨内缘向上推，抵膝关节下，胫骨向内上弯曲凹陷处即是。",
                        "massage": "双手轻握膝下处，屈曲拇指，指尖由下向上出力揉按阴陵泉，每次揉按1-3分钟，可缓解腹痛、膝痛等症。",
                        "xueweiName": "阴陵泉",
                        "jingluoName": "足太阴脾经",
                        "titleUrl": "阴陵泉"
                    }
                },
                {
                    "seq": 10,
                    "xueweiName": "血海",
                    "xueweiCode": "xuehai",
                    "position": {
                        "x": -0.056003,
                        "y": 0.681109,
                        "z": 0.077515
                    },
                    "xueweiDetail": {
                        "detailTitle": "血海：祛瘀血又生新血",
                        "detailDescription": "血，气血的血；海，海洋。本穴善治各种“血”症，犹如聚溢血重归于海。",
                        "cure": "调经统血，健脾化湿。主治腹胀、月经不调、痛经、荨麻疹、贫血、白癜风。",
                        "position": "在股前部，髌底内侧端上2寸，股内侧肌隆起处。",
                        "quickFind": "屈膝90°，手掌伏于膝盖上，拇指与其他四指呈45°，拇指指尖处即是。",
                        "massage": "每天早晚用拇指指尖按揉血海，每次1~3分钟，可使女人肌肤细腻、红润有光泽。",
                        "xueweiName": "血海",
                        "jingluoName": "足太阴脾经",
                        "titleUrl": "血海"
                    }
                },
                {
                    "seq": 11,
                    "xueweiName": "箕门",
                    "xueweiCode": "jimen",
                    "position": {
                        "x": -0.069036,
                        "y": 0.823881,
                        "z": 0.094955
                    },
                    "xueweiDetail": {
                        "detailTitle": "箕门：湿疹遗尿皆可消",
                        "detailDescription": "箕，簸箕；门，门户。两腿张开席地而坐，形如箕。穴在大腿内侧，左右对称，似箕之门户。",
                        "cure": "健脾渗湿，通利下焦。主治两股生疮、阴囊湿痒、小便不利、遗尿。",
                        "position": "在股前部，髌底内侧端与冲门连线上，髌底内侧端上8寸处。",
                        "quickFind": "坐位绷腿，大腿内侧有一鱼状肌肉隆起，鱼尾凹陷处即是。",
                        "massage": "每次各揉按左右箕门1~3分钟，先左后右，可治女性阴道瘙痒、男性阴囊湿疹。",
                        "xueweiName": "箕门",
                        "jingluoName": "足太阴脾经",
                        "titleUrl": "箕门"
                    }
                },
                {
                    "seq": 12,
                    "xueweiName": "冲门",
                    "xueweiCode": "chongmen",
                    "position": {
                        "x": -0.072877,
                        "y": 0.926045,
                        "z": 0.09509
                    },
                    "xueweiDetail": {
                        "detailTitle": "冲门：妇科疾病不用愁",
                        "detailDescription": "冲，冲要；门，门户。穴在气街部，为经气通过的重要门户。",
                        "cure": "健脾化湿，理气解痉。主治腹痛、腹胀、小便不利、妊娠浮肿、崩漏。",
                        "position": "在腹股沟斜纹中，髂外动脉搏动处的外侧，距耻骨联合中点上缘3.5寸。",
                        "quickFind": "仰卧，腹股沟外侧可摸到搏动，搏动外侧按压有酸胀感处即是。",
                        "massage": "仰卧，用中间三指按揉冲门1~3分钟，可治崩漏、带下等妇科病症。",
                        "xueweiName": "冲门",
                        "jingluoName": "足太阴脾经",
                        "titleUrl": "冲门"
                    }
                },
                {
                    "seq": 13,
                    "xueweiName": "府舍",
                    "xueweiCode": "fushe",
                    "position": {
                        "x": -0.12511,
                        "y": 0.979814,
                        "z": 0.081213
                    },
                    "xueweiDetail": {
                        "detailTitle": "府舍：腹痛腹胀不用愁",
                        "detailDescription": "府，指脏腑；舍，宅舍。穴位深处是腹腔，为脏腑的宅舍。",
                        "cure": "健脾理气，散结止痛。主治腹痛、腹中肿块、霍乱吐泻、疝气。",
                        "position": "在下腹部，脐中下4.3寸，前正中线旁开4寸。",
                        "quickFind": "仰卧，腹股沟外侧可摸到动脉搏动处，其外侧按压有酸胀感处即是。",
                        "massage": "仰卧，用中间三个手指按揉穴位1〜3分钟，可治便秘、下腹疼痛、腹胀等病症。",
                        "xueweiName": "府舍",
                        "jingluoName": "足太阴脾经",
                        "titleUrl": "府舍"
                    }
                },
                {
                    "seq": 14,
                    "xueweiName": "腹结",
                    "xueweiCode": "fujie",
                    "position": {
                        "x": -0.124324,
                        "y": 1.065078,
                        "z": 0.069083
                    },
                    "xueweiDetail": {
                        "detailTitle": "腹结：腹泻便秘双调节",
                        "detailDescription": "腹，腹部；结，结聚。本穴善治腹部结聚不通之症。",
                        "cure": "健脾化湿，理气调肠。主治腹泻、便秘、胁痛、打嗝、疝气。",
                        "position": "在下腹部，脐中下1.3寸，前正中线旁开4寸。",
                        "quickFind": "仰卧，气海旁开6横指，再向下0.2寸处。",
                        "massage": "常用拇指指腹轻轻揉按，每次1~3分钟，对消化系统有很好的保养作用。",
                        "xueweiName": "腹结",
                        "jingluoName": "足太阴脾经",
                        "titleUrl": "腹结"
                    }
                },
                {
                    "seq": 15,
                    "xueweiName": "大横",
                    "xueweiCode": "daheng",
                    "position": {
                        "x": -0.123574,
                        "y": 1.108866,
                        "z": 0.076204
                    },
                    "xueweiDetail": {
                        "detailTitle": "大横：促进消化又减肥",
                        "detailDescription": "大，大小之大；横，横竖之横。穴位在内应横行于大肠。",
                        "cure": "调理肠胃，温中驱寒。主治腹胀、腹痛、痢疾、腹泻、便秘、高脂血症。",
                        "position": "在腹部，脐中旁开4寸。",
                        "quickFind": "肚脐水平旁开4寸（锁骨中线上）处即是。",
                        "massage": "每天早晚用中指指腹按压，每次3~5分钟，可促进肠胃消化，防治腰腹肥胖。",
                        "xueweiName": "大横",
                        "jingluoName": "足太阴脾经",
                        "titleUrl": "大横"
                    }
                },
                {
                    "seq": 16,
                    "xueweiName": "腹哀",
                    "xueweiCode": "fuai",
                    "position": {
                        "x": -0.129184,
                        "y": 1.198922,
                        "z": 0.055908
                    },
                    "xueweiDetail": {
                        "detailTitle": "腹哀：肝胆疼痛就找它",
                        "detailDescription": "腹，腹部；哀，伤痛。本穴善治腹部各种伤痛。",
                        "cure": "健脾和胃，理气调肠。主治肝胆疾病、腹痛、消化不良、便秘、痢疾。",
                        "position": "在上腹部，脐上3寸，前正中线旁开4寸。",
                        "quickFind": "肚脐沿前正中线向上量4横指，再水平旁开6横指（锁骨中线上）处即是。",
                        "massage": "两掌平放于腹哀处，稍加用力后顺时针方向揉动，可辅助治疗胆结石、胆囊炎等肝胆疾病引起的疼痛、恶心。",
                        "xueweiName": "腹哀",
                        "jingluoName": "足太阴脾经",
                        "titleUrl": "腹哀"
                    }
                },
                {
                    "seq": 17,
                    "xueweiName": "食窦",
                    "xueweiCode": "shidou",
                    "position": {
                        "x": -0.146681,
                        "y": 1.294347,
                        "z": 0.041153
                    },
                    "xueweiDetail": {
                        "detailTitle": "食窦：食积反胃有良效",
                        "detailDescription": "食，食物；窦，孔窦。穴在乳头外下方，深部有储藏乳汁的孔窦。本穴能促进食物营养的吸收，为补益之孔穴。",
                        "cure": "消食导滞，宣肺平喘，健脾和中，利水消肿。主治食积、反胃、胸膜炎、胸胁胀痛。",
                        "position": "在胸部，第5肋间隙，前正中线旁开6寸。",
                        "quickFind": "仰卧，乳头旁开3横指，再向下1个肋间隙处即是。",
                        "massage": "将中间三指并拢，以指腹揉按食窦，每次1~3分钟，可治心脏疾病引起的胸痛、肋间神经痛、心悸等疾病。",
                        "xueweiName": "食窦",
                        "jingluoName": "足太阴脾经",
                        "titleUrl": "食窦"
                    }
                },
                {
                    "seq": 18,
                    "xueweiName": "天溪",
                    "xueweiCode": "tianxi",
                    "position": {
                        "x": -0.145051,
                        "y": 1.362784,
                        "z": 0.080465
                    },
                    "xueweiDetail": {
                        "detailTitle": "天溪：哺乳期间可催乳",
                        "detailDescription": "天，天空，指上天而言；溪，沟溪。穴当肋间如沟溪处。",
                        "cure": "宽胸通乳，理气止咳。主治胸部疼痛、咳嗽、胸胁胀痛、乳房肿痛。",
                        "position": "在胸部，第4肋间隙，前正中线旁开6寸。",
                        "quickFind": "仰卧，乳头旁开3横指处，乳头所在肋间隙即是。",
                        "massage": "将中间三指并拢，以指腹揉按天溪，每次1~3分钟，可治乳房发育不良或产后母乳不畅等。",
                        "xueweiName": "天溪",
                        "jingluoName": "足太阴脾经",
                        "titleUrl": "天溪"
                    }
                },
                {
                    "seq": 19,
                    "xueweiName": "胸乡",
                    "xueweiCode": "xiongxiang",
                    "position": {
                        "x": -0.165082,
                        "y": 1.428729,
                        "z": 0.036069
                    },
                    "xueweiDetail": {
                        "detailTitle": "胸乡：胸胁胀痛不用愁",
                        "detailDescription": "胸，胸部；乡，指部位。穴在胸部，能治胸部疾病。",
                        "cure": "宣肺止咳，理气止痛。主治胸部疼痛、咳嗽、胸胁胀痛、肋间神经痛。",
                        "position": "在胸部，第3肋间隙，前正中线旁开6寸。",
                        "quickFind": "仰卧，乳头旁开3横指，再向上1个肋间隙处即是。",
                        "massage": "将中间三指并拢，以指腹揉按胸乡，每次1~3分钟，可治心脏疾病引起的胸痛、肋间神经痛、咳嗽等症。",
                        "xueweiName": "胸乡",
                        "jingluoName": "足太阴脾经",
                        "titleUrl": "胸乡"
                    }
                },
                {
                    "seq": 20,
                    "xueweiName": "周荣",
                    "xueweiCode": "zhourong",
                    "position": {
                        "x": -0.16585,
                        "y": 1.450621,
                        "z": 0.030575
                    },
                    "xueweiDetail": {
                        "detailTitle": "周荣：心平气顺身体棒",
                        "detailDescription": "周，周身；荣，荣养。本穴可调和营气，荣养周身。",
                        "cure": "宣肺平喘、理气化痰。主治胸胁胀满、胁肋痛、咳嗽、食欲不振。",
                        "position": "在胸部，第2肋间隙，前正中线旁开6寸。",
                        "quickFind": "仰卧，乳头旁开3横指，再向上2个肋间隙处即是。",
                        "massage": "中间三指并拢，以指腹揉按穴位1~3分钟，每天早晚各1次。可缓解咳嗽或者胸胁胀满。长期坚持对呼吸系统有很好的保养作用。",
                        "xueweiName": "周荣",
                        "jingluoName": "足太阴脾经",
                        "titleUrl": "周荣"
                    }
                },
                {
                    "seq": 21,
                    "xueweiName": "大包",
                    "xueweiCode": "dabao",
                    "position": {
                        "x": -0.164935,
                        "y": 1.278004,
                        "z": -0.00273
                    },
                    "xueweiDetail": {
                        "detailTitle": "大包：肺部保健关键穴",
                        "detailDescription": "大，大小之大；包，包容。穴属脾之大络。脾土居中，与各脏腑有着最广泛的联系。",
                        "cure": "宽胸利胁，行气止痛，止咳平喘。主治肺炎、胸膜炎、哮喘、气喘、全身胀痛。",
                        "position": "在胸外侧区，第6肋间隙，在腋中线上。",
                        "quickFind": "正坐侧身或仰卧，腋窝顶点与第11肋骨端连线的中点处即是。",
                        "massage": "每天早晚用中指指尖揉按大包，每次1~3分钟，有利于清除穴位内部的瘀血，消除肿块，调理肺气，对肺部具有改善和养护功能。",
                        "xueweiName": "大包",
                        "jingluoName": "足太阴脾经",
                        "titleUrl": "大包"
                    }
                }
            ]
        },
        {
            "jingMaiName": "手少阴心经",
            "jingMaiCode": "shoushaoyinxinjing",
            "xueweiList": [
                {
                    "seq": 1,
                    "xueweiName": "极泉",
                    "xueweiCode": "jiquan",
                    "position": {
                        "x": 0,
                        "y": 0,
                        "z": 0
                    },
                    "xueweiDetail": {
                        "detailTitle": "极泉：治冠心病常用穴",
                        "detailDescription": "极，高大之意；泉，水泉。穴在腋窝高处，局部凹陷如泉。",
                        "cure": "宽胸宁神。主治冠心病、心痛、四肢不举、乳汁分泌不足。",
                        "position": "在腋窝中央，腋动脉搏动处。",
                        "quickFind": "上臂外展，腋窝顶点可触摸到动脉搏动，按压有酸胀感处即是。",
                        "massage": "每天早晚用中指按摩左右极泉各1~3分钟，可辅助治疗冠心病等各种心脏疾病。",
                        "xueweiName": "极泉",
                        "jingluoName": "手少阴心经",
                        "titleUrl": "极泉"
                    }
                },
                {
                    "seq": 2,
                    "xueweiName": "青灵",
                    "xueweiCode": "qingling",
                    "position": {
                        "x": -0.209527,
                        "y": 1.253215,
                        "z": 0.033873
                    },
                    "xueweiDetail": {
                        "detailTitle": "青灵：祛除疼痛无烦恼",
                        "detailDescription": "青，生发之象；灵，神灵。心为君主之官，通灵，具有脉气生发之象。",
                        "cure": "理气止痛，宽胸宁心。主治头痛、肩臂红肿、腋下肿痛、全身冷颤。",
                        "position": "在臂前部，肘横纹上3寸，肱二头肌的内侧沟中。",
                        "quickFind": "伸臂，确定少海与极泉位置，从少海沿两者连线量4横指处即是。",
                        "massage": "常用手掌拍打或用拇指指腹按揉青灵，每次1~3分钟，可预防肋痛、肩臂疼痛以及心绞痛等循环系统疾病。",
                        "xueweiName": "青灵",
                        "jingluoName": "手少阴心经",
                        "titleUrl": "青灵"
                    }
                },
                {
                    "seq": 3,
                    "xueweiName": "少海",
                    "xueweiCode": "shaohai",
                    "position": {
                        "x": -0.219133,
                        "y": 1.214986,
                        "z": 0.040013
                    },
                    "xueweiDetail": {
                        "detailTitle": "少海：常按少海疼痛无",
                        "detailDescription": "少，幼小；海，海洋。少，指手少阴经。此为心经合穴，脉气至此，犹如水流入海。",
                        "cure": "理气通络，益心安神。主治心痛、牙痛、肘臂挛痛、眼充血、鼻充血。",
                        "position": "在肘前部，横平肘横纹，肱骨内上髁前缘。",
                        "quickFind": "屈肘90°，肘横纹内侧端凹陷处。",
                        "massage": "每天早晚用拇指指腹按压少海，每次1~3分钟，可调理前臂麻木、肘关节周围软组织疾病。",
                        "xueweiName": "少海",
                        "jingluoName": "手少阴心经",
                        "titleUrl": "少海"
                    }
                },
                {
                    "seq": 4,
                    "xueweiName": "灵道",
                    "xueweiCode": "lingdao",
                    "position": {
                        "x": -0.279654,
                        "y": 1.060021,
                        "z": 0.084993
                    },
                    "xueweiDetail": {
                        "detailTitle": "灵道：癫痫止抽就用它",
                        "detailDescription": "灵，神灵；道，通道。心主神灵。穴在尺侧腕屈肌腱桡侧端，犹如通向神灵之道。",
                        "cure": "宁心，安神，通络。主治心脏疾病、胃痛、目赤肿痛、癫痫。",
                        "position": "在前臂内侧，腕掌侧远端横纹上1.5寸，尺侧腕屈肌腱的桡侧缘。",
                        "quickFind": "仰掌用力握拳，沿尺侧肌腱内侧的凹陷，从腕横纹向上量2横指处即是。",
                        "massage": "癫痫发作时抽搐的患者，平常多揉灵道，可以防治抽搐。",
                        "xueweiName": "灵道",
                        "jingluoName": "手少阴心经",
                        "titleUrl": "灵道"
                    }
                },
                {
                    "seq": 5,
                    "xueweiName": "通里",
                    "xueweiCode": "tongli",
                    "position": {
                        "x": -0.288766,
                        "y": 1.043888,
                        "z": 0.088303
                    },
                    "xueweiDetail": {
                        "detailTitle": "通里：有效缓解肘臂痛",
                        "detailDescription": "通，通往；里，内里。心经络脉由本穴别出，与小肠经互为表里而相通。",
                        "cure": "清热安神，通经活络。主治肘臂肿痛、头痛、头昏、心悸、扁桃体炎。",
                        "position": "在前臂前区，腕掌侧远端横纹上1寸，尺侧腕屈肌腱的桡侧缘。",
                        "quickFind": "仰掌用力握拳，沿尺侧肌腱内侧的凹陷，从腕横纹向上量1横指处即是。",
                        "massage": "可治坐骨神经痛，一侧坐骨神经痛就揉另一侧通里。",
                        "xueweiName": "通里",
                        "jingluoName": "手少阴心经",
                        "titleUrl": "通里"
                    }
                },
                {
                    "seq": 6,
                    "xueweiName": "阴郄",
                    "xueweiCode": "yinqie",
                    "position": {
                        "x": -0.297896,
                        "y": 1.023996,
                        "z": 0.094742
                    },
                    "xueweiDetail": {
                        "detailTitle": "阴郄：骨蒸盗汗有特效",
                        "detailDescription": "阴，阴阳之阴；郄，孔隙。此为手少阴经之郄穴。",
                        "cure": "宁心安神，清心除烦。主治胃痛、吐血、心痛、盗汗、失语。",
                        "position": "在前臂前区，腕掌侧远端横纹上0.5寸，尺侧腕屈肌腱的桡侧缘。",
                        "quickFind": "仰掌用力握拳，沿尺侧肌腱内侧的凹陷，从腕横纹向上量半横指处。",
                        "massage": "按摩阴郄，对骨蒸盗汗（晚上睡觉心里烦躁，易做噩梦，一出汗就醒，醒时不出汗）有特效。",
                        "xueweiName": "阴郄",
                        "jingluoName": "手少阴心经",
                        "titleUrl": "阴郄"
                    }
                },
                {
                    "seq": 7,
                    "xueweiName": "神门",
                    "xueweiCode": "shenmen",
                    "position": {
                        "x": -0.301951,
                        "y": 1.007457,
                        "z": 0.107198
                    },
                    "xueweiDetail": {
                        "detailTitle": "神门：安神固本之要穴",
                        "detailDescription": "神，心神；门，门户。心藏神。此为心经之门户。",
                        "cure": "补益心气，通经活络。主治心烦、失眠、痴呆、头痛、心悸、目眩、手臂疼痛、冠心病。",
                        "position": "在腕前区，腕掌侧远端横纹尺侧端，尺侧腕屈肌腱的桡侧缘。",
                        "quickFind": "微握掌，另手四指握住手腕，屈拇指，指甲尖所到凹陷处即是。",
                        "massage": "每天早晚用拇指指甲尖垂直掐按，每次1〜3分钟，可调理心烦、失眠、糖尿病、高血压等症。",
                        "xueweiName": "神门",
                        "jingluoName": "手少阴心经",
                        "titleUrl": "神门"
                    }
                },
                {
                    "seq": 8,
                    "xueweiName": "少府",
                    "xueweiCode": "shaofu",
                    "position": {
                        "x": -0.332954,
                        "y": 0.949527,
                        "z": 0.154938
                    },
                    "xueweiDetail": {
                        "detailTitle": "少府：养心护肾此穴灵",
                        "detailDescription": "少，幼小；府，处所。穴属手少阴心经，为脉气所溜之处。",
                        "cure": "清心泻热，理气活络。主治心悸、胸痛、手小指拘挛、臂神经痛。",
                        "position": "在手掌，横平第5掌指关节近端，第4、第5掌骨之间。",
                        "quickFind": "半握拳，小指指尖所指处即是。",
                        "massage": "常用拇指指尖按压少府，每次3~5分钟，可调节脏腑、活血润肤。",
                        "xueweiName": "少府",
                        "jingluoName": "手少阴心经",
                        "titleUrl": "少府"
                    }
                },
                {
                    "seq": 9,
                    "xueweiName": "少冲",
                    "xueweiCode": "shaochong",
                    "position": {
                        "x": -0.346925,
                        "y": 0.860939,
                        "z": 0.175027
                    },
                    "xueweiDetail": {
                        "detailTitle": "少冲：昏迷急救用此穴",
                        "detailDescription": "少，幼小；冲，冲动。本穴是手少心阴经井穴，脉气由此涌出并沿经脉上行。",
                        "cure": "生发心气，清热熄风，醒神开窍。主治癫狂、热病、中风昏迷、目黄、胸痛。",
                        "position": "在手指，小指末节桡侧，指甲根角侧上方0.1寸（指寸）。",
                        "quickFind": "伸小指，沿指甲底部与指桡侧引线交点处即是。",
                        "massage": "每天早晚用拇指指甲尖垂直掐按，每次3~5分钟，有利于心脏健康。",
                        "xueweiName": "少冲",
                        "jingluoName": "手少阴心经",
                        "titleUrl": "少冲"
                    }
                }
            ]
        },
        {
            "jingMaiName": "手太阳小肠经",
            "jingMaiCode": "shoutaiyangxiaochangjing",
            "xueweiList": [
                {
                    "seq": 1,
                    "xueweiName": "少泽",
                    "xueweiCode": "shaoze",
                    "position": {
                        "x": -0.338486,
                        "y": 0.859876,
                        "z": 0.178629
                    },
                    "xueweiDetail": {
                        "detailTitle": "少泽：专治头痛与昏迷",
                        "detailDescription": "少，幼小；泽，沼泽。穴在小指上，脉气初生之处，如始于小泽。",
                        "cure": "清热利咽，通乳开窍。主治头痛、颈项痛、中风昏迷、乳汁不足。",
                        "position": "在手指，小指末节尺侧，距指甲根角侧上方0.1寸（指寸）。",
                        "quickFind": "伸小指，沿指甲底部与指尺侧引线交点处即是。",
                        "massage": "用指甲尖垂直掐按少泽1~3分钟，也可把5根牙签捆在一起，点剌穴位100下，可治头痛、中风昏迷、产后无乳等症。",
                        "xueweiName": "少泽",
                        "jingluoName": "手太阳小肠经",
                        "titleUrl": "少泽"
                    }
                },
                {
                    "seq": 2,
                    "xueweiName": "前谷",
                    "xueweiCode": "qiangu",
                    "position": {
                        "x": -0.320084,
                        "y": 0.930022,
                        "z": 0.136904
                    },
                    "xueweiDetail": {
                        "detailTitle": "前谷：口腔溃疡泻火治",
                        "detailDescription": "前，前后之前；谷，山谷。第5掌指关节前凹陷如谷，穴在其处。",
                        "cure": "清利头目，安神定志，通经活络。主治头项急痛、口疮、手指痒麻、臂痛不得举。",
                        "position": "在手指，第5掌指关节尺侧远端赤白肉际凹陷中。",
                        "quickFind": "握拳，小指掌指关节前有一皮肤皱裳突起，其尖端处即是。",
                        "massage": "常用拇指指腹按揉前谷，每次1~3分钟，对上肢麻痹有良好的调理作用。",
                        "xueweiName": "前谷",
                        "jingluoName": "手太阳小肠经",
                        "titleUrl": "前谷"
                    }
                },
                {
                    "seq": 3,
                    "xueweiName": "后溪",
                    "xueweiCode": "houxi",
                    "position": {
                        "x": -0.314236,
                        "y": 0.944731,
                        "z": 0.135547
                    },
                    "xueweiDetail": {
                        "detailTitle": "后溪：颈椎腰椎病痛除",
                        "detailDescription": "后，前后之后；溪，山洼流水之沟。第5掌指关节后凹陷如沟。指穴位于第5掌骨之后方。",
                        "cure": "清心安神，通血活络。主治颈肩痛、肘臂痛、汗多、落枕、急性腰扭伤。",
                        "position": "在手内侧，第5掌指关节尺侧近端赤白肉际凹陷中。",
                        "quickFind": "握拳，小指掌指关节后有一皮肤皱罢突起，其尖端处即是。",
                        "massage": "以一手握另一手掌背，弯曲拇指，垂直下压后溪，每次掐按1~3分钟，可有效治疗颈椎痛、闪腰、颈腰部慢性劳损等症。",
                        "xueweiName": "后溪",
                        "jingluoName": "手太阳小肠经",
                        "titleUrl": "后溪"
                    }
                },
                {
                    "seq": 4,
                    "xueweiName": "腕骨",
                    "xueweiCode": "wangu",
                    "position": {
                        "x": -0.307515,
                        "y": 0.975021,
                        "z": 0.113722
                    },
                    "xueweiDetail": {
                        "detailTitle": "腕骨：胆囊疾病多按揉",
                        "detailDescription": "腕，腕部；骨，骨头。穴在腕部骨间。",
                        "cure": "利湿，止咳。主治黄疸、疟疾、手腕无力、落枕、前臂痛、头痛、耳鸣。",
                        "position": "在手内侧，第5掌骨基底与三角骨之间的赤白肉际凹陷中。",
                        "quickFind": "微握拳，掌心向胸，由后溪向腕部推，摸到两骨结合凹陷处。",
                        "massage": "用拇指指腹按压腕骨，每次1~3分钟，长期坚持对头项强痛、肩关节疼痛均有良好的调理作用。",
                        "xueweiName": "腕骨",
                        "jingluoName": "手太阳小肠经",
                        "titleUrl": "腕骨"
                    }
                },
                {
                    "seq": 5,
                    "xueweiName": "阳谷",
                    "xueweiCode": "yanggu",
                    "position": {
                        "x": -0.304278,
                        "y": 0.996539,
                        "z": 0.095577
                    },
                    "xueweiDetail": {
                        "detailTitle": "阳谷：主治眩晕与耳鸣",
                        "detailDescription": "阳，阴阳之阳；谷，山谷。外为阳，腕外骨隙形如山谷，穴当其处。",
                        "cure": "明目安神，通经活络。主治头痛，臂、腕外侧痛，耳鸣，耳聋。",
                        "position": "在腕部，尺骨茎突与三角骨之间的凹陷中。",
                        "quickFind": "屈腕，在手背腕外侧摸到两骨结合凹陷处即是。",
                        "massage": "用拇指指腹按压阳谷，每次1~3分钟，可协调脏腑功能，增强机体抗病能力。",
                        "xueweiName": "阳谷",
                        "jingluoName": "手太阳小肠经",
                        "titleUrl": "阳谷"
                    }
                },
                {
                    "seq": 6,
                    "xueweiName": "养老",
                    "xueweiCode": "yanglao",
                    "position": {
                        "x": -0.299834,
                        "y": 1.023107,
                        "z": 0.080309
                    },
                    "xueweiDetail": {
                        "detailTitle": "养老：晚年体健靠养老",
                        "detailDescription": "养，赡养；老，老人。本穴善治目花、耳聋、腰酸和肩痛等老年人常见病症。",
                        "cure": "清头明目，舒筋活络。主治老年痴呆、目视不明、耳聋、急性腰痛。",
                        "position": "在前臂外侧，腕背横纹上1寸，尺骨头桡侧凹陷中。",
                        "quickFind": "屈腕掌心向胸，沿小指侧隆起高骨往桡侧推，触及一骨缝处即是。",
                        "massage": "用食指指尖垂直下压养老1~3分钟，可辅助治疗高血压、老年痴呆、头昏眼花、耳聋、腰酸腿痛等老年病。",
                        "xueweiName": "养老",
                        "jingluoName": "手太阳小肠经",
                        "titleUrl": "养老"
                    }
                },
                {
                    "seq": 7,
                    "xueweiName": "支正",
                    "xueweiCode": "zhizheng",
                    "position": {
                        "x": -0.265503,
                        "y": 1.082482,
                        "z": 0.061509
                    },
                    "xueweiDetail": {
                        "detailTitle": "支正：头晕目眩找支正",
                        "detailDescription": "支，支别；正，正经。小肠之络脉由此别离正经，走向心经。",
                        "cure": "安神定志，清热解表，通经活络。主治头痛、目眩、腰背酸痛、四肢无力、糖尿病。",
                        "position": "在前臂外侧，腕背侧远端横纹上5寸，尺骨尺侧与尺侧腕屈肌之间。",
                        "quickFind": "屈肘俯掌，确定阳谷与小海位置，二者连线中点向下1横指处即是。",
                        "massage": "每天用拇指指腹揉按支正1~3分钟，可辅助治疗头晕、目眩以及手麻、颈椎压迫症。",
                        "xueweiName": "支正",
                        "jingluoName": "手太阳小肠经",
                        "titleUrl": "支正"
                    }
                },
                {
                    "seq": 8,
                    "xueweiName": "小海",
                    "xueweiCode": "xiaohai",
                    "position": {
                        "x": -0.222137,
                        "y": 1.186151,
                        "z": 0.040326
                    },
                    "xueweiDetail": {
                        "detailTitle": "小海：贫血眩晕求小海",
                        "detailDescription": "小，微小，指小肠经；海，海洋。此穴为小肠经合穴，气血至此犹如水流入海。",
                        "cure": "安神定志，清热通络。主治目眩、耳聋、颊肿、颈项痛、贫血眩晕。",
                        "position": "在肘外侧，尺骨鹰嘴与肱骨内上髁之间凹陷中。",
                        "quickFind": "屈肘，肘尖最高点与肘部内侧高骨最高点间凹陷处即是。",
                        "massage": "拇指指腹垂直下压小海1~3分钟，可改善贫血者下蹲后站立时导致的眼前昏黑及眩晕感。",
                        "xueweiName": "小海",
                        "jingluoName": "手太阳小肠经",
                        "titleUrl": "小海"
                    }
                },
                {
                    "seq": 9,
                    "xueweiName": "肩贞",
                    "xueweiCode": "jianzhen",
                    "position": {
                        "x": -0.170601,
                        "y": 1.413775,
                        "z": -0.127712
                    },
                    "xueweiDetail": {
                        "detailTitle": "肩贞：肩周炎的必用穴",
                        "detailDescription": "肩，肩部，指穴所在之部位；贞，第一。此为小肠经入肩的第一穴。",
                        "cure": "清头聪耳，通经活络。主治肩周炎、肩胛痛、手臂麻痛、耳鸣。",
                        "position": "在肩关节后下方，腋后纹头直上1寸。",
                        "quickFind": "正坐垂臂，从腋后纹头向上量1横指处即是。",
                        "massage": "以中指指腹按压肩贞，每次左右各揉按1~3分钟，可治肩胛痛、手臂麻木、耳鸣、耳聋等。",
                        "xueweiName": "肩贞",
                        "jingluoName": "手太阳小肠经",
                        "titleUrl": "肩贞"
                    }
                },
                {
                    "seq": 10,
                    "xueweiName": "臑俞",
                    "xueweiCode": "naoyu",
                    "position": {
                        "x": -0.128761,
                        "y": 1.492963,
                        "z": -0.119532
                    },
                    "xueweiDetail": {
                        "detailTitle": "臑俞：预防治疗肩周炎",
                        "detailDescription": "臑，上臂肌肉隆起处；俞，穴。穴在臑部，为经气输注之处。",
                        "cure": "舒筋活络，化痰消肿。主治肩臂酸痛无力、肩肿、颈淋巴结核。",
                        "position": "在肩后部，腋后纹头直上，肩胛冈下缘凹陷中。",
                        "quickFind": "手臂内收，腋后纹末端直上与肩胛冈下缘交点即是。",
                        "massage": "用中指指腹按压臑俞，每次1~3分钟，长期坚持对上肢和肩关节都有很好的保养作用，还可有效预防上肢不遂、肩周炎等。",
                        "xueweiName": "臑俞",
                        "jingluoName": "手太阳小肠经",
                        "titleUrl": "臑俞"
                    }
                },
                {
                    "seq": 11,
                    "xueweiName": "天宗",
                    "xueweiCode": "tianzong",
                    "position": {
                        "x": -0.093868,
                        "y": 1.46241,
                        "z": -0.139213
                    },
                    "xueweiDetail": {
                        "detailTitle": "天宗：健胸美体按天宗",
                        "detailDescription": "天，天空，指上部；宗，指“本”，含中心之意。意为穴在肩胛冈中点下窝正中。",
                        "cure": "舒筋活络，理气消肿。主治颈椎病、肩胛疼痛、肩周炎、颊颔肿、肘酸痛、乳房胀痛、气喘、小儿脊柱侧弯。",
                        "position": "在肩胛区，肩胛冈下缘与肩胛骨下角连线上1/3与下2/3交点凹陷中。",
                        "quickFind": "以对侧手，由颈下过肩，手伸向肩胛骨处，中指指腹所在处即是。",
                        "massage": "常用中指指腹按揉天宗，每次1~3分钟，或用艾条灸5~10分钟，可使颈肩气血旺盛、胸部气血畅通。",
                        "xueweiName": "天宗",
                        "jingluoName": "手太阳小肠经",
                        "titleUrl": "天宗"
                    }
                },
                {
                    "seq": 12,
                    "xueweiName": "秉风",
                    "xueweiCode": "bingfeng",
                    "position": {
                        "x": -0.099889,
                        "y": 1.504344,
                        "z": -0.120028
                    },
                    "xueweiDetail": {
                        "detailTitle": "秉风：肩胛疼痛就灸它",
                        "detailDescription": "秉，承受；风，风邪。穴在易受风邪之处。",
                        "cure": "散风活络，止咳化痰。主治肩胛疼痛不举、颈强不得回顾、咳嗽。",
                        "position": "在肩胛区，肩胛冈中点上方冈上窝中。",
                        "quickFind": "举臂，天宗直上，肩胛部凹陷处即是。",
                        "massage": "按揉秉风3~5分钟，或用艾条灸5~10分钟，可缓解肩胛疼痛。",
                        "xueweiName": "秉风",
                        "jingluoName": "手太阳小肠经",
                        "titleUrl": "秉风"
                    }
                },
                {
                    "seq": 13,
                    "xueweiName": "曲垣",
                    "xueweiCode": "quyuan",
                    "position": {
                        "x": -0.07883,
                        "y": 1.490913,
                        "z": -0.129606
                    },
                    "xueweiDetail": {
                        "detailTitle": "曲垣：常按此穴防衰老",
                        "detailDescription": "曲，弯曲；垣，矮墙。肩胛冈弯曲如墙，穴当其处。",
                        "cure": "舒筋活络，疏风止痛。主治肩胛拘挛疼痛、上肢酸麻、咳嗽。",
                        "position": "在肩胛区，肩胛冈内侧端上缘凹陷中。",
                        "quickFind": "低头，后颈部最突起椎体往下数2个椎体，即第2胸椎棘突，与臑俞连线中点处即是。",
                        "massage": "每天早晚用中指指腹按揉曲垣1~3分钟，对眼部疲劳、上肢不适等症状有很好的调理作用，还可延缓身体衰老。",
                        "xueweiName": "曲垣",
                        "jingluoName": "手太阳小肠经",
                        "titleUrl": "曲垣"
                    }
                },
                {
                    "seq": 14,
                    "xueweiName": "肩外俞",
                    "xueweiCode": "jianwaiyu",
                    "position": {
                        "x": -0.05698,
                        "y": 1.522806,
                        "z": -0.107542
                    },
                    "xueweiDetail": {
                        "detailTitle": "肩外俞：肩背疼痛刮痧除",
                        "detailDescription": "肩，肩部；外，外侧；俞，穴。穴在肩部，约当肩胛骨内侧缘之稍外方。",
                        "cure": "舒筋活络，祛风止痛。主治肩背酸痛、颈项僵硬、上肢冷痛、偏头痛。",
                        "position": "在脊柱区，第1胸椎棘突下，后正中线旁开3寸。",
                        "quickFind": "在背部，先找到第1胸椎棘突，在其下方旁开4横指处即是。",
                        "massage": "按揉肩外俞3~5分钟，或用艾条灸5〜10分钟，可治疗肩背疼痛、颈项强急等肩背颈项疾病。",
                        "xueweiName": "肩外俞",
                        "jingluoName": "手太阳小肠经",
                        "titleUrl": "肩外俞"
                    }
                },
                {
                    "seq": 15,
                    "xueweiName": "肩中俞",
                    "xueweiCode": "jianzhongyu",
                    "position": {
                        "x": -0.039794,
                        "y": 1.552333,
                        "z": -0.08821
                    },
                    "xueweiDetail": {
                        "detailTitle": "肩中俞：肩背僵硬按之消",
                        "detailDescription": "肩，肩部；中，中间；俞，穴。穴在肩部，约当肩胛骨内侧缘之里。",
                        "cure": "解表宣肺。主治咳嗽、肩背酸痛、颈项僵硬、发热恶寒。",
                        "position": "在脊柱区，第7颈椎棘突下，后正中线旁开2寸。",
                        "quickFind": "低头，后颈部最突起椎体旁开3横指处即是。",
                        "massage": "按揉肩中俞3~5分钟，可缓解颈肩疼痛。",
                        "xueweiName": "肩中俞",
                        "jingluoName": "手太阳小肠经",
                        "titleUrl": "肩中俞"
                    }
                },
                {
                    "seq": 16,
                    "xueweiName": "天窗",
                    "xueweiCode": "tianchuang",
                    "position": {
                        "x": -0.053132,
                        "y": 1.597793,
                        "z": -0.039237
                    },
                    "xueweiDetail": {
                        "detailTitle": "天窗：五官疾病就找它",
                        "detailDescription": "天，天空，指上部；窗，窗户。穴在头部，位于上，主治耳病，可通耳窍，如开天窗。",
                        "cure": "熄风宁神，利咽聪耳。主治头痛、耳鸣、咽喉肿痛、痔疮。",
                        "position": "在颈部，横平喉结，胸锁乳突肌的后缘。",
                        "quickFind": "转头，从耳下向喉咙中央走行的绷紧的肌肉后缘与喉结相平处即是。",
                        "massage": "按揉天窗3~5分钟，或用艾条灸5~10分钟，可治耳鸣、耳聋等耳部疾病。",
                        "xueweiName": "天窗",
                        "jingluoName": "手太阳小肠经",
                        "titleUrl": "天窗"
                    }
                },
                {
                    "seq": 17,
                    "xueweiName": "天容",
                    "xueweiCode": "tianrong",
                    "position": {
                        "x": -0.055767,
                        "y": 1.626065,
                        "z": -0.007351
                    },
                    "xueweiDetail": {
                        "detailTitle": "天容：落枕不适艾灸消",
                        "detailDescription": "天，天空，指上部；容，隆盛。穴在头部，位于上方，为经气隆盛之处。",
                        "cure": "清热利咽，消肿降逆。主治头痛、耳鸣、耳聋、咽喉肿痛、哮喘。",
                        "position": "在颈部，下颌角后方，胸锁乳突肌前缘凹陷中。",
                        "quickFind": "耳垂下方的下颌角后方凹陷处即是。",
                        "massage": "用中指指腹按揉天容3~5分钟，能缓解落枕带来的不适，用艾条灸天容5~10分钟，可治耳鸣、耳聋、咽喉肿痛等五官疾病。",
                        "xueweiName": "天容",
                        "jingluoName": "手太阳小肠经",
                        "titleUrl": "天容"
                    }
                },
                {
                    "seq": 18,
                    "xueweiName": "颧髎",
                    "xueweiCode": "quanliao",
                    "position": {
                        "x": -0.052008,
                        "y": 1.660144,
                        "z": 0.066517
                    },
                    "xueweiDetail": {
                        "detailTitle": "颧髎：色斑粉刺一扫光",
                        "detailDescription": "颧，颧部；髎，骨隙。穴在颧部骨隙中。",
                        "cure": "祛风镇惊，清热消肿。主治面痛、口眼隅斜、三叉神经痛、牙龈肿痛。",
                        "position": "在面部，颧骨下缘，目外眦直下凹陷中。",
                        "quickFind": "在面部，颧骨最高点下缘凹陷处即是。",
                        "massage": "常按摩颧髎，每次1~3分钟，对面部有很好的保养作用，可提升气色，振奋精神，还可以预防面神经麻痹、三叉神经痛等面部疾病。",
                        "xueweiName": "颧髎",
                        "jingluoName": "手太阳小肠经",
                        "titleUrl": "颧髎"
                    }
                },
                {
                    "seq": 19,
                    "xueweiName": "听宫",
                    "xueweiCode": "tinggong",
                    "position": {
                        "x": -0.071866,
                        "y": 1.681617,
                        "z": 0.003222
                    },
                    "xueweiDetail": {
                        "detailTitle": "听宫：耳聋耳鸣就找它",
                        "detailDescription": "听，听闻；宫，宫里。听宫，指耳窍。穴在耳部，可治耳病，有通耳窍之功。",
                        "cure": "聪耳开窍。主治耳鸣、耳聋、中耳炎、耳部疼痛、聋哑、牙痛、面瘫。",
                        "position": "在面部，耳屏正中与下颌骨踝突之间的凹陷中。",
                        "quickFind": "微张口，耳屏与下颌关节之间凹陷处即是。",
                        "massage": "常用的按摩手法是一压一放，力度适中，每次双侧同时按压1~3分钟。可治疗耳鸣、耳聋，也可用于辅助治疗面瘫、牙痛等头面疾病，有活络通窍、聪耳明目的功效。",
                        "xueweiName": "听宫",
                        "jingluoName": "手太阳小肠经",
                        "titleUrl": "听宫"
                    }
                }
            ]
        },
        {
            "jingMaiName": "足太阳膀胱经",
            "jingMaiCode": "zutaiyangbangguangjing",
            "xueweiList": [
                {
                    "seq": 1,
                    "xueweiName": "睛明",
                    "xueweiCode": "jingming",
                    "position": {
                        "x": -0.01245,
                        "y": 1.708606,
                        "z": 0.08253
                    },
                    "xueweiDetail": {
                        "detailTitle": "睛明：眼睛明亮的法宝",
                        "detailDescription": "睛，眼睛；明，明亮。穴在眼区，有明目之功。",
                        "cure": "泻热明目，祛风通络。主治目视不明、近视、夜盲、急性腰扭伤。",
                        "position": "在面部，目内眦内上方眶内侧壁凹陷中。",
                        "quickFind": "正坐合眼，手指置于内侧眼角稍上方，按压有一凹陷处即是。",
                        "massage": "睛明是治疗所有眼病的关键穴位，按摩时用拇指指端按揉睛明，每次双侧同时按揉2分钟左右。",
                        "xueweiName": "睛明",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "睛明"
                    }
                },
                {
                    "seq": 2,
                    "xueweiName": "攒竹",
                    "xueweiCode": "zanzhu",
                    "position": {
                        "x": -0.01245,
                        "y": 1.720662,
                        "z": 0.093471
                    },
                    "xueweiDetail": {
                        "detailTitle": "攒竹：刮一刮治黑眼圈",
                        "detailDescription": "攒，簇聚；竹，竹子。穴在眉头，眉毛丛生，犹如竹子簇聚。",
                        "cure": "泻热清目，祛风通络。主治头痛、口眼歪斜、目赤肿痛、近视、夜盲症。",
                        "position": "在面部，眉头凹陷中，额切迹处。",
                        "quickFind": "皱眉，眉毛内侧端有一隆起处即是。",
                        "massage": "可用食指中节由内向外沿眉毛刮抹眼眶，稍用力，对治疗眼睛红肿、肿痛等热证效果通常较好，也可疏筋活络，舒眉展目。",
                        "xueweiName": "攒竹",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "攒竹"
                    }
                },
                {
                    "seq": 3,
                    "xueweiName": "眉冲",
                    "xueweiCode": "meichong",
                    "position": {
                        "x": -0.006304,
                        "y": 1.777164,
                        "z": 0.077038
                    },
                    "xueweiDetail": {
                        "detailTitle": "眉冲：目赤肿痛找眉冲",
                        "detailDescription": "眉，眉毛；冲，直上。穴在前发际，眉毛的直上方。",
                        "cure": "散风清热，镇痉宁神。主治眩晕、头痛、鼻塞、目视不明、目赤肿痛。",
                        "position": "在头部，额切际直上入发际0.5寸。",
                        "quickFind": "手指自眉毛向上推，入发际0.5寸处按压有痛感处即是。",
                        "massage": "常用食指指腹按揉眉冲或用刮廖板刮拭，可治目赤肿痛、目视不明等眼部疾病，有疏风泻热的效果。",
                        "xueweiName": "眉冲",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "眉冲"
                    }
                },
                {
                    "seq": 4,
                    "xueweiName": "曲差",
                    "xueweiCode": "qucha",
                    "position": {
                        "x": -0.021434,
                        "y": 1.776691,
                        "z": 0.073734
                    },
                    "xueweiDetail": {
                        "detailTitle": "曲差：治疗鼻疾有特效",
                        "detailDescription": "曲，弯曲；差，不齐。本脉自眉冲曲而向外，至本穴又曲而向后，表面参差不齐。",
                        "cure": "清热明目，安神利窍。主治头痛、鼻塞、鼻出血、心中烦闷、眼病。",
                        "position": "在头部，前发际正中直上0.5寸，旁开1.5寸。",
                        "quickFind": "前发际正中直上0.5寸，再旁开量2横指，取前发际中点至额角发迹连线的内1/3与外2/3交界处即是。",
                        "massage": "用食指指腹按压曲差，每次左右各1~3分钟，可缓解鼻塞、流鼻涕、鼻炎等症状。",
                        "xueweiName": "曲差",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "曲差"
                    }
                },
                {
                    "seq": 5,
                    "xueweiName": "五处",
                    "xueweiCode": "wuchu",
                    "position": {
                        "x": -0.02167,
                        "y": 1.791584,
                        "z": 0.06062
                    },
                    "xueweiDetail": {
                        "detailTitle": "五处：小儿惊风不可怕",
                        "detailDescription": "五，第五；处，处所。此为足太阳之脉第五穴所在之处。",
                        "cure": "清热散风，明目镇痉。主治小儿惊风、头痛、目眩、目视不明、癫痫。",
                        "position": "在头部，前发际正中直上1寸，旁开1.5寸。",
                        "quickFind": "前发际正中直上1横指，再旁开量2横指处即是。",
                        "massage": "遇到小儿惊风时，用食指指腹按压五处，左右同时按压3分钟，能迅速缓解小儿惊风症状，使孩子及时得到救治。",
                        "xueweiName": "五处",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "五处"
                    }
                },
                {
                    "seq": 6,
                    "xueweiName": "承光",
                    "xueweiCode": "chengguang",
                    "position": {
                        "x": -0.02724,
                        "y": 1.803157,
                        "z": 0.037312
                    },
                    "xueweiDetail": {
                        "detailTitle": "承光：放松身心需常按",
                        "detailDescription": "承，承受；光，光明。穴在头顶部，容易承受光线。",
                        "cure": "清热明目，疏风散热。主治头痛、口眼歪斜、鼻塞、目眩、目视不明。",
                        "position": "在头部，前发际正中直上2.5寸，旁开1.5寸。",
                        "quickFind": "先取百会，再取百会至前发际的中点，再旁开量2横指处即是。",
                        "massage": "以食指指腹按压承光，每次左右各1~3分钟，对头痛、目眩、鼻塞等症有特殊的疗效。",
                        "xueweiName": "承光",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "承光"
                    }
                },
                {
                    "seq": 7,
                    "xueweiName": "通天",
                    "xueweiCode": "tongtian",
                    "position": {
                        "x": -0.031072,
                        "y": 1.809889,
                        "z": 0.001557
                    },
                    "xueweiDetail": {
                        "detailTitle": "通天：鼻内畅通无阻碍",
                        "detailDescription": "通，通达；天，天空，指上部。穴在头部，上通巅顶。",
                        "cure": "清热除湿，通利鼻窍。主治颈项强硬、头痛、头重、鼻塞、口眼隅斜。",
                        "position": "在头部，前发际正中直上4寸，旁开1.5寸处。",
                        "quickFind": "先取承光，其直上2横指处即是。",
                        "massage": "用食指按压通天，每次3分钟左右，也可用刮物疗法，可治疗头痛、鼻塞、鼻出血、鼻窦炎等疾病。",
                        "xueweiName": "通天",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "通天"
                    }
                },
                {
                    "seq": 8,
                    "xueweiName": "络却",
                    "xueweiCode": "luoque",
                    "position": {
                        "x": -0.038212,
                        "y": 1.803209,
                        "z": -0.040302
                    },
                    "xueweiDetail": {
                        "detailTitle": "络却：消除抑郁精神好",
                        "detailDescription": "络，联络；却，返回。膀胱经脉气由此入里联络于脑，然后又返回体表。",
                        "cure": "清热安神，平肝熄风。主治口嘀、眩晕、鼻塞、目视不明、抑郁症。",
                        "position": "在头部，前发际正中直上5.5寸，旁开1.5寸。",
                        "quickFind": "先取承光，其直上4横指处即是。",
                        "massage": "用食指按压络却，每天早晚各1次，每次3分钟左右，也可用刮痧疗法，可治疗头晕、目视不明、耳鸣等症。",
                        "xueweiName": "络却",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "络却"
                    }
                },
                {
                    "seq": 9,
                    "xueweiName": "玉枕",
                    "xueweiCode": "yuzhen",
                    "position": {
                        "x": -0.011785,
                        "y": 1.712365,
                        "z": -0.102207
                    },
                    "xueweiDetail": {
                        "detailTitle": "玉枕：头痛头晕就刮它",
                        "detailDescription": "玉，玉石；枕，枕头。古称枕骨为“玉枕骨”，穴在其上。",
                        "cure": "清热明目，通经活络。主治头痛、眩晕、目痛不能远视、鼻塞。",
                        "position": "在头部，后发际正中直上2.5寸，旁开1.3寸。",
                        "quickFind": "沿后发际正中向上轻推，触及枕骨，由此旁开2横指，在骨性隆起的外上缘有一凹陷处即是。",
                        "massage": "头痛时，可点按玉枕3分钟或用刮痧板由上向下刮拭此穴，刮至头皮发热，头痛就会缓解很多。",
                        "xueweiName": "玉枕",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "玉枕"
                    }
                },
                {
                    "seq": 10,
                    "xueweiName": "天柱",
                    "xueweiCode": "tianzhu",
                    "position": {
                        "x": -0.012258,
                        "y": 1.644753,
                        "z": -0.079621
                    },
                    "xueweiDetail": {
                        "detailTitle": "天柱：头脑清醒就靠它",
                        "detailDescription": "天，天空；柱，支柱。上部为天。颈椎古称“柱骨”，穴在其旁。",
                        "cure": "清头明目，强健筋骨。主治头痛、颈项僵硬、肩背疼痛、落枕、哮喘。",
                        "position": "在颈后部，横平第颂椎棘突上际，斜方肌外缘凹陷中。",
                        "quickFind": "后发际正中旁开2横指处即是。",
                        "massage": "每天坚持按压天柱，每次连叩9下，对治疗头痛、视力模糊、头脑不清有显著疗效。",
                        "xueweiName": "天柱",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "天柱"
                    }
                },
                {
                    "seq": 11,
                    "xueweiName": "大杼",
                    "xueweiCode": "dazhu",
                    "position": {
                        "x": -0.018405,
                        "y": 1.532223,
                        "z": -0.094723
                    },
                    "xueweiDetail": {
                        "detailTitle": "大杼：颈椎不适的克星",
                        "detailDescription": "大，大小之大；杼，即梭。第1胸椎较大，棘突如梭，穴在其旁。",
                        "cure": "强筋骨，清邪热。主治咳嗽、肩背痛、喘息、胸胁支满。",
                        "position": "在上背部，当第1胸椎棘突下，后正中线旁开1.5寸。",
                        "quickFind": "低头屈颈，颈背交界处椎骨高突向下推1个椎体，下缘旁开2横指处。",
                        "massage": "用中指指腹按压大杼，每次左右各按揉1~3分钟，可治咳嗽、发热、肩背痛等疾病。",
                        "xueweiName": "大杼",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "大杼"
                    }
                },
                {
                    "seq": 12,
                    "xueweiName": "风门",
                    "xueweiCode": "fengmen",
                    "position": {
                        "x": -0.017868,
                        "y": 1.506422,
                        "z": -0.105573
                    },
                    "xueweiDetail": {
                        "detailTitle": "风门：防治感冒莫忘它",
                        "detailDescription": "风，风邪；门，门户。穴居易为风邪侵入之处，并善治风邪之症，故被认为是风邪出入之门户。",
                        "cure": "宣肺解表，益气固表。主治伤风咳嗽、发热、头痛、哮喘、呕吐、感冒。",
                        "position": "在上背部，第2胸椎棘突下，后正中线旁开1.5寸。",
                        "quickFind": "低头屈颈，颈背交界处椎骨高突向下推2个椎体，其下缘旁开2横指处即是。",
                        "massage": "用中指指腹按压风门，每次左右各按揉1~3分钟，可有效治疗各种风寒感冒、发热、咳嗽、哮喘、支气管炎等疾病。",
                        "xueweiName": "风门",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "风门"
                    }
                },
                {
                    "seq": 13,
                    "xueweiName": "肺俞",
                    "xueweiCode": "feiyu",
                    "position": {
                        "x": -0.018878,
                        "y": 1.463898,
                        "z": -0.127397
                    },
                    "xueweiDetail": {
                        "detailTitle": "肺俞：经常摩擦防哮喘",
                        "detailDescription": "肺，肺脏；俞，输注。本穴是肺气转输于后背体表的部位。",
                        "cure": "宣肺解表，清热理气。主治咳嗽、哮喘、胸满喘逆、酒糟鼻、耳聋、小儿感冒。",
                        "position": "在上背部，第3胸椎棘突下，后正中线旁开1.5寸。",
                        "quickFind": "低头屈颈，颈背交界处椎骨高突向下推3个椎体，下缘旁开2横指处。",
                        "massage": "用手掌反复摩擦肺俞，可以很快缓解哮喘。",
                        "xueweiName": "肺俞",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "肺俞"
                    }
                },
                {
                    "seq": 14,
                    "xueweiName": "厥阴俞",
                    "xueweiCode": "jueyinyu",
                    "position": {
                        "x": -0.01813,
                        "y": 1.422356,
                        "z": -0.138673
                    },
                    "xueweiDetail": {
                        "detailTitle": "厥阴俞：保护心脏的卫士",
                        "detailDescription": "厥阴，两阴交会之意，在此指心包络；俞，输注。本穴是心包络之气转输于后背体表的部位。",
                        "cure": "宽胸理气，活血止痛。主治胃痛、呕吐、心痛、心悸、胸闷。",
                        "position": "在上背部，第4胸椎棘突下，后正中线旁开1.5寸。",
                        "quickFind": "低头屈颈，颈背交界处椎骨高突向下推4个椎体，下缘旁开2横指处。",
                        "massage": "常用按摩棒轻轻拍打厥阴俞30~60下，可缓解胸闷、心痛、心悸等症。",
                        "xueweiName": "厥阴俞",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "厥阴俞"
                    }
                },
                {
                    "seq": 15,
                    "xueweiName": "心俞",
                    "xueweiCode": "xinyu",
                    "position": {
                        "x": -0.017461,
                        "y": 1.380567,
                        "z": -0.136889
                    },
                    "xueweiDetail": {
                        "detailTitle": "心俞：养心安神多建功",
                        "detailDescription": "心，心脏；俞，输注。本穴是心气转输于后背体表的部位。",
                        "cure": "宽胸理气，通络安神。主治胸背痛、心悸、失眠、健忘、呕吐。",
                        "position": "在上背部，第5胸椎棘突下，后正中线旁开1.5寸。",
                        "quickFind": "肩胛骨下角水平连线与脊柱相交椎体处，往上推2个椎体，其下缘旁开2横指处即是。",
                        "massage": "按摩心俞可缓解心惊气促、心动过速、心绞痛等心血管疾病症状。",
                        "xueweiName": "心俞",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "心俞"
                    }
                },
                {
                    "seq": 16,
                    "xueweiName": "督俞",
                    "xueweiCode": "duyu",
                    "position": {
                        "x": -0.017974,
                        "y": 0.134135,
                        "z": -0.134135
                    },
                    "xueweiDetail": {
                        "detailTitle": "督俞：肠胃疾病的克星",
                        "detailDescription": "督，督脉；俞，输注。本穴是督脉之气转输于后背体表的部位。",
                        "cure": "理气止痛，强心通脉。主治发热、恶寒、心痛、腹痛、腹胀、肠鸣、冠心病、心绞痛、打嗝。",
                        "position": "在上背部，第6胸椎棘突下，后正中线旁开1.5寸。",
                        "quickFind": "肩胛骨下角水平连线与脊柱相交椎体处，往上推1个椎体，其下缘旁开2横指处即是。",
                        "massage": "重按督俞，可缓解心绞痛，或用刮痂板由上而下刮拭，也可用艾条灸5~10分钟，可治腹胀、腹痛等胃肠疾病。",
                        "xueweiName": "督俞",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "督俞"
                    }
                },
                {
                    "seq": 17,
                    "xueweiName": "膈俞",
                    "xueweiCode": "geyu",
                    "position": {
                        "x": -0.018083,
                        "y": 1.297168,
                        "z": -0.126639
                    },
                    "xueweiDetail": {
                        "detailTitle": "膈俞：止呕打嗝有特效",
                        "detailDescription": "膈，横膈；俞，输注。本穴是膈气转输于后背体表的部位。",
                        "cure": "理气宽胸，活血通脉。主治咳血、便血、心痛、心悸、胸痛、胸闷、呕吐、打嗝、荨麻疹。",
                        "position": "在背部，第7胸椎棘突下，后正中线旁开1.5寸。",
                        "quickFind": "肩胛骨下角水平连线与脊柱相交椎体处，其下缘旁开2横指处即是。",
                        "massage": "每天饭前按揉3次，每次200下，可治中风病人进食难、吃饭呛、喝水呛等症。",
                        "xueweiName": "膈俞",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "膈俞"
                    }
                },
                {
                    "seq": 18,
                    "xueweiName": "肝俞",
                    "xueweiCode": "ganyu",
                    "position": {
                        "x": -0.017945,
                        "y": 1.254772,
                        "z": -0.118488
                    },
                    "xueweiDetail": {
                        "detailTitle": "肝俞：清肝明目就靠它",
                        "detailDescription": "肝，肝脏；俞，输注。本穴是肝气转输于后背体表的部位。",
                        "cure": "疏肝利胆，理气明目。主治黄疸、肝炎、目视不明、痛经、眩晕、腹泻。",
                        "position": "在背部，第9胸椎棘突下，后正中线旁开1.5寸。",
                        "quickFind": "肩胛骨下角水平连线与脊柱相交椎体处，往下推2个椎体，其下缘旁开2横指处即是。",
                        "massage": "双手拇指分别按压在双侧肝俞上做旋转运动，由轻到重至不能承受为止，每次10~30分钟，可缓解眼红、眼痛等症状。",
                        "xueweiName": "肝俞",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "肝俞"
                    }
                },
                {
                    "seq": 19,
                    "xueweiName": "胆俞",
                    "xueweiCode": "danyu",
                    "position": {
                        "x": -0.017842,
                        "y": 1.212916,
                        "z": -0.105324
                    },
                    "xueweiDetail": {
                        "detailTitle": "胆俞：功效利胆与护胆",
                        "detailDescription": "胆，胆腑；俞，输注。本穴是胆腑之气转输于后背体表的部位。",
                        "cure": "疏肝利胆，清热化湿。主治胃脘部及肚腹胀满、呕吐、黄疸。",
                        "position": "在背部，第10胸椎棘突下，后正中线旁开1.5寸。",
                        "quickFind": "肩胛骨下角水平连线与脊柱相交椎体处，往下推3个椎体，其下缘旁开2横指处即是。",
                        "massage": "用双手拇指点压胆俞，局部有酸、胀、麻感为佳，每分钟100次，每日3次，可治胆经疾病。",
                        "xueweiName": "胆俞",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "胆俞"
                    }
                },
                {
                    "seq": 20,
                    "xueweiName": "脾俞",
                    "xueweiCode": "piyu",
                    "position": {
                        "x": -0.017842,
                        "y": 1.171459,
                        "z": -0.091788
                    },
                    "xueweiDetail": {
                        "detailTitle": "脾俞：不思饮食就按它",
                        "detailDescription": "脾，脾脏；俞，输注。本穴是脾气转输于后背体表的部位。",
                        "cure": "健脾和胃，利湿升清。主治腹胀、呕吐、腹泻、胃痛、神经性皮炎、小儿咳嗽、小儿发热。",
                        "position": "在下背部，第11胸椎棘突下，后正中线旁开1.5寸。",
                        "quickFind": "肚脐水平线与脊柱相交椎体处，往上推3个椎体，其上缘旁开2横指处即是。",
                        "massage": "当吃饭没胃口时，不妨按按脾俞，很快就会感觉有点饿了。",
                        "xueweiName": "脾俞",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "脾俞"
                    }
                },
                {
                    "seq": 21,
                    "xueweiName": "胃俞",
                    "xueweiCode": "weiyu",
                    "position": {
                        "x": -0.018177,
                        "y": 1.116964,
                        "z": -0.095252
                    },
                    "xueweiDetail": {
                        "detailTitle": "胃俞：养胃和胃就靠它",
                        "detailDescription": "胃，胃腑；俞，输注。本穴是胃气转输于后背体表的部位。",
                        "cure": "和胃健脾，理中降逆。主治胃痛、呕吐、腹泻、痢疾、小儿疳积。",
                        "position": "在下背部，第12胸椎棘突下，后正中线旁开1.5寸。",
                        "quickFind": "肚脐水平线与脊柱相交椎体处，往上推2个椎体，其上缘旁开2横指处即是。",
                        "massage": "双手握拳，将拳背第2、第3掌指关节放于脾俞、胃俞上，适当用力揉按0.5-1分钟，有和胃降逆、健脾助运之功效。",
                        "xueweiName": "胃俞",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "胃俞"
                    }
                },
                {
                    "seq": 22,
                    "xueweiName": "三焦俞",
                    "xueweiCode": "sanjiaoyu",
                    "position": {
                        "x": -0.01809,
                        "y": 1.074838,
                        "z": -0.101145
                    },
                    "xueweiDetail": {
                        "detailTitle": "三焦俞：腰椎疼痛不怕了",
                        "detailDescription": "三焦，三焦腑；俞，输注。本穴是三焦之气转输于后背体表的部位。",
                        "cure": "调理三焦，利水强腰。主治水肿、小便不利、遗尿、腹水、肠鸣腹泻。",
                        "position": "在腰部，第1腰椎棘突下，后正中线旁开1.5寸。",
                        "quickFind": "肚脐水平线与脊柱相交椎体处，往上推1个椎体，其上缘旁开2横指处即是。",
                        "massage": "常用食指指腹点揉按压三焦俞，每次3〜5分钟，可缓解腰痛，保护腰椎。",
                        "xueweiName": "三焦俞",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "三焦俞"
                    }
                },
                {
                    "seq": 23,
                    "xueweiName": "肾俞",
                    "xueweiCode": "shenyu",
                    "position": {
                        "x": -0.018252,
                        "y": 1.062388,
                        "z": -0.102506
                    },
                    "xueweiDetail": {
                        "detailTitle": "肾俞：护肾强肾第一穴",
                        "detailDescription": "肾，肾脏；俞，输注。本穴是肾气转输于后背体表的部位。",
                        "cure": "益肾助阳，利水强腰。主治遗精、阳痿、月经不调、小便不利、水肿闭经。",
                        "position": "在腰部，第2腰椎棘突下，后正中线旁开1.5寸。",
                        "quickFind": "肚脐水平线与脊柱相交椎体处，其下缘旁开2横指处即是。",
                        "massage": "每天按揉肾俞50~100次，可补肾强身。艾灸肾俞是补肾最有效的方法，每次灸5~15分钟，可治肾疾导致的腰痛、腿痛。",
                        "xueweiName": "肾俞",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "肾俞"
                    }
                },
                {
                    "seq": 24,
                    "xueweiName": "气海俞",
                    "xueweiCode": "qihaiyu",
                    "position": {
                        "x": -0.018181,
                        "y": 1.051796,
                        "z": -0.103429
                    },
                    "xueweiDetail": {
                        "detailTitle": "气海俞：提高性致除腰痛",
                        "detailDescription": "气海，元气之海；俞，输注。本穴前应气海，是元气转输于后背体表的部位。",
                        "cure": "益肾壮阳，调经止痛。主治痛经、痔疮、腰痛、腿膝不利。",
                        "position": "在腰部，第3腰椎棘突下，后正中线旁开1.5寸。",
                        "quickFind": "肚脐水平线与脊柱相交椎体处，往下推1个椎体，其下缘旁开2横指处即是。",
                        "massage": "常用按摩棒按摩气海俞，能防治腰背酸痛、腰膝无力、阳痿等症。",
                        "xueweiName": "气海俞",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "气海俞"
                    }
                },
                {
                    "seq": 25,
                    "xueweiName": "大肠俞",
                    "xueweiCode": "dachangyu",
                    "position": {
                        "x": -0.018187,
                        "y": 1.042349,
                        "z": -0.104071
                    },
                    "xueweiDetail": {
                        "detailTitle": "大肠俞：腰酸腰痛多按揉",
                        "detailDescription": "大肠，大肠腑；俞，输注。本穴是大肠之气转输于后背体表的部位。",
                        "cure": "理气降逆，调和肠胃。主治腹痛、腹胀、便秘、痢疾、腰脊强痛。",
                        "position": "在腰部，第4腰椎棘突下，后正中线旁开1.5寸。",
                        "quickFind": "两侧髂嵴连线与脊柱交点，旁开量2横指处即是。",
                        "massage": "用拇指指端往里向下叩按，以小腹舒适为宜，可治腹痛、腹泻等大肠疾病。",
                        "xueweiName": "大肠俞",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "大肠俞"
                    }
                },
                {
                    "seq": 26,
                    "xueweiName": "关元俞",
                    "xueweiCode": "guanyuanyu",
                    "position": {
                        "x": -0.018094,
                        "y": 1.032214,
                        "z": -0.105443
                    },
                    "xueweiDetail": {
                        "detailTitle": "关元俞：生殖系统守护神",
                        "detailDescription": "关，关藏；元，元气；俞，输注。本穴前应关元，是关藏的元阴元阳之气转输于后背体表的部位。",
                        "cure": "培补元气，调理下焦。主治腹泻、前列腺炎、夜尿症、慢性盆腔炎、痛经。",
                        "position": "在腰骶部，第5腰椎棘突下，后正中线旁开1.5寸。",
                        "quickFind": "两侧髂嵴连线与脊柱交点，往下推1个椎体，旁开量2横指处即是。",
                        "massage": "经常按揉关元俞，可缓解生殖系统疾病。",
                        "xueweiName": "关元俞",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "关元俞"
                    }
                },
                {
                    "seq": 27,
                    "xueweiName": "小肠俞",
                    "xueweiCode": "xiaochangyu",
                    "position": {
                        "x": -0.017951,
                        "y": 1.022018,
                        "z": -0.107289
                    },
                    "xueweiDetail": {
                        "detailTitle": "小肠俞：促进营养消化吸收",
                        "detailDescription": "小肠，小肠腑；俞，输注。本穴是小肠之气转输于后背体表的部位。",
                        "cure": "通调二便，清热利湿。主治腰痛、痢疾、腹泻、疝气、痔疮、盆腔炎。",
                        "position": "在髂部，横平第1骶后孔，骶正中嵴旁1.5寸。",
                        "quickFind": "两侧器靖连线与脊柱交点，往下推2个椎体，旁开量2横指处即是。",
                        "massage": "在小肠俞附近刮痧，每次5分钟；或用艾条灸小肠俞10~15分钟，可治遗尿、遗精等生殖系统疾病。",
                        "xueweiName": "小肠俞",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "小肠俞"
                    }
                },
                {
                    "seq": 28,
                    "xueweiName": "膀胱俞",
                    "xueweiCode": "bangguangyu",
                    "position": {
                        "x": -0.017699,
                        "y": 1.011434,
                        "z": -0.109618
                    },
                    "xueweiDetail": {
                        "detailTitle": "膀胱俞：小便不利常寻按",
                        "detailDescription": "膀胱，膀胱腑；俞，输注。本穴是膀胱之气转输于后背体表的部位。",
                        "cure": "清热利湿，通经活络。主治小便赤涩、癃闭、夜尿症、遗精、坐骨神经痛。",
                        "position": "在骶部，横平第2骶后孔，骶正中嵴旁1.5寸。",
                        "quickFind": "两侧髂嵴连线与脊柱交点，往下推3个椎体，旁开量2横指处即是。",
                        "massage": "在膀胱俞附近刮痧，每次3分钟，每周1次，可治小便不利、遗尿等膀胱功能失调病症。",
                        "xueweiName": "膀胱俞",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "膀胱俞"
                    }
                },
                {
                    "seq": 29,
                    "xueweiName": "中膂俞",
                    "xueweiCode": "zhonglüyu",
                    "position": {
                        "x": -0.017628,
                        "y": 0.985432,
                        "z": -0.113712
                    },
                    "xueweiDetail": {
                        "detailTitle": "中膂俞：调理不孕与不育",
                        "detailDescription": "中，中间；膂，挟脊肌肉；俞，输注。本穴位约居人体的中部，是挟脊肌肉之气转输于后背体表的部位。",
                        "cure": "益肾温阳，调理下焦。主治腰脊强痛、痢疾、肾虚、坐骨神经痛。",
                        "position": "在骶部，横平第3骶后孔，骶正中嵴旁1.5寸。",
                        "quickFind": "两侧骼嵴连线与脊柱交点，往下推4个椎体，旁开量2横指处即是。",
                        "massage": "按揉中膂俞100次，或用艾灸，每次灸3~5次，可治腹泻疝气。",
                        "xueweiName": "中膂俞",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "中膂俞"
                    }
                },
                {
                    "seq": 30,
                    "xueweiName": "白环俞",
                    "xueweiCode": "baihuanyu",
                    "position": {
                        "x": -0.0181,
                        "y": 0.970065,
                        "z": -0.114292
                    },
                    "xueweiDetail": {
                        "detailTitle": "白环俞：主治男女生殖病",
                        "detailDescription": "白，白色；环，物名；俞，穴。本穴可治妇女白带等病。",
                        "cure": "益肾固精，调理经带。主治月经不调、遗精、腰腿痛、下肢瘫痪。",
                        "position": "在骶部，横平第4骶后孔，骶正中嵴旁1.5寸。",
                        "quickFind": "两侧髂嵴连线与脊柱交点，往下推5个椎体，旁开量2横指处即是。",
                        "massage": "遗精、月经不调可用艾条灸白环俞，每次3~5分钟，每日或隔日1次；每日按揉100次，亦有效。",
                        "xueweiName": "白环俞",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "白环俞"
                    }
                },
                {
                    "seq": 31,
                    "xueweiName": "上髎",
                    "xueweiCode": "shangliao",
                    "position": {
                        "x": -0.006753,
                        "y": 1.013564,
                        "z": -0.104458
                    },
                    "xueweiDetail": {
                        "titleUrl": "testJingLuoTitle",
                        "jingluoName": "手阳明大肠经",
                        "detailTitle": "少海穴：感冒咽痛不再烦",
                        "detailDescription": "少，幼小、气初生之处也。",
                        "cure": "泻热开、感冒。",
                        "position": "在手指0.156寸。",
                        "quickFind": "一手拇指伸直，缘处即使。",
                        "massage": "用指甲，即可止戈。"
                    }
                },
                {
                    "seq": 32,
                    "xueweiName": "次髎",
                    "xueweiCode": "ciliao",
                    "position": {
                        "x": -0.006753,
                        "y": 0.998198,
                        "z": -0.103972
                    },
                    "xueweiDetail": {
                        "titleUrl": "testJingLuoTitle",
                        "jingluoName": "手阳明大肠经",
                        "detailTitle": "少海穴：感冒咽痛不再烦",
                        "detailDescription": "少，幼小、气初生之处也。",
                        "cure": "泻热开、感冒。",
                        "position": "在手指0.157寸。",
                        "quickFind": "一手拇指伸直，缘处即使。",
                        "massage": "用指甲，即可止戈。"
                    }
                },
                {
                    "seq": 33,
                    "xueweiName": "中髎",
                    "xueweiCode": "zhongliao",
                    "position": {
                        "x": -0.006989,
                        "y": 0.985195,
                        "z": -0.103313
                    },
                    "xueweiDetail": {
                        "titleUrl": "testJingLuoTitle",
                        "jingluoName": "手阳明大肠经",
                        "detailTitle": "少海穴：感冒咽痛不再烦",
                        "detailDescription": "少，幼小、气初生之处也。",
                        "cure": "泻热开、感冒。",
                        "position": "在手指0.158寸。",
                        "quickFind": "一手拇指伸直，缘处即使。",
                        "massage": "用指甲，即可止戈。"
                    }
                },
                {
                    "seq": 34,
                    "xueweiName": "下髎",
                    "xueweiCode": "xialiao",
                    "position": {
                        "x": -0.006989,
                        "y": 0.969829,
                        "z": -0.101368
                    },
                    "xueweiDetail": {
                        "titleUrl": "testJingLuoTitle",
                        "jingluoName": "手阳明大肠经",
                        "detailTitle": "少海穴：感冒咽痛不再烦",
                        "detailDescription": "少，幼小、气初生之处也。",
                        "cure": "泻热开、感冒。",
                        "position": "在手指0.159寸。",
                        "quickFind": "一手拇指伸直，缘处即使。",
                        "massage": "用指甲，即可止戈。"
                    }
                },
                {
                    "seq": 35,
                    "xueweiName": "会阳",
                    "xueweiCode": "huiyang",
                    "position": {
                        "x": -0.006753,
                        "y": 0.940751,
                        "z": -0.093214
                    },
                    "xueweiDetail": {
                        "detailTitle": "会阳：治疗痔疮与便血",
                        "detailDescription": "会，交会；阳，阴阳之阳。穴属阳经，与阳脉之海的督脉相交。",
                        "cure": "清热利湿，益肾固带。主治腹泻、痔疮、便血、阳痿、阴部汗湿瘙痒。",
                        "position": "在骶尾部，尾骨尖旁开0.5寸。",
                        "quickFind": "俯卧，顺着脊柱向下摸到尽头，旁开0.5寸处即是。",
                        "massage": "双手向后，手掌心朝向背部，用中指指腹揉按会阳，有酸痛感为佳，每次左右各揉按1~3分钟，可治腹泻、痢疾、痔疮、便血等症。",
                        "xueweiName": "会阳",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "会阳"
                    }
                },
                {
                    "seq": 36,
                    "xueweiName": "承扶",
                    "xueweiCode": "chengfu",
                    "position": {
                        "x": -0.050012,
                        "y": 0.858749,
                        "z": -0.074138
                    },
                    "xueweiDetail": {
                        "detailTitle": "承扶：腿痛痔疮常找它",
                        "detailDescription": "承，承受；扶，佐助。本穴位于股部上段，当肢体分界的臀沟中点，有佐助下肢承受头身重量的作用。",
                        "cure": "通便消痔，舒筋活络。主治下肢瘫痪、坐骨神经痛、痔疮。",
                        "position": "在股后部，臀下横纹的中点。",
                        "quickFind": "俯卧，臀下横纹正中点，按压有酸胀感处即是。",
                        "massage": "用食指、中指、无名指指腹向上按摩承扶，每次左右（或双侧同时）各按摩1~3分钟。可缓解腰腿痛、下肢瘫痪、痔疮、生殖器官疼痛等症。",
                        "xueweiName": "承扶",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "承扶"
                    }
                },
                {
                    "seq": 37,
                    "xueweiName": "殷门",
                    "xueweiCode": "yinmen",
                    "position": {
                        "x": -0.066094,
                        "y": 0.741882,
                        "z": -0.077866
                    },
                    "xueweiDetail": {
                        "detailTitle": "殷门：强健腰腿有绝招",
                        "detailDescription": "殷，深厚、正中；门，门户。穴位局部肌肉深厚，为膀胱经气通过之门户。",
                        "cure": "舒筋通络，强腰健膝。主治腰、骶、臀、股部疼痛，下肢瘫痪。",
                        "position": "在股后区，臀下横纹下6寸，股二头肌与半腱肌之间。",
                        "quickFind": "先找到承扶、膝盖后面凹陷中央的月国横纹中点，二者连线的中点上1横指处即是。",
                        "massage": "用手按摩，或用小木槌等器物敲打殷门，力度适中。对腰背疼痛和椎间盘突出症状效果明显。",
                        "xueweiName": "殷门",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "殷门"
                    }
                },
                {
                    "seq": 38,
                    "xueweiName": "浮郄",
                    "xueweiCode": "fuqie",
                    "position": {
                        "x": -0.09781,
                        "y": 0.542409,
                        "z": -0.065395
                    },
                    "xueweiDetail": {
                        "detailTitle": "浮郄：缓解小腿抽筋快",
                        "detailDescription": "浮，顺流；郄，空隙。本经之气从股后顺流下入的穴隙。",
                        "cure": "舒筋通络。主治腰、髄、臀、股部疼痛，坐骨神经痛，下肢瘫痪。",
                        "position": "在膝后部，腘横纹上1寸，股二头肌腱的内侧缘。",
                        "quickFind": "先找到委阳，向上1横指处即是。",
                        "massage": "用中指指腹点揉浮郄3~5分钟，可缓解腓肠肌痉挛（即小腿肚转筋）带来的不适。",
                        "xueweiName": "浮郄",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "浮郄"
                    }
                },
                {
                    "seq": 39,
                    "xueweiName": "委阳",
                    "xueweiCode": "weiyang",
                    "position": {
                        "x": -0.096864,
                        "y": 0.516877,
                        "z": -0.06786
                    },
                    "xueweiDetail": {
                        "detailTitle": "委阳：腰背疼痛按委阳",
                        "detailDescription": "委，弯曲；阳，阴阳之阳。外属阳，穴在腘窝横纹委中外侧。",
                        "cure": "舒筋活络，通利水湿。主治小便淋沥、便秘、腰背部疼痛。",
                        "position": "在膝部腘横纹上，股二头肌腱内侧缘。",
                        "quickFind": "膝盖后面凹陷中央的腘横纹外侧，股二头肌腱内侧即是。",
                        "massage": "用大拇指点到委阳上，用力向内揉按，每次左右各1~3分钟。可降血压，治腰背痛、脑后头痛、足跟痛。",
                        "xueweiName": "委阳",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "委阳"
                    }
                },
                {
                    "seq": 40,
                    "xueweiName": "委中",
                    "xueweiCode": "weizhong",
                    "position": {
                        "x": -0.080385,
                        "y": 0.516877,
                        "z": -0.064675
                    },
                    "xueweiDetail": {
                        "detailTitle": "委中：即刻缓解腰背痛",
                        "detailDescription": "委，弯曲；中，中间。穴在胭横纹中点。",
                        "cure": "舒筋活络，泻热清暑，凉血解毒。主治腰脊痛、坐骨神经痛、膝关节炎、半身不遂、皮肤瘙痒、发热。",
                        "position": "在膝后部，腘横纹中点。",
                        "quickFind": "膝盖后面凹陷中央的腘横纹中点即是。",
                        "massage": "用力掐按委中20~30次，可缓解急性腰痛。",
                        "xueweiName": "委中",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "委中"
                    }
                },
                {
                    "seq": 41,
                    "xueweiName": "附分",
                    "xueweiCode": "fufen",
                    "position": {
                        "x": -0.037322,
                        "y": 1.506671,
                        "z": -0.113692
                    },
                    "xueweiDetail": {
                        "detailTitle": "附分：颈肩不适就按它",
                        "detailDescription": "附，依附；分，分离。膀胱经自项而下，分为两行；本穴为第二行之首穴，附于第一行之旁。",
                        "cure": "舒筋活络，疏风散邪。主治肩背拘急疼痛、颈项强痛、坐骨神经痛。",
                        "position": "在上背部，第2胸椎棘突下，后正中线旁开3寸。",
                        "quickFind": "低头屈颈，颈背交界处椎骨高突向下推2个椎体，其下缘旁开4指处。",
                        "massage": "用力按揉或用刮方板从上向下刮拭附分，或艾灸附分10~15分钟，可治颈项强痛、肩背拘急。",
                        "xueweiName": "附分",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "附分"
                    }
                },
                {
                    "seq": 42,
                    "xueweiName": "魄户",
                    "xueweiCode": "pohu",
                    "position": {
                        "x": -0.037207,
                        "y": 1.463966,
                        "z": -0.139132
                    },
                    "xueweiDetail": {
                        "detailTitle": "魄户：咳嗽哮喘求魄户",
                        "detailDescription": "魄，气之灵；户，门户。肺藏魄；本穴与肺俞平列，如肺气出入门户。",
                        "cure": "理气降逆，舒筋活络。主治咳嗽、气喘、支气管炎、肺结核、颈项僵硬、肩背痛。",
                        "position": "在上背部，第3胸椎棘突下，后正中线旁开3寸。",
                        "quickFind": "低头屈颈，颈背交界处椎骨高突向下推3个椎体，其下缘旁开4指处。",
                        "massage": "用力按揉魄户，可治咳嗽、气喘等肺疾。",
                        "xueweiName": "魄户",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "魄户"
                    }
                },
                {
                    "seq": 43,
                    "xueweiName": "膏肓",
                    "xueweiCode": "gaohuang",
                    "position": {
                        "x": -0.037248,
                        "y": 1.422735,
                        "z": -0.147653
                    },
                    "xueweiDetail": {
                        "detailTitle": "膏肓：强肾保健常施灸",
                        "detailDescription": "膏，膏脂；肓，肓膜。在此指心下膈上的膏脂肓膜；因近于心包，故被看做心包组成部分。穴与厥阴俞平列，因名膏肓。",
                        "cure": "补虚益损，调理肺气。主治肺痔、咳嗽、气喘、盗汗、健忘、遗精。",
                        "position": "在上背部，第4胸椎棘突下，后正中线旁开3寸。",
                        "quickFind": "低头屈颈，颈背交界处椎骨高突向下推4个椎体，其下缘旁开4横指处。",
                        "massage": "颈肩痛时，可用刮痧板从上向下刮拭膏肓；若是咳嗽、气喘等肺疾，可艾灸膏肓，每次灸10-15分钟。",
                        "xueweiName": "膏肓",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "膏肓"
                    }
                },
                {
                    "seq": 44,
                    "xueweiName": "神堂",
                    "xueweiCode": "shentang",
                    "position": {
                        "x": -0.037314,
                        "y": 1.380592,
                        "z": -0.143816
                    },
                    "xueweiDetail": {
                        "detailTitle": "神堂：胸闷心慌用力按",
                        "detailDescription": "心藏神；穴如心神所居之殿堂。",
                        "cure": "宽胸理气，宁心安神。主治心悸、失眠、肩背痛、哮喘、心脏病。",
                        "position": "在背部，第5胸椎棘突下，后正中线旁开3寸。",
                        "quickFind": "肩胛骨下角水平连线与脊柱相交椎体处，往上推2个椎体，其下缘水平线与肩胛骨脊柱缘的垂直线交点即是。",
                        "massage": "用双手拇指直接点压神堂，可治咳嗽、气喘、脊背强痛等；经常用按摩槌敲打神堂，可畅通气血，调理肺、胃功能。",
                        "xueweiName": "神堂",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "神堂"
                    }
                },
                {
                    "seq": 45,
                    "xueweiName": "譩譆",
                    "xueweiCode": "yixi",
                    "position": {
                        "x": -0.037402,
                        "y": 1.339995,
                        "z": -0.139835
                    },
                    "xueweiDetail": {
                        "detailTitle": "譩譆：肩背酸痛不要怕",
                        "detailDescription": "譩譆，叹息声。取穴时，令患者发譩譆声，穴位局部能动应手指。",
                        "cure": "宣肺理气，通络止痛。主治咳嗽、气喘、目眩、肩背痛、季胁痛。",
                        "position": "在背部，第6胸椎棘突下，后正中线旁开3寸处。",
                        "quickFind": "肩胛骨下角水平连线与脊柱相交椎体处，往上推1个椎体，其下缘水平线与肩胛骨脊柱缘的垂直线交点即是。",
                        "massage": "肩背痛时，可从上向下刮拭譩譆；经常用按摩槌敲打刺激譩譆，可调理背部肌肉疼痛。",
                        "xueweiName": "譩譆",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "譩譆"
                    }
                },
                {
                    "seq": 46,
                    "xueweiName": "膈关",
                    "xueweiCode": "geguan",
                    "position": {
                        "x": -0.037343,
                        "y": 1.296969,
                        "z": -0.132126
                    },
                    "xueweiDetail": {
                        "detailTitle": "膈关：敲打叩击降胃气",
                        "detailDescription": "膈，横膈；关，关隘。本穴与膈俞平列，喻之为治疗横膈疾病的关隘。",
                        "cure": "宽胸理气，和胃降逆。主治饮食不下、呕吐、胸中噎闷、脊背强痛。",
                        "position": "在背部，第7胸椎棘突下，后正中线旁开3寸。",
                        "quickFind": "肩胛骨下角水平连线与肩胛骨脊柱缘的垂直线交点即是。",
                        "massage": "经常用按摩槌敲打刺激膈关，可防治呕吐、打嗝、胃痛等症；胸闷、呕吐时，可用艾条灸膈关，每次灸10-15分钟。",
                        "xueweiName": "膈关",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "膈关"
                    }
                },
                {
                    "seq": 47,
                    "xueweiName": "魂门",
                    "xueweiCode": "hunmen",
                    "position": {
                        "x": -0.037462,
                        "y": 1.212926,
                        "z": -0.113023
                    },
                    "xueweiDetail": {
                        "detailTitle": "魂门：点压缓解胸肋痛",
                        "detailDescription": "肝藏魂；穴如肝气出入之门户。",
                        "cure": "疏肝理气，降逆和胃。主治胸胁胀痛、呕吐、肠鸣腹泻、背痛。",
                        "position": "在背部，第9胸椎棘突下，后正中线旁开3寸处。",
                        "quickFind": "肩胛骨下角水平连线与脊柱相交椎体处，往下推2个椎体，其下缘水平线与肩胛骨脊柱缘的垂直线交点即是。",
                        "massage": "用拇指直接点压魂门1~3分钟，可治胸胁疼痛、呕吐、腹泻、背痛等症。经常用按摩槌敲打刺激魂门，可保肝利胆。",
                        "xueweiName": "魂门",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "魂门"
                    }
                },
                {
                    "seq": 48,
                    "xueweiName": "阳纲",
                    "xueweiCode": "yanggang",
                    "position": {
                        "x": -0.037343,
                        "y": 1.171082,
                        "z": -0.096007
                    },
                    "xueweiDetail": {
                        "detailTitle": "阳纲：消炎利胆就刮痧",
                        "detailDescription": "阳，阴阳之阳；纲，纲要。胆属阳；穴与胆俞平列，为治疗胆病的要穴。",
                        "cure": "疏肝利胆，健脾和中。主治腹泻、黄疸、腹痛、大便泻利、小便赤涩。",
                        "position": "在下背部，第10胸椎棘突下，后正中线旁开3寸。",
                        "quickFind": "肩胛骨下角水平连线与脊柱相交椎体处，往下推3个椎体，其下缘水平线与肩胛骨脊柱缘的垂直线交点即是。",
                        "massage": "经常用按摩槌敲打的方式剌激，可调理肝、胆、胃疾病引起的疼痛；用刮痧板从上向下刮拭阳纲，可治肠鸣、腹痛、腹泻等胃肠疾病。",
                        "xueweiName": "阳纲",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "阳纲"
                    }
                },
                {
                    "seq": 49,
                    "xueweiName": "意舍",
                    "xueweiCode": "yishe",
                    "position": {
                        "x": -0.037343,
                        "y": 1.116945,
                        "z": -0.093488
                    },
                    "xueweiDetail": {
                        "detailTitle": "意舍：艾灸调理糖尿病",
                        "detailDescription": "意，意念；舍，宅舍。脾藏意；穴与脾俞平列，如脾气之宅舍。",
                        "cure": "健脾和胃，利胆化湿。主治腹胀、背痛、食欲不振、腹泻、呕吐、纳呆。",
                        "position": "在下背部，第11胸椎棘突下，后正中线旁开3寸处。",
                        "quickFind": "肚脐水平线与脊柱相交椎体处，往上推3个椎体，其下缘水平线与肩胛骨脊柱缘的垂直线交点即是。",
                        "massage": "常按揉意舍，可助健脾；用艾灸方法，每次灸10~15分钟，可辅助治疗糖尿病。",
                        "xueweiName": "意舍",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "意舍"
                    }
                },
                {
                    "seq": 50,
                    "xueweiName": "胃仓",
                    "xueweiCode": "weicang",
                    "position": {
                        "x": -0.037107,
                        "y": 1.074865,
                        "z": -0.097366
                    },
                    "xueweiDetail": {
                        "detailTitle": "胃仓：增进食欲常按它",
                        "detailDescription": "胃，胃腑；仓，粮仓。穴犹如粮仓。",
                        "cure": "和胃健脾，消食导滞。主治胃痛、小儿食积、腹胀、便秘、水肿。",
                        "position": "在下背部，第12胸椎棘突下，后正中线旁开3寸处。",
                        "quickFind": "肚脐水平线与脊柱相交椎体处，往上推2个椎体，其下缘水平线与肩胛骨脊柱缘的垂直线交点即是。",
                        "massage": "常按揉胃仓可开胃；用艾灸的方法，每次灸10~15分钟，可治腹胀、食积等脾胃病症。",
                        "xueweiName": "胃仓",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "胃仓"
                    }
                },
                {
                    "seq": 51,
                    "xueweiName": "肓门",
                    "xueweiCode": "huangmen",
                    "position": {
                        "x": -0.036862,
                        "y": 1.051618,
                        "z": -0.102938
                    },
                    "xueweiDetail": {
                        "detailTitle": "肓门：腹部不适就按它",
                        "detailDescription": "肓，肓膜；门，门户。穴与三焦俞平列，如肓膜之气出入的门户。",
                        "cure": "理气和胃，清热消肿。主治痞块、心下痛、妇人乳疾、上腹痛、便秘。",
                        "position": "在腰部，第1腰椎棘突下，后正中线旁开3寸处。",
                        "quickFind": "肚脐水平线与脊柱相交椎体处，往上推1个椎体，其下缘水平线与肩胛骨脊柱缘的垂直线交点即是。",
                        "massage": "腹痛、便秘，可用中指指腹揉按肓门，每次3~5分钟。经常揉按也可预防消化不良。",
                        "xueweiName": "肓门",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "肓门"
                    }
                },
                {
                    "seq": 52,
                    "xueweiName": "志室",
                    "xueweiCode": "zhishi",
                    "position": {
                        "x": -0.036193,
                        "y": 1.026543,
                        "z": -0.113201
                    },
                    "xueweiDetail": {
                        "detailTitle": "志室：肾虚常按是绝招",
                        "detailDescription": "志，意志；室，房室。肾藏志；穴与肾俞平列，如肾气聚集之房室。",
                        "cure": "益肾固精，清热利湿，强壮腰膝。主治遗精、阴痛水肿、小便不利、腰脊强痛。",
                        "position": "在腰部，第2腰椎棘突下，后正中线旁开3寸处。",
                        "quickFind": "肚脐水平线与脊柱相交椎体处，其下缘水平线与肩胛骨脊柱缘的垂直线交点即是。",
                        "massage": "用力按揉志室，可补肾强腰；也可以用艾灸法，每次灸5~10分钟。",
                        "xueweiName": "志室",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "志室"
                    }
                },
                {
                    "seq": 53,
                    "xueweiName": "胞肓",
                    "xueweiCode": "baohuang",
                    "position": {
                        "x": -0.037256,
                        "y": 0.997817,
                        "z": -0.122279
                    },
                    "xueweiDetail": {
                        "detailTitle": "胞肓：腰脊疼痛多刮擦",
                        "detailDescription": "胞，囊袋；肓，肓膜。胞，在此主要指膀胱；穴与膀胱俞平列，故名。",
                        "cure": "补肾强腰，通利二便。主治小便不利、腰脊痛、腹胀、肠鸣、便秘。",
                        "position": "横平第2骶后孔，正中靖旁开3寸。",
                        "quickFind": "两侧髂嵴连线与脊柱交点，往下推3个椎体，其下缘水平线与肩胛骨脊柱缘的垂直线交点即是。",
                        "massage": "用中指揉按1〜3分钟，可改善腰膝寒冷；腰脊强痛时可从上向下刮拭胞肓。",
                        "xueweiName": "胞肓",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "胞肓"
                    }
                },
                {
                    "seq": 54,
                    "xueweiName": "秩边",
                    "xueweiCode": "zhibian",
                    "position": {
                        "x": -0.037423,
                        "y": 0.9699,
                        "z": -0.125828
                    },
                    "xueweiDetail": {
                        "detailTitle": "秩边：便秘痔疾不用怕",
                        "detailDescription": "秩，秩序；边，边缘。膀胱经背部诸穴，排列有序；本穴居其最下缘。",
                        "cure": "舒筋活络，强壮腰膝，调理下焦。主治腰骶痛、下肢痿痹、痔疮、小便不利。",
                        "position": "在骶区，横平第4骶后孔，骶正中嵴旁开3寸。",
                        "quickFind": "两侧髂嵴连线与脊柱交点，往下推5个椎体，其下缘水平线与肩胛骨脊柱缘的垂直线交点即是。",
                        "massage": "点按秩边，多防治腰腿疼痛，可用艾灸法，每次灸10〜15分钟，可治小便不利、便秘、痔疮、膀胱炎等病。",
                        "xueweiName": "秩边",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "秩边"
                    }
                },
                {
                    "seq": 55,
                    "xueweiName": "合阳",
                    "xueweiCode": "heyang",
                    "position": {
                        "x": -0.080316,
                        "y": 0.473851,
                        "z": -0.076944
                    },
                    "xueweiDetail": {
                        "detailTitle": "合阳：腰脚疼痛就揉它",
                        "detailDescription": "合，汇合；阳，阴阳之阳。本经自上而下分成两支，高而为阳。",
                        "cure": "舒筋通络，调经止带，强健腰膝。主治腰脊痛、下肢酸痛、崩漏、子宫出血、带下。",
                        "position": "在小腿后部，腘横纹下2寸，腓肠肌内、外侧头之间。",
                        "quickFind": "膝盖后面凹陷中央的腘横纹中点直下量3横指处即是。",
                        "massage": "从上向下刮擦合阳及其周围，可治疗腰痛、坐骨神经痛、痔疮。",
                        "xueweiName": "合阳",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "合阳"
                    }
                },
                {
                    "seq": 56,
                    "xueweiName": "承筋",
                    "xueweiCode": "chengjin",
                    "position": {
                        "x": -0.054057,
                        "y": 0.389104,
                        "z": -0.094464
                    },
                    "xueweiDetail": {
                        "detailTitle": "承筋：小腿痉挛揉承筋",
                        "detailDescription": "承，承受；筋，筋肉。穴在腓肠肌处；这是小腿以下承受其以上定位的主要筋肉。",
                        "cure": "舒筋活络，强健腰膝，清泻肠热。主治腰痛、小腿痛、急性腰扭伤、腿抽筋、痔疮。",
                        "position": "小腿后侧，腘横纹下5寸，腓肠肌两肌腹之间。",
                        "quickFind": "俯卧，小腿用力，后面肌肉明显隆起，中央处按压有酸胀感处即是。",
                        "massage": "用手轻握小腿侧部，拇指在小腿后，四指在腿侧，以拇指指腹揉按，每次左右各揉按1~3分钟，可治疗痔疮和小腿痉挛。",
                        "xueweiName": "承筋",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "承筋"
                    }
                },
                {
                    "seq": 57,
                    "xueweiName": "承山",
                    "xueweiCode": "chengshan",
                    "position": {
                        "x": -0.05406,
                        "y": 0.30905,
                        "z": -0.094455
                    },
                    "xueweiDetail": {
                        "detailTitle": "承山：腿脚抽筋不再来",
                        "detailDescription": "承，承受；山，山巅。腓肠肌之二肌腹高突如山，穴在其下，有承受之势。",
                        "cure": "理气止痛，舒筋活络，消痔。主治痔疮、便秘、腰背疼、腿抽筋、下肢瘫痪。",
                        "position": "在小腿后侧，腓肠肌两肌腹与肌腱交角处。",
                        "quickFind": "俯卧，膝盖后面凹陷中央的腘横纹中点与外踝尖连线的中点处即是。",
                        "massage": "用拇指指腹按摩承山，力度由轻到重，然后用手掌在穴位四周搓擦，令皮肤感到发热，以此方法可治疗小腿抽筋。",
                        "xueweiName": "承山",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "承山"
                    }
                },
                {
                    "seq": 58,
                    "xueweiName": "飞扬",
                    "xueweiCode": "feiyang",
                    "position": {
                        "x": -0.06751,
                        "y": 0.296546,
                        "z": -0.101399
                    },
                    "xueweiDetail": {
                        "detailTitle": "飞扬：迅速缓解腿疲劳",
                        "detailDescription": "飞，飞翔；扬，向上扬。外为阳，穴在小腿外侧，本经从此处飞离而去络肾经。",
                        "cure": "清热安神，舒筋活络。主治腰腿痛、小腿酸痛、头痛、脚气。",
                        "position": "在小腿后侧，昆仑直上7寸，腓肠肌外下缘与跟腱移行处。",
                        "quickFind": "先找到承山，其下1横指再旁开1横指处。",
                        "massage": "用食指、中指指腹揉按飞扬1~3分钟，可治头痛、目眩、腰腿疼痛等疾病。",
                        "xueweiName": "飞扬",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "飞扬"
                    }
                },
                {
                    "seq": 59,
                    "xueweiName": "跗阳",
                    "xueweiCode": "fuyang",
                    "position": {
                        "x": -0.069495,
                        "y": 0.222617,
                        "z": -0.092495
                    },
                    "xueweiDetail": {
                        "detailTitle": "跗阳：脚踝肿痛揉揉它",
                        "detailDescription": "跗，足背；阳，阴阳之阳。外为阳，上为阳；穴在小腿外侧足背外上方。",
                        "cure": "舒筋活络，退热散风。主治腰、骶、胯、股后外侧疼痛。",
                        "position": "在小腿后外侧，昆仑直上3寸，腓骨与跟腱之间。",
                        "quickFind": "平足外踝向上量4横指，按压有酸胀感处即是。",
                        "massage": "用拇指指节刮按跗阳1~3分钟，对外踝肿痛、脚麻痹等病症具有明显疗效。",
                        "xueweiName": "跗阳",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "跗阳"
                    }
                },
                {
                    "seq": 60,
                    "xueweiName": "昆仑",
                    "xueweiCode": "kunlun",
                    "position": {
                        "x": -0.081689,
                        "y": 0.11557,
                        "z": -0.08685
                    },
                    "xueweiDetail": {
                        "detailTitle": "昆仑：脚踝疼痛多拿捏",
                        "detailDescription": "昆仑，山名。外踝高突，比作昆仑，穴在其后。",
                        "cure": "安神清热，舒筋活络。主治头痛、腰骶疼痛、外踝部红肿、足部生疮。",
                        "position": "在踝部，外踝尖与跟腱之间凹陷中。",
                        "quickFind": "外踝尖与跟腱之间凹陷处即是。",
                        "massage": "拇指弯曲，用指节由上向下轻轻刮按1~3分钟，对腿足红肿、脚腕疼痛、脚踝疼痛等具有疗效。",
                        "xueweiName": "昆仑",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "昆仑"
                    }
                },
                {
                    "seq": 61,
                    "xueweiName": "仆参",
                    "xueweiCode": "pucan",
                    "position": {
                        "x": -0.099708,
                        "y": 0.066394,
                        "z": -0.088422
                    },
                    "xueweiDetail": {
                        "detailTitle": "仆参：牙槽脓肿有奇效",
                        "detailDescription": "仆，仆从；参，参拜。穴在足跟外侧，参拜时此处易显露。",
                        "cure": "舒筋活络，强壮腰膝，散热化气。主治牙槽脓肿、下肢痿弱、足跟痛、精神病。",
                        "position": "昆仑直下，跟骨外侧，赤白肉际处。",
                        "quickFind": "昆仑垂直向下量1横指处。",
                        "massage": "牙槽脓肿的初期，按压仆参会有疼痛感。常按此穴，一般不太严重的患者都会好转。",
                        "xueweiName": "仆参",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "仆参"
                    }
                },
                {
                    "seq": 62,
                    "xueweiName": "申脉",
                    "xueweiCode": "shenmo",
                    "position": {
                        "x": -0.118283,
                        "y": 0.096978,
                        "z": -0.070804
                    },
                    "xueweiDetail": {
                        "detailTitle": "申脉：安神宁心治失眠",
                        "detailDescription": "申，伸展的意思；脉，经脉。指其可治经脉之屈伸不利、气郁而呻等症，且可内应膀胱之本府也。",
                        "cure": "镇惊安神，止痫宁心。主治失眠，癫狂，痫症，中风，偏、正头痛，眩晕。",
                        "position": "在踝部，外踝下缘与跟骨之间凹陷中。",
                        "quickFind": "正坐垂足着地，外踝垂直向下可触及一凹陷，按压有酸胀感处即是。",
                        "massage": "按摩申脉可缓解头痛、眩晕、腰腿酸痛等症状；每天用拇指指腹揉按1~3分钟，可增强人体对寒冷的耐受性。",
                        "xueweiName": "申脉",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "申脉"
                    }
                },
                {
                    "seq": 63,
                    "xueweiName": "金门",
                    "xueweiCode": "jinmen",
                    "position": {
                        "x": -0.132872,
                        "y": 0.061561,
                        "z": -0.062691
                    },
                    "xueweiDetail": {
                        "detailTitle": "金门：急性腰痛就按它",
                        "detailDescription": "金，阳之称；门，门户。穴是阳维脉的始发点，故又被喻为进入阳维脉的门户。",
                        "cure": "通经活络，安神开窍。主治腰痛、足部扭伤、晕厥、牙痛、偏头痛。",
                        "position": "第5跖骨粗隆后方，骰骨外侧凹陷中。",
                        "quickFind": "正坐垂足着地，脚趾上翘可见一骨头凸起，外侧凹陷处即是。",
                        "massage": "在金门痛点处点按2分钟，可即时缓解急性腰痛；常用拇指指腹揉按金门，每次1~3分钟，可调理头晕目眩等症状。",
                        "xueweiName": "金门",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "金门"
                    }
                },
                {
                    "seq": 64,
                    "xueweiName": "京骨",
                    "xueweiCode": "jinggu",
                    "position": {
                        "x": -0.163292,
                        "y": 0.050068,
                        "z": -0.036221
                    },
                    "xueweiDetail": {
                        "detailTitle": "京骨：长按多掐保健康",
                        "detailDescription": "京骨，是第5跖骨粗隆的古称。穴在第5跖骨粗隆外侧。",
                        "cure": "清热止痉，明目舒筋。主治头痛、眩晕、膝痛、鼻塞、小儿惊风。",
                        "position": "在足背外侧，第5跖骨粗隆前下方，赤白肉际处。",
                        "quickFind": "沿小趾长骨往后推，可摸到一凸起，下方皮肤颜色深浅交界处即是。",
                        "massage": "用拇指指端轻轻掐揉京骨，以有酸痛感为宜，可治疗头痛、眩晕、鼻塞。",
                        "xueweiName": "京骨",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "京骨"
                    }
                },
                {
                    "seq": 65,
                    "xueweiName": "束骨",
                    "xueweiCode": "shugu",
                    "position": {
                        "x": -0.203972,
                        "y": 0.041734,
                        "z": 0.000518
                    },
                    "xueweiDetail": {
                        "detailTitle": "束骨：推按束骨防感冒",
                        "detailDescription": "束骨，为第5跖骨小头之古称。穴在第5跖骨小头外下方。",
                        "cure": "通经活络，清头明目。主治头痛、目赤、耳聋、痔疮、下肢后侧痛。",
                        "position": "在足背外侧，第5跖趾关节的近端，赤白肉际处。",
                        "quickFind": "沿小趾向上摸，摸到小趾与足部相连接的关节，关节后方皮肤颜色交界处即是。",
                        "massage": "用按摩棒按压束骨，每次100下，每天3次，可治疗头痛、项强、目眩等头部疾病。",
                        "xueweiName": "束骨",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "束骨"
                    }
                },
                {
                    "seq": 66,
                    "xueweiName": "足通谷",
                    "xueweiCode": "zutonggu",
                    "position": {
                        "x": -0.221483,
                        "y": 0.039741,
                        "z": 0.01927
                    },
                    "xueweiDetail": {
                        "detailTitle": "足通谷：温阳散寒治阳虚",
                        "detailDescription": "足，足部；通，通过；谷，山谷。穴在足部，该处凹陷如谷，脉气由此而通过。",
                        "cure": "清热安神，清头明目。主治头痛、头重、目眩、鼻塞、颈项痛。",
                        "position": "在足趾，第5跖趾关节的远端，赤白肉际处。",
                        "quickFind": "沿小趾向上摸，摸到小趾与足掌相连接的关节，关节前方皮肤颜色交界处即是。",
                        "massage": "常按足通谷，可治呼吸系统、循环系统、消化系统病症。",
                        "xueweiName": "足通谷",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "足通谷"
                    }
                },
                {
                    "seq": 67,
                    "xueweiName": "至阴",
                    "xueweiCode": "zhiyin",
                    "position": {
                        "x": -0.248179,
                        "y": 0.030586,
                        "z": 0.05664
                    },
                    "xueweiDetail": {
                        "detailTitle": "至阴：纠正胎位第一穴",
                        "detailDescription": "至，到达；阴，阴阳之阴。阴，在此指足少阴肾经。此穴为足太阳膀胱经末穴，从这里可到达足少阴肾经。",
                        "cure": "理气活血，清头明目。主治头痛、鼻塞、遗精、胎位不正、难产。",
                        "position": "在足趾，小趾末节外侧，趾甲根角侧后方0.1寸（指寸）。",
                        "quickFind": "足小趾外侧，趾甲外侧缘与下缘各作一垂线，其交点处即是。",
                        "massage": "掐按至阴可纠正胎位不正，或艾灸此穴，每日灸1次，每次10~15分钟，以足小趾皮肤潮红为度。灸前排空小便，松开腰带，以利胎儿活动。",
                        "xueweiName": "至阴",
                        "jingluoName": "足太阳膀胱经",
                        "titleUrl": "至阴"
                    }
                }
            ]
        },
        {
            "jingMaiName": "足少阴肾经",
            "jingMaiCode": "zushaoyinshenjing",
            "xueweiList": [
                {
                    "seq": 1,
                    "xueweiName": "涌泉",
                    "xueweiCode": "yongquan",
                    "position": {
                        "x": -0.171292,
                        "y": 0.023552,
                        "z": 0.04564
                    },
                    "xueweiDetail": {
                        "detailTitle": "涌泉：人体生命之源泉",
                        "detailDescription": "涌，外涌而出也；泉，泉水也。穴居足心陷中，经气自下而上，如涌出之泉水。",
                        "cure": "苏厥开窍，滋阴益肾，平肝熄风。主治休克、中暑、晕厥、癔病、喉痹、鼻出血、心烦、腰痛、高血压、低血压、尿潴留、遗精、头晕、气管炎、扁桃体炎、小儿腹泻、小儿厌食、神经衰弱。",
                        "position": "在足底，屈足卷趾时足心最凹陷处。",
                        "quickFind": "卷足，足底前1/3处可见有一凹陷处，按压有酸痛感处即是。",
                        "massage": "经常按摩剌激涌泉，使整个足底发热，可补肾健身，还可改善疲乏无力、神经衰弱。",
                        "xueweiName": "涌泉",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "涌泉"
                    }
                },
                {
                    "seq": 2,
                    "xueweiName": "然谷",
                    "xueweiCode": "rangu",
                    "position": {
                        "x": -0.098733,
                        "y": 0.070259,
                        "z": 0.02676
                    },
                    "xueweiDetail": {
                        "detailTitle": "然谷：滋阴补肾助睡眠",
                        "detailDescription": "然，然骨；谷，山谷。穴在然骨（舟骨粗隆）下陷中，如居山谷。",
                        "cure": "清热利湿，益气固肾。主治咽喉疼痛、阳痿、月经不调、胸胁胀满。",
                        "position": "在足内侧，足舟骨粗隆下方，赤白肉际处。",
                        "quickFind": "坐位垂足，内踝前下方明显骨性标志一骨前下方凹陷处即是。",
                        "massage": "经常按揉然谷，可固肾缩尿，防治老年人尿频；用艾条灸然谷5〜15分钟，可以清肾经虚火，常用于月经不调、带下、遗精、咽喉肿痛、小便不利等症。",
                        "xueweiName": "然谷",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "然谷"
                    }
                },
                {
                    "seq": 3,
                    "xueweiName": "太溪",
                    "xueweiCode": "taixi",
                    "position": {
                        "x": -0.048401,
                        "y": 0.121866,
                        "z": -0.060018
                    },
                    "xueweiDetail": {
                        "detailTitle": "太溪：大补肾气除百病",
                        "detailDescription": "太，甚大；溪，沟溪。穴在内踝与跟腱之间凹陷中，如巨大的沟溪。",
                        "cure": "滋阴益肾，壮阳强腰。主治扁桃体炎、慢性咽炎、闭经、失眠、冠心病、早泄。",
                        "position": "在踝区，内踝尖与跟腱之间的凹陷中。",
                        "quickFind": "坐位垂足，由足内踝向后推至与跟腱之间凹陷处即是。",
                        "massage": "用拇指指腹由上往下刮太溪，每日早晚左右足各刮1~3分钟，可调节和缓解肾炎、膀胱炎、遗尿、遗精等病症。",
                        "xueweiName": "太溪",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "太溪"
                    }
                },
                {
                    "seq": 4,
                    "xueweiName": "大钟",
                    "xueweiCode": "dazhong",
                    "position": {
                        "x": -0.048521,
                        "y": 0.121448,
                        "z": -0.0755
                    },
                    "xueweiDetail": {
                        "detailTitle": "大钟：强腰壮骨疗效好",
                        "detailDescription": "大，大小之大；钟，同“踵”，即足跟。穴在足跟，其骨较大，故名大钟。",
                        "cure": "益肾平喘，调理二便。主治咽喉肿痛、腰脊强痛、呕吐、哮喘、便秘。",
                        "position": "在足跟部，内踝后下方，跟骨上缘，跟腱附着部前缘凹陷中。",
                        "quickFind": "先找到太溪，向下量半横指，再向后平推至凹陷处即是。",
                        "massage": "拿捏大钟，可防治腰痛；用艾灸的方法，每次灸5~15分钟，可治气喘、支气管炎。",
                        "xueweiName": "大钟",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "大钟"
                    }
                },
                {
                    "seq": 5,
                    "xueweiName": "水泉",
                    "xueweiCode": "shuiquan",
                    "position": {
                        "x": -0.046642,
                        "y": 0.103719,
                        "z": -0.0593
                    },
                    "xueweiDetail": {
                        "detailTitle": "水泉：艾灸痛经疗效佳",
                        "detailDescription": "水，水液；泉，水泉。水泉有水源之意，肾主水。穴属本经郄穴，能治小便淋沥。",
                        "cure": "清热益肾，疏经活络。主治小便不利、足跟痛、痛经、闭经、腹痛。",
                        "position": "在足跟区，太溪直下1寸，跟骨结节内侧凹陷中。",
                        "quickFind": "先找到太溪，直下用拇指量1横指，按压有酸胀感处即是。",
                        "massage": "按揉水泉，可防治足跟痛；女性痛经，可在经期每天早晚各用艾条灸1次，每次10-15分钟，可止痛。",
                        "xueweiName": "水泉",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "水泉"
                    }
                },
                {
                    "seq": 6,
                    "xueweiName": "照海",
                    "xueweiCode": "zhaohai",
                    "position": {
                        "x": -0.055294,
                        "y": 0.132357,
                        "z": -0.026664
                    },
                    "xueweiDetail": {
                        "detailTitle": "照海：月经不调的救星",
                        "detailDescription": "照，光照；海，海洋。穴属肾经，气盛如海，意为肾中真阳，可光照周身。",
                        "cure": "滋阴清热，调经止痛。主治咽喉肿痛、气喘、便秘、月经不调、遗精、失眠。",
                        "position": "在内踝尖下1寸，内踝下缘边际凹陷中。",
                        "quickFind": "坐位垂足，由内踝尖垂直向下推，至下缘凹陷处，按压有酸痛感处即是。",
                        "massage": "常用拇指指腹轻轻向下揉按，每次1~3分钟，有补肾、养肝、健脾的功效。",
                        "xueweiName": "照海",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "照海"
                    }
                },
                {
                    "seq": 7,
                    "xueweiName": "复溜",
                    "xueweiCode": "fuliu",
                    "position": {
                        "x": -0.04839,
                        "y": 0.201221,
                        "z": -0.061188
                    },
                    "xueweiDetail": {
                        "detailTitle": "复溜：滋补肾阴数它强",
                        "detailDescription": "复，同“伏”，深伏；溜，流动。穴居照海之上，在此指经气至“海”入而复出并继续溜注之意。",
                        "cure": "补肾益阴，清热利水。主治水肿、腹胀、腰脊强痛、盗汗、自汗。",
                        "position": "在小腿内侧，内踝尖上2寸，跟腱的前缘。",
                        "quickFind": "先找到太溪，直上量3横指，跟腱前缘处，按压有酸胀感处即是。",
                        "massage": "用拇指指腹由下往上推按复溜1~3分钟，可缓解腹泻、盗汗、四肢乏力、腰脊强痛。",
                        "xueweiName": "复溜",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "复溜"
                    }
                },
                {
                    "seq": 8,
                    "xueweiName": "交信",
                    "xueweiCode": "jiaoxin",
                    "position": {
                        "x": -0.054417,
                        "y": 0.200982,
                        "z": -0.034868
                    },
                    "xueweiDetail": {
                        "detailTitle": "交信：调经养血止崩漏",
                        "detailDescription": "交，交会；信，信用。信，五常之一，属土，指脾。本经脉气在本穴交会脾经。",
                        "cure": "益肾调经，调理二便。主治淋病、月经不调、子宫脱垂、便秘、痛经。",
                        "position": "在小腿内侧，内踝尖上2寸，胫骨内侧缘后际凹陷中。",
                        "quickFind": "先找到太溪，直上量3横指，再前推至胫骨后凹陷处即是。",
                        "massage": "弯曲拇指，用拇指指腹垂直揉按交信，有轻微酸胀感为宜，每次左右各揉按1~3分钟，先左后右，可治月经不调、痛经、崩漏等妇科疾病。",
                        "xueweiName": "交信",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "交信"
                    }
                },
                {
                    "seq": 9,
                    "xueweiName": "筑宾",
                    "xueweiCode": "zhubin",
                    "position": {
                        "x": -0.045936,
                        "y": 0.270358,
                        "z": -0.033193
                    },
                    "xueweiDetail": {
                        "detailTitle": "筑宾：腿脚无力好帮手",
                        "detailDescription": "筑，强健；宾，同“膑”，泛指膝和小腿。穴在小腿内侧，有使腿膝强健的作用。",
                        "cure": "调理下焦，宁心安神。主治脚软无力、肾炎、膀胱炎、腓肠肌痉挛。",
                        "position": "在小腿内侧，太溪直上5寸，比目鱼肌与跟腱之间。",
                        "quickFind": "先找到太溪，直上量7横指，按压有酸胀感处即是。",
                        "massage": "用食指指腹揉按筑宾，力度适中，可改善小腿痉挛、脚软无力等不适症状。",
                        "xueweiName": "筑宾",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "筑宾"
                    }
                },
                {
                    "seq": 10,
                    "xueweiName": "阴谷",
                    "xueweiCode": "yingu",
                    "position": {
                        "x": -0.04766,
                        "y": 0.494364,
                        "z": -0.027738
                    },
                    "xueweiDetail": {
                        "detailTitle": "阴谷：遗尿遗精选阴谷",
                        "detailDescription": "阴，阴阳之阴；谷，山谷。内为阴。穴在膝关节内侧，局部凹陷如谷。",
                        "cure": "益肾调经，理气止痛。主治小便难、遗精、早泄、阴囊湿痒、妇人带漏。",
                        "position": "在膝后区，胭横纹上，半腱肌肌腱外侧缘。",
                        "quickFind": "微屈膝，在胭窝横纹内侧可触及两条筋，两筋之间凹陷处即是。",
                        "massage": "用食指指腹揉按阴谷，力度适中，每次揉按1~3分钟，可治疗阳痿、早泄、遗精、前列腺炎等男性功能障碍疾病。",
                        "xueweiName": "阴谷",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "阴谷"
                    }
                },
                {
                    "seq": 11,
                    "xueweiName": "横骨",
                    "xueweiCode": "henggu",
                    "position": {
                        "x": -0.02817,
                        "y": 0.946698,
                        "z": 0.103904
                    },
                    "xueweiDetail": {
                        "detailTitle": "横骨：男性疾病按摩除",
                        "detailDescription": "横骨，为耻骨之古称。穴在横骨上缘上方，故称横骨。",
                        "cure": "益肾助阳，调理下焦。主治腹痛、外生殖器肿痛、遗精、闭经、盆腔炎。",
                        "position": "在下腹部，脐中下5寸，前正中线旁开0.5寸。",
                        "quickFind": "仰卧，耻骨联合上缘中点，再旁开半横指处即是。",
                        "massage": "用拇指指腹从上向下推摩，每次3~5分钟。可治小便不利、遗尿、遗精等泌尿生殖系统疾病。",
                        "xueweiName": "横骨",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "横骨"
                    }
                },
                {
                    "seq": 12,
                    "xueweiName": "大赫",
                    "xueweiCode": "dahe",
                    "position": {
                        "x": -0.028186,
                        "y": 0.97782,
                        "z": 0.108649
                    },
                    "xueweiDetail": {
                        "detailTitle": "大赫：生殖健康的福星",
                        "detailDescription": "大，大小之大；赫，显赫。显赫有盛大之意。本穴为足少阴冲脉之会，乃下焦元气充盛之处。",
                        "cure": "益肾助阳，调经止带。主治遗精、月经不调、痛经、不孕、带下。",
                        "position": "在下腹部，脐中下4寸，前正中线旁开0.5寸。",
                        "quickFind": "仰卧，依上法找到横骨，向上1横指处即是。",
                        "massage": "用拇指指腹从上向下推摩大赫，每次3~5分钟。可治生殖系统、泌尿系统疾病。",
                        "xueweiName": "大赫",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "大赫"
                    }
                },
                {
                    "seq": 13,
                    "xueweiName": "气穴",
                    "xueweiCode": "qixue",
                    "position": {
                        "x": -0.028175,
                        "y": 1.008514,
                        "z": 0.112181
                    },
                    "xueweiDetail": {
                        "detailTitle": "气穴：调理冲任效果好",
                        "detailDescription": "气，气血之气，在此指肾气；穴，土室。穴在关元旁，为肾气藏聚之室。",
                        "cure": "调理冲任，益肾暧胞。主治月经不调、痛经、带下、遗精、阳痿。",
                        "position": "脐中下3寸，前正中线旁开0.5寸。",
                        "quickFind": "肚脐下4横指，再旁开半横指处。",
                        "massage": "用拇指指腹从上向下推摩气穴，每次3~5分钟。可有效治疗生殖疾病。",
                        "xueweiName": "气穴",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "气穴"
                    }
                },
                {
                    "seq": 14,
                    "xueweiName": "四满",
                    "xueweiCode": "siman",
                    "position": {
                        "x": -0.028175,
                        "y": 1.043975,
                        "z": 0.119631
                    },
                    "xueweiDetail": {
                        "detailTitle": "四满：腹痛腹冷不怕了",
                        "detailDescription": "四，第四；满，充满。此乃肾经入腹的第四穴，可治腹部胀满。",
                        "cure": "理气调经，利水消肿。主治痛经、不孕症、遗精、水肿、小腹痛、便秘。",
                        "position": "脐中下2寸，前正中线旁开0.5寸。",
                        "quickFind": "仰卧，肚脐下飛指，再旁开半横指处即是。",
                        "massage": "按揉四满可治腹痛、便秘、腹泻、月经不调等疾病；或艾条灸，每次5~15分钟。",
                        "xueweiName": "四满",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "四满"
                    }
                },
                {
                    "seq": 15,
                    "xueweiName": "中注",
                    "xueweiCode": "zhongzhu",
                    "position": {
                        "x": -0.028175,
                        "y": -0.126182,
                        "z": 0.126182
                    },
                    "xueweiDetail": {
                        "detailTitle": "中注：经常按摩促消化",
                        "detailDescription": "中，中间；注，灌注。肾经之气由此灌注中焦。",
                        "cure": "调经止带，通调腑气。主治腹胀、呕吐、腹泻、痢疾、腰腹疼痛。",
                        "position": "在下腹部，脐中下1寸，前正中线旁开0.5寸。",
                        "quickFind": "仰卧，肚脐下半横指，再旁开半横指处即是。",
                        "massage": "按揉中注可治腹痛、便秘、腹泻、月经不调等疾病；可用艾条灸中注，每次5~15分钟。",
                        "xueweiName": "中注",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "中注"
                    }
                },
                {
                    "seq": 16,
                    "xueweiName": "肓俞",
                    "xueweiCode": "huangyu",
                    "position": {
                        "x": -0.028036,
                        "y": 1.108556,
                        "z": 0.124808
                    },
                    "xueweiDetail": {
                        "detailTitle": "肓俞：告别便秘的痛苦",
                        "detailDescription": "肓，肓膜：俞，输注。肾经之气由此灌注中焦。",
                        "cure": "理气止痛，润肠通便。主治绕脐腹痛、腹胀、呕吐、腹泻、痢疾、便秘。",
                        "position": "在腹中部，脐中旁开0.5寸。",
                        "quickFind": "仰卧，肚脐旁开半横指处即是。",
                        "massage": "用拇指指腹从上向下推摩肓俞，每次3~5分钟，用艾条灸肓俞，每次5~15分钟。可治腹痛、便秘、腹泻、月经不调、疝气等疾病。",
                        "xueweiName": "肓俞",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "肓俞"
                    }
                },
                {
                    "seq": 17,
                    "xueweiName": "商曲",
                    "xueweiCode": "shangqu",
                    "position": {
                        "x": -0.028024,
                        "y": 1.144026,
                        "z": 0.116508
                    },
                    "xueweiDetail": {
                        "detailTitle": "商曲：解决腹痛的烦恼",
                        "detailDescription": "商，五音之一，属金；曲，弯曲。商为金音，大肠属金，本穴内对大肠弯曲处。",
                        "cure": "健脾和胃，消积止痛。主治绕脐腹痛、腹胀、呕吐、腹泻、痢疾、便秘。",
                        "position": "在上腹部，脐中上2寸，前正中线旁开0.5寸。",
                        "quickFind": "仰卧，肚脐上璃指，再旁开半横指处即是。",
                        "massage": "用拇指指腹从上向下推摩商曲，每次3~5分钟，或用艾条灸商曲，每次5~15分钟。可治胃痛、便秘、腹泻等胃肠疾病。",
                        "xueweiName": "商曲",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "商曲"
                    }
                },
                {
                    "seq": 18,
                    "xueweiName": "石关",
                    "xueweiCode": "shiguan",
                    "position": {
                        "x": -0.028355,
                        "y": 1.172807,
                        "z": 0.119515
                    },
                    "xueweiDetail": {
                        "detailTitle": "石关：脾胃虚寒按石关",
                        "detailDescription": "石，石头；关，重要。石有坚实之意。本穴为治腹部坚实病症的要穴。",
                        "cure": "降逆止呕、温经散寒。主治闭经、带下、脾胃虚寒、腹痛。",
                        "position": "在上腹部，脐中上3寸，前正中线旁开0.5寸。",
                        "quickFind": "仰卧，肚脐上4横指，再旁开半横指处即是。",
                        "massage": "两手中指指腹相互叠加，用力按压石关，有酸胀的感觉为宜，每次揉按3~5分钟，可治呕吐、腹痛、妇人不孕等脾胃虚寒之证。",
                        "xueweiName": "石关",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "石关"
                    }
                },
                {
                    "seq": 19,
                    "xueweiName": "阴都",
                    "xueweiCode": "yindou",
                    "position": {
                        "x": -0.028142,
                        "y": 1.201799,
                        "z": 0.118182
                    },
                    "xueweiDetail": {
                        "detailTitle": "阴都：有效缓解胃痛",
                        "detailDescription": "阴，阴阳之阴；都，会聚。穴在腹部，为水谷聚焦之处。",
                        "cure": "调理胃肠，宽胸降逆。主治腹胀、肠鸣、腹痛、哮喘、便秘、妇人不孕。",
                        "position": "在上腹部，脐中上4寸，前正中线旁开0.5寸。",
                        "quickFind": "仰卧，胸剑联合与肚脐连线中点，再旁开半横指处即是。",
                        "massage": "中间三指指腹摩阴都、中脘，可治胃胀、胃痛、恶心等。",
                        "xueweiName": "阴都",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "阴都"
                    }
                },
                {
                    "seq": 20,
                    "xueweiName": "腹通谷",
                    "xueweiCode": "futonggu",
                    "position": {
                        "x": -0.02824,
                        "y": 1.230831,
                        "z": 0.117908
                    },
                    "xueweiDetail": {
                        "detailTitle": "腹通谷：胃痛呕吐不用怕",
                        "detailDescription": "腹，腹部；通，通过；谷，水谷。穴在腹部，为通过水谷之处。",
                        "cure": "健脾和胃，宽胸安神。主治腹痛，腹胀，呕吐，胸痛，急、慢性胃炎。",
                        "position": "在上腹部，脐中上5寸，前正中线旁开0.5寸。",
                        "quickFind": "仰卧，胸剑联合处，直下量4横指，再旁开半横指处即是。",
                        "massage": "按揉腹通谷，可治胃痛、呕吐、腹痛、腹胀等胃肠疾病。",
                        "xueweiName": "腹通谷",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "腹通谷"
                    }
                },
                {
                    "seq": 21,
                    "xueweiName": "幽门",
                    "xueweiCode": "youmen",
                    "position": {
                        "x": -0.028156,
                        "y": 1.260156,
                        "z": 0.115258
                    },
                    "xueweiDetail": {
                        "detailTitle": "幽门：腹胀腹泻双调节",
                        "detailDescription": "幽，隐藏在腹部深处；门，门户。胃之下口称幽门。穴之深部，邻近幽门。",
                        "cure": "健脾和胃，降逆止呕。主治腹痛、呕吐、胃痛、胃溃疡、消化不良。",
                        "position": "在上腹部，脐中上6寸，前正中线旁开0.5寸。",
                        "quickFind": "仰卧，胸剑联合处，直下量3横指，再旁开半横指处即是。",
                        "massage": "按揉幽门，可治呕吐、腹痛、腹胀、腹泻等胃肠疾病。",
                        "xueweiName": "幽门",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "幽门"
                    }
                },
                {
                    "seq": 22,
                    "xueweiName": "步廊",
                    "xueweiCode": "bulang",
                    "position": {
                        "x": -0.045662,
                        "y": 1.328489,
                        "z": 0.117693
                    },
                    "xueweiDetail": {
                        "detailTitle": "步廊：乳房保健关键穴",
                        "detailDescription": "步，步行；廊，走廊。穴当中庭旁；经气自此，如步行于庭堂之两廊。",
                        "cure": "宽胸理气，止咳平喘。主治咳嗽、哮喘、胸痛、乳痈、胸膜炎。",
                        "position": "在胸部，第5肋间隙，前正中线旁开2寸。",
                        "quickFind": "仰卧，平乳头的肋间隙的下一肋间，由前正中线旁开戏指处即是。",
                        "massage": "急性乳腺炎患者可自步廊向乳头方向推抹50~100次。",
                        "xueweiName": "步廊",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "步廊"
                    }
                },
                {
                    "seq": 23,
                    "xueweiName": "神封",
                    "xueweiCode": "shenfeng",
                    "position": {
                        "x": -0.045777,
                        "y": 1.36395,
                        "z": 0.117637
                    },
                    "xueweiDetail": {
                        "detailTitle": "神封：缓解气喘与咳嗽",
                        "detailDescription": "神，指心；封，领属。穴之所在为心之所属。",
                        "cure": "宽胸理肺，降逆止呕。主治咳嗽、哮喘、呕吐、胸痛、乳痈、胸膜炎。",
                        "position": "在胸部，第4肋间隙，前正中线旁开2寸。",
                        "quickFind": "仰卧，平乳头的肋间隙中，由前正中线旁开飛指处即是。",
                        "massage": "用中指指腹揉按神封3~5分钟，可缓解跑步后或搬重物后造成的气喘。",
                        "xueweiName": "神封",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "神封"
                    }
                },
                {
                    "seq": 24,
                    "xueweiName": "灵墟",
                    "xueweiCode": "lingxu",
                    "position": {
                        "x": -0.045777,
                        "y": 1.394683,
                        "z": 0.102702
                    },
                    "xueweiDetail": {
                        "detailTitle": "灵墟：风寒咳嗽找灵墟",
                        "detailDescription": "灵，指心；墟，土堆。本穴内应心脏，外当肌肉隆起处，其隆起犹如土堆。",
                        "cure": "疏肝宽胸，肃降肺气，壮阳益气。主治咳嗽、哮喘、胸痛、乳痈、胸膜炎、心悸。",
                        "position": "在胸部，第3肋间隙，前正中线旁开2寸。",
                        "quickFind": "仰卧，自乳头垂直向上推1个肋间隙，该肋间隙中，由前正中线旁开3横指处即是。",
                        "massage": "治疗风寒咳嗽，常按揉灵墟，每次10~15分钟，具有止咳化痰的功效。",
                        "xueweiName": "灵墟",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "灵墟"
                    }
                },
                {
                    "seq": 25,
                    "xueweiName": "神藏",
                    "xueweiCode": "shencang",
                    "position": {
                        "x": -0.040464,
                        "y": 1.425416,
                        "z": 0.082118
                    },
                    "xueweiDetail": {
                        "detailTitle": "神藏：艾灸一下咳喘除",
                        "detailDescription": "神，指心；藏，匿藏。穴当心神匿藏之处。",
                        "cure": "宽胸理气，降逆平喘。主治咳嗽、哮喘、胸痛、支气管炎、呕吐。",
                        "position": "在胸部，第2肋间隙，前正中线旁开2寸。",
                        "quickFind": "仰卧，自乳头垂直向上推2个肋间隙，该肋间隙中，由前正中线旁开3横指处即是。",
                        "massage": "轻轻按揉神藏，可治咳嗽、气喘等肺疾。",
                        "xueweiName": "神藏",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "神藏"
                    }
                },
                {
                    "seq": 26,
                    "xueweiName": "彧中",
                    "xueweiCode": "yuzhong",
                    "position": {
                        "x": -0.036313,
                        "y": 1.458142,
                        "z": 0.061417
                    },
                    "xueweiDetail": {
                        "detailTitle": "彧中：定喘顺气好帮手",
                        "detailDescription": "彧，通“郁”；中，中间。郁有茂盛之意，穴当肾气行于胸中大盛之处。",
                        "cure": "宽胸理气，止咳化痰。主治咳嗽、胸胁胀满、不嗜食、咽喉肿痛。",
                        "position": "在胸部，第1肋间隙，前正中线旁开2寸。",
                        "quickFind": "仰卧，自锁骨下缘垂直向下推1个肋骨，就是第1肋间隙，由前正中线旁开預指处即是。",
                        "massage": "生气或疲累后，胸胁部有时会感到疼痛，而且不断咳嗽，此时可以用拇指指腹点按彧中，有助于止痛、定咳、顺气。",
                        "xueweiName": "彧中",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "彧中"
                    }
                },
                {
                    "seq": 27,
                    "xueweiName": "俞府",
                    "xueweiCode": "yufu",
                    "position": {
                        "x": -0.031874,
                        "y": 1.489562,
                        "z": 0.040375
                    },
                    "xueweiDetail": {
                        "detailTitle": "俞府：推揉胜过止咳药",
                        "detailDescription": "俞，输注；府，通“腑”。肾之经气由此输入内脏。",
                        "cure": "止咳平喘，和胃降逆。主治咳嗽、哮喘、呕吐、胸胁胀满、不嗜食。",
                        "position": "在胸部，锁骨下缘，前正中线旁开2寸。",
                        "quickFind": "仰卧，锁骨下可触及一凹陷，在此凹陷中，前正中线旁开3横指处即是。",
                        "massage": "经常推揉、拍打俞府可调气散结，延缓呼吸器官衰老。",
                        "xueweiName": "俞府",
                        "jingluoName": "足少阴肾经",
                        "titleUrl": "俞府"
                    }
                }
            ]
        },
        {
            "jingMaiName": "手厥阴心包经",
            "jingMaiCode": "shoujueyinxinbaojing",
            "xueweiList": [
                {
                    "seq": 1,
                    "xueweiName": "天池",
                    "xueweiCode": "tianchi",
                    "position": {
                        "x": -0.144293,
                        "y": 1.352984,
                        "z": 0.082163
                    },
                    "xueweiDetail": {
                        "detailTitle": "天池：乳腺增生的克星",
                        "detailDescription": "天，天空；池，池塘。穴在乳旁，乳房之泌乳，有如水自天池而出。",
                        "cure": "活血化瘀，宽胸理气。主治咳嗽、胸痛、胸闷、乳汁分泌不足、乳腺炎。",
                        "position": "在胸部，第4肋间隙，前正中线旁开5寸。",
                        "quickFind": "仰卧，自乳头沿水平线向外侧旁开1横指，按压有酸胀感处即是。",
                        "massage": "中指指腹垂直下压揉按天池，持续3~5分钟为宜，可治乳腺增生、乳腺炎等疾病。",
                        "xueweiName": "天池",
                        "jingluoName": "手厥阴心包经",
                        "titleUrl": "天池"
                    }
                },
                {
                    "seq": 2,
                    "xueweiName": "天泉",
                    "xueweiCode": "tianquan",
                    "position": {
                        "x": -0.226538,
                        "y": 1.360339,
                        "z": 0.03725
                    },
                    "xueweiDetail": {
                        "detailTitle": "天泉：增强心脏之活力",
                        "detailDescription": "天，天空；泉，泉水。源于天地的经气由此而下，如泉水从天而降。",
                        "cure": "宽胸理气，活血通脉。主治心痛、打嗝、上臂内侧痛、胸背痛。",
                        "position": "在臂前区，腋前纹头下2寸，肱二头肌的长、短头之间。",
                        "quickFind": "伸肘仰掌，腋前纹头直下3横指，在肱二头肌肌腹间隙中，按压有酸胀感处即是。",
                        "massage": "心脏供血不足者，可每天坚持用中指指腹揉天泉，每次1~3分钟。",
                        "xueweiName": "天泉",
                        "jingluoName": "手厥阴心包经",
                        "titleUrl": "天泉"
                    }
                },
                {
                    "seq": 3,
                    "xueweiName": "曲泽",
                    "xueweiCode": "quze",
                    "position": {
                        "x": -0.271338,
                        "y": 1.19518,
                        "z": 0.080528
                    },
                    "xueweiDetail": {
                        "detailTitle": "曲泽：胸闷心慌多按揉",
                        "detailDescription": "曲，弯曲；泽，沼泽。经气流注至此，入曲肘浅凹处，犹如水进沼泽。",
                        "cure": "清心镇痛，和胃降逆。主治胃痛、呕吐、腹泻、风疹、心痛、心悸。",
                        "position": "在肘前区，肘横纹上，肱二头肌腱的尺侧缘凹陷中。",
                        "quickFind": "肘微弯，肘弯里可摸到一条大筋，内侧横纹上可触及凹陷处即是。",
                        "massage": "用拇指垂直按压曲泽1~3分钟，可治心火上升引起的心痛、心悸等心血管疾病。",
                        "xueweiName": "曲泽",
                        "jingluoName": "手厥阴心包经",
                        "titleUrl": "曲泽"
                    }
                },
                {
                    "seq": 4,
                    "xueweiName": "曲泽",
                    "xueweiCode": "quze",
                    "position": {
                        "x": -0.302172,
                        "y": 1.111737,
                        "z": 0.09977
                    },
                    "xueweiDetail": {
                        "detailTitle": "曲泽：胸闷心慌多按揉",
                        "detailDescription": "曲，弯曲；泽，沼泽。经气流注至此，入曲肘浅凹处，犹如水进沼泽。",
                        "cure": "清心镇痛，和胃降逆。主治胃痛、呕吐、腹泻、风疹、心痛、心悸。",
                        "position": "在肘前区，肘横纹上，肱二头肌腱的尺侧缘凹陷中。",
                        "quickFind": "肘微弯，肘弯里可摸到一条大筋，内侧横纹上可触及凹陷处即是。",
                        "massage": "用拇指垂直按压曲泽1~3分钟，可治心火上升引起的心痛、心悸等心血管疾病。",
                        "xueweiName": "曲泽",
                        "jingluoName": "手厥阴心包经",
                        "titleUrl": "曲泽"
                    }
                },
                {
                    "seq": 5,
                    "xueweiName": "间使",
                    "xueweiCode": "jianshi",
                    "position": {
                        "x": -0.314542,
                        "y": 1.064262,
                        "z": 0.107768
                    },
                    "xueweiDetail": {
                        "detailTitle": "间使：治疗打嗝之要穴",
                        "detailDescription": "间，间隙；使，臣使。穴属心包经，位于两筋之间隙，心包为臣使之官，故名。",
                        "cure": "宽胸和胃，清心安神，理气镇痛。主治打嗝、呕吐、中风、月经不调、尊麻疹。",
                        "position": "在前臂前区，腕掌侧远端横纹上3寸，掌长肌腱与桡侧腕屈肌腱之间。",
                        "quickFind": "微屈腕握拳，从腕横纹向上量很指，两条索状筋之间即是。",
                        "massage": "用拇指指腹用力按压间使，有酸胀感为宜，一般按摩3~5分钟，即可消除打嗝症状。",
                        "xueweiName": "间使",
                        "jingluoName": "手厥阴心包经",
                        "titleUrl": "间使"
                    }
                },
                {
                    "seq": 6,
                    "xueweiName": "内关",
                    "xueweiCode": "neiguan",
                    "position": {
                        "x": -0.322487,
                        "y": 1.049723,
                        "z": 0.110696
                    },
                    "xueweiDetail": {
                        "detailTitle": "内关：心脏健康的卫士",
                        "detailDescription": "内，内外之内；关，关隘。穴在前臂内侧要处，犹如关隘。",
                        "cure": "宁心安神，和胃降逆，理气镇痛。主治心痛、心悸、失眠、癫痫、胃痛、呕吐、打嗝、哮喘、高血压、低血压、冠心病、汗多、神经性皮炎、小儿惊风。",
                        "position": "在前臂前区，腕掌侧远端横纹上2寸，掌长肌腱与桡侧腕屈肌腱之间。",
                        "quickFind": "微屈腕握拳，从腕横纹向上量飛指，两条索状筋之间即是内关。",
                        "massage": "用左手拇指指尖按压右侧内关10~15分钟，每日2~3次；再用右手按压左侧内关，反复操作。可改善风湿性心脏病、心肌炎、冠心病、心绞痛、心律不齐等症状。",
                        "xueweiName": "内关",
                        "jingluoName": "手厥阴心包经",
                        "titleUrl": "内关"
                    }
                },
                {
                    "seq": 7,
                    "xueweiName": "大陵",
                    "xueweiCode": "daling",
                    "position": {
                        "x": -0.335915,
                        "y": 1.016647,
                        "z": 0.129673
                    },
                    "xueweiDetail": {
                        "detailTitle": "大陵：牙肿口臭不见了",
                        "detailDescription": "大，大小之大；陵，丘陵。掌根突起部如同丘陵，穴在其腕侧凹陷中。",
                        "cure": "宁心安神，和营通络，宽胸和胃。主治身热、头痛、扁桃体炎、咽炎、肾虚、失眠。",
                        "position": "在腕前区，腕掌侧远端横纹中，掌长肌腱与楼侧腕屈肌腱之间。",
                        "quickFind": "微屈腕握拳，从腕横纹上，两条索状筋之间即是。",
                        "massage": "用拇指指尖垂直掐按大陵，每天早晚两侧各掐按1~3分钟。以治疗心胸痛、胃炎、扁桃体炎等疾病。",
                        "xueweiName": "大陵",
                        "jingluoName": "手厥阴心包经",
                        "titleUrl": "大陵"
                    }
                },
                {
                    "seq": 8,
                    "xueweiName": "劳宫",
                    "xueweiCode": "laogong",
                    "position": {
                        "x": -0.363432,
                        "y": 0.968956,
                        "z": 0.141863
                    },
                    "xueweiDetail": {
                        "detailTitle": "劳宫：开窍醒神解疲劳",
                        "detailDescription": "劳，劳动；宫，中央。手司劳动，劳指手。穴在手掌部的中央。",
                        "cure": "清心泻热，开窍醒神，消肿止痒。主治热病、汗多、心烦、口腔溃疡、中风昏迷、高脂血症。",
                        "position": "在掌区，横平第3掌指关节近端，第2、第3掌骨之间偏于第3掌骨。",
                        "quickFind": "握拳屈指，中指尖所指掌心处，按压有酸痛感处即是。",
                        "massage": "用拇指指腹揉按劳宫，每次1~3分钟，可治腹泻，用拇指尖掐按可治中风昏迷、中暑等急症。",
                        "xueweiName": "劳宫",
                        "jingluoName": "手厥阴心包经",
                        "titleUrl": "劳宫"
                    }
                },
                {
                    "seq": 9,
                    "xueweiName": "中冲",
                    "xueweiCode": "zhongchong",
                    "position": {
                        "x": -0.424504,
                        "y": 0.828551,
                        "z": 0.18938
                    },
                    "xueweiDetail": {
                        "detailTitle": "中冲：晕车中暑一按消",
                        "detailDescription": "中，中间；冲，冲动，涌出。穴在中指端，心包经之井穴，经气由此涌出，沿经脉上行。",
                        "cure": "苏厥开窍，清心泻热。主治心痛、心悸、中风、中暑、目赤、舌痛、小儿惊风。",
                        "position": "在手指，中指末端最高点。",
                        "quickFind": "俯掌，在手中指尖端的中央取穴。",
                        "massage": "用较重的手法掐中冲；或用硬物，如发夹，捻按中冲约10秒钟，可治疗晕车、中风昏迷、中暑等症状。",
                        "xueweiName": "中冲",
                        "jingluoName": "手厥阴心包经",
                        "titleUrl": "中冲"
                    }
                }
            ]
        },
        {
            "jingMaiName": "手少阳三焦经",
            "jingMaiCode": "shoushaoyangsanjiaojing",
            "xueweiList": [
                {
                    "seq": 1,
                    "xueweiName": "关冲",
                    "xueweiCode": "guanchong",
                    "position": {
                        "x": -0.377213,
                        "y": 0.836816,
                        "z": 0.182134
                    },
                    "xueweiDetail": {
                        "detailTitle": "关冲：远离更年期烦恼",
                        "detailDescription": "关，通“弯”，指无名指；冲，冲要。穴在无名指端，经气由此涌出，沿经上行。",
                        "cure": "泻热开窍，清利喉舌，活血通络。主治头痛、咽喉肿痛、视物不明、肘痛。",
                        "position": "在手指，第4指末节尺侧，指甲根角侧上方0.1寸（指寸）。",
                        "quickFind": "沿手无名指指甲底部与侧缘引线的交点处即是。",
                        "massage": "用拇指指尖掐按关冲1~3分钟，可缓解更年期症状，如心慌气短、性欲减退等。",
                        "xueweiName": "关冲",
                        "jingluoName": "手少阳三焦经",
                        "titleUrl": "关冲"
                    }
                },
                {
                    "seq": 2,
                    "xueweiName": "液门",
                    "xueweiCode": "yemen",
                    "position": {
                        "x": -0.337135,
                        "y": 0.909338,
                        "z": 0.144668
                    },
                    "xueweiDetail": {
                        "detailTitle": "液门：清火散热有奇效",
                        "detailDescription": "液，水液；门，门户。此为本经荥穴，属水，有通调水道之功，犹如水气出入之门户。",
                        "cure": "清头目，利三焦，通络止痛。主治手背红肿、五指拘挛、腕部无力、热病。",
                        "position": "在手背，当第4、第5指间，指蹊缘后方赤白肉际处。",
                        "quickFind": "抬臂俯掌，手背部第4、第5指指缝间掌指关节前可触及一凹陷处即是。",
                        "massage": "每天早晚用拇指指腹按揉液门200次左右，可缓解头痛、目眩、咽喉肿痛、眼睛赤涩、龋齿等病症。",
                        "xueweiName": "液门",
                        "jingluoName": "手少阳三焦经",
                        "titleUrl": "液门"
                    }
                },
                {
                    "seq": 3,
                    "xueweiName": "中渚",
                    "xueweiCode": "zhongzhu",
                    "position": {
                        "x": -0.33145,
                        "y": 0.933541,
                        "z": 0.122338
                    },
                    "xueweiDetail": {
                        "detailTitle": "中渚：颈肩背痛常用穴",
                        "detailDescription": "中，中间；渚，水中小块陆地。穴在五输流注穴之中间，经气如水循渚而行。",
                        "cure": "清热通络，开窍益聪。主治前臂疼痛、脂溢性皮炎、头痛、目眩、耳聋。",
                        "position": "在手背，第4、第5掌骨间，第4掌指关节近端凹陷中。",
                        "quickFind": "抬臂俯掌，手背部第4、第5指指缝间掌指关节后可触及凹陷处即是。",
                        "massage": "每次按摩左右中渚各1~3分钟，可治肢体关节肿痛以及屈伸不利之症。",
                        "xueweiName": "中渚",
                        "jingluoName": "手少阳三焦经",
                        "titleUrl": "中渚"
                    }
                },
                {
                    "seq": 4,
                    "xueweiName": "阳池",
                    "xueweiCode": "yangchi",
                    "position": {
                        "x": -0.323052,
                        "y": 1.00187,
                        "z": 0.076731
                    },
                    "xueweiDetail": {
                        "detailTitle": "阳池：驱走手脚的寒冷",
                        "detailDescription": "阳，阴阳之阳；池，池塘。穴在腕背凹陷中，经气至此如水入池塘。",
                        "cure": "清热通络，通调三焦，益阴增液。主治腕关节肿痛、手足怕冷、口干、糖尿病。",
                        "position": "在腕后区，腕背侧远端横纹上，指总伸肌腱的尺侧缘凹陷中。",
                        "quickFind": "抬臂垂腕，背面，由第4掌骨向上推至腕关节横纹，可触及凹陷处即是。",
                        "massage": "用中指指腹按摩阳池，可改善女性在经期、孕期和产褥期出现的手脚冰凉状况。",
                        "xueweiName": "阳池",
                        "jingluoName": "手少阳三焦经",
                        "titleUrl": "阳池"
                    }
                },
                {
                    "seq": 5,
                    "xueweiName": "外关",
                    "xueweiCode": "waiguan",
                    "position": {
                        "x": -0.313913,
                        "y": 1.05592,
                        "z": 0.054556
                    },
                    "xueweiDetail": {
                        "detailTitle": "外关：缓解腰痛治风湿",
                        "detailDescription": "外，内外之外；关，关隘。穴在前臂外侧要处，犹如关隘。",
                        "cure": "清热解表，通经活络。主治感冒、头痛、三叉神经痛、颈椎病、落枕。",
                        "position": "在前臂外侧，腕背侧远端横纹上2寸，尺骨与桡骨间隙中点。",
                        "quickFind": "抬臂俯掌，掌腕背横纹中点直上3横指，前臂两骨头之间的凹陷处即是。",
                        "massage": "用拇指揉、点外关，力量由轻到重，以穴位下有酸胀感为度，可治腰痛、手臂疼痛、偏头痛、风湿等症。",
                        "xueweiName": "外关",
                        "jingluoName": "手少阳三焦经",
                        "titleUrl": "外关"
                    }
                },
                {
                    "seq": 6,
                    "xueweiName": "支沟",
                    "xueweiCode": "zhigou",
                    "position": {
                        "x": -0.320577,
                        "y": 1.077934,
                        "z": 0.046725
                    },
                    "xueweiDetail": {
                        "detailTitle": "支沟：排除体内的毒素",
                        "detailDescription": "支，通“肢”；沟，沟渠。支，在此指上肢。穴在上肢尺骨与桡骨间沟中。",
                        "cure": "清利三焦，通腑降逆。主治胸胁痛、腹胀、便秘、心绞痛、上肢瘫痪。",
                        "position": "在前臂外侧，腕背侧远端横纹上3寸，尺骨与桡骨间隙中点。",
                        "quickFind": "抬臂俯掌，掌腕背横纹中点直上4横指，前臂两骨头之间的凹陷处即是。",
                        "massage": "按揉支沟3~5分钟，可清除体内堆积宿便，防止便秘、腹胀。",
                        "xueweiName": "支沟",
                        "jingluoName": "手少阳三焦经",
                        "titleUrl": "支沟"
                    }
                },
                {
                    "seq": 7,
                    "xueweiName": "会宗",
                    "xueweiCode": "huizong",
                    "position": {
                        "x": -0.303419,
                        "y": 1.076744,
                        "z": 0.044188
                    },
                    "xueweiDetail": {
                        "detailTitle": "会宗：温通经脉治耳鸣",
                        "detailDescription": "会，会合；宗，集聚。此为三焦经郄穴，是经气会聚之处。",
                        "cure": "清利三焦，安神定志，疏通经络。主治偏头痛、耳聋、耳鸣、咳喘胸满、臂痛。",
                        "position": "在前臂外侧，腕背侧远端横纹上3寸，尺骨的桡侧缘。",
                        "quickFind": "抬臂俯掌，掌腕背横纹中点直上4横指，拇指侧按压有酸胀感处即是。",
                        "massage": "常用食指指腹揉按会宗，有温通经脉的功效，可预防听力和视力减退。",
                        "xueweiName": "会宗",
                        "jingluoName": "手少阳三焦经",
                        "titleUrl": "会宗"
                    }
                },
                {
                    "seq": 8,
                    "xueweiName": "三阳络",
                    "xueweiCode": "sanyangluo",
                    "position": {
                        "x": -0.294007,
                        "y": 1.098324,
                        "z": 0.034244
                    },
                    "xueweiDetail": {
                        "detailTitle": "三阳络：治疗耳聋与牙痛",
                        "detailDescription": "三阳，指手三阳经；络，联络。本穴联络手之三条阳经。",
                        "cure": "舒筋通络，开窍镇痛。主治前臂酸痛、耳聋、牙痛、脑血管病后遗症。",
                        "position": "在前臂外侧，腕背侧远端横纹上4寸，尺骨与桡骨间隙中点。",
                        "quickFind": "先找到支沟，直上1横指，前臂两骨头之间凹陷处即是。",
                        "massage": "用拇指指甲垂直下压三阳络，揉按3分钟，先左后右，可有效缓解牙痛。",
                        "xueweiName": "三阳络",
                        "jingluoName": "手少阳三焦经",
                        "titleUrl": "三阳络"
                    }
                },
                {
                    "seq": 9,
                    "xueweiName": "四渎",
                    "xueweiCode": "sidu",
                    "position": {
                        "x": -0.279316,
                        "y": 1.138073,
                        "z": 0.019715
                    },
                    "xueweiDetail": {
                        "detailTitle": "四渎：咽喉肿痛有特效",
                        "detailDescription": "四，四个；渎，河流。古称长江、黄河、淮河、济水为四渎。经气至此，渗灌更广，故喻称四渎。",
                        "cure": "开窍聪耳，清利咽喉。主治咽喉肿痛、耳聋、耳鸣、头痛、下牙痛、眼疾。",
                        "position": "在前臂外侧，肘尖下5寸，尺骨与桡骨间隙中。",
                        "quickFind": "先找到阳池，其与肘尖连线的中点上1横指处即是。",
                        "massage": "经常对四渎进行点按，每次~3分钟，可以预防耳鸣、耳聋，对偏头痛、牙痛也有很好的调理作用。",
                        "xueweiName": "四渎",
                        "jingluoName": "手少阳三焦经",
                        "titleUrl": "四渎"
                    }
                },
                {
                    "seq": 10,
                    "xueweiName": "天井",
                    "xueweiCode": "tianjing",
                    "position": {
                        "x": -0.224862,
                        "y": 1.223559,
                        "z": -0.015134
                    },
                    "xueweiDetail": {
                        "detailTitle": "天井：淋巴结核不用怕",
                        "detailDescription": "天，天空；井，水井。喻上为天。穴在上肢鹰嘴窝，其陷如井。",
                        "cure": "行气散结，安神通络。主治前臂酸痛、淋巴结核、落枕、偏头痛。",
                        "position": "在肘后侧，肘尖上1寸凹陷中。",
                        "quickFind": "屈肘，肘尖直上1横指凹陷处即是。",
                        "massage": "用一手轻握另一手肘下，弯曲中指以指尖垂直向上按摩天井，每天早晚各按1次，每次左右各1~3分钟。可治疗麦粒肿、淋巴结核。",
                        "xueweiName": "天井",
                        "jingluoName": "手少阳三焦经",
                        "titleUrl": "天井"
                    }
                },
                {
                    "seq": 11,
                    "xueweiName": "清冷渊",
                    "xueweiCode": "qinglengyuan",
                    "position": {
                        "x": -0.221148,
                        "y": 1.240275,
                        "z": -0.024851
                    },
                    "xueweiDetail": {
                        "detailTitle": "清冷渊：着急上火就揉它",
                        "detailDescription": "清泠，清凉；渊，深水。本穴具有清三焦之热的作用，犹如入清凉深水之中。",
                        "cure": "疏散风寒，通经止痛。主治前臂及肩背部酸痛不举、头项痛、眼疾。",
                        "position": "在臂后侧，肘尖与肩峰角连线上，肘尖上2寸。",
                        "quickFind": "屈肘，肘尖直上3横指凹陷处即是。",
                        "massage": "用中指指腹揉清泠渊1~3分钟，可缓解着急上火、嗓子痛、牙痛、眼睛。",
                        "xueweiName": "清冷渊",
                        "jingluoName": "手少阳三焦经",
                        "titleUrl": "清冷渊"
                    }
                },
                {
                    "seq": 12,
                    "xueweiName": "消泺",
                    "xueweiCode": "xiaoluo",
                    "position": {
                        "x": -0.214945,
                        "y": 1.280317,
                        "z": -0.050106
                    },
                    "xueweiDetail": {
                        "detailTitle": "消泺：有效治疗各种痛",
                        "detailDescription": "消，消除；泺，小水、沼泽。本穴属三焦经，具有通调水道的作用。",
                        "cure": "清热安神，活络止痛。主治颈项强急肿痛、臂痛、头痛、牙痛。",
                        "position": "在臂后侧，肘尖与肩峰角连线上，肘尖上5寸。",
                        "quickFind": "先取肩髎，其与肘尖连线上，肘尖上7横指处即是。",
                        "massage": "四指并拢向消泺施加压力，一压一松，持续3~5分钟为宜，可治头痛、颈项强痛、臂痛、牙痛等疾病。",
                        "xueweiName": "消泺",
                        "jingluoName": "手少阳三焦经",
                        "titleUrl": "消泺"
                    }
                },
                {
                    "seq": 13,
                    "xueweiName": "臑会",
                    "xueweiCode": "naohui",
                    "position": {
                        "x": -0.20064,
                        "y": 1.330912,
                        "z": -0.071832
                    },
                    "xueweiDetail": {
                        "detailTitle": "臑会：专治肩膀疼与痛",
                        "detailDescription": "臑，上臂肌肉隆起处；会，交会。穴在上臂肌肉隆起处，为三焦经和阳维脉之交会处。",
                        "cure": "化痰散结，通络止痛。主治肩胛肿痛、肩臂酸痛。",
                        "position": "在臂后侧，平腋后纹头，三角肌的后下缘。",
                        "quickFind": "先取肩髎，其与肘尖连线上，肩髎下4横指处即是。",
                        "massage": "经常拿捏臑会，每次1〜3分钟，可以预防肩关节炎、上肢麻痹等症。",
                        "xueweiName": "臑会",
                        "jingluoName": "手少阳三焦经",
                        "titleUrl": "臑会"
                    }
                },
                {
                    "seq": 14,
                    "xueweiName": "肩髎",
                    "xueweiCode": "jianliao",
                    "position": {
                        "x": -0.200965,
                        "y": 1.479174,
                        "z": -0.115996
                    },
                    "xueweiDetail": {
                        "detailTitle": "肩髎：缓解肩痛与臂痛",
                        "detailDescription": "肩，肩部；髎，骨隙。穴在肩部骨隙中。",
                        "cure": "祛风湿，通经络。主治肩胛肿痛、肩臂痛、中风偏瘫、尊麻疹。",
                        "position": "在肩部，肩峰角与肱骨大结节两骨间凹陷中。",
                        "quickFind": "外展上臂，肩膀后下方凹陷处即是。",
                        "massage": "用拇指、食指和中指拿捏肩髎3~5分钟，每天早晚各1次。可缓解臂痛不能举、胁肋疼痛等症状。",
                        "xueweiName": "肩髎",
                        "jingluoName": "手少阳三焦经",
                        "titleUrl": "肩髎"
                    }
                },
                {
                    "seq": 15,
                    "xueweiName": "天髎",
                    "xueweiCode": "tianliao",
                    "position": {
                        "x": -0.107658,
                        "y": 1.524784,
                        "z": -0.10812
                    },
                    "xueweiDetail": {
                        "detailTitle": "天髎：治疗颈项强直痛",
                        "detailDescription": "天，天空；髎，骨隙。上为天。穴在肩胛冈上方之骨隙中。",
                        "cure": "祛风除湿，通经止痛。主治肩臂痛、颈项僵硬疼痛、胸中烦满。",
                        "position": "在肩胛骨上角处，当肩井与曲垣之间的中点，横平第1胸椎棘突。",
                        "quickFind": "肩胛骨上角，其上方的凹陷处即是。",
                        "massage": "用中指指腹揉按天髎，以有酸胀感为宜，可治肩臂痛、颈项僵硬疼痛。",
                        "xueweiName": "天髎",
                        "jingluoName": "手少阳三焦经",
                        "titleUrl": "天髎"
                    }
                },
                {
                    "seq": 16,
                    "xueweiName": "天牖",
                    "xueweiCode": "tianyou",
                    "position": {
                        "x": -0.056703,
                        "y": 1.628223,
                        "z": -0.027933
                    },
                    "xueweiDetail": {
                        "detailTitle": "天牖：缓解颈肩酸与痛",
                        "detailDescription": "天，天空；牖，窗。上为天，穴在侧颈部上方，本穴能开上窍，故喻为天窗。",
                        "cure": "清头明目，通经活络。主治头痛、头晕、颈肩酸痛、目痛、耳鸣、喉痛。",
                        "position": "在项后，横平下颌角，胸锁乳突肌的后缘凹陷中。",
                        "quickFind": "乳突后方直下平下颌角的凹陷处即是。",
                        "massage": "常用中指指腹轻轻按摩天牖，每次3~5分钟，对肩颈不适有良好的调理作用。",
                        "xueweiName": "天牖",
                        "jingluoName": "手少阳三焦经",
                        "titleUrl": "天牖"
                    }
                },
                {
                    "seq": 17,
                    "xueweiName": "翳风",
                    "xueweiCode": "yifeng",
                    "position": {
                        "x": -0.061326,
                        "y": 1.645881,
                        "z": -0.012927
                    },
                    "xueweiDetail": {
                        "detailTitle": "翳风：快速止嗝就按它",
                        "detailDescription": "翳，遮蔽；风，风邪。穴当耳垂后方，为遮蔽风邪之处。",
                        "cure": "聪耳通窍，散内泻热。主治打嗝、中耳炎、三叉神经痛、牙痛、颊肿、失眠。",
                        "position": "在颈部，耳垂后方，乳突下端前方凹陷中。",
                        "quickFind": "头偏向一侧，将耳垂下压，所覆盖范围中的凹陷处即是。",
                        "massage": "用手指尖大力按压翳风，一般5分钟内就可以止嗝。",
                        "xueweiName": "翳风",
                        "jingluoName": "手少阳三焦经",
                        "titleUrl": "翳风"
                    }
                },
                {
                    "seq": 18,
                    "xueweiName": "瘈脉",
                    "xueweiCode": "zhimo",
                    "position": {
                        "x": -0.070407,
                        "y": 1.668559,
                        "z": -0.031433
                    },
                    "xueweiDetail": {
                        "detailTitle": "瘈脉：小儿惊风疗效佳",
                        "detailDescription": "瘈，瘈疭，指络脉。穴在耳后络脉，有治瘈疭的作用。",
                        "cure": "熄风解痉，活络通窍。主治头痛、耳聋、耳鸣、小儿惊风、呕吐。",
                        "position": "在头部，乳突中央，角孙至翳风沿耳轮弧形连线的上2/3与下1/3交点处。",
                        "quickFind": "沿翳风和角孙做耳轮连线，连线的上2/3与下1/3交点处即是。",
                        "massage": "将食指和中指并拢轻轻贴于耳后根处，顺时针方向按摩瘈脉1~3分钟，每天早晚各1次。可治头痛、耳鸣、耳聋等症。",
                        "xueweiName": "瘈脉",
                        "jingluoName": "手少阳三焦经",
                        "titleUrl": "瘈脉"
                    }
                },
                {
                    "seq": 19,
                    "xueweiName": "颅息",
                    "xueweiCode": "luxi",
                    "position": {
                        "x": -0.076634,
                        "y": 1.69069,
                        "z": -0.037545
                    },
                    "xueweiDetail": {
                        "detailTitle": "颅息：头痛耳鸣揉颅息",
                        "detailDescription": "颅，头颅；息，安宁。穴在头颅部，可安脑宁神。",
                        "cure": "通窍聪耳，泻热镇惊。主治耳鸣、头痛、耳聋、小儿惊风、呕吐。",
                        "position": "在头部，角孙至翳风沿耳轮弧形连线的上1/3与下2/3交点处。",
                        "quickFind": "先找到翳风和角孙，二者之间做耳轮连线，连线的上1/3与下1/3交点处即是。",
                        "massage": "将食指和中指贴于耳后根处按摩1~3分钟，可治头痛、耳鸣、耳聋、中耳炎等症。",
                        "xueweiName": "颅息",
                        "jingluoName": "手少阳三焦经",
                        "titleUrl": "颅息"
                    }
                },
                {
                    "seq": 20,
                    "xueweiName": "角孙",
                    "xueweiCode": "jiaosun",
                    "position": {
                        "x": -0.07829,
                        "y": 1.719157,
                        "z": -0.025958
                    },
                    "xueweiDetail": {
                        "detailTitle": "角孙：保护眼睛不受伤",
                        "detailDescription": "角，角隅；孙，孙络。穴在颞额部，相当于耳上角对应处，而有孙络。",
                        "cure": "清热消肿，散风止痛。主治目赤肿痛、牙痛、头痛、颈项僵硬。",
                        "position": "在侧头部，耳尖正对发际处。",
                        "quickFind": "在头部，将耳郭折叠向前，找到耳尖，耳尖直上入发际处即是。",
                        "massage": "用拇指指腹揉按角孙，每次1~3分钟，对白内障、目生翳膜、齿龈肿痛等疾病疗效明显。",
                        "xueweiName": "角孙",
                        "jingluoName": "手少阳三焦经",
                        "titleUrl": "角孙"
                    }
                },
                {
                    "seq": 21,
                    "xueweiName": "耳门",
                    "xueweiCode": "ermen",
                    "position": {
                        "x": -0.073604,
                        "y": 1.691805,
                        "z": -0.003679
                    },
                    "xueweiDetail": {
                        "detailTitle": "耳门：保护耳朵有绝招",
                        "detailDescription": "耳，耳窍；门，门户。穴在耳前，犹如耳之门户。",
                        "cure": "开窍聪耳，泻热活络。主治耳鸣、耳聋、耳道流脓、中耳炎、牙痛。",
                        "position": "在耳前，耳屏上切迹与下颌骨髁突之间的凹陷中。",
                        "quickFind": "耳屏上缘的前方，张口有凹陷处即是。",
                        "massage": "每天早晚各揉按耳门1次，每次1~3分钟，可改善和治疗耳鸣、中耳炎、耳道炎、重听等耳部疾病。",
                        "xueweiName": "耳门",
                        "jingluoName": "手少阳三焦经",
                        "titleUrl": "耳门"
                    }
                },
                {
                    "seq": 22,
                    "xueweiName": "耳和髎",
                    "xueweiCode": "erheliao",
                    "position": {
                        "x": -0.07208,
                        "y": 1.708308,
                        "z": 0.012931
                    },
                    "xueweiDetail": {
                        "detailTitle": "耳和髎：五官疾病不苦恼",
                        "detailDescription": "耳，耳窍；和，调和；髎，骨隙。穴当耳前骨的前表陷隙中，可调耳和声。",
                        "cure": "祛风通络，解痉止痛。主治牙关拘急、口眼歪斜、头重痛、耳鸣。",
                        "position": "在头部，鬓发后缘，耳郭根的前方，颞浅动脉的后缘。",
                        "quickFind": "在头侧部，鬓发后缘作垂直线，耳郭根部作水平线，二者交点处即是。",
                        "massage": "常用中指指腹轻轻按摩耳和髎，每次3~5分钟，可预防面部痉挛，调理头重、中风后遗症等疾病。",
                        "xueweiName": "耳和髎",
                        "jingluoName": "手少阳三焦经",
                        "titleUrl": "耳和髎"
                    }
                },
                {
                    "seq": 23,
                    "xueweiName": "丝竹空",
                    "xueweiCode": "sizhukong",
                    "position": {
                        "x": -0.056703,
                        "y": 1.714607,
                        "z": 0.063783
                    },
                    "xueweiDetail": {
                        "detailTitle": "丝竹空：头痛头晕都点它",
                        "detailDescription": "丝竹，即细竹；空，空隙。眉毛，状如细竹。穴在眉梢之凹陷处。",
                        "cure": "清头明目，散骨镇惊。主治头痛、头晕、目赤肿痛、视神经萎缩。",
                        "position": "在面部，眉梢凹陷中。",
                        "quickFind": "在面部，眉毛外侧缘眉梢凹陷处。",
                        "massage": "用拇指指腹向内揉按左右丝竹空，每次1〜3分钟，有酸、胀、痛的感觉为宜，可治各种头痛、头晕、目眩、目赤疼痛等疾病。",
                        "xueweiName": "丝竹空",
                        "jingluoName": "手少阳三焦经",
                        "titleUrl": "丝竹空"
                    }
                }
            ]
        },
        {
            "jingMaiName": "足少阳胆经",
            "jingMaiCode": "zushaoyangdanjing",
            "xueweiList": [
                {
                    "seq": 1,
                    "xueweiName": "瞳子髎",
                    "xueweiCode": "tongziliao",
                    "position": {
                        "x": -0.059955,
                        "y": 1.701991,
                        "z": 0.057953
                    },
                    "xueweiDetail": {
                        "detailTitle": "瞳子髎：治疗眼花特效穴",
                        "detailDescription": "瞳子，即瞳孔；髎，骨隙。穴在小眼角外方骨隙中，横对瞳孔。",
                        "cure": "平肝熄风，明目退翳。主治目痛、角膜炎、青光眼、视神经萎缩等。",
                        "position": "在面部，目外眦外侧0.5寸凹陷中。",
                        "quickFind": "正坐，目外眦旁，眼眶外侧缘处。",
                        "massage": "用两手拇指用力垂直揉按瞳子髎，每天早晚各揉按1次，每次1~3分钟。可治目赤肿痛、角膜炎、屈光不正、青光眼等症。",
                        "xueweiName": "瞳子髎",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "瞳子髎"
                    }
                },
                {
                    "seq": 2,
                    "xueweiName": "听会",
                    "xueweiCode": "tinghui",
                    "position": {
                        "x": -0.07184,
                        "y": 1.67172,
                        "z": -0.001379
                    },
                    "xueweiDetail": {
                        "detailTitle": "听会：改善耳鸣与耳聋",
                        "detailDescription": "听，听觉；会，聚会。穴在耳前，功司耳闻，为耳部经气聚会之处。",
                        "cure": "开窍聪耳，通经活络。主治头痛、下颌关节炎、口眼歪斜、耳鸣、耳聋。",
                        "position": "在面部，耳屏间切迹与下颌骨髁突之间的凹陷中。",
                        "quickFind": "正坐，耳屏下缘前方，张口有凹陷处即是。或先取下关，向上推至额弓上缘的凹陷中即是。",
                        "massage": "耳聋耳鸣时，用拇指指尖垂直按压听会，每次用，直到症状缓和为止。",
                        "xueweiName": "听会",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "听会"
                    }
                },
                {
                    "seq": 3,
                    "xueweiName": "上关",
                    "xueweiCode": "shangguan",
                    "position": {
                        "x": -0.071573,
                        "y": 1.70933,
                        "z": 0.016966
                    },
                    "xueweiDetail": {
                        "detailTitle": "上关：口眼歪斜可按它",
                        "detailDescription": "上，上方；关，关界。关，指颧骨弓，穴当其上缘。",
                        "cure": "聪耳镇痉，散风活络。主治头痛、眩晕、偏风、口眼斜、耳鸣、耳聋。",
                        "position": "在面部，额弓上缘中央凹陷中。",
                        "quickFind": "正坐，耳屏往前量2横指，耳前额骨弓上侧凹陷处即是。",
                        "massage": "用中指指腹轻轻揉按上关1~3分钟，可治疗耳鸣、耳聋、牙痛、口眼歪斜等病。",
                        "xueweiName": "上关",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "上关"
                    }
                },
                {
                    "seq": 4,
                    "xueweiName": "颔厌",
                    "xueweiCode": "hanyan",
                    "position": {
                        "x": -0.071285,
                        "y": 1.753096,
                        "z": 0.018317
                    },
                    "xueweiDetail": {
                        "detailTitle": "颔厌：五官疾病不苦恼",
                        "detailDescription": "颔，下颔；厌，顺从。穴在颛额处，随咀嚼顺从下颌运动。",
                        "cure": "清热散风，通络止痛。主治头痛、眩晕、偏头痛、颈项痛、耳鸣、耳聋。",
                        "position": "在头部，从头维至曲鬓的弧形连线的上1/4与下3/4的交点处。",
                        "quickFind": "先找到头维和曲鬓，两穴连线的上1/4处即是。",
                        "massage": "用中指指腹垂直揉按颔厌，以有胀痛的感觉为宜，每天早晚各揉按1次，每次1~3分钟，可治五官科疾病。",
                        "xueweiName": "颔厌",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "颔厌"
                    }
                },
                {
                    "seq": 5,
                    "xueweiName": "悬颅",
                    "xueweiCode": "xuanlu",
                    "position": {
                        "x": -0.073264,
                        "y": 1.740046,
                        "z": 0.013742
                    },
                    "xueweiDetail": {
                        "detailTitle": "悬颅：集中精力不走神",
                        "detailDescription": "悬，悬挂；颅，头颅。穴在颞颥部，如悬挂在头颅之两侧。",
                        "cure": "通络消肿，清热散风。主治偏头痛、目外眦红肿、牙痛、神经衰弱。",
                        "position": "在头部，头维至曲鬓的弧形连线的中点处。",
                        "quickFind": "先找到头维和曲鬓，两穴连线的中点处即是。",
                        "massage": "许多孩子在学习的时候容易分心，注意力不集中，家长可以帮助孩子多揉揉悬颅，每次1~3分钟，有助于孩子集中注意力。",
                        "xueweiName": "悬颅",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "悬颅"
                    }
                },
                {
                    "seq": 6,
                    "xueweiName": "悬厘",
                    "xueweiCode": "xuanli",
                    "position": {
                        "x": -0.075668,
                        "y": 1.729187,
                        "z": -0.000075
                    },
                    "xueweiDetail": {
                        "detailTitle": "悬厘：偏头痛的终结者",
                        "detailDescription": "悬，悬垂；厘，同“毛”，指头发。穴在颞颥颗蔽部，位于悬垂的长发之中。",
                        "cure": "通络止痛，清热散风。主治热病汗不出、头痛、眩晕、三叉神经痛。",
                        "position": "在头部，从头维至曲鬓的弧形连线（其弧度与鬓发弧度相应）的上3/4与下1/4的交点处。",
                        "quickFind": "先找到头维和曲鬓，两穴连线的下1/4处即是。",
                        "massage": "头晕目眩时，用食指和中指轻轻揉按悬厘，不适很快就能缓解；重按悬厘，可止偏头痛。",
                        "xueweiName": "悬厘",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "悬厘"
                    }
                },
                {
                    "seq": 7,
                    "xueweiName": "曲鬓",
                    "xueweiCode": "qubin",
                    "position": {
                        "x": -0.07676,
                        "y": 1.717032,
                        "z": -0.012703
                    },
                    "xueweiDetail": {
                        "detailTitle": "曲鬓：牙痛颊肿就揉它",
                        "detailDescription": "曲，弯曲；鬓，鬓发。穴在耳上鬓发边际的弯曲处。",
                        "cure": "清热止痛，活络通窍。主治头痛、眩晕、口眼㖞斜、牙痛、颊肿。",
                        "position": "鬓角发际后缘与耳尖水平线的交点处。",
                        "quickFind": "在耳前鬓角发际后缘作垂直线，与耳尖水平线相交处即是。",
                        "massage": "用中指指腹垂直揉按曲鬓1~3分钟，可治疗头痛、牙痛、颊肿等症。",
                        "xueweiName": "曲鬓",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "曲鬓"
                    }
                },
                {
                    "seq": 8,
                    "xueweiName": "率谷",
                    "xueweiCode": "lügu",
                    "position": {
                        "x": -0.204638,
                        "y": 0.056458,
                        "z": 0.018329
                    },
                    "xueweiDetail": {
                        "detailTitle": "率谷：艾灸可治偏头痛",
                        "detailDescription": "率，统率；谷，山谷。穴在耳上，为以“谷”命名诸穴的最高者，如诸谷的统帅。",
                        "cure": "平肝熄风，疏经活络。主治头痛、眩晕、小儿惊风、胃寒、呕吐。",
                        "position": "在头部，耳尖直上入发际1.5寸。",
                        "quickFind": "角孙直上2横指处。",
                        "massage": "头痛时，依头痛的程度，每天用清艾条悬灸率谷3~5次，每次15分钟，或由前向后推抹率谷50-100次，可止偏头痛。",
                        "xueweiName": "率谷",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "率谷"
                    }
                },
                {
                    "seq": 9,
                    "xueweiName": "天冲",
                    "xueweiCode": "tianchong",
                    "position": {
                        "x": -0.077174,
                        "y": 1.726263,
                        "z": -0.040973
                    },
                    "xueweiDetail": {
                        "detailTitle": "天冲：牙龈肿痛找天冲",
                        "detailDescription": "天，天空；冲，冲出。天，指头部，穴在其两侧，胆经气血在本穴冲向巅顶。",
                        "cure": "祛风定惊，清热消肿，益气补阳。主治头痛、眩晕、癫痫、呕吐、牙龈肿痛。",
                        "position": "在头部，耳根后缘直上，入发际2寸。",
                        "quickFind": "耳根后缘，直上入发际团黄指处即是。",
                        "massage": "头痛、牙龈肿痛时，可用中指指腹轻轻按摩天冲，很快就能止痛，效果非常好。",
                        "xueweiName": "天冲",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "天冲"
                    }
                },
                {
                    "seq": 10,
                    "xueweiName": "浮白",
                    "xueweiCode": "fubai",
                    "position": {
                        "x": -0.074185,
                        "y": 1.704692,
                        "z": -0.048593
                    },
                    "xueweiDetail": {
                        "detailTitle": "浮白：专治头发白与花",
                        "detailDescription": "浮，浮浅；白，光明。穴位于体表浮浅部位，有清头明目之功。",
                        "cure": "理气散结，散风止痛。主治头痛、发白、颈项强痛、胸痛、打嗝、耳聋。",
                        "position": "在头部，耳后乳突的后上方，天冲与完骨弧形连线（其弧度与鬓发弧度相应）的上1/3与下2/3交点处。",
                        "quickFind": "先找到天冲和完骨，二者弧形连线上1/3处即是。",
                        "massage": "用中指指腹每天早晚各揉按浮白1~3分钟，可治经常熬夜不睡觉或者经常失眠而引起的头发白。",
                        "xueweiName": "浮白",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "浮白"
                    }
                },
                {
                    "seq": 11,
                    "xueweiName": "头窍阴",
                    "xueweiCode": "touqiaoyin",
                    "position": {
                        "x": -0.067447,
                        "y": 1.676732,
                        "z": -0.047093
                    },
                    "xueweiDetail": {
                        "detailTitle": "头窍阴：耳鸣耳聋不担忧",
                        "detailDescription": "头，头部；窍，空窍；阴，阴阳之阴。肝肾属阴，开窍于耳目。穴在头部，可治疗耳目之疾。",
                        "cure": "平肝镇痛，开窍聪耳。主治头痛、眩晕、耳鸣、耳聋、牙痛、口苦。",
                        "position": "在头部，当天冲与完骨的弧形连线（其弧度与耳郭弧度相应）的上2/3与下1/3交点处。",
                        "quickFind": "先找到天冲和完骨，二者弧形连线下1/3处即是。",
                        "massage": "每天早晚各揉按头窍阴1次，每次1~3分钟，可改善和治疗耳鸣、耳聋等耳部疾病。",
                        "xueweiName": "头窍阴",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "头窍阴"
                    }
                },
                {
                    "seq": 12,
                    "xueweiName": "完骨",
                    "xueweiCode": "wangu",
                    "position": {
                        "x": -0.058729,
                        "y": 1.648023,
                        "z": -0.039477
                    },
                    "xueweiDetail": {
                        "detailTitle": "完骨：常按可改善贫血",
                        "detailDescription": "完骨，即颞骨乳突。穴在耳后颞骨乳突下缘。",
                        "cure": "通络宁神，祛风清热。主治头痛、眩晕、耳鸣、耳聋、失眠、失语症。",
                        "position": "在头部，耳后乳突的后下方凹陷中。",
                        "quickFind": "耳后明显突起，其下方凹陷处即是。",
                        "massage": "每天用拇指指腹揉按完骨1~3分钟，对五官疾病具有明显的治疗效果。",
                        "xueweiName": "完骨",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "完骨"
                    }
                },
                {
                    "seq": 13,
                    "xueweiName": "本神",
                    "xueweiCode": "benshen",
                    "position": {
                        "x": -0.04644,
                        "y": 1.77903,
                        "z": 0.052433
                    },
                    "xueweiDetail": {
                        "detailTitle": "本神：头痛目眩就按它",
                        "detailDescription": "本，根本；神，神志。穴在前发际神庭旁。内为脑之所在；脑为元神之府，主神志，为人之根本。",
                        "cure": "祛风定惊，安神止痛。主治头痛、眩晕、颈项强直、中风、小儿惊风。",
                        "position": "前发际上0.5寸，头正中线旁开3寸。",
                        "quickFind": "正坐，从外眼角直上入发际半横指，按压有酸痛感处即是。",
                        "massage": "每天早晚各按摩本神1次，每次1~3分钟，可有效治疗头痛、目眩等疾病。",
                        "xueweiName": "本神",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "本神"
                    }
                },
                {
                    "seq": 14,
                    "xueweiName": "阳白",
                    "xueweiCode": "yangbai",
                    "position": {
                        "x": -0.033482,
                        "y": 1.737189,
                        "z": 0.082364
                    },
                    "xueweiDetail": {
                        "detailTitle": "阳白：眼部不适按按它",
                        "detailDescription": "阳，阴阳之阳；白，光明。头为阳，穴在头面部，有明目之功。",
                        "cure": "清头明目，祛风泻热。主治头痛、颈项强直、角膜痒痛、近视、面瘫。",
                        "position": "在头部，眉上1寸，瞳孔直上。",
                        "quickFind": "正坐，眼向前平视，自眉中直上1横指处即是。",
                        "massage": "将中指指腹置于阳白上，垂直揉按1~3分钟，能有效治疗眼疾。",
                        "xueweiName": "阳白",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "阳白"
                    }
                },
                {
                    "seq": 15,
                    "xueweiName": "头临泣",
                    "xueweiCode": "toulinqi",
                    "position": {
                        "x": -0.028569,
                        "y": 1.776187,
                        "z": 0.070511
                    },
                    "xueweiDetail": {
                        "detailTitle": "头临泣：头痛鼻塞及时了",
                        "detailDescription": "头，头部；临，调治；泣，流泪。穴在头部，可调治迎风流泪等病。",
                        "cure": "聪耳明目，安神定志。主治头痛、目眩、目赤肿痛、耳鸣、耳聋。",
                        "position": "在头部，前发际上0.5寸，瞳孔直上。",
                        "quickFind": "正坐，眼向前平视，自眉中直上半横指处即是。",
                        "massage": "每天早晚各揉按头临泣1~3分钟，可改善和治疗头痛、目痛、鼻塞、鼻窦炎等疾病。",
                        "xueweiName": "头临泣",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "头临泣"
                    }
                },
                {
                    "seq": 16,
                    "xueweiName": "目窗",
                    "xueweiCode": "muchuang",
                    "position": {
                        "x": -0.027129,
                        "y": 1.800804,
                        "z": 0.04284
                    },
                    "xueweiDetail": {
                        "detailTitle": "目窗：擦亮眼睛看更清",
                        "detailDescription": "目，眼睛；窗，窗户。穴在眼的上方，善治眼疾，犹如眼目之窗。",
                        "cure": "明目开窍，祛风定惊。主治头痛、头晕、小儿惊风、白内障、近视。",
                        "position": "在头部，前发际上1.5寸，瞳孔直上。",
                        "quickFind": "正坐，眼向前平视，自眉中直上，前发际直上2横指处即是。",
                        "massage": "将中指指腹置于目窗上垂直揉按，每天早晚各1次，每次1~3分钟，可有效治疗目痛、目眩、近视、远视等眼疾。",
                        "xueweiName": "目窗",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "目窗"
                    }
                },
                {
                    "seq": 17,
                    "xueweiName": "正营",
                    "xueweiCode": "zhengying",
                    "position": {
                        "x": -0.034051,
                        "y": 1.807538,
                        "z": 0.009707
                    },
                    "xueweiDetail": {
                        "detailTitle": "正营：专治头痛与头晕",
                        "detailDescription": "正，正当；营，同“荣”。正营，惶恐不安的意思。本穴主治惶恐不安等神志病。",
                        "cure": "平肝明目，疏风止痛。主治头痛、头晕、目痛、眩晕、呕吐、惶恐不安。",
                        "position": "在头部，前发际上2.5寸，瞳孔直上。",
                        "quickFind": "取前发际到百会的中点作一水平线，再找到目窗作一垂直线，两线交点处即是。",
                        "massage": "头痛头晕时，用手指指腹掐揉正营，可快速缓解。",
                        "xueweiName": "正营",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "正营"
                    }
                },
                {
                    "seq": 18,
                    "xueweiName": "承灵",
                    "xueweiCode": "chengling",
                    "position": {
                        "x": -0.036413,
                        "y": 1.805412,
                        "z": -0.035022
                    },
                    "xueweiDetail": {
                        "detailTitle": "承灵：面部痉挛按按它",
                        "detailDescription": "承，承受；灵，神灵。脑主神灵，故脑上顶骨又称天灵骨，穴就在其外下方。",
                        "cure": "通利官窍，散风清热。主治头痛、眩晕、目痛、风寒、鼻塞、鼻出血。",
                        "position": "在头部，前发际上4寸，瞳孔直上。",
                        "quickFind": "先找到百会，向前1横指作一水平线，再找到目窗作一垂直线，两线交点处即是。",
                        "massage": "经常用中指指腹按压承灵，每次1~3分钟，对面部痉挛有良好的调理作用。",
                        "xueweiName": "承灵",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "承灵"
                    }
                },
                {
                    "seq": 19,
                    "xueweiName": "脑空",
                    "xueweiCode": "naokong",
                    "position": {
                        "x": -0.043096,
                        "y": 1.720357,
                        "z": -0.092941
                    },
                    "xueweiDetail": {
                        "detailTitle": "脑空：后脑疼痛不要怕",
                        "detailDescription": "脑，脑髓；空，空窍。穴在枕骨外侧，内通脑窍，主治脑病。",
                        "cure": "散风清热，醒脑宁神。主治头痛、耳聋、癫痫、眩晕、身热、颈强、惊悸。",
                        "position": "横平枕外隆凸的上缘，风池直上。",
                        "quickFind": "在后脑勺摸到隆起的最高骨，上缘外约飛指凹陷处即是。",
                        "massage": "用双手拇指指腹揉按脑空，每次不少于30下，对头痛、耳聋等症有明显疗效。",
                        "xueweiName": "脑空",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "脑空"
                    }
                },
                {
                    "seq": 20,
                    "xueweiName": "风池",
                    "xueweiCode": "fengchi",
                    "position": {
                        "x": -0.024784,
                        "y": 1.640049,
                        "z": -0.075388
                    },
                    "xueweiDetail": {
                        "detailTitle": "风池：疏风散寒治感冒",
                        "detailDescription": "风，风邪；池，池塘。穴在枕骨下，局部凹陷如池，乃祛风之要穴。",
                        "cure": "平肝熄风，祛风散毒。主治外感发热、头痛、眩晕、等麻疹、黄褐斑、小儿脊柱侧弯、高血压。",
                        "position": "在项后，枕骨之下，胸锁乳突肌上端与斜方肌上端之间的凹陷中。",
                        "quickFind": "正坐，后头骨下两条大筋外缘陷窝中，与耳垂齐平处即是。",
                        "massage": "以双手拇指指腹由下往上揉按风池，以有酸胀感为宜。每次按压不少于30下，可治各种头痛。",
                        "xueweiName": "风池",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "风池"
                    }
                },
                {
                    "seq": 21,
                    "xueweiName": "肩井",
                    "xueweiCode": "jianjing",
                    "position": {
                        "x": -0.191019,
                        "y": 1.511775,
                        "z": -0.028619
                    },
                    "xueweiDetail": {
                        "detailTitle": "肩井：治疗落枕与肩痛",
                        "detailDescription": "肩，肩部；井，水井。穴在肩上，局部凹陷如井。",
                        "cure": "祛风清热，活络消肿。主治肩臂疼痛、落枕、颈椎病、肩周炎、抑郁症、乳房胀痛、小儿脊柱侧弯、更年期综合征。",
                        "position": "在肩胛区，第7颈椎棘突与肩峰最外侧点连线的中点。",
                        "quickFind": "先找到大椎，再找到锁骨肩峰端，二者连线中点即是。",
                        "massage": "按摩肩井，可缓解落枕和肩酸背痛等症；拿捏肩井，可发汗解表治感冒。",
                        "xueweiName": "肩井",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "肩井"
                    }
                },
                {
                    "seq": 22,
                    "xueweiName": "渊腋",
                    "xueweiCode": "yuanye",
                    "position": {
                        "x": -0.20321,
                        "y": 1.437899,
                        "z": 0.022506
                    },
                    "xueweiDetail": {
                        "detailTitle": "渊腋：腋窝汗多不用愁",
                        "detailDescription": "渊，深潭；腋，腋部。穴在腋下。",
                        "cure": "理气宽胸，消肿止痛。主治胸满、胁痛、腋下汗多、腋下肿、臂痛不举。",
                        "position": "在胸外侧，第4肋间隙中，在腋中线上。",
                        "quickFind": "正坐举臂，从腋横纹水平沿腋中线直下儂指处即是。",
                        "massage": "用食指或中指点按渊腋，每次3~5分钟，对治疗腋下汗多特别有效。",
                        "xueweiName": "渊腋",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "渊腋"
                    }
                },
                {
                    "seq": 23,
                    "xueweiName": "辄筋",
                    "xueweiCode": "zhejin",
                    "position": {
                        "x": -0.180258,
                        "y": 1.424977,
                        "z": 0.024194
                    },
                    "xueweiDetail": {
                        "detailTitle": "辄筋：养肝护肝好帮手",
                        "detailDescription": "辄，车耳，马车的护轮板；筋，筋肉。两侧胁肋肌肉隆起，形如车耳，穴在其处。",
                        "cure": "降逆平喘，理气止痛。主治咳嗽、气喘、呕吐、肋间神经痛。",
                        "position": "在胸外侧，第4肋间隙中，腋中线前1寸。",
                        "quickFind": "正坐举臂，从渊腋向前下量1横指处即是。",
                        "massage": "每天用食指指腹揉按辄筋1~3分钟，可有效治疗气喘、胸胁痛、呕吐等疾病。",
                        "xueweiName": "辄筋",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "辄筋"
                    }
                },
                {
                    "seq": 24,
                    "xueweiName": "日月",
                    "xueweiCode": "riyue",
                    "position": {
                        "x": -0.078857,
                        "y": 1.267188,
                        "z": 0.110538
                    },
                    "xueweiDetail": {
                        "detailTitle": "日月：主治胆囊的疾病",
                        "detailDescription": "日，太阳；月，月亮。日为阳，指胆；月为阴，指肝。此为治肝胆疾病的要穴。",
                        "cure": "利胆疏肝，降逆和胃。主治肋间神经痛、肝炎、抑郁症、口苦、胆囊炎。",
                        "position": "在胸部，第7肋间隙，前正中线旁开4寸。",
                        "quickFind": "正坐或仰卧，自乳头垂直向下推3个肋间隙，按压有酸胀感处即是。",
                        "massage": "日月以治疗胆囊炎、胆结石、胆绞痛等胆本身疾病为主。稍用力指压，效果较好。",
                        "xueweiName": "日月",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "日月"
                    }
                },
                {
                    "seq": 25,
                    "xueweiName": "京门",
                    "xueweiCode": "jingmen",
                    "position": {
                        "x": -0.125187,
                        "y": 1.189986,
                        "z": 0.05948
                    },
                    "xueweiDetail": {
                        "detailTitle": "京门：健脾温阳止腹泻",
                        "detailDescription": "京，同“原”字；门，门户。此为肾之募穴。穴之所在为肾气出入的门户。",
                        "cure": "补肾通淋，健脾温阳。主治胁肋痛、腹胀、腹泻、腰痛、尿黄、肾炎。",
                        "position": "在上腹部，第12肋骨游离端下际。",
                        "quickFind": "章门后2横指处即是。",
                        "massage": "用拇指指腹按揉京门，对腹胀、腹泻、肠鸣等胃肠疾病有良好疗效。",
                        "xueweiName": "京门",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "京门"
                    }
                },
                {
                    "seq": 26,
                    "xueweiName": "带脉",
                    "xueweiCode": "daimo",
                    "position": {
                        "x": -0.10777,
                        "y": 1.109076,
                        "z": 0.0849
                    },
                    "xueweiDetail": {
                        "detailTitle": "带脉：调经止带效果好",
                        "detailDescription": "带，腰带；脉，经脉。穴属胆经，交会在带脉之上。",
                        "cure": "健脾利湿，调经止带。主治月经不调、赤白带下、闭经、痛经、不孕。",
                        "position": "在侧腹部，第11肋骨游离端垂线与脐水平线的交点上。",
                        "quickFind": "腋中线与肚脐水平线相交处即是。",
                        "massage": "月经不调、白带异常者可在每天早上起床后，手握空拳，敲击带脉100次。",
                        "xueweiName": "带脉",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "带脉"
                    }
                },
                {
                    "seq": 27,
                    "xueweiName": "五枢",
                    "xueweiCode": "wushu",
                    "position": {
                        "x": -0.096081,
                        "y": 1.048632,
                        "z": 0.089558
                    },
                    "xueweiDetail": {
                        "detailTitle": "五枢：妇科疾病的福音",
                        "detailDescription": "五，五个；枢，枢纽。五为中数，少阳主枢；意指穴在人身体中部的枢要之处。",
                        "cure": "调经止带，调理下焦。主治月经不调、子宫内膜炎、痛经。",
                        "position": "在下腹部，横平脐下3寸，骼前上棘内侧。",
                        "quickFind": "从肚脐向下4指处作水平线，与骼前上棘相交处即是。",
                        "massage": "常按揉五枢，可治痛经、带下、月经不调等妇科病症。",
                        "xueweiName": "五枢",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "五枢"
                    }
                },
                {
                    "seq": 28,
                    "xueweiName": "维道",
                    "xueweiCode": "weidao",
                    "position": {
                        "x": -0.07115,
                        "y": 1.021095,
                        "z": 0.100437
                    },
                    "xueweiDetail": {
                        "detailTitle": "维道：消除四肢的浮肿",
                        "detailDescription": "维，维系；道，通道。本穴为胆经与带脉之会，带脉维系诸经。",
                        "cure": "调理冲任，利水止痛。主治四肢浮肿、盆腔炎、附件炎、子宫脱垂。",
                        "position": "在下腹部，骼前上棘内下0.5寸。",
                        "quickFind": "先找到五枢，其前下半横指处即是。",
                        "massage": "以两手拇指自上向下摩动维道，每次左右各按摩1~3分钟，以减轻腰背疼痛、腰肌劳损、下肢瘫痹、膝关节炎等慢性病带来的不适。",
                        "xueweiName": "维道",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "维道"
                    }
                },
                {
                    "seq": 29,
                    "xueweiName": "居髎",
                    "xueweiCode": "juliao",
                    "position": {
                        "x": -0.152076,
                        "y": 0.968927,
                        "z": 0.064808
                    },
                    "xueweiDetail": {
                        "detailTitle": "居髎：针对腰腿疼与痛",
                        "detailDescription": "居，居处；髎，近骨之凹陷处。穴居髋骨上凹陷处。",
                        "cure": "舒筋活络，益肾强腰。主治腰腿痹痛、月经不调、白带过多。",
                        "position": "在臀区，骼前上棘与股骨大转子最凸点连线的中点处。",
                        "quickFind": "骼前上棘是侧腹隆起的骨性标志，股骨大转子是骼部最隆起处，二者连线中点即是。",
                        "massage": "两手拇指自上向下摩动居髎，每次左右各按摩1~3分钟，可治腰腿痹痛、瘫痪等症。",
                        "xueweiName": "居髎",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "居髎"
                    }
                },
                {
                    "seq": 30,
                    "xueweiName": "环跳",
                    "xueweiCode": "huantiao",
                    "position": {
                        "x": -0.12339,
                        "y": 0.961218,
                        "z": -0.112313
                    },
                    "xueweiDetail": {
                        "detailTitle": "环跳：腰腿疼痛先按它",
                        "detailDescription": "环，环曲；跳，跳跃。穴在髀枢中，髀枢为环曲跳跃的枢纽。",
                        "cure": "祛风化湿，强健腰膝。主治腰胯疼痛、腰痛、下肢痿痹、坐骨神经痛。",
                        "position": "在臀区，股骨大转子最凸点与骶管裂孔连线上的外1/3与内2/3交点处。",
                        "quickFind": "侧卧上腿弯曲，拇指横纹按在股骨大转头上，拇指指向脊柱，指尖所在凹陷处即是。",
                        "massage": "常用拇指指端用力揉按环跳，每次1~3分钟，可防治下肢痿痹、膝关节痛等下肢疾病。",
                        "xueweiName": "环跳",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "环跳"
                    }
                },
                {
                    "seq": 31,
                    "xueweiName": "风市",
                    "xueweiCode": "fengshi",
                    "position": {
                        "x": -0.185432,
                        "y": 0.75313,
                        "z": 0.027978
                    },
                    "xueweiDetail": {
                        "detailTitle": "风市：常按常揉远中风",
                        "detailDescription": "风，风邪；市，集市。集市有集散之意，此为疏散风邪之要穴。",
                        "cure": "祛风化湿，通经活络。主治眩晕、中风、半身不遂、下肢痿痹、神经性皮炎、皮肤瘙痒、脂溢性皮炎、寻麻疹。",
                        "position": "在大腿外侧中线上，当臀下横纹与腘横纹之间中点处。",
                        "quickFind": "直立垂手，手掌并拢伸直，中指指尖处即是。",
                        "massage": "以中指指腹垂直下压风市，以有酸、胀、麻感为宜，每次左右各按3~5分钟，先左后右，可治中风、半身不遂、下肢麻痹等症。",
                        "xueweiName": "风市",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "风市"
                    }
                },
                {
                    "seq": 32,
                    "xueweiName": "中渎",
                    "xueweiCode": "zhongdu",
                    "position": {
                        "x": -0.176311,
                        "y": 0.694355,
                        "z": 0.027306
                    },
                    "xueweiDetail": {
                        "detailTitle": "中渎：常按消除胆结石",
                        "detailDescription": "中，中间；渎，小的沟渠。穴在股外侧两筋之间，如在沟渎之中。",
                        "cure": "祛风散寒，疏通经络。主治胆结石、下肢痿痹、半身不遂、坐骨神经痛。",
                        "position": "在股部，腘横纹上5寸，骼胫束后缘。",
                        "quickFind": "先找到风市，直下量3横指处即是。",
                        "massage": "胆囊有问题的人，按该穴肯定很痛，每天坚持敲打对胆囊有保健和调理作用。",
                        "xueweiName": "中渎",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "中渎"
                    }
                },
                {
                    "seq": 33,
                    "xueweiName": "膝阳关",
                    "xueweiCode": "xiyangguan",
                    "position": {
                        "x": -0.146783,
                        "y": 0.017394,
                        "z": -0.017394
                    },
                    "xueweiDetail": {
                        "detailTitle": "膝阳关：治疗膝痛有特效",
                        "detailDescription": "膝，膝部；阳，阴阳之阳；关，机关。外为阳。穴在膝关节外侧。",
                        "cure": "疏利关节，祛风化湿。主治膝关节肿痛、胭筋挛急、小腿麻木。",
                        "position": "在膝部，股骨外上髁后上缘，股二头肌腱与器胫束之间的凹陷中。",
                        "quickFind": "屈膝90°，膝上外侧有一高骨，其上方有一凹陷处即是。或阳陵泉直上4横指处。",
                        "massage": "用中指指腹揉按膝阳关，有胀痛的感觉，可改善和治疗膝关节肿痛、挛急及小腿麻木等下肢疾病。",
                        "xueweiName": "膝阳关",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "膝阳关"
                    }
                },
                {
                    "seq": 34,
                    "xueweiName": "阳陵泉",
                    "xueweiCode": "yanglingquan",
                    "position": {
                        "x": -0.138213,
                        "y": 0.466439,
                        "z": -0.030509
                    },
                    "xueweiDetail": {
                        "detailTitle": "阳陵泉：胆囊发炎先按它",
                        "detailDescription": "阳，阴阳之阳；陵，丘陵；泉，水泉。外为阳，膝外侧腓骨小头隆起如陵，穴在其下陷中，犹如水泉。",
                        "cure": "利胆舒肝，强健腰膝。主治耳鸣、耳聋、口苦、坐骨神经痛、腿抽筋、甲状腺肿大、脂溢性皮炎、白瘢风、乳房胀痛、胆囊炎。",
                        "position": "在小腿外侧，腓骨头前下方凹陷中。",
                        "quickFind": "屈膝90°，膝关节外下方，腓骨小头前下方凹陷处即是。",
                        "massage": "按摩阳陵泉，能增加胆囊的运动和排空能力，减轻胆囊内压力，缓解胆囊炎等症。",
                        "xueweiName": "阳陵泉",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "阳陵泉"
                    }
                },
                {
                    "seq": 35,
                    "xueweiName": "阳交",
                    "xueweiCode": "yangjiao",
                    "position": {
                        "x": -0.114801,
                        "y": 0.27026,
                        "z": -0.072508
                    },
                    "xueweiDetail": {
                        "detailTitle": "阳交：急性疼痛找阳交",
                        "detailDescription": "阳，阴阳之阳；交，交会。外为阳，穴在小腿外侧，与膀胱经交会。",
                        "cure": "疏肝理气，安神定志。主治膝痛、足胫痿痹、面部浮肿、坐骨神经痛。",
                        "position": "在小腿外侧，外踝尖上7寸，腓骨后缘。",
                        "quickFind": "腘横纹头与外踝尖连线上，中点向下1横指，腓骨后缘处即是。",
                        "massage": "用拇指指腹揉按阳交，每次1~3分钟，可治突发头痛、乳腺痛、坐骨神经痛等症。",
                        "xueweiName": "阳交",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "阳交"
                    }
                },
                {
                    "seq": 36,
                    "xueweiName": "外丘",
                    "xueweiCode": "waiqiu",
                    "position": {
                        "x": -0.119364,
                        "y": 0.263376,
                        "z": -0.055373
                    },
                    "xueweiDetail": {
                        "detailTitle": "外丘：止痛能手",
                        "detailDescription": "夕卜，内外之外；丘，丘陵。穴在外踝上方，局部肌肉隆起如丘。",
                        "cure": "舒肝理气，通络安神。主治癫疾呕沫、腹痛、脚气、小腿抽筋。",
                        "position": "在小腿外侧，外踝尖上7寸，腓骨前缘。",
                        "quickFind": "腘横纹头与外踝尖连线中点向下1横指，腓骨前缘处即是。",
                        "massage": "按揉外丘最好采取指压带揉动的方式，每次约3分钟。可缓解急性胆囊疼痛、头痛等症。",
                        "xueweiName": "外丘",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "外丘"
                    }
                },
                {
                    "seq": 37,
                    "xueweiName": "光明",
                    "xueweiCode": "guangming",
                    "position": {
                        "x": -0.113801,
                        "y": 0.228293,
                        "z": -0.056854
                    },
                    "xueweiDetail": {
                        "detailTitle": "光明：提高视力按光明",
                        "detailDescription": "光明，即明亮的意思。为胆经络穴，主治眼病，使之重见光明。",
                        "cure": "舒肝明目，活络消肿。主治目赤肿痛、视物不明、偏头痛、精神病。",
                        "position": "在小腿外侧，外踝尖上5寸，腓骨前缘。",
                        "quickFind": "先找到外丘，沿腓骨前缘向下3横指处即是。",
                        "massage": "用中指指腹垂直按压光明，每日早晚各揉按1次，每次1~3分钟，可治近视眼、老年白内障、青光眼、视神经疾病等症。",
                        "xueweiName": "光明",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "光明"
                    }
                },
                {
                    "seq": 38,
                    "xueweiName": "阳辅",
                    "xueweiCode": "yangfu",
                    "position": {
                        "x": -0.110945,
                        "y": 0.198274,
                        "z": -0.056654
                    },
                    "xueweiDetail": {
                        "detailTitle": "阳辅：熬夜头晕就按它",
                        "detailDescription": "阳，阴阳之阳；辅，辅助。外为阳，辅，指辅骨，即腓骨。穴在小腿外侧用腓骨前。",
                        "cure": "清热散风，疏通经络。主治胸胁痛、下肢外侧痛、膝下浮肿。",
                        "position": "在小腿外侧，外踝尖上4寸，腓骨前缘。",
                        "quickFind": "腘横纹头与外踝尖连线的下1/4，腓骨前缘。",
                        "massage": "用拇指指腹，用力上下推动阳辅穴1~2分钟，每5分钟按摩1次，共按摩4~5次，可治疗熬夜出现的头晕、口苦等症状。",
                        "xueweiName": "阳辅",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "阳辅"
                    }
                },
                {
                    "seq": 39,
                    "xueweiName": "悬钟",
                    "xueweiCode": "xuanzhong",
                    "position": {
                        "x": -0.113392,
                        "y": 0.160558,
                        "z": -0.057449
                    },
                    "xueweiDetail": {
                        "detailTitle": "悬钟：降低血压效果好",
                        "detailDescription": "悬，悬挂；钟，钟铃。穴当外踝上，是古时小儿悬挂脚铃处。别名绝骨。",
                        "cure": "舒肝益肾，平肝熄风。主治颈项僵硬、半身不遂、头晕、耳鸣、高血压。",
                        "position": "在小腿外侧，外踝尖上3寸，腓骨前缘。",
                        "quickFind": "外踝尖直上4横指处，腓骨前缘处即是。",
                        "massage": "每天睡前艾灸悬钟1次，每次8分钟，可治疗高血压病人低压值偏高；经常按揉此穴，可强健筋骨，补髓充脑。",
                        "xueweiName": "悬钟",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "悬钟"
                    }
                },
                {
                    "seq": 40,
                    "xueweiName": "丘墟",
                    "xueweiCode": "qiuxu",
                    "position": {
                        "x": -0.143693,
                        "y": 0.092,
                        "z": -0.04336
                    },
                    "xueweiDetail": {
                        "detailTitle": "丘墟：清醒头脑按丘墟",
                        "detailDescription": "丘，小土堆；墟，大土堆。本穴在外踝（如墟）与跟骨滑车突（如丘）之间。",
                        "cure": "健脾利湿，泻热退黄，舒筋活络。主治胸胁痛、髋关节疼痛、下肢酸痛。",
                        "position": "在踝部，外踝的前下方，趾长伸肌腱的外侧凹陷中。",
                        "quickFind": "脚掌用力背伸，足背可见明显趾长伸肌腱，其外侧、足外踝前下方凹陷处即是。",
                        "massage": "用拇指指腹按压丘墟，每天早上按揉200次。对目赤肿痛、颈项痛、胸胁痛等疾病有良好的治疗效果。",
                        "xueweiName": "丘墟",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "丘墟"
                    }
                },
                {
                    "seq": 41,
                    "xueweiName": "足临泣",
                    "xueweiCode": "zulinqi",
                    "position": {
                        "x": -0.172324,
                        "y": 0.048437,
                        "z": -0.027946
                    },
                    "xueweiDetail": {
                        "detailTitle": "足临泣：呵护女性乳房佳",
                        "detailDescription": "足，足部；临，调治；泣，流泪。穴在足部，可调治迎风流泪等眼疾。",
                        "cure": "舒肝熄风，化痰消肿。主治头痛、目赤肿痛、牙痛、乳痈、胁肋痛、白带过多。",
                        "position": "在足背，第4、第5跖骨底结合部的前方，第5趾长伸肌腱外侧凹陷中。",
                        "quickFind": "坐位，小趾向上翘起，小趾长伸肌腱外侧凹陷中，按压有酸胀感处即是。",
                        "massage": "用拇指指腹揉按足临泣，以有酸胀、微痛的感觉为宜，可治疗女性乳房疾病，如乳腺炎、乳腺增生等。",
                        "xueweiName": "足临泣",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "足临泣"
                    }
                },
                {
                    "seq": 42,
                    "xueweiName": "地五会",
                    "xueweiCode": "diwuhui",
                    "position": {
                        "x": -0.176307,
                        "y": 0.063619,
                        "z": -0.014826
                    },
                    "xueweiDetail": {
                        "detailTitle": "地五会：足趾麻木就找它",
                        "detailDescription": "地，土地；五，五个；会，会合。地在下，指足部。足部胆经穴有五，本穴居其中。",
                        "cure": "舒肝消肿，通经活络。主治头痛、目眩、目赤肿痛、腋部肿痛、耳聋。",
                        "position": "第4、第5跖骨间，第4跖趾关节近端凹陷中。",
                        "quickFind": "小趾向上翘起，小趾长伸肌腱内侧缘处。",
                        "massage": "经常用拇指指腹按揉地五会，对足趾麻木等不适有很好的调理作用。",
                        "xueweiName": "地五会",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "地五会"
                    }
                },
                {
                    "seq": 43,
                    "xueweiName": "侠溪",
                    "xueweiCode": "xiaxi",
                    "position": {
                        "x": -0.204638,
                        "y": 0.056458,
                        "z": 0.018329
                    },
                    "xueweiDetail": {
                        "detailTitle": "侠溪：头痛目眩按一按",
                        "detailDescription": "侠，通“夹”字；溪，沟溪。穴在第4、第5趾的夹缝间，局部犹如沟溪。",
                        "cure": "平肝熄风，消肿止痛。主治头痛、耳鸣、贫血、肋间神经痛、高血压。",
                        "position": "第4、第5趾间，趾蹊缘后方赤白肉际处。",
                        "quickFind": "坐位，在足背部第4、第5趾之间连接处的缝纹头处即是。",
                        "massage": "头痛目眩、耳鸣时，可按揉侠溪来缓冲。",
                        "xueweiName": "侠溪",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "侠溪"
                    }
                },
                {
                    "seq": 44,
                    "xueweiName": "足窍阴",
                    "xueweiCode": "zuqiaoyin",
                    "position": {
                        "x": -0.246614,
                        "y": 0.035627,
                        "z": 0.078499
                    },
                    "xueweiDetail": {
                        "detailTitle": "足窍阴：点刺可治头牙痛",
                        "detailDescription": "足，足部；窍，孔窍；阴，阴阳之阴。肾肝属阴，开窍于耳目。穴在足部，治疗耳目之疾。",
                        "cure": "疏肝解郁，通经活络。主治偏头痛、目赤肿痛、耳鸣、耳聋、胸胁痛。",
                        "position": "第4趾末节外侧，趾甲根角侧后方0.1寸。",
                        "quickFind": "坐位，第4趾趾甲外侧缘与下缘各作一垂线，其交点处即是。",
                        "massage": "头痛和牙痛时，用5根牙签捆在一起点刺足窍阴，每次100下。",
                        "xueweiName": "足窍阴",
                        "jingluoName": "足少阳胆经",
                        "titleUrl": "足窍阴"
                    }
                }
            ]
        },
        {
            "jingMaiName": "足厥阴肝经",
            "jingMaiCode": "zujueyinganjing",
            "xueweiList": [
                {
                    "seq": 1,
                    "xueweiName": "大敦",
                    "xueweiCode": "dadun",
                    "position": {
                        "x": -0.214087,
                        "y": 0.046788,
                        "z": 0.13196
                    },
                    "xueweiDetail": {
                        "detailTitle": "大敦：快速止血的能手",
                        "detailDescription": "大，大小之大；敦，敦厚。大，指大趾。穴在大趾外侧，肌肉敦厚。",
                        "cure": "回阳救逆，调经通淋。主治闭经、崩漏、遗尿、月经过多、睾丸炎。",
                        "position": "在足趾，大趾末节外侧，趾甲根角侧后方0.1寸（指寸）。",
                        "quickFind": "坐位，大趾趾甲外侧缘与下缘各作一垂线，其交点处即是。",
                        "massage": "经常用手指点按大敦，可缓解出血症。",
                        "xueweiName": "大敦",
                        "jingluoName": "足厥阴肝经",
                        "titleUrl": "大敦"
                    }
                },
                {
                    "seq": 2,
                    "xueweiName": "行间",
                    "xueweiCode": "hangjian",
                    "position": {
                        "x": -0.192395,
                        "y": 0.056724,
                        "z": 0.099218
                    },
                    "xueweiDetail": {
                        "detailTitle": "行间：改善目赤与头痛",
                        "detailDescription": "行，运行；间，中间。穴在第1、第2跖趾关节的前方陷中，经气运行其间。",
                        "cure": "清肝泻热，凉血安神，熄风活络。主治目赤、头痛、高血压、阳痿、痛经、甲状腺肿大。",
                        "position": "在足背，第1、第2跖趾间，跖趾缘后方赤白肉际处。",
                        "quickFind": "坐位，在足背部第1、第2两趾之间连接处的缝纹头处即是。",
                        "massage": "一边用中指指腹强压行间，一边吐气，有轻微疼痛感，重复按压2〜3分钟，可缓解头痛、耳鸣耳聋、失眠。",
                        "xueweiName": "行间",
                        "jingluoName": "足厥阴肝经",
                        "titleUrl": "行间"
                    }
                },
                {
                    "seq": 3,
                    "xueweiName": "太冲",
                    "xueweiCode": "taichong",
                    "position": {
                        "x": -0.176949,
                        "y": 0.076796,
                        "z": 0.067979
                    },
                    "xueweiDetail": {
                        "detailTitle": "太冲：清肝火又消怒气",
                        "detailDescription": "太，大；冲，重要部位，穴在足背，脉气盛大。为肝经要穴。",
                        "cure": "平肝泻热，舒肝养血，清利下焦。失眠、头痛、腰痛、全身胀痛、甲状腺肿大、肝炎、闭经、胆囊炎、胆结石。",
                        "position": "在足背，当第1、第2跖骨间，跖骨底结合部前方凹陷中。",
                        "quickFind": "足背，沿第1、第2趾间横纹向足背上推，感觉到有一凹陷处即是。",
                        "massage": "按揉太冲，对除焦虑有特效。",
                        "xueweiName": "太冲",
                        "jingluoName": "足厥阴肝经",
                        "titleUrl": "太冲"
                    }
                },
                {
                    "seq": 4,
                    "xueweiName": "中封",
                    "xueweiCode": "zhongfeng",
                    "position": {
                        "x": -0.105875,
                        "y": 0.163668,
                        "z": -0.105875
                    },
                    "xueweiDetail": {
                        "detailTitle": "中封：保养精血之要穴",
                        "detailDescription": "中，中间；封，聚土成堆，穴在两踝之间，如土堆之中。",
                        "cure": "清泻肝胆，通利下焦，舒筋通络。主治内踝肿痛、足冷、小腹痛、喘干、肝炎。",
                        "position": "在内踝前，胫骨前肌腱的内侧缘凹陷处。",
                        "quickFind": "坐位，拇趾上翘，足背可见一大筋，其内侧、足内踝前下方凹陷处即是。",
                        "massage": "用拇指指端用力按中封，每次3分钟，以有酸胀感为宜，可调理男性肾虚。",
                        "xueweiName": "中封",
                        "jingluoName": "足厥阴肝经",
                        "titleUrl": "中封"
                    }
                },
                {
                    "seq": 5,
                    "xueweiName": "蠡沟",
                    "xueweiCode": "ligou",
                    "position": {
                        "x": -0.100273,
                        "y": 0.291717,
                        "z": -0.001962
                    },
                    "xueweiDetail": {
                        "detailTitle": "蠡沟：治疗瘙痒有奇效",
                        "detailDescription": "蠡，贝壳；沟，水沟。腓肠肌外形酷似贝壳，穴在其前方沟中。",
                        "cure": "疏肝理气，调经止带。主治疝气、遗尿、阴痛阴痒、月经不调、崩漏。",
                        "position": "在小腿内侧，内踝尖上5寸，胫骨内侧面的中央。",
                        "quickFind": "坐位，内踝尖垂直向上量7横指，胫骨内侧凹陷处即是。",
                        "massage": "多揉蠡沟可治阴囊湿疹、阴道瘙痒等湿热病。",
                        "xueweiName": "蠡沟",
                        "jingluoName": "足厥阴肝经",
                        "titleUrl": "蠡沟"
                    }
                },
                {
                    "seq": 6,
                    "xueweiName": "中都",
                    "xueweiCode": "zhongdou",
                    "position": {
                        "x": -0.09265,
                        "y": 0.361711,
                        "z": 0.008657
                    },
                    "xueweiDetail": {
                        "detailTitle": "中都：急性疼痛揉中都",
                        "detailDescription": "中，中间；都，会聚。穴在小腿内侧中间，为肝经之气深聚之处。",
                        "cure": "疏肝理气，调经止血。主治疝气、痢疾、小腹痛、遗精、崩漏。",
                        "position": "在小腿内侧，内踝尖上7寸，胫骨内侧面的中央。",
                        "quickFind": "坐位，内踝尖与阴陵泉连线之中点上半横指处即是。",
                        "massage": "用中指指腹揉中都，可缓解急性肋骨痛、急性肝区痛、急性眼睛胀痛。",
                        "xueweiName": "中都",
                        "jingluoName": "足厥阴肝经",
                        "titleUrl": "中都"
                    }
                },
                {
                    "seq": 7,
                    "xueweiName": "膝关",
                    "xueweiCode": "xiguan",
                    "position": {
                        "x": -0.082456,
                        "y": 0.483666,
                        "z": 0.027473
                    },
                    "xueweiDetail": {
                        "detailTitle": "膝关：膝部疼痛就揉它",
                        "detailDescription": "膝，膝部；关，关节。穴在膝关节附近。",
                        "cure": "散风祛湿，疏通关节。主治膝髌肿痛、膝关节痛、下肢痿痹。",
                        "position": "在膝部，胫骨内侧髁的下方，阴陵泉后1寸。",
                        "quickFind": "先找到阴陵泉，向后量1横指，可触及一凹陷处即是。",
                        "massage": "用拇食二指的指腹拿捏膝关3~5分钟，可以有效缓解膝部和下肢疼痛。",
                        "xueweiName": "膝关",
                        "jingluoName": "足厥阴肝经",
                        "titleUrl": "膝关"
                    }
                },
                {
                    "seq": 8,
                    "xueweiName": "曲泉",
                    "xueweiCode": "ququan",
                    "position": {
                        "x": -0.069605,
                        "y": 0.580518,
                        "z": 0.06848
                    },
                    "xueweiDetail": {
                        "detailTitle": "曲泉：乳腺增生就找它",
                        "detailDescription": "曲，弯曲；泉，水泉。穴在腘窝横纹内侧端；屈膝时局部呈凹陷如泉。",
                        "cure": "清利湿热，通调下焦。主治月经不调、子宫脱垂、乳腺增生、阳痿。",
                        "position": "在膝部，腘横纹内侧端，半腱肌肌腱内缘凹陷中。",
                        "quickFind": "膝内侧，屈膝时可见膝关节内侧面横纹端，其横纹头凹陷处即是。",
                        "massage": "常用手指敲击左腿曲泉，能疏肝解郁，有效防治乳腺增生。",
                        "xueweiName": "曲泉",
                        "jingluoName": "足厥阴肝经",
                        "titleUrl": "曲泉"
                    }
                },
                {
                    "seq": 9,
                    "xueweiName": "阴包",
                    "xueweiCode": "yinbao",
                    "position": {
                        "x": -0.045696,
                        "y": 0.686676,
                        "z": 0.066962
                    },
                    "xueweiDetail": {
                        "detailTitle": "阴包：生殖泌尿它统管",
                        "detailDescription": "阴，阴阳之阴；包，通“胞”。穴在大腿内侧，主子宫疾病。",
                        "cure": "调经止痛，利尿通淋。主治月经不调、腰骶痛、小便难、遗尿。",
                        "position": "在股前区，髌底上4寸，股内肌与缝匠肌之间。",
                        "quickFind": "大腿内侧，膝盖内侧上端的骨性标志，直上6横指处即是。",
                        "massage": "用拇指指腹轻揉阴包，可增强生殖器官的功能，也可预防女性乳腺疾病。",
                        "xueweiName": "阴包",
                        "jingluoName": "足厥阴肝经",
                        "titleUrl": "阴包"
                    }
                },
                {
                    "seq": 10,
                    "xueweiName": "足五里",
                    "xueweiCode": "zuwuli",
                    "position": {
                        "x": -0.052247,
                        "y": 0.903978,
                        "z": 0.091215
                    },
                    "xueweiDetail": {
                        "detailTitle": "足五里：通利小便见效快",
                        "detailDescription": "足，下肢；五，数词；里，古代有以里为寸之说。穴在下肢，约当箕门上5寸。",
                        "cure": "疏肝理气，清利祛热。主治腹胀、小便不通、阴囊湿痒、风痔。",
                        "position": "在股前侧，气冲直下3寸，动脉搏动处。",
                        "quickFind": "先取气冲，直下4横指处即是。",
                        "massage": "按摩足五里，可缓解小便不通畅、阴部湿痒、浑身倦怠无力等症状。",
                        "xueweiName": "足五里",
                        "jingluoName": "足厥阴肝经",
                        "titleUrl": "足五里"
                    }
                },
                {
                    "seq": 11,
                    "xueweiName": "阴廉",
                    "xueweiCode": "yinlian",
                    "position": {
                        "x": -0.048398,
                        "y": 0.915947,
                        "z": 0.090549
                    },
                    "xueweiDetail": {
                        "detailTitle": "阴廉：调经止带此穴佳",
                        "detailDescription": "阴，阴阳之阴；廉，边缘。内为阴。穴在大腿内侧阴器的边缘。",
                        "cure": "调经止带，通利下焦。主治月经不调、小腹疼痛、下肢痉挛。",
                        "position": "在股前侧，气冲直下2寸。",
                        "quickFind": "先取气冲，直下3横指处即是。",
                        "massage": "用中指指腹同时揉按两侧阴廉3~5分钟，可治生殖系统疾病。",
                        "xueweiName": "阴廉",
                        "jingluoName": "足厥阴肝经",
                        "titleUrl": "阴廉"
                    }
                },
                {
                    "seq": 12,
                    "xueweiName": "急脉",
                    "xueweiCode": "jimo",
                    "position": {
                        "x": -0.070105,
                        "y": 0.939484,
                        "z": 0.094019
                    },
                    "xueweiDetail": {
                        "detailTitle": "急脉：急性腹痛就按它",
                        "detailDescription": "急，急促；脉，脉气。肝经气血在此吸热后化为强劲的风气。",
                        "cure": "疏理肝胆，通调下焦。主治小腹痛、疝气、阴茎痛、股内侧部疼痛。",
                        "position": "在腹股沟区，横平耻骨联合上缘，前正中线旁开2.5寸处。",
                        "quickFind": "腹股沟动脉搏动处即是。",
                        "massage": "用中指指腹轻揉左右急脉，每次1~3分钟，可改善精力减退、腰腿寒冷。",
                        "xueweiName": "急脉",
                        "jingluoName": "足厥阴肝经",
                        "titleUrl": "急脉"
                    }
                },
                {
                    "seq": 13,
                    "xueweiName": "章门",
                    "xueweiCode": "zhangmen",
                    "position": {
                        "x": -0.141461,
                        "y": 1.189326,
                        "z": 0.032475
                    },
                    "xueweiDetail": {
                        "detailTitle": "章门：腹胀按之效如神",
                        "detailDescription": "章，同“障“”字；门，门户。穴在季肋下，如同屏障内脏之门户。",
                        "cure": "疏肝健脾，理气散结。主治腹痛、腹胀、口干、口苦、呕吐、打嗝、腹泻。",
                        "position": "在侧腹部，第11肋游离端的下际。",
                        "quickFind": "正坐，屈肘合腋，肘尖所指处，按压有酸胀感处即是。",
                        "massage": "腹痛、腹胀时用拇指指腹轻柔地按摩，一般持续3~5分钟，即可缓解。",
                        "xueweiName": "章门",
                        "jingluoName": "足厥阴肝经",
                        "titleUrl": "章门"
                    }
                },
                {
                    "seq": 14,
                    "xueweiName": "期门",
                    "xueweiCode": "qimen",
                    "position": {
                        "x": -0.103664,
                        "y": 1.258035,
                        "z": 0.095564
                    },
                    "xueweiDetail": {
                        "detailTitle": "期门：疏肝理气化瘀积",
                        "detailDescription": "期，周期；门，门户。两侧胁肋如敞开之门户。",
                        "cure": "疏肝健脾，理气活血。主治乳房胀痛、肋间神经痛、肝炎、抑郁症。",
                        "position": "在胸部，第6肋间隙，前正中线旁开4寸。",
                        "quickFind": "正坐或仰卧，自乳头垂直向下推2个肋间隙，按压有酸胀感处即是。",
                        "massage": "每天按揉期门2次，每次200下。可治各种妇科疾病和男科前列腺肥大。",
                        "xueweiName": "期门",
                        "jingluoName": "足厥阴肝经",
                        "titleUrl": "期门"
                    }
                }
            ]
        },
        {
            "jingMaiName": "督脉",
            "jingMaiCode": "dumai",
            "xueweiList": [
                {
                    "seq": 1,
                    "xueweiName": "长强",
                    "xueweiCode": "zhangqiang",
                    "position": {
                        "x": 0.002,
                        "y": 0.982266,
                        "z": -0.095906
                    },
                    "xueweiDetail": {
                        "detailTitle": "长强：治疗便秘与痔疮",
                        "detailDescription": "长，长短之长；强，强弱之强。肾为生命之源。脊柱长而强韧，穴在其下端。",
                        "cure": "宁神镇惊，通便消痔。主治腹泻、便秘、便血、痔疮、脱肛、女性阴道瘙痒、阴囊湿疹。",
                        "position": "在尾骨下方，尾骨端与肛门连线的中点处。",
                        "quickFind": "仰卧屈膝，在尾骨端下，尾骨端与肛门连线中点处即是。",
                        "massage": "正坐，上身前俯，一手伸到臀后，用中指用力揉按长强，每天早晚各揉按1~3分钟。可治疗便秘、痔疮、脱肛，并迅速止泻。",
                        "xueweiName": "长强",
                        "jingluoName": "督脉",
                        "titleUrl": "长强"
                    }
                },
                {
                    "seq": 2,
                    "xueweiName": "腰俞",
                    "xueweiCode": "yaoyu",
                    "position": {
                        "x": 0.002,
                        "y": 1.004716,
                        "z": -0.101732
                    },
                    "xueweiDetail": {
                        "detailTitle": "腰俞：咽喉腰痛不用怕",
                        "detailDescription": "腰，腰部；俞，输注。穴在腰部，是经气输注之处。",
                        "cure": "调经清热，散寒除湿。主治腹泻、便秘、痔疮、尾骶痛、月经不调。",
                        "position": "在髄区，正对髄管裂孔，后正中线上。",
                        "quickFind": "俯卧，后正中线上，顺着脊柱向下，正对骶管裂孔处即是。",
                        "massage": "正坐，一手伸到臀后，用中指用力揉按腰俞，每天早晚各揉按1~3分钟，可治腹泻等肠腑疾病，以及月经不调等。",
                        "xueweiName": "腰俞",
                        "jingluoName": "督脉",
                        "titleUrl": "腰俞"
                    }
                },
                {
                    "seq": 3,
                    "xueweiName": "腰阳关",
                    "xueweiCode": "yaoyangguan",
                    "position": {
                        "x": 0.002,
                        "y": 1.075198,
                        "z": -0.099404
                    },
                    "xueweiDetail": {
                        "detailTitle": "腰阳关：遗精阳痿不复返",
                        "detailDescription": "腰，腰部；阳，阴阳之阳；关，机关。督脉为阳。穴属督脉，位于腰部转动处，如腰之机关。",
                        "cure": "祛寒除湿，舒筋活络。主治腰骶痛、下肢痿痹、遗精、阳痿、月经不调。",
                        "position": "在腰部脊柱区，第4腰椎棘突下凹陷中，后正中线上。",
                        "quickFind": "两侧髂前上棘连线与脊柱交点处，可触及一凹陷处即是。",
                        "massage": "左手或右手握拳，以食指掌指关节突起部揉按腰阳关3~5分钟，可治腰膝酸痛、阳痿、早泄等。",
                        "xueweiName": "腰阳关",
                        "jingluoName": "督脉",
                        "titleUrl": "腰阳关"
                    }
                },
                {
                    "seq": 4,
                    "xueweiName": "命门",
                    "xueweiCode": "mingmen",
                    "position": {
                        "x": 0.002,
                        "y": 1.117115,
                        "z": -0.092508
                    },
                    "xueweiDetail": {
                        "detailTitle": "命门：强腰膝还补肾气",
                        "detailDescription": "命，生命；门，门户。肾为生命之源。穴在肾俞之间，相当于肾气出入之门户。",
                        "cure": "补肾壮阳。主治遗精、阳痿、不孕、腰脊强痛、下肢痿痹。",
                        "position": "在腰部脊柱区，第2腰椎棘突下凹陷中。",
                        "quickFind": "肚脐水平线与后正中线交点，按压有凹陷处即是。",
                        "massage": "每天按摩命门3分钟，可治疗阳痿、遗精、月经不调、四肢冷等疾病。",
                        "xueweiName": "命门",
                        "jingluoName": "督脉",
                        "titleUrl": "命门"
                    }
                },
                {
                    "seq": 5,
                    "xueweiName": "悬枢",
                    "xueweiCode": "xuanshu",
                    "position": {
                        "x": 0.002,
                        "y": 1.171105,
                        "z": -0.085784
                    },
                    "xueweiDetail": {
                        "detailTitle": "悬枢：腰脊强痛就按它",
                        "detailDescription": "悬，悬挂；枢，枢纽。穴在腰部，仰卧时局部悬起，是腰部活动的枢纽。",
                        "cure": "助阳健脾，通调肠气。主治遗精、阳痿、不孕、腰脊强痛、下肢痿痹。",
                        "position": "在腰部脊柱区，第1腰椎棘突下凹陷中，后正中线上。",
                        "quickFind": "从命门沿后正中线向上推一个椎体，其上缘凹陷处即是。",
                        "massage": "常按揉悬枢，可治腹胀、腹泻、消化不良、腰背部疼痛等胃肠疾病。",
                        "xueweiName": "悬枢",
                        "jingluoName": "督脉",
                        "titleUrl": "悬枢"
                    }
                },
                {
                    "seq": 6,
                    "xueweiName": "脊中",
                    "xueweiCode": "jizhong",
                    "position": {
                        "x": 0.002,
                        "y": 1.213022,
                        "z": -0.098642
                    },
                    "xueweiDetail": {
                        "detailTitle": "脊中：健脾利湿就找它",
                        "detailDescription": "脊，脊柱；中，中间。脊柱古作二十一椎；穴在第十一椎下，正当其中。",
                        "cure": "健脾利湿，宁神镇惊。主治腹泻、反胃、吐血、痢疾、痔疮、小儿疳积。",
                        "position": "在背部脊柱区，第11胸椎棘突下凹陷中，后正中线上。",
                        "quickFind": "两侧肩胛下角连线与后正中线相交处向下推4个椎体，其下缘凹陷处即是。",
                        "massage": "用拇指指腹常按揉脊中，可治腹胀、腹泻、痔疮、脱肛、便血等肠腑病症。",
                        "xueweiName": "脊中",
                        "jingluoName": "督脉",
                        "titleUrl": "脊中"
                    }
                },
                {
                    "seq": 7,
                    "xueweiName": "中枢",
                    "xueweiCode": "zhongshu",
                    "position": {
                        "x": 0.002,
                        "y": 1.254938,
                        "z": -0.114411
                    },
                    "xueweiDetail": {
                        "detailTitle": "中枢：健脾胃又促消化",
                        "detailDescription": "中，中间；枢，枢纽。穴在第10胸椎下，相当于脊柱中部之枢纽。",
                        "cure": "健脾利湿，清热止痛。主治呕吐、腹满、胃痛、食欲不振、腰背痛。",
                        "position": "在背部脊柱区，第10胸椎棘突下凹陷中，后正中线上。",
                        "quickFind": "两侧肩胛下角连线与后正中线相交处向下推3个椎体，其下缘凹陷处即是。",
                        "massage": "常按揉中枢穴，可治腰背疼痛、呕吐、腹胀、胃痛、食欲不振等脾胃疾病。",
                        "xueweiName": "中枢",
                        "jingluoName": "督脉",
                        "titleUrl": "中枢"
                    }
                },
                {
                    "seq": 8,
                    "xueweiName": "筋缩",
                    "xueweiCode": "jinsuo",
                    "position": {
                        "x": 0.002,
                        "y": 1.296855,
                        "z": -0.122724
                    },
                    "xueweiDetail": {
                        "detailTitle": "筋缩：善治筋脉拘挛病",
                        "detailDescription": "筋，筋肉；缩，挛缩。本穴能治筋肉挛缩诸病。",
                        "cure": "平肝熄风，宁神镇痉。主治抽搐、脊强、四肢不收、筋挛拘急。",
                        "position": "在背部脊柱区，第9胸椎棘突下凹陷中，后正中线上。",
                        "quickFind": "两侧肩胛下角连线与后正中线相交处向下推2个椎体，其下缘凹陷处即是。",
                        "massage": "经常点揉筋缩，可治腰椎间盘突出、筋脉拘挛、小儿抽动症、癫痫等症。",
                        "xueweiName": "筋缩",
                        "jingluoName": "督脉",
                        "titleUrl": "筋缩"
                    }
                },
                {
                    "seq": 9,
                    "xueweiName": "至阳",
                    "xueweiCode": "zhiyang",
                    "position": {
                        "x": 0.002,
                        "y": 1.339816,
                        "z": -0.130085
                    },
                    "xueweiDetail": {
                        "detailTitle": "至阳：快速止痛有绝招",
                        "detailDescription": "至，到达；阳，阴阳之阳。本穴与横膈平。经气至此从膈下的阳中之阴到达膈上的阳中之阳。",
                        "cure": "利胆退黄，宽胸利膈。主治胃痛、胸胁胀痛、黄疸、腰背疼痛、心悸。",
                        "position": "在背部脊柱区，第7胸椎棘突下凹陷中，后正中线上。",
                        "quickFind": "两侧肩胛下角连线与后正中线相交处椎体，其下缘凹陷处即是。",
                        "massage": "用按摩槌敲打刺激至阳，每次3~5分钟，可即时缓解心绞痛、胃痛和腹痛症状。",
                        "xueweiName": "至阳",
                        "jingluoName": "督脉",
                        "titleUrl": "至阳"
                    }
                },
                {
                    "seq": 10,
                    "xueweiName": "灵台",
                    "xueweiCode": "lingtai",
                    "position": {
                        "x": 0.002,
                        "y": 1.380689,
                        "z": -0.130085
                    },
                    "xueweiDetail": {
                        "detailTitle": "灵台：忧郁失眠养心穴",
                        "detailDescription": "灵，神灵；台，亭台。穴在神道与心俞两穴之下，故喻为心灵之台。",
                        "cure": "清热化湿，止咳定喘。主治咳嗽、气喘、颈项僵硬、背痛、忧郁、失眠。",
                        "position": "在背部脊柱区，第6胸椎棘突下凹陷中，后正中线上。",
                        "quickFind": "两侧肩胛下角连线与后正中线相交处向上推1个椎体，其下缘凹陷处即是。",
                        "massage": "经常用按摩槌，在灵台处轻轻敲打，可以提高睡眠质量。",
                        "xueweiName": "灵台",
                        "jingluoName": "督脉",
                        "titleUrl": "灵台"
                    }
                },
                {
                    "seq": 11,
                    "xueweiName": "神道",
                    "xueweiCode": "shendao",
                    "position": {
                        "x": 0.002,
                        "y": 1.422605,
                        "z": -0.128704
                    },
                    "xueweiDetail": {
                        "detailTitle": "神道：帮助缓解心绞痛",
                        "detailDescription": "神，心神；道，通道。心藏神，穴在心俞旁，如同心神之通道。",
                        "cure": "宁神安心，清热平喘。主治失眠、肩背痛、小儿惊风、咳嗽、神经衰弱。",
                        "position": "在背部脊柱区，第5胸椎棘突下凹陷中，后正中线上。",
                        "quickFind": "两侧肩胛下角连线与后正中线相交处向上推2个椎体，其下缘凹陷处即是。",
                        "massage": "用双手中指指腹互相叠加，用力揉按神道3~5分钟，可缓解心脏供血不足，治疗心绞痛、心脏不适。",
                        "xueweiName": "神道",
                        "jingluoName": "督脉",
                        "titleUrl": "神道"
                    }
                },
                {
                    "seq": 12,
                    "xueweiName": "身柱",
                    "xueweiCode": "shenzhu",
                    "position": {
                        "x": 0.002,
                        "y": 1.464522,
                        "z": -0.114324
                    },
                    "xueweiDetail": {
                        "detailTitle": "身柱：治疗咳嗽和气喘",
                        "detailDescription": "身，身体；柱，支柱。穴在第3胸椎下，上连头项，下通背腰，如一身之支柱。",
                        "cure": "宣肺清热，宁神镇咳。主治咳嗽、气喘、腰脊强痛、神经衰弱、牛皮癣。",
                        "position": "在上背部脊柱区，第3胸椎棘突下凹陷中，后正中线上。",
                        "quickFind": "两侧肩胛骨内侧角连线与后正中线相交处椎体，其下缘凹陷处即是。",
                        "massage": "用中指指尖揉按身柱，有剌痛感为宜，每次揉按3~5分钟，可治气喘、感冒、咳嗽、肺结核，以及因咳嗽导致的肩背疼痛等疾病；常按揉捶击此穴，可保健强身。",
                        "xueweiName": "身柱",
                        "jingluoName": "督脉",
                        "titleUrl": "身柱"
                    }
                },
                {
                    "seq": 13,
                    "xueweiName": "陶道",
                    "xueweiCode": "taodao",
                    "position": {
                        "x": 0.002,
                        "y": 1.506438,
                        "z": -0.101291
                    },
                    "xueweiDetail": {
                        "detailTitle": "陶道：常按可愉悦身心",
                        "detailDescription": "陶，陶冶；道，通道。比喻脏腑之气汇聚于督脉，由此路上升。",
                        "cure": "解表清热，截虐宁神。主治头痛、目眩、闭经、寻麻疹、精神病。",
                        "position": "在项背部脊柱区，第1胸椎棘突下凹陷中，后正中线上。",
                        "quickFind": "低头，颈背交界椎骨高突处垂直向下推1个椎体，其下缘凹陷处即是。",
                        "massage": "陶道是一个能让人快乐的穴位，常按可使人心情安静踏实，精神得到愉悅。",
                        "xueweiName": "陶道",
                        "jingluoName": "督脉",
                        "titleUrl": "陶道"
                    }
                },
                {
                    "seq": 14,
                    "xueweiName": "大椎",
                    "xueweiCode": "dazhui",
                    "position": {
                        "x": 0.002,
                        "y": 1.548142,
                        "z": -0.090382
                    },
                    "xueweiDetail": {
                        "detailTitle": "大椎：感冒清热找大椎",
                        "detailDescription": "大，巨大；椎，椎骨。古称第一胸椎棘突为大椎，穴适在其上方，故名。",
                        "cure": "清热解表，截虐止痫。主治感冒发热、手足怕冷、颈椎病、扁桃体炎、痤疮。",
                        "position": "在项背部脊柱区，第7颈椎棘突下凹陷中，后正中线上。",
                        "quickFind": "低头，颈背交界椎骨高突处椎体，其下缘凹陷处即是。",
                        "massage": "按揉大椎，可治颈项疼痛，在大椎拔罐20~30分钟，可治感冒、头痛、咳嗽、气喘。",
                        "xueweiName": "大椎",
                        "jingluoName": "督脉",
                        "titleUrl": "大椎"
                    }
                },
                {
                    "seq": 15,
                    "xueweiName": "哑门",
                    "xueweiCode": "yamen",
                    "position": {
                        "x": 0.002,
                        "y": 1.620257,
                        "z": -0.076825
                    },
                    "xueweiDetail": {
                        "detailTitle": "哑门：声音沙哑不苦恼",
                        "detailDescription": "哑，音哑；门，门户。本穴深刺可以致哑，也可治哑，故比喻为音哑的门户。",
                        "cure": "散风熄风，开窍醒神。主治舌缓不语、重舌、失语、大脑发育不全。",
                        "position": "在项后，第2颈椎棘突上际凹陷中，后正中线上。",
                        "quickFind": "沿脊柱向上，入后发际上半横指处即是。",
                        "massage": "哑门特殊，若按摩方法不对，不但治不了病，反而会致失声，所以按摩时要谨慎。",
                        "xueweiName": "哑门",
                        "jingluoName": "督脉",
                        "titleUrl": "哑门"
                    }
                },
                {
                    "seq": 16,
                    "xueweiName": "风府",
                    "xueweiCode": "fengfu",
                    "position": {
                        "x": 0.002,
                        "y": 1.644996,
                        "z": -0.080443
                    },
                    "xueweiDetail": {
                        "detailTitle": "风府：感冒及时擦风府",
                        "detailDescription": "风，风邪；府，处所。本穴为治风邪之处。",
                        "cure": "散风熄风，通关开窍。主治感冒、颈项强痛、眩晕、咽喉肿痛、中风。",
                        "position": "在颈后区，枕外隆突直下，两侧斜方肌之间凹陷中。",
                        "quickFind": "沿脊柱向上，入后发际上1横指处即是。",
                        "massage": "双手拇指指尖相互叠加向下，用指腹揉按风府，有酸痛、胀麻的感觉。每次揉按1~3分钟，可治风邪而致伤风感冒、发热、鼻塞等疾病。",
                        "xueweiName": "风府",
                        "jingluoName": "督脉",
                        "titleUrl": "风府"
                    }
                },
                {
                    "seq": 17,
                    "xueweiName": "脑户",
                    "xueweiCode": "naohu",
                    "position": {
                        "x": 0.002,
                        "y": 1.698597,
                        "z": -0.099801
                    },
                    "xueweiDetail": {
                        "detailTitle": "脑户：头痛按之可减轻",
                        "detailDescription": "脑，脑髓；户，门户。督脉循脊上行入脑。穴在枕部，相当于脉气入脑的门户。",
                        "cure": "醒神开窍，平肝熄风。主治癫狂、痫症、眩晕、头重、头痛、颈项僵硬。",
                        "position": "在头部正中线上，枕外隆凸的上缘凹陷中。",
                        "quickFind": "正坐或俯卧，在后正中线上，枕外粗隆上缘的凹陷处。",
                        "massage": "揉按脑户3~5分钟，可有效缓解工作或心理压力引起的头痛。",
                        "xueweiName": "脑户",
                        "jingluoName": "督脉",
                        "titleUrl": "脑户"
                    }
                },
                {
                    "seq": 18,
                    "xueweiName": "强间",
                    "xueweiCode": "qiangjian",
                    "position": {
                        "x": 0.002,
                        "y": 1.740146,
                        "z": -0.102087
                    },
                    "xueweiDetail": {
                        "detailTitle": "强间：让你睡好心情好",
                        "detailDescription": "强，强硬；间，中间。穴当顶骨与枕骨结合之中间，能治头项强痛。",
                        "cure": "醒神宁心，平肝熄风。主治头痛、颈项强不得回顾、目眩、口㖞、痫症。",
                        "position": "在头部正中线上，后发际正中直上4寸。",
                        "quickFind": "百会与风府连线的中点。",
                        "massage": "用中指指腹揉按强间，每次1~3分钟。可治头痛、目眩、颈项强痛等。",
                        "xueweiName": "强间",
                        "jingluoName": "督脉",
                        "titleUrl": "强间"
                    }
                },
                {
                    "seq": 19,
                    "xueweiName": "后顶",
                    "xueweiCode": "houding",
                    "position": {
                        "x": 0.002,
                        "y": 1.766563,
                        "z": -0.095182
                    },
                    "xueweiDetail": {
                        "detailTitle": "后顶：头痛眩晕就按它",
                        "detailDescription": "后，后方；顶，头顶。穴在头顶之后方。",
                        "cure": "醒神安神，熄风止痉。主治颈项僵硬、头痛、眩晕、心烦、失眠。",
                        "position": "在头部正中线上，后发际正中直上5.5寸。",
                        "quickFind": "正坐或俯卧，在后正中线上，前、后发际之间的中点。",
                        "massage": "用拇指指腹垂直揉按后顶，每天早晚各1次，可治头痛、眩晕、耳鸣等。",
                        "xueweiName": "后顶",
                        "jingluoName": "督脉",
                        "titleUrl": "后顶"
                    }
                },
                {
                    "seq": 20,
                    "xueweiName": "百会",
                    "xueweiCode": "baihui",
                    "position": {
                        "x": 0.002,
                        "y": 1.811767,
                        "z": -0.039322
                    },
                    "xueweiDetail": {
                        "detailTitle": "百会：长命百岁保健穴",
                        "detailDescription": "百，多的意思；会，交会。百会是足三阳经、肝经和督脉等多经之交会处。",
                        "cure": "熄风醒脑，升阳固脱。主治中风、惊悸、头痛、头晕、失眠、健忘、耳鸣、眩晕、脱肛、痔疮、低血压。",
                        "position": "在头部正中线上，前发际正中直上5寸。",
                        "quickFind": "正坐，两耳尖与头正中线相交处，按压有凹陷。",
                        "massage": "两手中指叠压，按百会3分钟，长期坚持，可使人开慧增智、益寿延年。",
                        "xueweiName": "百会",
                        "jingluoName": "督脉",
                        "titleUrl": "百会"
                    }
                },
                {
                    "seq": 21,
                    "xueweiName": "前顶",
                    "xueweiCode": "qianding",
                    "position": {
                        "x": 0,
                        "y": 1.815537,
                        "z": -0.006116
                    },
                    "xueweiDetail": {
                        "detailTitle": "前顶：头晕就要按前顶",
                        "detailDescription": "前，前方；顶，头顶。穴在头顶直前方。",
                        "cure": "熄风醒脑，宁神镇静。主治癫痫、小儿惊风、头痛、头晕。",
                        "position": "在头部正中线上，前发际正中直上3.5寸。",
                        "quickFind": "正坐，由百会向前2横指即是。",
                        "massage": "用双手中指交叠用力向下按揉3~5分钟，有酸胀感，可缓解头痛症状。",
                        "xueweiName": "前顶",
                        "jingluoName": "督脉",
                        "titleUrl": "前顶"
                    }
                },
                {
                    "seq": 22,
                    "xueweiName": "囟会",
                    "xueweiCode": "xinhui",
                    "position": {
                        "x": 0,
                        "y": 1.808362,
                        "z": 0.036532
                    },
                    "xueweiDetail": {
                        "detailTitle": "囟会：头痛鼻塞不见了",
                        "detailDescription": "囟门，囟门；会，在此作“闭合”讲。穴当大囟门的闭合处。",
                        "cure": "安神醒脑，清热消肿。主治头痛、鼻塞、目眩、心悸、面肿、鼻塞。",
                        "position": "在头部，正中线上，前发际正中直上2寸。",
                        "quickFind": "正坐，从前发际正中直上3横指处即是。",
                        "massage": "每天早晚各揉按囟会1次，每次1~3分钟，可改善和治疗头痛、眩晕、癫痫、鼻窦炎等疾病。",
                        "xueweiName": "囟会",
                        "jingluoName": "督脉",
                        "titleUrl": "囟会"
                    }
                },
                {
                    "seq": 23,
                    "xueweiName": "上星",
                    "xueweiCode": "shangxing",
                    "position": {
                        "x": 0,
                        "y": 1.795817,
                        "z": 0.060268
                    },
                    "xueweiDetail": {
                        "detailTitle": "上星：有效缓解眼疲劳",
                        "detailDescription": "上，上方；星，星球。人头像天，穴在头上，如星在天。",
                        "cure": "熄风清热，宁神通鼻。主治头痛、眩晕、目赤肿痛、鼻出血、鼻痛、眼疲劳。",
                        "position": "在头部，正中线上，前发际正中直上1寸。",
                        "quickFind": "正坐，前发际正中直上1横指处即是。",
                        "massage": "用拇指指腹垂直向下压按上星，每次1~3分钟。可治各种头痛、头晕、目眩、目赤疼痛以及鼻窦炎、鼻出血等疾病。",
                        "xueweiName": "上星",
                        "jingluoName": "督脉",
                        "titleUrl": "上星"
                    }
                },
                {
                    "seq": 24,
                    "xueweiName": "神庭",
                    "xueweiCode": "shenting",
                    "position": {
                        "x": 0,
                        "y": 1.781059,
                        "z": 0.075118
                    },
                    "xueweiDetail": {
                        "detailTitle": "神庭：头昏呕吐不怕了",
                        "detailDescription": "神，神明；庭，前庭。脑为元神之府，神在此指脑。穴在前额部，如脑室之前庭。",
                        "cure": "宁神醒脑，降逆平喘。主治失眠、头晕、目眩、鼻塞、流泪、目赤肿痛。",
                        "position": "在头部，正中线上，前发际正中直上0.5寸。",
                        "quickFind": "正坐，从前发际正中直上1横指，拇指指甲中点处即是。",
                        "massage": "用中指指尖掐按神庭，每次3~5分钟，可缓解和调理由重感冒或晕车、晕船引起的头昏、呕吐等症状。",
                        "xueweiName": "神庭",
                        "jingluoName": "督脉",
                        "titleUrl": "神庭"
                    }
                },
                {
                    "seq": 25,
                    "xueweiName": "印堂",
                    "xueweiCode": "yintang",
                    "position": {
                        "x": 0,
                        "y": 1.721564,
                        "z": 0.094834
                    },
                    "xueweiDetail": {
                        "detailTitle": "印堂：提神醒脑找印堂",
                        "detailDescription": "印，泛指图章；堂，厅堂。古代指额部两眉头之间为“阙”，星相家称之为印堂，穴位在其上，故名。",
                        "cure": "清头明目，通鼻开窍。失眠、头痛、眩晕、过敏性鼻炎、三叉神经痛。",
                        "position": "在头部，两眉毛内侧端中间的凹陷中。",
                        "quickFind": "两眉头连线中点处即是。",
                        "massage": "若头痛、失眠、血压升高时，印堂就会晦暗，这时可以用中指指腹点按印堂3~5分钟，不适感觉就会得到缓解。",
                        "xueweiName": "印堂",
                        "jingluoName": "督脉",
                        "titleUrl": "印堂"
                    }
                },
                {
                    "seq": 26,
                    "xueweiName": "素髎",
                    "xueweiCode": "suliao",
                    "position": {
                        "x": 0,
                        "y": 1.668075,
                        "z": 0.115527
                    },
                    "xueweiDetail": {
                        "detailTitle": "素髎：昏迷急救马上按",
                        "detailDescription": "素，鼻茎；缪，骨隙。穴在鼻茎下端的骨隙中。",
                        "cure": "清热消肿，通利鼻窍。主治惊风、昏迷、鼻塞、低血压、休克、小儿惊风。",
                        "position": "在面部，鼻尖的正中央。",
                        "quickFind": "正坐或仰卧，面部鼻尖正中央即是。",
                        "massage": "遇到有人因为血压下降而引发休克或者呼吸困难时，可立刻掐按病人素髎，直到症状有所缓和。",
                        "xueweiName": "素髎",
                        "jingluoName": "督脉",
                        "titleUrl": "素髎"
                    }
                },
                {
                    "seq": 27,
                    "xueweiName": "水沟",
                    "xueweiCode": "shuigou",
                    "position": {
                        "x": 0,
                        "y": 1.648449,
                        "z": 0.100031
                    },
                    "xueweiDetail": {
                        "detailTitle": "水沟：人体急救保命穴",
                        "detailDescription": "水，水液；沟，沟渠。穴在人中沟中，人中沟形似水沟。",
                        "cure": "醒神开窍，清热熄风。主治晕厥、中暑、惊风、面肿、腰脊强痛。",
                        "position": "在面部，人中沟的上1/3与中1/3交点处。",
                        "quickFind": "仰卧，面部人中沟上1/3处即是。",
                        "massage": "掐水沟（人中），是最常用的急救措施。具体方法是：每分钟掐压人中20~40次，每次持续0.5~1秒。一般病人会很快苏醒，病情较重患者要立刻送医院。",
                        "xueweiName": "水沟",
                        "jingluoName": "督脉",
                        "titleUrl": "水沟"
                    }
                },
                {
                    "seq": 28,
                    "xueweiName": "兑端",
                    "xueweiCode": "duiduan",
                    "position": {
                        "x": 0,
                        "y": 1.64066,
                        "z": 0.10415
                    },
                    "xueweiDetail": {
                        "detailTitle": "兑端：牙痛鼻塞就找它",
                        "detailDescription": "兑，指口；端，尖端。穴在口的上唇尖端。",
                        "cure": "宁神醒脑，生津止渴。主治昏迷、牙痛、齿龈痛、鼻塞。",
                        "position": "在面部，上唇结节的中点。",
                        "quickFind": "仰卧，面部人中沟下端的皮肤与上唇的交界处即是。",
                        "massage": "齿龈痛、鼻塞时，可用食指指腹揉按兑端，有很好的缓解和调理作用。",
                        "xueweiName": "兑端",
                        "jingluoName": "督脉",
                        "titleUrl": "兑端"
                    }
                },
                {
                    "seq": 29,
                    "xueweiName": "龈交",
                    "xueweiCode": "yinjiao",
                    "position": {
                        "x": 0,
                        "y": 0,
                        "z": 0
                    },
                    "xueweiDetail": {
                        "detailTitle": "龈交：治疗急性腰扭伤",
                        "detailDescription": "龈，齿龈；交，交会。上齿龈中缝，为督脉和任脉的交会处。",
                        "cure": "宁神镇痉，清热消肿。主治小儿面疮、鼻塞、鼻息肉、癫狂、心烦。",
                        "position": "在上唇内，上唇系带与上牙龈的交点。",
                        "quickFind": "唇内的正中线上，上唇系带与上牙龈相接处即是。",
                        "massage": "每天用舌头向上唇内侧顶，可刺激到龈交穴，有促进身体水分循环，预防下半身水肿的作用。",
                        "xueweiName": "龈交",
                        "jingluoName": "督脉",
                        "titleUrl": "龈交"
                    }
                }
            ]
        },
        {
            "jingMaiName": "任脉",
            "jingMaiCode": "renmai",
            "xueweiList": [
                {
                    "seq": 1,
                    "xueweiName": "会阴",
                    "xueweiCode": "huiyin",
                    "position": {
                        "x": 0,
                        "y": 0.88326,
                        "z": 0.028896
                    },
                    "xueweiDetail": {
                        "detailTitle": "会阴：生殖疾病按之效",
                        "detailDescription": "会，交会；阴，在此指下部两阴窍。两阴之间名会阴，穴当其中。",
                        "cure": "醒神镇惊，通调二阴。主治阴痒、阴痛、便秘、闭经、昏迷。",
                        "position": "在会阴部。男性在阴囊根部与肛门连线的中点，女性在大阴唇后联合与肛门连线的中点。",
                        "quickFind": "仰卧屈膝，在会阴部，取两阴连线的中点即是。",
                        "massage": "用中指指腹揉按会阴1~3分钟，有酸胀感为宜。可调理男性生殖器官疾病。",
                        "xueweiName": "会阴",
                        "jingluoName": "任脉",
                        "titleUrl": "会阴"
                    }
                },
                {
                    "seq": 2,
                    "xueweiName": "曲骨",
                    "xueweiCode": "qugu",
                    "position": {
                        "x": 0,
                        "y": 0.946668,
                        "z": 0.11122
                    },
                    "xueweiDetail": {
                        "detailTitle": "曲骨：畅通小便按按它",
                        "detailDescription": "曲，弯曲；骨，骨头。曲骨，指耻骨，穴在耻骨联合上缘。",
                        "cure": "调经止带，通利小便。主治遗精、阳痿、前列腺炎、月经不调、痛经。",
                        "position": "在下腹部，耻骨联合上缘，前正中线上。",
                        "quickFind": "在下腹部，正中线上，从下腹部向下摸到一横着走行的骨性标志上缘。",
                        "massage": "中指指腹揉按曲骨3~5分钟，可治疗和调理小便不利、月经不调等疾病。",
                        "xueweiName": "曲骨",
                        "jingluoName": "任脉",
                        "titleUrl": "曲骨"
                    }
                },
                {
                    "seq": 3,
                    "xueweiName": "中极",
                    "xueweiCode": "zhongji",
                    "position": {
                        "x": 0,
                        "y": 0.977896,
                        "z": 0.11122
                    },
                    "xueweiDetail": {
                        "detailTitle": "中极：解除尿频与尿痛",
                        "detailDescription": "中，中间；极，正是。穴位正是在人体上下左右之中间。",
                        "cure": "益肾通经。主治尿频、遗精、月经不调、痛经、前列腺炎、夜尿症。",
                        "position": "在下腹部，脐中下4寸，前正中线上。",
                        "quickFind": "在下腹部，正中线上，耻骨联合上缘1横指处即是。",
                        "massage": "中指指腹揉按中极，每次1〜3分钟，对男女性生殖系统有保健作用。",
                        "xueweiName": "中极",
                        "jingluoName": "任脉",
                        "titleUrl": "中极"
                    }
                },
                {
                    "seq": 4,
                    "xueweiName": "关元",
                    "xueweiCode": "guanyuan",
                    "position": {
                        "x": 0,
                        "y": 1.00858,
                        "z": 0.115212
                    },
                    "xueweiDetail": {
                        "detailTitle": "关元：性保健第一要穴",
                        "detailDescription": "关，关藏；元，元气。穴在脐下3寸，为关藏人身元气之处。",
                        "cure": "培肾固本，调气回阳。主治虚胖浮肿、月经不调、痛经、遗精、阳痿、不孕不育、小儿发热、白带过多、肠胃疾病、脂肪肝。",
                        "position": "在下腹部，脐中下3寸，前正中线上。",
                        "quickFind": "在下腹部，正中线上，肚脐中央向下4横指处即是。",
                        "massage": "先将手掌温热，敷在穴位上，再指压关元，可增加刺激时的舒适感，常摩揉关元，也可益肾壮阳。",
                        "xueweiName": "关元",
                        "jingluoName": "任脉",
                        "titleUrl": "关元"
                    }
                },
                {
                    "seq": 5,
                    "xueweiName": "石门",
                    "xueweiCode": "shimen",
                    "position": {
                        "x": 0,
                        "y": 1.043715,
                        "z": 0.122296
                    },
                    "xueweiDetail": {
                        "detailTitle": "石门：治疗水肿就热敷",
                        "detailDescription": "石，岩石；门，门户。石有坚实之意。本穴能治下腹坚实之证。",
                        "cure": "理气止痛，通利水道。主治闭经、带下、小腹绞痛、水肿、小便不利。",
                        "position": "在下腹部，当脐中下2寸，前正中线上。",
                        "quickFind": "在下腹部，正中线上，肚脐中央向下3横指处即是。",
                        "massage": "对于女性来说，石门不太适宜指压，也最好不要灸，可能引起不孕。可用蘸上姜汁的热毛巾热敷。",
                        "xueweiName": "石门",
                        "jingluoName": "任脉",
                        "titleUrl": "石门"
                    }
                },
                {
                    "seq": 6,
                    "xueweiName": "气海",
                    "xueweiCode": "qihai",
                    "position": {
                        "x": 0,
                        "y": 1.061062,
                        "z": 0.123634
                    },
                    "xueweiDetail": {
                        "detailTitle": "气海：任脉之补虚要穴",
                        "detailDescription": "气，元气；海，海洋。穴在脐下，为人体元气之海。",
                        "cure": "益气助阳，调经固经。主治小腹疾病、肠胃疾病、虚证、遗精。",
                        "position": "在下腹部，脐中下1.5寸，前正中线上。",
                        "quickFind": "在下腹部，正中线上，肚脐中央向下与关元之间的中点处即是。",
                        "massage": "常按揉气海，可补气；用艾条温和灸气海，每次10〜15分钟，可治月经不调、痛经、腹泻、消化不良等。",
                        "xueweiName": "气海",
                        "jingluoName": "任脉",
                        "titleUrl": "气海"
                    }
                },
                {
                    "seq": 7,
                    "xueweiName": "阴交",
                    "xueweiCode": "yinjiao",
                    "position": {
                        "x": 0,
                        "y": 1.077212,
                        "z": 0.124362
                    },
                    "xueweiDetail": {
                        "detailTitle": "阴交：腹泻不止揉阴交",
                        "detailDescription": "阴，阴阳之阴；交，交会。穴在脐下1寸，为任脉、冲脉和肾经交会处。",
                        "cure": "调经固带，利水消肿。主治阴部多汗湿痒、月经不调、血崩、带下。",
                        "position": "在下腹部，脐中下1寸，前正中线上。",
                        "quickFind": "在下腹部，正中线上，肚脐中央向下1横指处即是。",
                        "massage": "腹泻、腹胀时，用中指指腹轻揉阴交3~5分钟，不适就会减轻。",
                        "xueweiName": "阴交",
                        "jingluoName": "任脉",
                        "titleUrl": "阴交"
                    }
                },
                {
                    "seq": 8,
                    "xueweiName": "神阙",
                    "xueweiCode": "shenque",
                    "position": {
                        "x": 0,
                        "y": 1.114179,
                        "z": 0.12141
                    },
                    "xueweiDetail": {
                        "detailTitle": "神阙：睡前按之补亏虚",
                        "detailDescription": "神，神气；阙，宫门。穴在脐中。脐为胎儿气血运行之要道，如神气出入之宫门。",
                        "cure": "温阳救逆，利水固脱。主治腹泻、腹胀、月经不调、崩漏、遗精、不孕、小儿腹泻。",
                        "position": "在脐区，脐中央。",
                        "quickFind": "在脐区，肚脐中央即是。",
                        "massage": "经常揉脐，可防治小儿腹泻、疳积等；突然大汗淋漓、唇舌苍白、手脚冰冷之虚脱症，马上温灸神阙可起到急救作用。",
                        "xueweiName": "神阙",
                        "jingluoName": "任脉",
                        "titleUrl": "神阙"
                    }
                },
                {
                    "seq": 9,
                    "xueweiName": "水分",
                    "xueweiCode": "shuifen",
                    "position": {
                        "x": 0,
                        "y": 1.143838,
                        "z": 0.114369
                    },
                    "xueweiDetail": {
                        "detailTitle": "水分：水肿腹水常按它",
                        "detailDescription": "水，水谷；分，分别。穴在脐上1寸，内应小肠，水谷至此分别清浊。",
                        "cure": "通调水道，理气止痛。主治水肿、腹泻、腹痛、绕脐痛、肠鸣。",
                        "position": "在上腹部，脐中上1寸，前正中线上。",
                        "quickFind": "在上腹部，肚脐中央向上1横指处。",
                        "massage": "水肿、腹水时用食指揉按腹部的水分，按至有热感为止。",
                        "xueweiName": "水分",
                        "jingluoName": "任脉",
                        "titleUrl": "水分"
                    }
                },
                {
                    "seq": 10,
                    "xueweiName": "下脘",
                    "xueweiCode": "xiawan",
                    "position": {
                        "x": 0,
                        "y": 1.172877,
                        "z": 0.116335
                    },
                    "xueweiDetail": {
                        "detailTitle": "下脘：水肿腹水常按它",
                        "detailDescription": "下，下方；脫，胃脱。穴当胃腕之下部。",
                        "cure": "健脾和胃，降逆止呕。主治胃痛、腹痛、腹胀、呕吐、打嗝、腹泻。",
                        "position": "在上腹部，脐中上2寸，前正中线上。",
                        "quickFind": "在上腹部，正中线上，肚脐中央向上3横指处即是。",
                        "massage": "按摩时以手掌按揉下脱50~100次，对缓解腹痛，治疗消化不良、呕吐十分有效。",
                        "xueweiName": "下脘",
                        "jingluoName": "任脉",
                        "titleUrl": "下脘"
                    }
                },
                {
                    "seq": 11,
                    "xueweiName": "建里",
                    "xueweiCode": "jianli",
                    "position": {
                        "x": 0,
                        "y": 1.201917,
                        "z": 0.114102
                    },
                    "xueweiDetail": {
                        "detailTitle": "建里：体虚之人温补药",
                        "detailDescription": "建，建立；里，里部。当胃院部，有助于建立中焦里气。",
                        "cure": "和胃健脾，通降腑气。主治胃痛、呕吐、食欲不振、肠中切痛。",
                        "position": "在上腹部，脐中上3寸，前正中线上。",
                        "quickFind": "在上腹部，正中线上，肚脐中央向上4横指处即是。",
                        "massage": "按压揉摩建里，常用来治疗胃痛、食欲不振、腹痛等病。",
                        "xueweiName": "建里",
                        "jingluoName": "任脉",
                        "titleUrl": "建里"
                    }
                },
                {
                    "seq": 12,
                    "xueweiName": "中脘",
                    "xueweiCode": "zhongwan",
                    "position": {
                        "x": 0,
                        "y": 1.230956,
                        "z": 0.11142
                    },
                    "xueweiDetail": {
                        "detailTitle": "中脘：胃痛呕吐有奇效",
                        "detailDescription": "中，中间；脱，胃脱。穴当胃脱之中部。",
                        "cure": "和胃降逆，健脾利水。主治胃痛、小儿厌食、呕吐、高血压、急性肠胃炎、脂肪肝。",
                        "position": "在上腹部，脐中上4寸，前正中线上。",
                        "quickFind": "在上腹部，肚脐与胸剑联合连线的中点处。",
                        "massage": "在中脘或摩或按，可治疗胃痛、呕吐等症。",
                        "xueweiName": "中脘",
                        "jingluoName": "任脉",
                        "titleUrl": "中脘"
                    }
                },
                {
                    "seq": 13,
                    "xueweiName": "上脘",
                    "xueweiCode": "shangwan",
                    "position": {
                        "x": 0,
                        "y": 1.259996,
                        "z": 0.109271
                    },
                    "xueweiDetail": {
                        "detailTitle": "上脘：增加你的胃动力",
                        "detailDescription": "上，上方；脘，胃皖。穴当胃脘之上部。",
                        "cure": "和胃降逆，化痰宁神。主治胃痛、呕吐、打嗝、纳呆、痢疾。",
                        "position": "在上腹部，脐中上5寸，前正中线上。",
                        "quickFind": "在上腹部，中皖上1横指处。",
                        "massage": "因吃得太快、吃得太饱，或者其他原因而引起胃胀、呕吐、打嗝等症状时，用拇指指腹揉按上腕3〜5分钟，可有效缓解不适。",
                        "xueweiName": "上脘",
                        "jingluoName": "任脉",
                        "titleUrl": "上脘"
                    }
                },
                {
                    "seq": 14,
                    "xueweiName": "巨阙",
                    "xueweiCode": "juque",
                    "position": {
                        "x": 0,
                        "y": 1.289035,
                        "z": 0.110022
                    },
                    "xueweiDetail": {
                        "detailTitle": "巨阙：治胃下垂有良效",
                        "detailDescription": "巨，巨大；阙，宫门。此为心之募穴，如心气出入的大门",
                        "cure": "安神宁心，宽胸止痛。主治胃痛、心痛、腹胀、脚气、急性肠胃炎。",
                        "position": "在上腹部，脐中上6寸，前正中线上。",
                        "quickFind": "在上腹部，正中线上，中脘与胸剑联合之间的中点处即是。",
                        "massage": "按揉巨阙善治胃下垂，亦可用艾灸法，每次5~10分钟。",
                        "xueweiName": "巨阙",
                        "jingluoName": "任脉",
                        "titleUrl": "巨阙"
                    }
                },
                {
                    "seq": 15,
                    "xueweiName": "鸠尾",
                    "xueweiCode": "jiuwei",
                    "position": {
                        "x": 0,
                        "y": 1.318074,
                        "z": 0.106826
                    },
                    "xueweiDetail": {
                        "detailTitle": "鸠尾：皮肤干燥不用愁",
                        "detailDescription": "鸠，鸠鸟；尾，尾巴。胸骨剑突形如鸠鸟之尾，穴在其下。",
                        "cure": "安心宁神，宽胸定喘。主治咽喉肿痛、偏头痛、哮喘、呕吐、胃痛。",
                        "position": "在上腹部，胸剑结合部下1寸，前正中线上。",
                        "quickFind": "从胸剑结合部沿前正中线直下1横指处即是。",
                        "massage": "经常用四指叩击鸠尾，可使皮肤富有光泽，气色饱满，精神充沛。",
                        "xueweiName": "鸠尾",
                        "jingluoName": "任脉",
                        "titleUrl": "鸠尾"
                    }
                },
                {
                    "seq": 16,
                    "xueweiName": "中庭",
                    "xueweiCode": "zhongting",
                    "position": {
                        "x": 0,
                        "y": 1.346015,
                        "z": 0.101233
                    },
                    "xueweiDetail": {
                        "detailTitle": "中庭：胸满呕吐就找它",
                        "detailDescription": "中，中间；庭，庭院。穴在心下，犹如在宫殿前的庭院之中。",
                        "cure": "宽胸消胀，降逆止呕。主治心痛、胸满、噎嗝、呕吐、小儿吐乳。",
                        "position": "在胸部，胸剑结合中点处，前正中线上。",
                        "quickFind": "在胸部，由锁骨往下数第5肋间，平第5肋间，当前正中线上即是。",
                        "massage": "由上向下推中庭100次，可治疗胸腹胀满、呕吐、噎嗝等胃气上逆病症。",
                        "xueweiName": "中庭",
                        "jingluoName": "任脉",
                        "titleUrl": "中庭"
                    }
                },
                {
                    "seq": 17,
                    "xueweiName": "膻中",
                    "xueweiCode": "shanzhong",
                    "position": {
                        "x": 0,
                        "y": 1.36778,
                        "z": 0.096887
                    },
                    "xueweiDetail": {
                        "detailTitle": "膻中：乳汁不足就灸它",
                        "detailDescription": "膻，袒露；中，中间。胸部袒露出的中间部位古称膻中，穴当其处。",
                        "cure": "理气止痛，生津增液。主治胸闷、气短、气管炎、咳喘、呕吐、更年期综合征、产妇乳少、乳房胀痛、小儿咳嗽。",
                        "position": "在胸部，横平第4肋间隙，前正中线上。",
                        "quickFind": "在胸部，由锁骨往下数第4肋间，平第4肋间，当前正中线上即是。",
                        "massage": "每天按揉300-500次膻中，可治疗产后乳汁不足；用艾条灸5~10分钟亦有效。",
                        "xueweiName": "膻中",
                        "jingluoName": "任脉",
                        "titleUrl": "膻中"
                    }
                },
                {
                    "seq": 18,
                    "xueweiName": "玉堂",
                    "xueweiCode": "yutang",
                    "position": {
                        "x": 0,
                        "y": 1.389493,
                        "z": 0.087215
                    },
                    "xueweiDetail": {
                        "detailTitle": "玉堂：宽胸止痛就按它",
                        "detailDescription": "玉，玉石；堂，殿堂。玉有贵重之意。穴在相当于心的部位，因其重要故比之为玉堂。",
                        "cure": "宽胸止痛，止咳平喘。主治咳嗽、胸痛、呕吐、哮喘、气短喘息。",
                        "position": "在胸部，横平第3肋间隙，前正中线上。",
                        "quickFind": "在胸部，由锁骨往下数第3肋间，平第3肋间，当前正中线上即是。",
                        "massage": "两手中指指腹相互叠加，用力按压玉堂，有酸胀感。每次3~5分钟，可治呕吐、胸痛、乳房胀痛等气滞引起的疾病。",
                        "xueweiName": "玉堂",
                        "jingluoName": "任脉",
                        "titleUrl": "玉堂"
                    }
                },
                {
                    "seq": 19,
                    "xueweiName": "紫宫",
                    "xueweiCode": "zigong",
                    "position": {
                        "x": 0,
                        "y": 1.411207,
                        "z": 0.075524
                    },
                    "xueweiDetail": {
                        "detailTitle": "紫宫：呼吸顺畅按按它",
                        "detailDescription": "紫，紫色；宫，宫殿。紫宫，星名，代表帝王所居之处。穴对心的部位，心为君主之官。",
                        "cure": "宽胸理气，止咳平喘。主治咳嗽、气喘、胸胁支满、胸痛、食欲不振。",
                        "position": "在胸部，横平第2肋间隙，前正中线上。",
                        "quickFind": "在胸部，由锁骨往下数第2肋间，平第2肋间，当前正中线上即是。",
                        "massage": "用中间三指按揉紫宫5~15分钟，可治咳嗽、气喘、胸痛、支气管炎、呕吐等症。",
                        "xueweiName": "紫宫",
                        "jingluoName": "任脉",
                        "titleUrl": "紫宫"
                    }
                },
                {
                    "seq": 20,
                    "xueweiName": "华盖",
                    "xueweiCode": "huagai",
                    "position": {
                        "x": 0,
                        "y": 1.43292,
                        "z": 0.063505
                    },
                    "xueweiDetail": {
                        "detailTitle": "华盖：止咳平喘按华盖",
                        "detailDescription": "华盖在此指帝王所用的盖伞。穴位所在相当于肺脏部位；肺布心君之上，犹如心之华盖。",
                        "cure": "宽胸利肺，止咳平喘。主治咳嗽、气喘、咽喉肿痛、胸胁支满、胸痛。",
                        "position": "在胸部，横平第1肋间隙，前正中线上。",
                        "quickFind": "在胸部，由锁骨往下数第1肋间，平第1肋间，当前正中线上即是。",
                        "massage": "两手中指指腹相互叠加，用力按压华盖，每次3~5分钟，可治咳嗽、气喘、扁桃体炎等疾病。",
                        "xueweiName": "华盖",
                        "jingluoName": "任脉",
                        "titleUrl": "华盖"
                    }
                },
                {
                    "seq": 21,
                    "xueweiName": "璇玑",
                    "xueweiCode": "xuanji",
                    "position": {
                        "x": 0,
                        "y": 1.454634,
                        "z": 0.054249
                    },
                    "xueweiDetail": {
                        "detailTitle": "璇玑：定喘顺气找璇巩",
                        "detailDescription": "璇，同“旋”；巩，同“机”。璇巩，为北斗星的第二至第三星，与紫宫星相对，故名。",
                        "cure": "宽胸利肺，止咳平喘。主治咳嗽、气喘、胸胁支满、胸痛、咽喉肿痛。",
                        "position": "在胸部，胸骨上窝下1寸，前正中线上。",
                        "quickFind": "仰卧，从天突沿前正中线向下1横指处即是。",
                        "massage": "用拇指指腹直接点压，有酸、胀、麻感觉时为宜，每次3~5分钟。可治咳嗽、气喘、胸痛、咽喉肿痛等病。",
                        "xueweiName": "璇玑",
                        "jingluoName": "任脉",
                        "titleUrl": "璇玑"
                    }
                },
                {
                    "seq": 22,
                    "xueweiName": "天突",
                    "xueweiCode": "tiantu",
                    "position": {
                        "x": 0,
                        "y": 1.476347,
                        "z": 0.04208
                    },
                    "xueweiDetail": {
                        "detailTitle": "天突：声音沙哑可缓解",
                        "detailDescription": "天，天空；突，突出。穴位于气管上段，喻为肺气上通于天的部位。",
                        "cure": "宣通肺气，消痰止咳。主治哮喘、咳嗽、咯吐脓血、暴喑、咽喉肿痛、小儿感冒。",
                        "position": "在颈前区，胸骨上窝中央，前正中线上。",
                        "quickFind": "仰卧，由喉结直下可摸到一凹窝，中央处即是。",
                        "massage": "用中指指腹慢慢按压天突1~2分钟，按摩时要格外轻柔，可治由于咳嗽、咽炎等呼吸系统疾病引起的声音嘶哑。",
                        "xueweiName": "天突",
                        "jingluoName": "任脉",
                        "titleUrl": "天突"
                    }
                },
                {
                    "seq": 23,
                    "xueweiName": "廉泉",
                    "xueweiCode": "lianquan",
                    "position": {
                        "x": 0,
                        "y": 1.584481,
                        "z": 0.06237
                    },
                    "xueweiDetail": {
                        "detailTitle": "廉泉：中风失语就求它",
                        "detailDescription": "廉，清；泉，水泉。舌下两脉古名廉泉，在喉结上缘。廉泉靠近此脉。",
                        "cure": "利喉舒舌，消肿止痛。主治舌下肿痛、舌强不语、口舌生疮、口苦。",
                        "position": "在颈前区，喉结上方，舌骨上缘凹陷中，前正中线上。",
                        "quickFind": "仰坐，从下巴沿颈前正中线向下推，喉结上方可触及舌骨体，上缘中点处即是。",
                        "massage": "用拇指指腹点揉廉泉，用力要轻且均匀，反复进行3~5分钟，可调治舌痛、中风失语、慢性咽炎等病症。",
                        "xueweiName": "廉泉",
                        "jingluoName": "任脉",
                        "titleUrl": "廉泉"
                    }
                },
                {
                    "seq": 24,
                    "xueweiName": "承浆",
                    "xueweiCode": "chengjiang",
                    "position": {
                        "x": 0,
                        "y": 1.607811,
                        "z": 0.091753
                    },
                    "xueweiDetail": {
                        "detailTitle": "承浆：口腔疾病好助手",
                        "detailDescription": "承，承受；浆，水浆。穴在新唇正中的凹陷中，为承受从口流出的水浆之处。",
                        "cure": "生津敛液，舒筋活络。主治中风昏迷、口眼歪斜、流涎、牙关紧闭。",
                        "position": "在面部，须唇沟的正中凹陷处。",
                        "quickFind": "正坐仰靠，颁唇沟正中按压有凹陷处即是。",
                        "massage": "用拇指指腹直接点压承浆，局部有酸、胀、麻感，每次1~3分钟。有通经活络、清热利咽的功效。",
                        "xueweiName": "承浆",
                        "jingluoName": "任脉",
                        "titleUrl": "承浆"
                    }
                }
            ]
        }
    ]
}
